<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{
    "num_cand": "U2FsdGVkX18SKAHlqI5/QKKJ2yy5Xrwzcl9lMvjKDMM=",
    "cpf": "U2FsdGVkX19tvLABlhPd26OKPCmvToLNEEnkOA57JsM="
}, {
    "num_cand": "U2FsdGVkX1/SmRYL5lB+4LOYFs7n7ig2YnhvLekIdO8=",
    "cpf": "U2FsdGVkX1/9ncrlwQoCSuyPUWv33DBq8j3TPdeEoWQ="
}, {
    "num_cand": "U2FsdGVkX1+JsR9XUDN82+k0rw+O2azRey+jrQCyCYE=",
    "cpf": "U2FsdGVkX19ZZsyuHhq+JgcAhpuK4RZJYpAegq26N68="
}, {
    "num_cand": "U2FsdGVkX1+9WppYvzUNPadIYd1H7Q7sT/Z9JC9cSbo=",
    "cpf": "U2FsdGVkX1/XqtWm7KAR2jzZkoktAO0Pjm/htjEwQtU="
}, {
    "num_cand": "U2FsdGVkX1/PBcCy8tJzLRFysk6Rzcyq9D+jzUscZJ8=",
    "cpf": "U2FsdGVkX1/p6QMebGaVoWrvMqhOSZxKQQjeBuIRxnA="
}, {
    "num_cand": "U2FsdGVkX19FdaD3CciDT47t49/h21slICGB7igBxRg=",
    "cpf": "U2FsdGVkX186giR4h3IfYMlpDE2Q9XDFV3NGv7/m8ng="
}, {
    "num_cand": "U2FsdGVkX19hKFEfnnjO1sIxzTBSbhqMEYlyfYc1xQc=",
    "cpf": "U2FsdGVkX1+gUBkkaYMlgMFuqGIxszFCxw5gCGVOX+I="
}, {
    "num_cand": "U2FsdGVkX18BKoNNM39yA00ZVoAz6wfGtsP5+2XZheE=",
    "cpf": "U2FsdGVkX19VfEiPh6F8/Af1DOYki8fhxmNkHKTdT9I="
}, {
    "num_cand": "U2FsdGVkX19qkQ1/gHzEgpPUhQvZm2HJe2MH1pkqwDw=",
    "cpf": "U2FsdGVkX1/MoMPdZfHwzR35B1KvLQ0sRThk7RGnyOM="
}, {
    "num_cand": "U2FsdGVkX1+hiKWkijfJjoOsWfqS34BFXjnxaaf5q1g=",
    "cpf": "U2FsdGVkX184Vp7pIdJ8mTSORL9v6K+RdnBmEixaFjY="
}, {
    "num_cand": "U2FsdGVkX18Skon/6AkAREB+Ej445X3/aPZiVgqwrkM=",
    "cpf": "U2FsdGVkX1+5NF6KhILFon9nyoihMSNqsfWqMg6mX3s="
}, {
    "num_cand": "U2FsdGVkX1+hQ7Wc1vuJhoASoYLeHWQ0iFD39q84vH0=",
    "cpf": "U2FsdGVkX19XkKep/9syYkgxukLsSYW7K/5so6lQGTw="
}, {
    "num_cand": "U2FsdGVkX198vLyONeM2OnksCwfxCHcdouN3LOQgQmA=",
    "cpf": "U2FsdGVkX1/hXoad2yBm36JcCo5IOFuDRQZ1HMq2tr4="
}, {
    "num_cand": "U2FsdGVkX18wRuk45ZPRTN2jFkOU81Ak21X6fynDclA=",
    "cpf": "U2FsdGVkX19ED5FU8gt2qTjm1tL0wo4/7MSVhZWrrCk="
}, {
    "num_cand": "U2FsdGVkX1+P1OnZSd7u8/yEsqOvQnnuAPLwnilk1Ww=",
    "cpf": "U2FsdGVkX1/hGn95XjJK7fQF58BXwjFKwUnoCviJZDE="
}, {
    "num_cand": "U2FsdGVkX18p5b2DGpxojzdfeLdeqGtPvPLBXnrKGYU=",
    "cpf": "U2FsdGVkX1/FqZPCl/2YQerDLIJsyTmGkRGyt0o4H8Y="
}, {
    "num_cand": "U2FsdGVkX199i6cyiF8OnSwzuZebFaet/UYPZVqX/04=",
    "cpf": "U2FsdGVkX1+22Dg0WrZ9M1kAa30FO+DAez07n7WGsIA="
}, {
    "num_cand": "U2FsdGVkX1+6YDBnduvuZbQK7QuI+Pz1uvptEJ3ATPo=",
    "cpf": "U2FsdGVkX1+xyYpsEW/Kt4fuECYL09mMdVrLy/gfCWk="
}, {
    "num_cand": "U2FsdGVkX1880DuLhai/TXrM17zSWCCzdSU8QmGnvzY=",
    "cpf": "U2FsdGVkX18xV4aTj9Aa3K6B/kjtFjc2nFZPRF4+BbI="
}, {
    "num_cand": "U2FsdGVkX1+onT7949J678jQC8+O62GEhCGHINa4VV8=",
    "cpf": "U2FsdGVkX1/PlzSvZsN7FF7IKMdUn9nC6GwIhM21dVI="
}, {
    "num_cand": "U2FsdGVkX19eMcbXHZUBrefhC+Qrqq6xZBEfygS1HVU=",
    "cpf": "U2FsdGVkX19GxWlaLzffdpHf/vbzfZgvDUaYZjy6+gQ="
}, {
    "num_cand": "U2FsdGVkX1+wi34Vitf+8XrO/EZA6cAw+3XjlIF3HZw=",
    "cpf": "U2FsdGVkX18SKEMvR7knR4RzXg5QIBNdwk5R6/RwpvM="
}, {
    "num_cand": "U2FsdGVkX19vvYUuVP89N4GV0OCBb0ZPfGqx62eD7Mk=",
    "cpf": "U2FsdGVkX1+lzsBkb1StLeWYXZ/xe98LQYro3M0hUlk="
}, {
    "num_cand": "U2FsdGVkX1/0M2CiPIJYmMBjgH1o/pMMVbVALCejhPI=",
    "cpf": "U2FsdGVkX1/vsYrP4M9ATglO0QOj0kz0FYOo/VYPI/s="
}, {
    "num_cand": "U2FsdGVkX1/OaWzUbYP8+dSc6bjHEoF+4V2MIiwFWOo=",
    "cpf": "U2FsdGVkX19bvJ6lspyF8XsINp2/CesaCO5Ca1xpE4o="
}, {
    "num_cand": "U2FsdGVkX19ylY86af121ovAteR4qPBXsbHuC07siek=",
    "cpf": "U2FsdGVkX1/BZDyr4/dkyOAHAyKAiD2PmBrPOZKgJgk="
}, {
    "num_cand": "U2FsdGVkX18elbOP8/yJ1mzjgPKS6fmkO+7iVe6I+xY=",
    "cpf": "U2FsdGVkX182v/mCpQjeI5O6lDBzyHCmtSrMCDtScL4="
}, {
    "num_cand": "U2FsdGVkX19T4ScpDSRMGHNAw08bZsDpugoF3UE6rkM=",
    "cpf": "U2FsdGVkX1/KmqHNno0DFK7mymemJQu14Jm1+q7jsGI="
}, {
    "num_cand": "U2FsdGVkX19O56XBqjsDET+OLtoevGtkIYkMjXh7pgg=",
    "cpf": "U2FsdGVkX1/F7bI3lM0A8p8dThpQa2FENi/SdfVmaUg="
}, {
    "num_cand": "U2FsdGVkX187dK5WbVYLnNqJfmPwW3WqDFjFplDpaQQ=",
    "cpf": "U2FsdGVkX1+LZISVrKHaqqf5QyHvz6HcL4jnqZekoj8="
}, {
    "num_cand": "U2FsdGVkX196/HmUCF3xP1sW6VsqKRrQ9ZhZ/MPFqNA=",
    "cpf": "U2FsdGVkX184n/vz2w/cdDYlVVd2iJLF/XMIfmeKr5M="
}, {
    "num_cand": "U2FsdGVkX1/WhY5HEvv3X2WSx8a8BVx70rqGDh8kocU=",
    "cpf": "U2FsdGVkX1/cH4ieRO0gu7miHTA4Y9R1/rz51QAYK7U="
}, {
    "num_cand": "U2FsdGVkX1/aFH3/srTyPUSXa3k1NAxVU9kuAw9tOJg=",
    "cpf": "U2FsdGVkX19GreaB9ecycleoVPROzNzivZkhDg3MA4I="
}, {
    "num_cand": "U2FsdGVkX1+c00PBUrZvdLQ0oo4znT7yHTolKU6L0q4=",
    "cpf": "U2FsdGVkX18KkobOzIHXhvzPz5rP9erH9yoqKJlVB1g="
}, {
    "num_cand": "U2FsdGVkX1+O3yBpGhdT0UwFiwPtO2cYQc8N+hIIY9s=",
    "cpf": "U2FsdGVkX1/ZK8OgN5y7IVXQyWhm9OQyDaMN9wVQYC8="
}, {
    "num_cand": "U2FsdGVkX1/s2BoR+OAFQycdOAT83GRMMBrST+OZrjE=",
    "cpf": "U2FsdGVkX1/fchDX+xoM3nI1UMXSGPoFwEmTq5tqA5U="
}, {
    "num_cand": "U2FsdGVkX18sW4XxyxPAahzWCUqX3KkrB/FmJbDy7NI=",
    "cpf": "U2FsdGVkX1+PKyvLkzSgOvbXQT/yQK1MpTo1Z54G8z8="
}, {
    "num_cand": "U2FsdGVkX1/sVdGUqsjGCt8rUu+oXieZa8fzNq1HPp8=",
    "cpf": "U2FsdGVkX1/3Y2EOefd7IOQn/S6B0Q56ELAHtGfaztk="
}, {
    "num_cand": "U2FsdGVkX1/UfiqNVHVyVaPCgOBzL/uI7AvzCNHS2OY=",
    "cpf": "U2FsdGVkX1+hC72UfFSDRbOv9JdNPmmys64JsnJsTo8="
}, {
    "num_cand": "U2FsdGVkX1+VCbuvow4tO6Nu5uV1UeU3VPus9+6GIRU=",
    "cpf": "U2FsdGVkX1/S66TDI+CfbIny4YTYKRMg2s7Z4gsQp14="
}, {
    "num_cand": "U2FsdGVkX1+B1FBdSzoYbxfwtohqFZc1auDbx96bCGI=",
    "cpf": "U2FsdGVkX1/1CUscMLfz7BJLL99fLGPe226l28tJVY0="
}, {
    "num_cand": "U2FsdGVkX197I5PhiPDdYWCLlqWpU9ZUpOIIahheUMY=",
    "cpf": "U2FsdGVkX1+Xmye3NCIC5XVecIEdA9r6Sml1rkwzE5w="
}, {
    "num_cand": "U2FsdGVkX1+NCEk72/H9hpEc1ZMSm2fDKVQ6/8KWbl0=",
    "cpf": "U2FsdGVkX1/0rCpo3aGnH0IAojwLdixjLKgKnrBbdyU="
}, {
    "num_cand": "U2FsdGVkX1/CwHPsBGrLXIv9wgPfB6OVxVXitsaZnPA=",
    "cpf": "U2FsdGVkX19sqVTVydQcwudK1p368THs6IQnIUQ/ewE="
}, {
    "num_cand": "U2FsdGVkX18I25zPd4Oz0E3Y+BYF4ERozG7sfCzEd24=",
    "cpf": "U2FsdGVkX1+5BsGQjLkU/gtLnDceMi4EvwSCNsdXLII="
}, {
    "num_cand": "U2FsdGVkX1/sMyyshvX48wjAAbIErZHy4n4/2gBwMkk=",
    "cpf": "U2FsdGVkX1/2zz16OhQoeMeL36708P/NpDhKHdHe/+s="
}, {
    "num_cand": "U2FsdGVkX19zw/P8d6ULRl3tHixXnE3+JX4EIStRSvc=",
    "cpf": "U2FsdGVkX19nIRFIBhh6R2NgfIM0gWuR0Z+Z7BnNAm0="
}, {
    "num_cand": "U2FsdGVkX185AUkJCKLI9QGNQGvLyj+j1BLAluKwSP4=",
    "cpf": "U2FsdGVkX1//WddjuLPLeF3B9Mrr33lkAEgt1xSR+Uw="
}, {
    "num_cand": "U2FsdGVkX1/ZmqUgxsVUZoSJIkLwdm4heIWnOETWevY=",
    "cpf": "U2FsdGVkX18SwYGnwTTHIBXrLDfKHSPiTKcoyfaK2Dg="
}, {
    "num_cand": "U2FsdGVkX1+l/wnr7BZzKCLeAYW+CFjlRLAMIl444dA=",
    "cpf": "U2FsdGVkX19d6ODod/XJ6nGeSTgxjBIR4RiA0/YSlXg="
}, {
    "num_cand": "U2FsdGVkX18YwK8Gu9KN7WGCpdvd+xhYNgmNyx7LCko=",
    "cpf": "U2FsdGVkX1+ufXrZv21GBLVdAIODzqKuUsQrPyqslrY="
}, {
    "num_cand": "U2FsdGVkX1/LKv6dntO9JbLrYI24pVTL1X1y1IP26IU=",
    "cpf": "U2FsdGVkX1/DKmtaC6M8xxS/XSv/oEaI1i6hY08GLoo="
}, {
    "num_cand": "U2FsdGVkX1/exXzzzScBhFG3VZJBlp3G4Y23wOdqLcY=",
    "cpf": "U2FsdGVkX1+UX+DvSdFEef6GEzdc77Zyxr/TAtVOgYM="
}, {
    "num_cand": "U2FsdGVkX18WlfsoRc9H0kCjA9zYapk2vGNjFmxw5Dg=",
    "cpf": "U2FsdGVkX18Xjr1/ti3u+o2GejDAvVXqWwYXztt/NTE="
}, {
    "num_cand": "U2FsdGVkX19ZHaNaj5K2r7n+NwtQfeK7p1a6x+gmE8M=",
    "cpf": "U2FsdGVkX1/21zB2llhUYMPzNV8cgmhdUkvCZDqL47U="
}, {
    "num_cand": "U2FsdGVkX1/3ycr/lwNGusLV9CVytfYBDrHV6K0ppNg=",
    "cpf": "U2FsdGVkX1+ndJRSJiI68i8eGl4l902R7rpAMqN43aM="
}, {
    "num_cand": "U2FsdGVkX1942n77Z5guZXZNQhUyDF2njXgSKJEBZno=",
    "cpf": "U2FsdGVkX193peFQWE2XRrYzqkT4YjVjojNWW3wniDk="
}, {
    "num_cand": "U2FsdGVkX19bxV24F/SDxLHqUTC/cNqA/dLAdTvFn6g=",
    "cpf": "U2FsdGVkX1/Zf2Lv7pIBepu54X5QIGUKBnMgX36CMGE="
}, {
    "num_cand": "U2FsdGVkX18+Fd9owNWNPl5Y7gMR2sh2WcoKK+X89mc=",
    "cpf": "U2FsdGVkX1/hth35vnN3ZQKWZu7rIuQWHzfR6RJgSNw="
}, {
    "num_cand": "U2FsdGVkX1/1gTzXawxDXtFroIyZFewt97ZzGq6CCSk=",
    "cpf": "U2FsdGVkX1+hQtv7RGKsH/lo78mzOwbopkExGRPTu6Y="
}, {
    "num_cand": "U2FsdGVkX1/w/Ir7PNW7s1J7bCB/sle5Z+YlOVWKEzA=",
    "cpf": "U2FsdGVkX19smUoKgzpx/yatcK7orHt6wTHBtkIYJ3I="
}, {
    "num_cand": "U2FsdGVkX18HkhmAx0NR27ay5MLknjBN+IaZ57fFB80=",
    "cpf": "U2FsdGVkX1+vbdtq/DDLYSUPaQ7/F2F7YIxvzXQThcQ="
}, {
    "num_cand": "U2FsdGVkX1/6ztZzdDMOSHBTQ3n577MXrRTU3f9IQ7w=",
    "cpf": "U2FsdGVkX1/wxgZU86u2KHERLLpcKzwrhzJd38m8yNg="
}, {
    "num_cand": "U2FsdGVkX1/8DlRUsOz7qQgmYTrhxwIQ0q1g4app2Uk=",
    "cpf": "U2FsdGVkX1/YtV69X71g6Fchne5wIYi4dAD3gEnd+84="
}, {
    "num_cand": "U2FsdGVkX18Y/nKnWm5im8CrPPgNCANAjUpV3zKNtHk=",
    "cpf": "U2FsdGVkX1+dnLBObUUyTg1kT28DQVS7OJhmpuQ7SmU="
}, {
    "num_cand": "U2FsdGVkX19Cv41R/Nd1MX/BRsCBXKt79IBjwM/+gwk=",
    "cpf": "U2FsdGVkX180sfv0mJaFM2A91mlmwTkSKsOo+cmj8xQ="
}, {
    "num_cand": "U2FsdGVkX18dX4OaHg5pK0sMmT+Jn7rB2ZrdM+4Sh3w=",
    "cpf": "U2FsdGVkX18XzEgwbD3zVOsGQoXgGK2/OyGT2EzsCMA="
}, {
    "num_cand": "U2FsdGVkX1/EIwLtdTTBY9M1MhO6E5D/rdeb6NfRBF8=",
    "cpf": "U2FsdGVkX1/UbgenLLf+conm8xBm2YwfMO7ULpxUebI="
}, {
    "num_cand": "U2FsdGVkX18FeogA/BeUo1m9qN/a4GRMZvAWGscGR4s=",
    "cpf": "U2FsdGVkX19jUhrb10e5QIGb6krLqVhusI+cP5GNxPk="
}, {
    "num_cand": "U2FsdGVkX1/ti1c+vdovKp37DZMFXkaowpEssIWqelI=",
    "cpf": "U2FsdGVkX1/Ib90hlYt4KdKyLSW/YCCJ0TTcAz/UCmE="
}, {
    "num_cand": "U2FsdGVkX1+LFzWsf9PlyZbZoOSTT5zROFkcQbJhbR0=",
    "cpf": "U2FsdGVkX19oMyj+ZowCo0LqYBBNWnWPRLEWWaIbHXc="
}, {
    "num_cand": "U2FsdGVkX18v96i/k6GHGvURDc5NUksGkfpVY4bDcVQ=",
    "cpf": "U2FsdGVkX18ebX/G/uKx52H8tce7pdo+6Y8TgdOqWbA="
}, {
    "num_cand": "U2FsdGVkX1/ZdWyNYQhHm1+PHWlZKCC0ics3/rhZRQM=",
    "cpf": "U2FsdGVkX18fsgWFywzxaYlD7WO36aVatAHVPaUk8uE="
}, {
    "num_cand": "U2FsdGVkX19iigZjOEQ8C94KHWlHRvHna++P4XTjPZI=",
    "cpf": "U2FsdGVkX19aWK9qYdzEsgtf8CUBxMMN6KNw0Hj7pF4="
}, {
    "num_cand": "U2FsdGVkX19t03owi4bnn5mkHJraXiJgl4gAiTwpbWY=",
    "cpf": "U2FsdGVkX1+R12LArRJZkkZ3WembVhYkcWZbFRySWI8="
}, {
    "num_cand": "U2FsdGVkX1/t+jhb7+ccsTD60yRl/NkymkUtLO1ND7I=",
    "cpf": "U2FsdGVkX19AcLDEw0mPjFwxI71R0dMz+ChzMJ2e920="
}, {
    "num_cand": "U2FsdGVkX1+EtZT9pHJOr0avRYkyiAxVnjoDx72q474=",
    "cpf": "U2FsdGVkX19TXJS2ZuvbLFDruItdLb4alexmWXiwU0k="
}, {
    "num_cand": "U2FsdGVkX1+DEVFSX6H0t2vkvYew8QzeEsevWH1IT9E=",
    "cpf": "U2FsdGVkX184alDPPPyQaRaI9sVGmYLEjkXeLmALgG4="
}, {
    "num_cand": "U2FsdGVkX18E0+Hyb9WEeAt96q2y/crn8Pt6ndn43WQ=",
    "cpf": "U2FsdGVkX195qylxOCWTLRiRhaSYfyGjlHBT71XcBb0="
}, {
    "num_cand": "U2FsdGVkX196k2tGJLdoTnJ/Pcjnf7JvAuin1ySO0/U=",
    "cpf": "U2FsdGVkX19fvb1dc5DNtwauTSrSStdzISayy+tBD/A="
}, {
    "num_cand": "U2FsdGVkX18rPRst8zwqz5zGSSns6YVrO78ItVZMulI=",
    "cpf": "U2FsdGVkX18n1AV6oQyK+P8xjYJiLHhU8UxLuouL6L8="
}, {
    "num_cand": "U2FsdGVkX18Bh0710cAR5qOooU3USWicFWCxj+K0uOY=",
    "cpf": "U2FsdGVkX18WMGW8NmTAWGzI5Ta+SmASoKt1oBWy+IU="
}, {
    "num_cand": "U2FsdGVkX1/Sd8vE39XqtB7Ict7jj/9EGySVHFbN7bw=",
    "cpf": "U2FsdGVkX19DJyfEZcI+XMN1aHKl2cOTdgIXLFSqZWs="
}, {
    "num_cand": "U2FsdGVkX1/uKsaVsM19JgxCns3Jei0cHQ2AukGr4dM=",
    "cpf": "U2FsdGVkX185DRRBYpMtudN1jbgPShzX6aqEdEUhaoY="
}, {
    "num_cand": "U2FsdGVkX1/vSIycyrAwXGi+rHrDgSNm8qf7Eblg3BU=",
    "cpf": "U2FsdGVkX18QmUntjcjdTmkgkoj2WIxoaYXlKqWNSwU="
}, {
    "num_cand": "U2FsdGVkX1+WB7+O5AZYC20OUw7L/QQqnaova0/TS7Y=",
    "cpf": "U2FsdGVkX19rIBwjzs2//2zX/A2kF1xEGYsDHMLWHTM="
}, {
    "num_cand": "U2FsdGVkX1/BOAR5pcMC3rDSZsMaZXjhQd4uhXdSqYs=",
    "cpf": "U2FsdGVkX18Q/qJZV74nwWAuOpaGrCpBvGb67rtVEv4="
}, {
    "num_cand": "U2FsdGVkX1/WJESo5EGHpkFKXsyoC+xcIRR6spVLUng=",
    "cpf": "U2FsdGVkX18xRmfyuKlH8Fl8KN1hjpao9vWN3Qg2kps="
}, {
    "num_cand": "U2FsdGVkX1/7n0BsmnEnkW4C8GS6LF8JstCXvDts7NI=",
    "cpf": "U2FsdGVkX195zBEDprgND1bS21p2zuUTQOr/QTX2JnI="
}, {
    "num_cand": "U2FsdGVkX1+m8+7Z4IFLpp1VRi+/N36dQqTYs2u7drs=",
    "cpf": "U2FsdGVkX1+65yAmxkjxrBhVVI2rykaXtQXEJMJgmHw="
}, {
    "num_cand": "U2FsdGVkX19P0rlNdifeLkBN6sFiYNGj7KPY9B4xz40=",
    "cpf": "U2FsdGVkX18apLtrqrlYVl7/HZpzFNaaLXxifaXl/xc="
}, {
    "num_cand": "U2FsdGVkX1+MIWdKLhil9kRAGjf33hEp8siFBewBdjU=",
    "cpf": "U2FsdGVkX19EZ8BMs8cX0+nZS3PZEd31ZkFgscpx0Ac="
}, {
    "num_cand": "U2FsdGVkX1+TRjSIU2pcfmaoHGc6zWuEInFq29zCHwE=",
    "cpf": "U2FsdGVkX18rLTVXlZNBEK3xv8ktwP31apRrbhbgcMs="
}, {
    "num_cand": "U2FsdGVkX19CbH2j5oFEY4crk7M/ATPxuLHuxFVB8MM=",
    "cpf": "U2FsdGVkX1+xeCJE8DxJSoeskwyut3oVNLWE71bgnWY="
}, {
    "num_cand": "U2FsdGVkX190FGgPn4POrY3TpHYvFdJ7jSPtgLAlaFE=",
    "cpf": "U2FsdGVkX1+5sxmXKw8yupASb9kt5PTJW0mrBWvJXQ0="
}, {
    "num_cand": "U2FsdGVkX1+SSvbBY0f4SslhNTafGTT53mSjaz3sLeg=",
    "cpf": "U2FsdGVkX19nAFx7a+cpcSrM9Nla8gpIcSGHuaqTnmk="
}, {
    "num_cand": "U2FsdGVkX1/lOIJtY3jJQ5a1e9tuQR/3QCqM9J7KU5Y=",
    "cpf": "U2FsdGVkX19jWLzTnutEGvWqKaGJznj53rM/8JDCMSU="
}, {
    "num_cand": "U2FsdGVkX18/ElNbAUH/WwCN5NRbzdDKIt0tnr7NAg8=",
    "cpf": "U2FsdGVkX18n2pcTZVGI8XRCIZ/Fr7CRXZ6ZF4uSecI="
}, {
    "num_cand": "U2FsdGVkX18bps1xOoTsnG+nZYdX1x9SsaK/t8qFZVc=",
    "cpf": "U2FsdGVkX1/1F/E7podcodBw+nHL9y4fr4TDJZDM9C0="
}, {
    "num_cand": "U2FsdGVkX1+Y+zZYa8rzPzTkteqlSLkYqjewLkGAw14=",
    "cpf": "U2FsdGVkX19sTvOn1lGKnS1f9uPQrYvdNgqi49yozZ8="
}, {
    "num_cand": "U2FsdGVkX1/65DKAT411Gk4nwZphyTeoe5HFd7ozREo=",
    "cpf": "U2FsdGVkX1/OXLnVUhP4sl01nL9DpgjKpb77u0ew3Ok="
}, {
    "num_cand": "U2FsdGVkX1+R9HuLHSB4ShYyRU1m5nQhzuqq+O8KBLU=",
    "cpf": "U2FsdGVkX1/2Vl+TMWUk6wMmf1C5l/FyfH0CBYDZ+Bs="
}, {
    "num_cand": "U2FsdGVkX1/CdYqqS22ET2hR4BCGhYePBjxQBLbFjp8=",
    "cpf": "U2FsdGVkX19D9QLTXtMQTVKaEoii+eHfv4MemWfa1U4="
}, {
    "num_cand": "U2FsdGVkX183mIZ5KWfwUOxoT1wDqC7Lvugm1gvyshw=",
    "cpf": "U2FsdGVkX1+wwMTFR/GMgHbChKN1DwTepYs8vV5ph5Y="
}, {
    "num_cand": "U2FsdGVkX1+7jn4kT3XpOmq4W+27bvg0HQDjboV0mng=",
    "cpf": "U2FsdGVkX19WlLdUVbpTMdyzCCpiEzhe7RcUDkg1WBM="
}, {
    "num_cand": "U2FsdGVkX1805D3z2jAj7rXb90+zkbSaAYTBCxMONiY=",
    "cpf": "U2FsdGVkX19f8w7yWwJ4J++tCW/+G9a9uBB0v877PLo="
}, {
    "num_cand": "U2FsdGVkX1+gnbzzpAWErxeIZkO4qzwjfr2bY1x+v2Y=",
    "cpf": "U2FsdGVkX1+LrPh69RheX1UiTytmy53hScTBPEwigds="
}, {
    "num_cand": "U2FsdGVkX1+ohjxNtAIBQJprqZjpD+vWM0XvW89jsqY=",
    "cpf": "U2FsdGVkX1+6vdR1Vd5IrrhB5Wh15H38QihJnH+Cf84="
}, {
    "num_cand": "U2FsdGVkX1/S558UpHaCGFZxW55vdofxXBNjInGc86Y=",
    "cpf": "U2FsdGVkX19KjZT3SvhdBmUdcB7S4kHD1e0TChYYx3Y="
}, {
    "num_cand": "U2FsdGVkX1/w0h68+ALznaBs7s/RSAacxJpbJBNPtYs=",
    "cpf": "U2FsdGVkX18LAoIzy/Dl599f++wpIEgtpLC73If7vhU="
}, {
    "num_cand": "U2FsdGVkX1/zYmORmGWlAalL+ViocvuoQajEcDPN8fE=",
    "cpf": "U2FsdGVkX1+Eu+q3q0Z5cm5zO+sJuB1WRL0IgBx4Aoc="
}, {
    "num_cand": "U2FsdGVkX19laFxQnogfWTe606a545Qq3ZmbCb+e2dI=",
    "cpf": "U2FsdGVkX18SIFPDOopyWeCyui+mq3Q/vHaPN3oyM1c="
}, {
    "num_cand": "U2FsdGVkX19ldukdJtadkPpCahXLyJ33U7YK4mIlNXY=",
    "cpf": "U2FsdGVkX18PjlIxbLJ8eEp2nOn6il30jy4AUKf/GJk="
}, {
    "num_cand": "U2FsdGVkX18QntIWS96dwoEWF9AnBfZuy4Bp7s66NbU=",
    "cpf": "U2FsdGVkX1/KBKODXuxHIZtmPNS1/juY1RYY9XWG9NM="
}, {
    "num_cand": "U2FsdGVkX1/JyCzaScf9oJhYbg5npG05r6mV9ogwGCU=",
    "cpf": "U2FsdGVkX1/Ulf7COEVdKQaD5Zi1O00ZFyHBfVgrZuc="
}, {
    "num_cand": "U2FsdGVkX1/GfwYXMrd8sJaPykuVsB/EtTgY6DhnY68=",
    "cpf": "U2FsdGVkX1/TbJvLGKZBovBWWyCttk+xR+5VERUNxq8="
}, {
    "num_cand": "U2FsdGVkX1+NInnU9kE6GY0TZppUkGyBCjAHjKCVHnI=",
    "cpf": "U2FsdGVkX1/+cVsOsJ+yuapVsnzwt5CnJ552zvqCI44="
}, {
    "num_cand": "U2FsdGVkX1+3x7zdte3lYEGlZsLfO1e0PsJFPdsnro0=",
    "cpf": "U2FsdGVkX1/LdP6dd3Y1Ydru2pmLRPLgN4CObLwEBT0="
}, {
    "num_cand": "U2FsdGVkX19yCnguPqHuypnRuT7eyEx6ZQvXW/cAjbE=",
    "cpf": "U2FsdGVkX19ah/aCPWqQMUkPkwu4/aZo163WGGmwxBc="
}, {
    "num_cand": "U2FsdGVkX180ofTOWaDVQUOB29Uwtoqc0ZCOOTNOTFI=",
    "cpf": "U2FsdGVkX19BrjIz4SMvRfFKYK3tDrAK6R8S5tlJJjA="
}, {
    "num_cand": "U2FsdGVkX1+cyFkdyoT8QaQCXTNM4goE+Bccg64dLhc=",
    "cpf": "U2FsdGVkX18V894nj/mpG5KLiA4eA72R1JNXwCxmE5g="
}, {
    "num_cand": "U2FsdGVkX1++Omrz6gI0ovXXwIkLJPCyr0W8ok3J3AQ=",
    "cpf": "U2FsdGVkX1+zGPvMf5aFEexpBSJpI2s2e4w+k8qCtrc="
}, {
    "num_cand": "U2FsdGVkX1/n2Xdd6PhZYRNtXJCOONf6gK8ES4n383s=",
    "cpf": "U2FsdGVkX1+L72hwAklZS0RdBprYYKuSs1dcMdkGj+U="
}, {
    "num_cand": "U2FsdGVkX18kSGbwp/a+IG6dkwLg9ALX2RR9JAxlUx4=",
    "cpf": "U2FsdGVkX1/s7BBlecL0sbF8hfZzLBHHRc0IhZkSlVI="
}, {
    "num_cand": "U2FsdGVkX1+L3NNlsJFS9HT5lOsq/4MGSH2SxemyoRc=",
    "cpf": "U2FsdGVkX18gBCpAF+Mf5Z+ygT4JtgyGBPcr0IXM08A="
}, {
    "num_cand": "U2FsdGVkX19BiZ9/ms5McZQnGss6q4GgzDT89JsguyM=",
    "cpf": "U2FsdGVkX1+J4XF6JtZ16MyAioKIratq5XMaT6X+a5c="
}, {
    "num_cand": "U2FsdGVkX190cWPbHfRjA05MF/1nqEgSzSRPYdY9WvU=",
    "cpf": "U2FsdGVkX19GVto/PO0ISQEgHD8yuSV6uatvQLrZFbE="
}, {
    "num_cand": "U2FsdGVkX18LnSIIAsLrR978UsZUU9rL8zG93UDJrhw=",
    "cpf": "U2FsdGVkX18Atjo97XB9/ZtCJaJQsJPGdvJyRTJZZXI="
}, {
    "num_cand": "U2FsdGVkX18tVQcA0bOb7ExxD0TXUq6dUj/kQJh1F3Y=",
    "cpf": "U2FsdGVkX1/bPOeYDZi3lbG/Ih3ZMGM9dVsOPZgvT+s="
}, {
    "num_cand": "U2FsdGVkX1+1gmeK+uO6IW5CvlCtZ3FiPCIYheE+vZA=",
    "cpf": "U2FsdGVkX19b3WTH58FZEPKRf/7hT7Tl/slOOktAuwA="
}, {
    "num_cand": "U2FsdGVkX18VL9JDoRV0JLFo1owBmXCc+GL0+BUdV7A=",
    "cpf": "U2FsdGVkX19No+F5xWbwR3v2ASouz1VYtN4jj7KCdsI="
}, {
    "num_cand": "U2FsdGVkX1/J2yjRNOnQTKa9Wsq653dfxdiL4Jta8ZE=",
    "cpf": "U2FsdGVkX18PgcIP7Ep3IAdn/guDHmVPD5Uw5KntFiA="
}, {
    "num_cand": "U2FsdGVkX1/y8AL0Vvt/jq21xjKHG/KFkrCAmrVfYG8=",
    "cpf": "U2FsdGVkX1+diVUNTzLPeASLWuVXsZPsHvOfgAFxW/I="
}, {
    "num_cand": "U2FsdGVkX183FDu6WYkMHw5NHWD3YWsN/ofBlnytYA8=",
    "cpf": "U2FsdGVkX1/ml2oNiq1GWhszPdcVpen6tkTCcvNOIT0="
}, {
    "num_cand": "U2FsdGVkX19ASvmnD4CuBAvAo3bUFYIYUVQaWwJ+EDA=",
    "cpf": "U2FsdGVkX19A6ij4S8Neo282mb+MGLmIhKBDkgBipys="
}, {
    "num_cand": "U2FsdGVkX1/3oQw2v3KNpIKtr7hmJ43YA2qMudEh/bI=",
    "cpf": "U2FsdGVkX192Dw2VOnBGGY1kgSDEz9kBSK/tloGhCdw="
}, {
    "num_cand": "U2FsdGVkX19fF5k3ZBqN6kjtjGPqjg9brU6iQfMRwKI=",
    "cpf": "U2FsdGVkX1/yKSEnGhK9hrHruBRh3VXA7vyqlW74S+Y="
}, {
    "num_cand": "U2FsdGVkX18QTAMvVXTUlYAn+1W4X3ggXWLp+Aw2P2Y=",
    "cpf": "U2FsdGVkX1/pWvnzc9MynSl+dJ8G9k/RNxVU8H70khs="
}, {
    "num_cand": "U2FsdGVkX18X2r+MZs7+ncvnMakAOQaIrHVcfPL/5i8=",
    "cpf": "U2FsdGVkX1+rBcL7k7Dad21f+n9VMKkLtV+xw42cGXs="
}, {
    "num_cand": "U2FsdGVkX19d9LWC4Tha2DuCdPelABn5uogKiRwGX9o=",
    "cpf": "U2FsdGVkX18EQIwc46lTj53Gyc+iqF4mNdWtEkamDJI="
}, {
    "num_cand": "U2FsdGVkX18f7yCXGpomo7oOOBEfsq7dA/exVlMtF6s=",
    "cpf": "U2FsdGVkX18pSLXWp6CdSoS5szZbFA2ga9BPMtkQRSY="
}, {
    "num_cand": "U2FsdGVkX1+gxL5yfLYRCpeYPli545MC20HXL7G+AkE=",
    "cpf": "U2FsdGVkX19TO6deZEx1Z9ozth5/ZI6wesbuQer7CqA="
}, {
    "num_cand": "U2FsdGVkX18FDnjfUqfPPZ/T28RG2VtBRhdVw41Zne0=",
    "cpf": "U2FsdGVkX18slupK+hqPvW2FOEOxr23730xCijhwGeQ="
}, {
    "num_cand": "U2FsdGVkX18/Kc1eKAgWRNiARd+yPXYcBiDFA7tQOHI=",
    "cpf": "U2FsdGVkX1/+V7fvLOgmorpV8sDbgGJk7oIWbAKKmmA="
}, {
    "num_cand": "U2FsdGVkX1/biqKrhwqN4kBfhpOPENtvkvmrF2tfDFc=",
    "cpf": "U2FsdGVkX18j81sbhJEotl89USXluQUMaFC/uODJplM="
}, {
    "num_cand": "U2FsdGVkX1+QXCC0Mgvn1bdRQXy4BhYwaXkWTcEr+N4=",
    "cpf": "U2FsdGVkX19hDF9OtyU+SDz8ZB2h/csczjyg3RCwoak="
}, {
    "num_cand": "U2FsdGVkX19JshV7e7LV6BrSglk73BmH5u5dIJlUJmo=",
    "cpf": "U2FsdGVkX19FVGBbV0UPuemhH3s9CLbwllLBro5KKaA="
}, {
    "num_cand": "U2FsdGVkX19zcRUlDB1kC4NgKuE0tz/B5SzYbQv/nYw=",
    "cpf": "U2FsdGVkX18zp8BgckL2caUTjTfyWGfTk9Om3u9fcVY="
}, {
    "num_cand": "U2FsdGVkX18pCPCAhxy1W0M3SP9BncO0KtqFstR/p0s=",
    "cpf": "U2FsdGVkX1/pM1cmf0LVQ45RL7eVFAXuBjhR6HXt8lQ="
}, {
    "num_cand": "U2FsdGVkX1852/NTykmFcv/3z8p9Y9XEhwkuUfVgBjU=",
    "cpf": "U2FsdGVkX19Cu71z035mHZW+SnAmgzGarokQjMieRZE="
}, {
    "num_cand": "U2FsdGVkX1+GQt7IfzyhSTJAMAD2nzmruQr5nRJ4Hxw=",
    "cpf": "U2FsdGVkX193m5dBSk35tTkTFRIVPWwXIIjnxky3bMw="
}, {
    "num_cand": "U2FsdGVkX1/jAgjKb6JR/3lV8iHLQFEdBsCJeYC5Z6o=",
    "cpf": "U2FsdGVkX18FIBVTDwIR0AkTGzaQddAvbhnifhDFmbQ="
}, {
    "num_cand": "U2FsdGVkX18ywh+YL4K6nFjxJwmOs929vlyTyymjle8=",
    "cpf": "U2FsdGVkX1+6nnksXcq6tFVhtn2V/U7J0lZr1iIuui4="
}, {
    "num_cand": "U2FsdGVkX1/tCfqNFLrMeBQcuS5BVrA+TMF37H6aYBE=",
    "cpf": "U2FsdGVkX1+JgyOfyy46/P7U36A+V49OWArBLH4SkEQ="
}, {
    "num_cand": "U2FsdGVkX19+I5Yob1gOX41v5aMMXJnoaOFXN4IjzYM=",
    "cpf": "U2FsdGVkX19O47meT+1xWA9B71+KlCzFTymN9Wvc3Lg="
}, {
    "num_cand": "U2FsdGVkX19FOm6Lp20L662g+qOEHBppymnR07TvMBg=",
    "cpf": "U2FsdGVkX1/Mqc976m7WUZa2noXTmLrV/12NFhqpPA4="
}, {
    "num_cand": "U2FsdGVkX1/tnzluKO+hHgasksWy5hVGL6m7z/hEEWw=",
    "cpf": "U2FsdGVkX18lKOyCnW1hqePgaMdNMCVfUp6qXkA9dIY="
}, {
    "num_cand": "U2FsdGVkX1+GSDhdrucpEoMsx4L77dNiTW3HBJDcNbI=",
    "cpf": "U2FsdGVkX1/xYPx5+JyvAXA3IF7rjmLidNksvdBUt7o="
}, {
    "num_cand": "U2FsdGVkX18gwS4SyGaMcJoioi0wIWY/5XQWlEbG2Uw=",
    "cpf": "U2FsdGVkX1+w7ShYMCZpr/nen03l8h6qMSjuGQfiSF8="
}, {
    "num_cand": "U2FsdGVkX1+h6B+FB2+Qk4Sfp8XnmdUJlqweuqJzJOM=",
    "cpf": "U2FsdGVkX1+btLDS785zhKOMBrJaoOoL8KKVcS4b/C0="
}, {
    "num_cand": "U2FsdGVkX18903+7QRTBL2wZ04j6CVpbO75ObDs7IbY=",
    "cpf": "U2FsdGVkX18g9Cy7daWa1kDfkseZfRDo5eW39K7hGKY="
}, {
    "num_cand": "U2FsdGVkX1+zx3djFYQVWEBbvVNzSsMYBiFKipKJTRk=",
    "cpf": "U2FsdGVkX19Yu101OrxSV7ieBfrRGtfZ6x+x3Vu8vP8="
}, {
    "num_cand": "U2FsdGVkX190jGxjVWw+a166VAMjAMhHHLyFOE1bI6I=",
    "cpf": "U2FsdGVkX1/Dc4zsjQIZljo0n5KPU5dijVFDrsvgrns="
}, {
    "num_cand": "U2FsdGVkX18qxv9OxEcKJk6Vddbk7PO2iU+Sh9M2r54=",
    "cpf": "U2FsdGVkX1+0PHFm7sxlszSzH/WeGTvQN/L6ycvxc7E="
}, {
    "num_cand": "U2FsdGVkX1+PMJ36NlGhpZdnTq3YV2E5ATVSbrpKbKo=",
    "cpf": "U2FsdGVkX18jgHOrz35RPCHShyLc/1DPzwvB5BOA08o="
}, {
    "num_cand": "U2FsdGVkX19BVzfH3GpqXuKQtoPMK+DaXzVLR6R0txw=",
    "cpf": "U2FsdGVkX19yzWch9jquSmEo+ouzN9Oamrgtmn0y2mA="
}, {
    "num_cand": "U2FsdGVkX1/IG9VdJUcBMAa20goyT6is/pHvB85K0KM=",
    "cpf": "U2FsdGVkX18jc+yIGjkaRTMGpbDNXTL4ondSDuSXmh4="
}, {
    "num_cand": "U2FsdGVkX1/l4sOpbynr/eEV+kMwneLRsgmO8CnxSkI=",
    "cpf": "U2FsdGVkX1/jQ3YWEiAK52uvNas/y4Nd7VrNZoIte0M="
}, {
    "num_cand": "U2FsdGVkX19k/EzLmArwS205DSJagnmiQMNlXyglTIU=",
    "cpf": "U2FsdGVkX19OMZB80/MxQmdGD8bpVHIrYTBJyo2RjPw="
}, {
    "num_cand": "U2FsdGVkX1/dZy8bb9u05HLeQKrYME+/y7s7FMqRLbg=",
    "cpf": "U2FsdGVkX18RuSbbPGEwZb6OOWFHqpTzoyIYAXCyyjI="
}, {
    "num_cand": "U2FsdGVkX1/nEPyJe3WBLm2MbWYCqMeC4DN4QqjvtSM=",
    "cpf": "U2FsdGVkX18W3DJEUO562k2GrLAeLuL5xz1lh0xsN5U="
}, {
    "num_cand": "U2FsdGVkX19wHJrVYrJubACFRfMEfe89+J3gQbbJJvQ=",
    "cpf": "U2FsdGVkX1+QxhuEmsntFd50qm5KZ+6yWbdGQV6WW4U="
}, {
    "num_cand": "U2FsdGVkX18F/tQFjVdusl5Xu6Tnw3Tvl8oT0PasNyU=",
    "cpf": "U2FsdGVkX18domxgiZANCwHVJ0uTtTrXvhJVgCrPgaY="
}, {
    "num_cand": "U2FsdGVkX1+cSzl1EnaZAwRf0xOVRYc3KllaklonOBg=",
    "cpf": "U2FsdGVkX1+MTWCAec/jw+VL0JtutmEu3U4JWh4LAuI="
}, {
    "num_cand": "U2FsdGVkX1+HhxCBGyyUifsyGR8sraPfD36m2CMjKsM=",
    "cpf": "U2FsdGVkX1+8sDU14Px9kXQ4w4kvn2QUNFeGaqy0qvE="
}, {
    "num_cand": "U2FsdGVkX1/MI+xQfnHKdp9Uxy3igDOWS2rQ5kae7Yk=",
    "cpf": "U2FsdGVkX1/ljK0TXfUiss/rOOOCD2JffzLnqcfMYYM="
}, {
    "num_cand": "U2FsdGVkX1/pCzK0vEH39ycdCgvdpeajz7Y6Zjtmkhw=",
    "cpf": "U2FsdGVkX19OP7yD07arNSXlWbvjNeeUAQRq6sfI1KQ="
}, {
    "num_cand": "U2FsdGVkX19XnvgDlGRo6N1KOUOfl7wSzB52wu1p9ks=",
    "cpf": "U2FsdGVkX18b+BEdFm/ISa5KcszK1/gPXPpWDgprcEY="
}, {
    "num_cand": "U2FsdGVkX19yeqcKuQlLXFiKqNkSEzg8Sm7kes5SZoQ=",
    "cpf": "U2FsdGVkX1+EW6PJhSAppnlGL74DhrHdK7WhC5JR/mc="
}, {
    "num_cand": "U2FsdGVkX18E8LYhWP6oOf/uNHW0xQdwmXDGBdsIa0M=",
    "cpf": "U2FsdGVkX1/B5bwyhvGHgR1eLX1mOS0nO8N5Z5gj3Kk="
}, {
    "num_cand": "U2FsdGVkX19kXvM1R336PqbW9sZ1EdA+tY3O18Cb9aw=",
    "cpf": "U2FsdGVkX1/JUepAglr5Rz2H3vN7ugWqnaJT2GXrRos="
}, {
    "num_cand": "U2FsdGVkX1+wZLQn691vAW1YSwKrvB3cxklhC69D+xU=",
    "cpf": "U2FsdGVkX18Umjb/y/aJ1hc8IO9lbMQR9aUUWYpwNE8="
}, {
    "num_cand": "U2FsdGVkX1/qHCV76hOWg6q5SW2CXgbVAZPzJ65/AHM=",
    "cpf": "U2FsdGVkX1+szQFujH7l70tdYrrq22AdSygPFJOr49s="
}, {
    "num_cand": "U2FsdGVkX1/kPftVSnfFTBK+JCEcPme0DyLYdpSCdek=",
    "cpf": "U2FsdGVkX1+IrcTY/CnLfM5FWW7M8erjKM2nt9nXlRQ="
}, {
    "num_cand": "U2FsdGVkX19F9UVWzujIq768Zxh0tjjL0IuL5eyT/wM=",
    "cpf": "U2FsdGVkX19C+pIiqLPETvVbql7gvfi4y5JXg8bHA4w="
}, {
    "num_cand": "U2FsdGVkX18+5OSR7x+2uVWjPScEYNYtAeeRmIYNvls=",
    "cpf": "U2FsdGVkX1/54p12rjdcuxiK2ugKa4JNlF/EsFZ6eCE="
}, {
    "num_cand": "U2FsdGVkX18WIeZCtIh3JQrkPWkRrNTVjPgc9f1+eoY=",
    "cpf": "U2FsdGVkX1+UTlbCUkUZ231jDXTq6FfEbdtIHlnP/74="
}, {
    "num_cand": "U2FsdGVkX1/Qrn0fnOCeRWkxVYVOg7pSO6WMg0WECV4=",
    "cpf": "U2FsdGVkX185frxz+ymhkd1TrpBwdkipxUuOZ1PX0w0="
}, {
    "num_cand": "U2FsdGVkX184X0An8DeVidNx/eFyMo7so5u7E009kd8=",
    "cpf": "U2FsdGVkX1/D/FmQVjBnm+eUFunEZTh1+k4cDsMZyz4="
}, {
    "num_cand": "U2FsdGVkX19uzQMBAPR0Pvk6x8kppnVQIg0U152+RTM=",
    "cpf": "U2FsdGVkX1/HiWxzYLhlI9UQbbHC9xs3aTxlZOMvDM8="
}, {
    "num_cand": "U2FsdGVkX19ERVyKTWzIZcRifntu1ZrgUg1nz6+f0MU=",
    "cpf": "U2FsdGVkX1+FVzclNVBg18bnEMz2lLe56v/8hh0KLWc="
}, {
    "num_cand": "U2FsdGVkX1/+UtvdOCrVuIo0D+xMDXXNAhNQhkJiSJI=",
    "cpf": "U2FsdGVkX19qUGzcKmHJZEaX3MPsPMoN6liKXRV2m30="
}, {
    "num_cand": "U2FsdGVkX1/wArGWxLSTbe2kXUQDTwjzMX8x9gJ4RjY=",
    "cpf": "U2FsdGVkX1/YrRBJZB8BTLXTuFVl6Vu3W582OlLYCTQ="
}, {
    "num_cand": "U2FsdGVkX1/1zwP21bFxB68+D3KjIuy8rXz2if/pIPY=",
    "cpf": "U2FsdGVkX1/bucmO+cj6HPaYvyTT+ihfNGAgBK04IE4="
}, {
    "num_cand": "U2FsdGVkX1/siyWqWBsl0W6yGMMlVVdk5OKmjfBQgmI=",
    "cpf": "U2FsdGVkX18z8YSGuIrD0hjfUGw/kF0URwrQvip58jE="
}, {
    "num_cand": "U2FsdGVkX18aDa7OdXQ4mowlCfd2ank90qPJ1KYZNr0=",
    "cpf": "U2FsdGVkX1/v7XLCBu1MxOn65NVikY/nhuPuI0wOjRw="
}, {
    "num_cand": "U2FsdGVkX1+oaJRSeaGTcK1bg8lB/pG3TYrVtfRozN4=",
    "cpf": "U2FsdGVkX1+hNQAoeWbj7SWusM3Q4Cn8RpxrBbpqFjQ="
}, {
    "num_cand": "U2FsdGVkX19EvIzxMBbgAhwmD6qizrMcxGcd2xCcvhk=",
    "cpf": "U2FsdGVkX18JHtjMNyHi9A3Dq0Rp1ziLer4Dvbw6gpY="
}, {
    "num_cand": "U2FsdGVkX1+FOs8+DEfhFJRvdWoshsuwFnRtkfvbzIg=",
    "cpf": "U2FsdGVkX1+rQpcVPhPIR69J3lYX6J8kP0bAMrd7Ebo="
}, {
    "num_cand": "U2FsdGVkX18G6o6rHNSklNioqG+9WlJJJGpsWdgsIe0=",
    "cpf": "U2FsdGVkX1+skXTqf/vCBcyoPD/gvBHedKp9gRPkNhc="
}, {
    "num_cand": "U2FsdGVkX1+Ew5I7BI0yvvZtK4MZkcUxTK3Vs0v/q/I=",
    "cpf": "U2FsdGVkX18T5lD96noGobBp7L12/nKN8vZA1wUSpd4="
}, {
    "num_cand": "U2FsdGVkX19Rn67/YL+SGZzMDWjtaw0erMJqT/E9N/Q=",
    "cpf": "U2FsdGVkX18ghaNpeq9YLKxZhwj1flVFr0K/0WxOCXI="
}, {
    "num_cand": "U2FsdGVkX1/Rio6seH2m7tYws2P3SOuBQJZ2KrWGLYA=",
    "cpf": "U2FsdGVkX19ABsmXcO5vPbbhIdZIvxaQvt9hMd8r5U0="
}, {
    "num_cand": "U2FsdGVkX19ww1duuWh7XfgB0ncHGy1iTyk53mBcWK4=",
    "cpf": "U2FsdGVkX1/pwyHOJEH7WqtnWMD2LPhbRC5VMiWjjws="
}, {
    "num_cand": "U2FsdGVkX18LPp7ZmB8W1IsIxklybPH4ZSZrew3di2U=",
    "cpf": "U2FsdGVkX18O09FfvgZ5SUCypHx8smPYky7n9acq+Ag="
}, {
    "num_cand": "U2FsdGVkX18qEE/alI8iT/ZK6g385tnpuWzhfzjEcPg=",
    "cpf": "U2FsdGVkX1+EBwgSRUJSqksU84qnXssyfNYk9NzvGj0="
}, {
    "num_cand": "U2FsdGVkX1/stKXOL27VV4fioyjIxHiHCnam2IEgKJc=",
    "cpf": "U2FsdGVkX1/nHHagcTzhVDVaEtuaGfTDL6M/pn5g+qw="
}, {
    "num_cand": "U2FsdGVkX19ZRnVjsmQyM6UvtUXjl9bH2qLxSGFlf10=",
    "cpf": "U2FsdGVkX1/NqluaRYjmaU8Ve08aLBWRaXIEpfe+Ih0="
}, {
    "num_cand": "U2FsdGVkX18/s2A35HnyOp1V9Yq6/TFZ7N4h5RKNez8=",
    "cpf": "U2FsdGVkX19YaTd1RnCd7nQw9lLalfDkKj89tJ6R+mI="
}, {
    "num_cand": "U2FsdGVkX1/ssYFojpF2JI6YjgxbGQwuYLT+OKJnqIQ=",
    "cpf": "U2FsdGVkX1+UG4famtbvMFu6x5KdHFRPk2rwBPWKSoo="
}, {
    "num_cand": "U2FsdGVkX18VDgpGhUm6oHrCuxKIBBgoclsA3pRMGpI=",
    "cpf": "U2FsdGVkX18tOQmStEIqDzhmdy/eTps9IRBcOFfDUqU="
}, {
    "num_cand": "U2FsdGVkX1/rePxfVzrwNEKlgF87DEAL6RMkQZXBetg=",
    "cpf": "U2FsdGVkX1/eOhICydiFuQqY4tJ2mSZVLlnGr9UGjS8="
}, {
    "num_cand": "U2FsdGVkX1+Z0cuhlm1ysXe5vrjPQYNMvc9/41xLr2k=",
    "cpf": "U2FsdGVkX185OwnbY7BvMgVhssgiXzzoHD2Cc04ayBU="
}, {
    "num_cand": "U2FsdGVkX1/hVOhj3YrhpG0FiLcaBHw8qpB1Nl46pnA=",
    "cpf": "U2FsdGVkX1+L7zRBMR6xnPmFe7UCW9JVicAY1ddQwmg="
}, {
    "num_cand": "U2FsdGVkX1+3Lki8BVnQgIlrfgCXpZisMIFerIK2hko=",
    "cpf": "U2FsdGVkX1/C4BsqyItgvOpTizRPUcU4ePxHgAbV7Kg="
}, {
    "num_cand": "U2FsdGVkX1/KWB4P88n95LfK3ZZSOIRzSSSp/W6K8qE=",
    "cpf": "U2FsdGVkX1/rUbpBKps+vQSjbDKPFJJrWs9E1yIjdNo="
}, {
    "num_cand": "U2FsdGVkX18vxv937tgydxCzEtwNwq9wgX9HlIXZKXs=",
    "cpf": "U2FsdGVkX1/GpK9u+7KjtcaVzqKckRb0r+BBdR85y2k="
}, {
    "num_cand": "U2FsdGVkX19JPbIcpSSdPh0oXmtMIzCV/OdsDO1T310=",
    "cpf": "U2FsdGVkX1+aLkoCyQRRIjF+u04JI6gXrg1VfFKklq8="
}, {
    "num_cand": "U2FsdGVkX1/kAM7zgYgjsto8ICTriU8U5Vkhgagq720=",
    "cpf": "U2FsdGVkX1+cu6tQwAdEMGaiibcdAr/G6JQj/rlqDwA="
}, {
    "num_cand": "U2FsdGVkX19y1EYosHxFSHq8EManHcVLcl/jo0See8Q=",
    "cpf": "U2FsdGVkX1+kuZ5Gi7ilc8PFbd0qXqOtu/MHYyWyYB8="
}, {
    "num_cand": "U2FsdGVkX1+c8kJuG46+JNh+hoIaS2pPDoVLSw6xKcY=",
    "cpf": "U2FsdGVkX1+TIMyFbWntC5M3Vf9TeDjqQ3kkVFerd+Y="
}, {
    "num_cand": "U2FsdGVkX18MmAiB0gtZqY9Ycy96E0UB0/FLm0UG8d4=",
    "cpf": "U2FsdGVkX19ksPt35vtKA/WX8+1iUcB4NWDxG0S+4K4="
}, {
    "num_cand": "U2FsdGVkX1/weG7xfYStt7Z5YCJ/zBIFgzo25nmlrc8=",
    "cpf": "U2FsdGVkX184Y5Afr/yyw/TuWR6/Qh2cML/hHLlzPuM="
}, {
    "num_cand": "U2FsdGVkX19w1q1b+9eY4SnnlJuUHUP693rflViYma4=",
    "cpf": "U2FsdGVkX1/7eEhD3I1AoZqp2VnlNldrgnNyI9Y2ZGk="
}, {
    "num_cand": "U2FsdGVkX1/LH1ISnrrMovYW+o4EPmS8rmHIV0zapxw=",
    "cpf": "U2FsdGVkX181bRZotsnm2W5sT/EB58xSlPrObH+rmrk="
}, {
    "num_cand": "U2FsdGVkX18rCc7TJUIIEqfg2NudCx5uFdXJta2iVUc=",
    "cpf": "U2FsdGVkX19q54uoN5dosA1oO2JTqjhwkAvYYKUxVGg="
}, {
    "num_cand": "U2FsdGVkX18i7t3PuAhfLh/44LkgnHtoEaTZ4AkSkVc=",
    "cpf": "U2FsdGVkX19LMPOb0KynivPaZNAWiKUNH6pvQsyOl9Y="
}, {
    "num_cand": "U2FsdGVkX190+8zeDeqneVOae4Wdcau4vd3CHFNUcJA=",
    "cpf": "U2FsdGVkX193bmHHldK4ylIMnP8dRx1IByiBoMut3tQ="
}, {
    "num_cand": "U2FsdGVkX1/YeYSCHYfJl2JXnVuqtiR/SjD0lcUBlUg=",
    "cpf": "U2FsdGVkX1/nBOlmrdi31n36SDo3bCZYPHZ+3FNr3ew="
}, {
    "num_cand": "U2FsdGVkX18i3h4HPlKeZ1oH+dEKuG7kNMBkPb9yEUM=",
    "cpf": "U2FsdGVkX1+m1EqHwW0KtHt3leJiLhFymh4n4cD/NPI="
}, {
    "num_cand": "U2FsdGVkX1+WD9v6H5vFobqSm8SpOwJT1UHBCyzydiM=",
    "cpf": "U2FsdGVkX1+N3Mt4xwzNrkU9YhJhM0eXvLV0NzbMQXU="
}, {
    "num_cand": "U2FsdGVkX19yiFXDvf/L0JkLo1tOjcqfEXMyViRcS9M=",
    "cpf": "U2FsdGVkX1/IRf/425X68NUBDW6JkihVMTYhWRyRhgw="
}, {
    "num_cand": "U2FsdGVkX1+zR6dFZKuiAryIm7AiNrii+5qSxmQkgXQ=",
    "cpf": "U2FsdGVkX1/knUVlNnTU/+9e9NXvaiZF68GBqOtQiYA="
}, {
    "num_cand": "U2FsdGVkX1/4G1NDn9eTVBhAOSKODhOPmlQTEuGeu5Q=",
    "cpf": "U2FsdGVkX1+YlrfQ8GuBFq9hjGndUs+RklpCd6Y1z7g="
}, {
    "num_cand": "U2FsdGVkX18YpWWKsy8+YbYBTwACL7yI8AV2i5rty58=",
    "cpf": "U2FsdGVkX192KDMFUKfGTDhan6yKkJ2KTtYyh2S4Wk8="
}, {
    "num_cand": "U2FsdGVkX1+hwdBCcKYKuGc93UxrsTFmNe3kDD6A90U=",
    "cpf": "U2FsdGVkX19BGdV5vb9rsQEbIyMHfkHrjwzOrGIuBZU="
}, {
    "num_cand": "U2FsdGVkX18Hr0REBpAH64SnHVOFyGuS7ZRI+NG4JEo=",
    "cpf": "U2FsdGVkX18Xc6JNKdTrT/acnGIZfT3GcnHqSFFu/wU="
}, {
    "num_cand": "U2FsdGVkX1/c+kj2IWM5LI+lgOC7fOU8LjvprH5TpIs=",
    "cpf": "U2FsdGVkX1/uSZOfB0HPMKuBbd8Eo8CkIuJEuNzDNL0="
}, {
    "num_cand": "U2FsdGVkX18xl9OLfSmxLdF/x5TTJu9zLsvQR+ijX+o=",
    "cpf": "U2FsdGVkX1+PBIl18qOHHHoJQ536WzxB+OZ6oDKH5II="
}, {
    "num_cand": "U2FsdGVkX1/cxoVBIF4EiBhWSFhjZ9woZvdtj7FReQg=",
    "cpf": "U2FsdGVkX1+DAw0gurmVIvdy+bBjMjKncOF4Kmw9sRw="
}, {
    "num_cand": "U2FsdGVkX1+9uIGt7HIKMuyVOJ09tzkFf2RhrhLD6j4=",
    "cpf": "U2FsdGVkX1/AACQ125H8jAAgINFZRYJsT3L/a+Oc0d0="
}, {
    "num_cand": "U2FsdGVkX1+0Pi8P4X4Ff/bzHOmgBdeCsl/rHvHM1bM=",
    "cpf": "U2FsdGVkX1/mVYcfYMdaAViuwH4/uhrz5UnMomcjudM="
}, {
    "num_cand": "U2FsdGVkX1/dmjsfJyaHvwXdFlxFZrFsK1tmH/Zv7gU=",
    "cpf": "U2FsdGVkX18ML3C3FTa47G3Q/B0N3jJi7/Q2G655eXM="
}, {
    "num_cand": "U2FsdGVkX196A4VKfQclGgHYcIA1n6wqgEnx30JPBi8=",
    "cpf": "U2FsdGVkX19VajX91TGkeGMocLFy+f5Mj1oYQuR+POE="
}, {
    "num_cand": "U2FsdGVkX1/toHyNeGVdPCAjssMZ55r8M0Mz73rTBM0=",
    "cpf": "U2FsdGVkX18TgyCOh8r/pAL4ZMSF9R1fsiIdjJ/iXjA="
}, {
    "num_cand": "U2FsdGVkX1+k+JpGE+14b3p+0hFrjalB3KLizVpzOA0=",
    "cpf": "U2FsdGVkX1+A4/H/rcU1NHt5hbh/ohwF7tdGxv1p7Q8="
}, {
    "num_cand": "U2FsdGVkX1/BILzBje7+HbMyvCNbBwyTVqCV++ARAnE=",
    "cpf": "U2FsdGVkX18ari8ZOOLkbustP175caIbSIs+Y6oogN0="
}, {
    "num_cand": "U2FsdGVkX18R+Mh8GXJENzYWkx226vDU3a0Bvo7G+8g=",
    "cpf": "U2FsdGVkX1/RGLrdEk3xNqMrcZTqWnNm/b2SFZW9gy0="
}, {
    "num_cand": "U2FsdGVkX19w7eW0NbvfiekYCFzJfO6XqrL/L5f8kzo=",
    "cpf": "U2FsdGVkX1+kJ9fpS20hQtRxKnTOSzVBzBGxorF7ZQ4="
}, {
    "num_cand": "U2FsdGVkX19wZ8Qn2Zfd8ni60Fu1JsZtcK8CGeyNRa4=",
    "cpf": "U2FsdGVkX19QNSzd4ZTO2NtNlmcmrrjtTFr7HRAeNIE="
}, {
    "num_cand": "U2FsdGVkX18HiccYEuH16N0XHDNTdSKeMF8wEG3+maQ=",
    "cpf": "U2FsdGVkX18hn1SqL4M7AaliOvvaghaqaE8wvfG/S/s="
}, {
    "num_cand": "U2FsdGVkX1/plMx4gwHTRvUJZ0VXjKcPAsCc79Yi9lU=",
    "cpf": "U2FsdGVkX1+IdRiWsAt+OIcA58Yp5kPTYpFsCsA4Dz0="
}, {
    "num_cand": "U2FsdGVkX19mQAnnr5vW6XCdJTPqqHTXnAdYP/Ha3E4=",
    "cpf": "U2FsdGVkX18x/3jK+9fAjW+UlE+17P3sxxpZYaoXxTw="
}, {
    "num_cand": "U2FsdGVkX1+O5Nfjrp+QPTfk+vK9hr+wYb5Lfku/XKs=",
    "cpf": "U2FsdGVkX19Xhm90QNrC6ipVFaEAl5brm3roymp5L6U="
}, {
    "num_cand": "U2FsdGVkX1/AMyE5eJMXHU1pQA14J9ynSYt6IfE+eEQ=",
    "cpf": "U2FsdGVkX18AygFvNM+jtvY55vCrozj3d/pcHSVPGrA="
}, {
    "num_cand": "U2FsdGVkX1/SbRnlBxJrZGVTEgTai5ODSrXDy20YI04=",
    "cpf": "U2FsdGVkX1/5YiPi+tsML8pSGkMMN58Oey2YqoEyNFM="
}, {
    "num_cand": "U2FsdGVkX1/Df22CiZcsNlokckp84HQIjejtvRcVr90=",
    "cpf": "U2FsdGVkX1/tLZUyS4JFh/s2u1QwRU9bbAfH0w7jVGs="
}, {
    "num_cand": "U2FsdGVkX1/5MyOYsYXMm2+PV8Pxmpb2mwNKtpJ/eRs=",
    "cpf": "U2FsdGVkX1/M8mx/xYEvhMNiRQEdQB4rCaOuShboRyc="
}, {
    "num_cand": "U2FsdGVkX18oNkaZpo+CJI1EXCW50ql6tHaJ8B0arHI=",
    "cpf": "U2FsdGVkX1/LsLfWP2lavyGW0a19fuXK3HIvtP3aDzA="
}, {
    "num_cand": "U2FsdGVkX1+6TjCX9oGLtbpjv5QVOGNH2e7Ze+DMcwg=",
    "cpf": "U2FsdGVkX19TTceTqHQtqxR6vfX2+pgZ6LsuqCiCIxU="
}, {
    "num_cand": "U2FsdGVkX1+JS5a/DIrvN/F9Bs+pieEtg4JgBerosL4=",
    "cpf": "U2FsdGVkX1825dJOKahDhN9dzj7FP+pqs/kxazdXPN8="
}, {
    "num_cand": "U2FsdGVkX1952Q8hsGnT+RHZT2fjow7wQBmFpVffZoE=",
    "cpf": "U2FsdGVkX19gGZIjARy+k2B3QCRRnXiOqYvPpVHktzU="
}, {
    "num_cand": "U2FsdGVkX1/xlD4Kf1eVNphjF4Z2cCvS8ozu+V8IxTc=",
    "cpf": "U2FsdGVkX18tZqNShV7hPuPPT7X7IRrKZd2Iv909+O0="
}, {
    "num_cand": "U2FsdGVkX18gwdAIRj90CcADotnEQZHCgRJLF+k+C3g=",
    "cpf": "U2FsdGVkX1+hc4hvwzaoxPcz0lDmzqMlLQC3MhBbUhk="
}, {
    "num_cand": "U2FsdGVkX1/auTpiFzeVOmo7gVPG3bChzAi/s+Seeq8=",
    "cpf": "U2FsdGVkX19nbUdgIgaTQC1Apdqfc3h1Svb/OBYRV4Y="
}, {
    "num_cand": "U2FsdGVkX1+iTthotU8jxHeu6SqGyiI5KhZOIY5BJLM=",
    "cpf": "U2FsdGVkX1/+r5R+WyGnBn6WqLKNfM4YzWaI19TfOu0="
}, {
    "num_cand": "U2FsdGVkX1+5Z6TkOjbw7BolhI83DH6QdEb0ElU4Uck=",
    "cpf": "U2FsdGVkX19lDrVgTIa9wsybhb/oxc4H5ivM5TyE22E="
}, {
    "num_cand": "U2FsdGVkX1+w4PzPz5sNIdqEbNauXadN5DQ6RM+sTLk=",
    "cpf": "U2FsdGVkX1+zju+rMS/nOibf+WKyXlskcJEAzBGHs9s="
}, {
    "num_cand": "U2FsdGVkX1+0HQHKS3/RSiJ2/NBrQ8r0UAVXE2k7puM=",
    "cpf": "U2FsdGVkX19bCbKwSQKrNwGnoT3C8Nf2VDeZVpu+Qd4="
}, {
    "num_cand": "U2FsdGVkX196+fxkv9ZUXiGuonQLub1EktgcRO46kMs=",
    "cpf": "U2FsdGVkX18R3iQ2iRtbp8pt/uTWvWvY6uOMa3xzSNI="
}, {
    "num_cand": "U2FsdGVkX1+i4MaEDznpy2RTunBN0ZMizhIJiivFNo8=",
    "cpf": "U2FsdGVkX1/rjfPXBdUw5NxrgRkozrkFHhMJCx1C1T0="
}, {
    "num_cand": "U2FsdGVkX18Sk7dYjbLw9bdrwRczrO74J/NSjAsF+kQ=",
    "cpf": "U2FsdGVkX18gn4S+dqmpDlgjZ3YnpujbLiG7K4Q2yNw="
}, {
    "num_cand": "U2FsdGVkX1+zhfDQReW11jEymyTbHUjK8cRH0+1IkG8=",
    "cpf": "U2FsdGVkX18YzrBy0wKKUGUVT3SHVmHEo1CsXXN5Xfw="
}, {
    "num_cand": "U2FsdGVkX1/g8/u0ndzrXnzJinbiu4vzKNrnwlSgPQs=",
    "cpf": "U2FsdGVkX1+1aIhJoulxRcC3OjPz7ZHRAR2xNnZ0V4k="
}, {
    "num_cand": "U2FsdGVkX18ivrHHeMYFh7qyHubdkw1s1UApaPHKE18=",
    "cpf": "U2FsdGVkX19LNrqNUaEVvLr7UDrwDsG4GamF6HRzQLU="
}, {
    "num_cand": "U2FsdGVkX181eDyomH4h9ssiUf/BthTqMUq1yFTb/wk=",
    "cpf": "U2FsdGVkX1/QhQhY5ezMggXdtoIoretk+vGYxYCD+zU="
}, {
    "num_cand": "U2FsdGVkX1/A5RUcc5ymLxE9XO+yXGe80VhBgHIIq7w=",
    "cpf": "U2FsdGVkX185q8wz9lyme+nAWCBlRNEj+ptfCdJmx9g="
}, {
    "num_cand": "U2FsdGVkX1/serfkyNC9lOkvQhpR4tMlKQ0EEUfL5zk=",
    "cpf": "U2FsdGVkX1/W0VkNLd6knn5WOVD8J/4LgjGoto2GVe8="
}, {
    "num_cand": "U2FsdGVkX1/ecXZ+DNPqL+tVAPZwHVpqzh46JihcctI=",
    "cpf": "U2FsdGVkX18G2LN2fvhkeiyxtfjNIVyX0aFMWZ6FPjQ="
}, {
    "num_cand": "U2FsdGVkX1/htPq7sMIy0tElERj7WU4vHpqLlrLSNWE=",
    "cpf": "U2FsdGVkX18EyadJ6fGeJCdbPKYuVfv+v36+LgNvDGY="
}, {
    "num_cand": "U2FsdGVkX18HkYxsP36TxmgNAMs9JNCax8fZeQqHnIY=",
    "cpf": "U2FsdGVkX1++PD23gGZPCBK9mLHZBo/03UE48/ed/Lk="
}, {
    "num_cand": "U2FsdGVkX19v1BLY9SYIAUh+5b3Qbtma8Vi+f672MZw=",
    "cpf": "U2FsdGVkX19N+PFg8QBx/aUDvxseefi8jJRWI722Brg="
}, {
    "num_cand": "U2FsdGVkX18FBbYAjpgX61wlewFM0lcPHhh9tBWDMuM=",
    "cpf": "U2FsdGVkX1/IT9J6snmHzwij1Z/2VXBJlNSERq5UP84="
}, {
    "num_cand": "U2FsdGVkX1/EHz1aNI0YbCiH9b9iK9B2hu834f9QzVg=",
    "cpf": "U2FsdGVkX189HysQKk2C+B3RLM/NPRCdhZzP2DhdYQM="
}, {
    "num_cand": "U2FsdGVkX18lcywAxUUm6x46rKvMhu7LwJANr//gkEI=",
    "cpf": "U2FsdGVkX1/leXQrbvKmYeYRz3N2C+sN4rFqLdjTjps="
}, {
    "num_cand": "U2FsdGVkX19J6PRiTyLU4uLOG6AjSAFWONoxpoyzJG0=",
    "cpf": "U2FsdGVkX1/WxMyHlJLdivSZsT/WI5qDxtbXVRch2po="
}, {
    "num_cand": "U2FsdGVkX18ZNCfJs8N8gdYGT1/11vN4BAIWaj/mNbM=",
    "cpf": "U2FsdGVkX191Zx24XKXQDIAjxS6u44UojEtnQWUyS+k="
}, {
    "num_cand": "U2FsdGVkX180TD9Gv8cTKTt/Fk+/faXO63sO5vcuUVw=",
    "cpf": "U2FsdGVkX1/3W6hPElgSqfRLp8KpDwOMkHl6A+543SY="
}, {
    "num_cand": "U2FsdGVkX18mT6t9h/ijZaAu485v76YWGPA7Gmz0xb0=",
    "cpf": "U2FsdGVkX19N91RYgtAE225aauvCuxi8boyDGp5MmSQ="
}, {
    "num_cand": "U2FsdGVkX1990L5Y9ldqbL+N/yWf856C308vPIFBEds=",
    "cpf": "U2FsdGVkX19Augz8pC0WmP7WqC5ryVTOJtmDCy0gKdQ="
}, {
    "num_cand": "U2FsdGVkX18I9WF8hvRUvfnl6oeidx7xXs2G8IGmiNc=",
    "cpf": "U2FsdGVkX1/z1d0P93JpqOY9SE1pfRS95tQjRDy3wbw="
}, {
    "num_cand": "U2FsdGVkX19HswV1kqqNQ1+UEc+0QmFVxtj7T3yP3Wc=",
    "cpf": "U2FsdGVkX1+QC7QqmAdGaZeVQ9QAPub+k9M7baL+QZk="
}, {
    "num_cand": "U2FsdGVkX1/W14pAgPu5j0XlRC7DFYtp4G0i1pfTWE8=",
    "cpf": "U2FsdGVkX1/Hfs87qXoSoO+UW0Z+QrjdK4KJ8+Mb0fo="
}, {
    "num_cand": "U2FsdGVkX1+vbvjUL+lQdPrmwy8OFxjd940FQH7BIA8=",
    "cpf": "U2FsdGVkX1+hCTssSBuUI7k+KlsOSIAHw8IK+TAtuLY="
}, {
    "num_cand": "U2FsdGVkX1+kRAZKom6542ThOKAmyQ+Fh9IC5/Wqmg0=",
    "cpf": "U2FsdGVkX18U8FJr00N6rF18aoJj4FN8IkFWEbPhmWQ="
}, {
    "num_cand": "U2FsdGVkX1+/VRgfU3/iLnV5A8bfWF/EYxci+Jt4LC4=",
    "cpf": "U2FsdGVkX1/s3ASG3o2D6DzVeJcSrHvF3bwNkCXvGSg="
}, {
    "num_cand": "U2FsdGVkX1+wPN5k958CYo6ZPvOIvhbQsmyfSyx4Or0=",
    "cpf": "U2FsdGVkX19qRp4hrx8yKIDzRqqbuudskwMF/W+zGjQ="
}, {
    "num_cand": "U2FsdGVkX18FVk8WjoVeH8RvVZl/q/eS9aLNs5G1nNY=",
    "cpf": "U2FsdGVkX1/B3u/k8iEDGf6owlDbXb6JMpX4daQolY0="
}, {
    "num_cand": "U2FsdGVkX19aFwplNlP9EIYSvA1OU5MEqYARYiNfoBE=",
    "cpf": "U2FsdGVkX18l9X2YTsVAXoro4EqmXQvAvA8hEIeCdfU="
}, {
    "num_cand": "U2FsdGVkX19cIcUDkaY1Be0SVEP4FP6ZusDdYtlCWBE=",
    "cpf": "U2FsdGVkX1/au76gyT87ZMtU7pl3kO+AhCF4jcDSfmA="
}, {
    "num_cand": "U2FsdGVkX193dYLYTEp3io2ZZeJE5aNS+n52QlbqM9U=",
    "cpf": "U2FsdGVkX1/cISO3Nymgc/2rTOdhhofCaSvUQOWWq6I="
}, {
    "num_cand": "U2FsdGVkX1+0/c2GHYZeGsQqjU9GhcIL91Dd/kst8i8=",
    "cpf": "U2FsdGVkX19mehdIbwkYPrfRDXCUR0GogstbKulmc1s="
}, {
    "num_cand": "U2FsdGVkX1/JgGczYW1Safe6AWOO1L/cjsH99nPjGig=",
    "cpf": "U2FsdGVkX18KQauio27uFr5uDLCJUGNI4PK0G2lS8uQ="
}, {
    "num_cand": "U2FsdGVkX18LbmcGM52iIUnnj7AZK7tIia9K+mjTSHo=",
    "cpf": "U2FsdGVkX188N0j2R4+WCr4HkpdkYncQMx10hqSOyag="
}, {
    "num_cand": "U2FsdGVkX1898yYGduSUN3J+3n29aX/a5MMbt9nKblc=",
    "cpf": "U2FsdGVkX1+rAyh67n9Eh10vzEY10PyTHx3OxCMLuHw="
}, {
    "num_cand": "U2FsdGVkX1+dZVT29qK+4Z9x86ptHuRa3s1zbQweVrQ=",
    "cpf": "U2FsdGVkX1+7dqZQ6G9ZvJ86hAxQ/LWsKM5tjwgTotQ="
}, {
    "num_cand": "U2FsdGVkX18TJ5VSFIcpdZFFPrZ4InrlVR1/9ktibqM=",
    "cpf": "U2FsdGVkX18GSHt0Ud4JWPi9vEtoXHYMZ/Pr/kfeijU="
}, {
    "num_cand": "U2FsdGVkX18OTkbIsKT8j4SNwaXpalVSa1tuWYaxgHM=",
    "cpf": "U2FsdGVkX1/JNSdx8Y2GoDAjVaGJuJjuGmAF3AiL8LU="
}, {
    "num_cand": "U2FsdGVkX1+pUcPy3/NeH+0dIj6mYpV1n1QBUV52FTg=",
    "cpf": "U2FsdGVkX1+0FnyNvWlcWGoea6DTvA6reD+yqPGI+og="
}, {
    "num_cand": "U2FsdGVkX18iz9e+L6mr4sbzDskcCGqR3pFIRoGuhgU=",
    "cpf": "U2FsdGVkX1+sriLtlEbUREie4eQIpsql+EnBcM7Rajw="
}, {
    "num_cand": "U2FsdGVkX1+v7fKcE12hJqeqAijmWB3LMNu9s5pKApA=",
    "cpf": "U2FsdGVkX18JTO9C8+iV8o7022VPI0MIN/PaxQFAG18="
}, {
    "num_cand": "U2FsdGVkX1/6JhulwUNVTfYgytyUK9Qj03ySkMl7yng=",
    "cpf": "U2FsdGVkX1/O00OCn/A/c35Dc7/tvZ6Fv4thfYH7Fuk="
}, {
    "num_cand": "U2FsdGVkX18EQAZnSogknHcTniuAI3admr9PNREgGMo=",
    "cpf": "U2FsdGVkX1/HCcP6nnd10EvHtSK/YfN1/TdS3bykvdc="
}, {
    "num_cand": "U2FsdGVkX195/ltXLgGg+z+3PBXHyj3vkn5/738yku4=",
    "cpf": "U2FsdGVkX1+qhbcDA7oKIF9vaNMLOeEKTbMWO/ps51s="
}, {
    "num_cand": "U2FsdGVkX1/pblzXFGdC6ubtXkqbgd3qxEjxu3BNNZ8=",
    "cpf": "U2FsdGVkX19g/Qb8iizOd9oQ46LqlG84IR2cET0Q05s="
}, {
    "num_cand": "U2FsdGVkX1/QGbzrEQJlj4JzsceF717gI0aSYsft+Eg=",
    "cpf": "U2FsdGVkX18/o99z/0cK8g2drY+xRKIQLv+6oCnofc4="
}, {
    "num_cand": "U2FsdGVkX1/FwsW/9NI2wuQHdRMq1m5FglyA/KmBwnw=",
    "cpf": "U2FsdGVkX1+z/ixU2E5gc1mH88vjCMdghu9k52Shpno="
}, {
    "num_cand": "U2FsdGVkX1+y3DpUnAx0NRCoetgJQaKJ6+lNaQbM1SU=",
    "cpf": "U2FsdGVkX1+/Z8iLExMIUjE/hZ5aA6O+N4fDblQ3gsI="
}, {
    "num_cand": "U2FsdGVkX1+QkPH4tDty9TM5QV+uZZhQZbfDXuzHiAQ=",
    "cpf": "U2FsdGVkX18yFnu4FaBoZJ1d8ydTQzO3ocqoMtoKwh4="
}, {
    "num_cand": "U2FsdGVkX19X594d63+6vX9WsMeGcTvE9eQc1Okyn5U=",
    "cpf": "U2FsdGVkX19BrSep4gdWZ3JRTl3o3h1nq/mmIyvluAw="
}, {
    "num_cand": "U2FsdGVkX1/I6NnWvDmq7F2Q+kEnASmunzz+4wwEP6E=",
    "cpf": "U2FsdGVkX1/lmZzFCOoMxl0/wE0a6YMFxFyJOo+SxL4="
}, {
    "num_cand": "U2FsdGVkX1/Dukom6IorzamW4fAiHVqK+KlO88Vfu98=",
    "cpf": "U2FsdGVkX1/cE7SdWa7PAjehPXK56+ZbiKEGb/RRMKU="
}, {
    "num_cand": "U2FsdGVkX1+DZuT5u7/7VL1bDWeK9ZJ3etkalzlToUg=",
    "cpf": "U2FsdGVkX1+XYg0mtAcjtJhxoiuRzJTk7WSGq8lbK2U="
}, {
    "num_cand": "U2FsdGVkX1/7auPQQQV8DnoU5aAFL0IspPcIJpyEhQA=",
    "cpf": "U2FsdGVkX19v8za8N2wdqXrrHia/wuK1hgVPf1Nu3bw="
}, {
    "num_cand": "U2FsdGVkX1/jwAdoD772O4pYC648sb1MFVGJofJKNug=",
    "cpf": "U2FsdGVkX19mYN0HYNiZzITzonKu9h33oF+cEpPePX4="
}, {
    "num_cand": "U2FsdGVkX1+WLspFOh66ONh9HVqzSjt+P+WpOvlZdSk=",
    "cpf": "U2FsdGVkX1/HxWR0S6tTWQMyH7z36P8zLWfUvefW03k="
}, {
    "num_cand": "U2FsdGVkX18R9+BCu7cR5nwjc1hsEmpICJ4dHjCXEVo=",
    "cpf": "U2FsdGVkX1+wRTZhNCBl8qbMxx+8yioBwQC6U7AuMnc="
}, {
    "num_cand": "U2FsdGVkX19+J1Y4ZFFxjDSVXxd+L6sY33fDSJ8TtIU=",
    "cpf": "U2FsdGVkX1848NXJnJMkDqnM6Tc/ljQ7R1AQrNiOhuI="
}, {
    "num_cand": "U2FsdGVkX188vsRdm36AgSA4sC17eTQbdpQ2LLvVCHQ=",
    "cpf": "U2FsdGVkX19tgosw4X+josQK9owel2AU3EY77enRPs8="
}, {
    "num_cand": "U2FsdGVkX18OIFXpb6Mza+DJiOy3e8zoiPYAsXPx+2g=",
    "cpf": "U2FsdGVkX1/TisOcBXexIHFKuZVfQLEHF42QZ9x+kqQ="
}, {
    "num_cand": "U2FsdGVkX18qFdU9rcxU4rUNszL93DkQxnY3ZfnCOTE=",
    "cpf": "U2FsdGVkX1/n40KAoocPyT2vC4L1cDGN++WGyAwlxTI="
}, {
    "num_cand": "U2FsdGVkX19LJa+n9/oRiuzx8s+29N+qqCYjKBaehss=",
    "cpf": "U2FsdGVkX19LWgcJwO6BXQPwEomqD3IMDAvA/dL1+uw="
}, {
    "num_cand": "U2FsdGVkX19+QfZYAbHQ0GYbhJOWQbDk7dzCMP7Csis=",
    "cpf": "U2FsdGVkX18Suy83tRqAE0yLwRGTaO6Ch6V84ZicSH4="
}, {
    "num_cand": "U2FsdGVkX18QnwL53LavrgAG/JLBRiKleGY/U95Qafw=",
    "cpf": "U2FsdGVkX1/ImEwIcMtU5plA+h9D6l1r7B7Sqx7R5EA="
}, {
    "num_cand": "U2FsdGVkX18peQ6kPabXP8UClUQl9O16cPQarhm9peE=",
    "cpf": "U2FsdGVkX1+ohWat0oqDDy+7fpmAp51k0+iLmiSUJ6k="
}, {
    "num_cand": "U2FsdGVkX18deO4Zy4Fb5VJyfl/mvyJZfrBP8WP1SD0=",
    "cpf": "U2FsdGVkX19u2z2yjybSar8IRDkS+LD9b0kqSr3F6Tc="
}, {
    "num_cand": "U2FsdGVkX19heb4KEktuJjhJifWSFcHyZhC/I29nqmc=",
    "cpf": "U2FsdGVkX1/gFp74WKNp2QMENe5hL9lhAwIxuG9dlKc="
}, {
    "num_cand": "U2FsdGVkX1/ONq9n6BXd8YxaBSTZiqFEGAsG4RiFP2o=",
    "cpf": "U2FsdGVkX1+D9TzSMQE0CHgpqmjnd2JsG/1R7rjjGOw="
}, {
    "num_cand": "U2FsdGVkX1+XcdKn7k1AD7JDUqIqiKNYiyX6JM8rzLI=",
    "cpf": "U2FsdGVkX1/j5CI34Lf2Gb+D+mDCRJv/YtuLTdS9eJ0="
}, {
    "num_cand": "U2FsdGVkX1+a8kxEhjo6yIyxQcef3IVylQTRzGjfwC8=",
    "cpf": "U2FsdGVkX1+vMHrjeMzcH0u0ZEu3dQvCGUfT+afmNPg="
}, {
    "num_cand": "U2FsdGVkX1/C/yrMUHIKFM2MTGbvYI3M3iwc/t/kXR0=",
    "cpf": "U2FsdGVkX1+FCdEUidUnCzfY+SHpricI1LIiZ656y3o="
}, {
    "num_cand": "U2FsdGVkX1+2iJ8aCt88rSc+cO+ZRCSV5jy1d0ECBQk=",
    "cpf": "U2FsdGVkX19j0HUj6NeKLxSFoQuEgKB1ESEuOvTXAPA="
}, {
    "num_cand": "U2FsdGVkX1/wKSCY7unz2C8mLvgGmySg4kKwlEHzZN0=",
    "cpf": "U2FsdGVkX19RUKMVlR+EQoZWh0Af7H1R6/tO3UOfupE="
}, {
    "num_cand": "U2FsdGVkX1/caKVQ+TLS695bv1Gfaz/OhnSKFrek/iw=",
    "cpf": "U2FsdGVkX1+ZZmdZgieMkNzioRcrQpGtrpkawY4VPGQ="
}, {
    "num_cand": "U2FsdGVkX1+S8MRDDUgkAXn6REV4AQwqGy49u7vmX1Y=",
    "cpf": "U2FsdGVkX1/XmbSQjeI0qUlTnN0St+5T1kJIEvcXzGI="
}, {
    "num_cand": "U2FsdGVkX19ii6085fUgE95aXBUWygkyg+oVB2IuVhE=",
    "cpf": "U2FsdGVkX19nWJK/5/kK7lxqN+1MLc06u+TwE6U9A9Q="
}, {
    "num_cand": "U2FsdGVkX18bWytx5wIlh5fBelnYnKDiKLumKFJKbmg=",
    "cpf": "U2FsdGVkX1+p+meoNVT4s5VcYcwytwh1WdcgASdJFe0="
}, {
    "num_cand": "U2FsdGVkX1+hIajROmJvRmTV1QNItFOe+OmWslmmg8E=",
    "cpf": "U2FsdGVkX1//wBVzw/7fdryYyMGoq4kFRuwPPhBtv4Y="
}, {
    "num_cand": "U2FsdGVkX184U28GMOWsczIboQe5pfO8fUhNtAIxLXE=",
    "cpf": "U2FsdGVkX1+NFTr7TamPYv/LehxuOgOKs6SOjN5gj1w="
}, {
    "num_cand": "U2FsdGVkX19gjVKug6K3l6ztPi+uIPzLXPswq9hY368=",
    "cpf": "U2FsdGVkX1+RveXQ1BPNIwSmho37FlwyWWTdJ0AZpKY="
}, {
    "num_cand": "U2FsdGVkX18XXaTB7as3RLp4d2I8gZ/RJaX6kU1YaG4=",
    "cpf": "U2FsdGVkX183zTa/TAo1wg5uVXL+WBHxgRhIpWq4awU="
}, {
    "num_cand": "U2FsdGVkX18gB+1aCTQp6ZoEa+4+TQUG+vBGa3v9omw=",
    "cpf": "U2FsdGVkX1+h6qWussZuMKAp7nwmZGK/U9AulcqvsFo="
}, {
    "num_cand": "U2FsdGVkX18dHeWrR9H8wRTU3ibNLSAxMSvlaznAMNc=",
    "cpf": "U2FsdGVkX189uYDIlTpDba9N/ooCyM8sn6e9iDslFnI="
}, {
    "num_cand": "U2FsdGVkX19u+xSCq4PxrpWi/tWCczJpjO+eN5Jnd9E=",
    "cpf": "U2FsdGVkX1/wsKK5WHo5LghdRA7Y32MwPO26woYeYFA="
}, {
    "num_cand": "U2FsdGVkX1/mK2OwXeWlN8yHlZaYHF/+mb66mnEp90o=",
    "cpf": "U2FsdGVkX1/WkHvrEPYNNxt0epGY9DkU7JWhH37J6Yw="
}, {
    "num_cand": "U2FsdGVkX1+VWL4ctRvHm2fETzXVLYN6mf3BZHh3cV4=",
    "cpf": "U2FsdGVkX18uRDZTWwxukPEjks9tsx+DNOe0h/JWD+A="
}, {
    "num_cand": "U2FsdGVkX19nyg3UmxHR28pH3CnX+p9excy8usybTF0=",
    "cpf": "U2FsdGVkX1+HjblXQyqBd4XdvMu23/7lajAqBczAesI="
}, {
    "num_cand": "U2FsdGVkX1+I9IR56r9pBS3Tg9CxNXAnoe/B5beEQek=",
    "cpf": "U2FsdGVkX1+ijHt45l7rcF7yRypJIdTy8ONR/z99OvI="
}, {
    "num_cand": "U2FsdGVkX1+6mcEHYANJ1XUfN2w5R7TBOB3Nyqs2L5U=",
    "cpf": "U2FsdGVkX1/fuvp+skcoy7wz3xyxlW6cpk2bddlfnG8="
}, {
    "num_cand": "U2FsdGVkX19UyLJKe+KaDrDiibN6jcD/zWVYD//6CoM=",
    "cpf": "U2FsdGVkX1/bDv7PzWInhKXcpfWvrTyPmpRTy6YNazU="
}, {
    "num_cand": "U2FsdGVkX18n2w3zPn4Ml8zKjMP45gaevvLpgyKpbE8=",
    "cpf": "U2FsdGVkX1/kmLRkxWKjPu9NFHFOjYKYzVkcNcB4ujo="
}, {
    "num_cand": "U2FsdGVkX1+0sxWhxw0qGMzLBFwPIZngye5V9YF5EnI=",
    "cpf": "U2FsdGVkX1+cv7puJgx+sCaMabFh6F8wnisPriWN34A="
}, {
    "num_cand": "U2FsdGVkX185nM1hPW7Krjb8mAxRfwH2GeycOi2QjBA=",
    "cpf": "U2FsdGVkX1/SU3vxqIBGn0Y8HdIK8rtlPhaaw6MH23o="
}, {
    "num_cand": "U2FsdGVkX196/yMv6i/IWa/TuKY0n5x9eEJ6/pM7h6A=",
    "cpf": "U2FsdGVkX18BTkTAGxPiesszStEvlPkwwhBvUjJpvTw="
}, {
    "num_cand": "U2FsdGVkX19klvCf0w9jQzgYASYNAi5OHQ2YISkVEFU=",
    "cpf": "U2FsdGVkX1/C9NnkY+7wE56J63WbHbXK5AsoRBW/kNU="
}, {
    "num_cand": "U2FsdGVkX1+5G6OLTu6Loyi8mfwz1SJPx+1h3TwqqFY=",
    "cpf": "U2FsdGVkX1+8Uy+QfFLGKULVInO0GqskypNhev6DnFg="
}, {
    "num_cand": "U2FsdGVkX1/F8+jg+RWUJ/+vNyc25ixEBCJDJjKm5jU=",
    "cpf": "U2FsdGVkX18xSBzZDd3w7QL5QcEMDJDN6FhBeGjKCck="
}, {
    "num_cand": "U2FsdGVkX1+7oIGsmFMId7Nv6XCD+t84atkLnerFvxQ=",
    "cpf": "U2FsdGVkX19QBV3lEeqCizziYMub9bIQ1umMK4HBc2A="
}, {
    "num_cand": "U2FsdGVkX18LUDA/Bo6i2Od+xcJsjdGYlVKn//XDNxA=",
    "cpf": "U2FsdGVkX1/eV5M2I5pU+HwGZ2IZ2CEO0oS19oMDdF4="
}, {
    "num_cand": "U2FsdGVkX19IXz6SVFORIVRuYlr1ovzBzW5HEQnsbiQ=",
    "cpf": "U2FsdGVkX18NpIazatJDRPZV2v4s91ULXcRieOu7J0Q="
}, {
    "num_cand": "U2FsdGVkX1/aL4XjzuFJTCrIMQIPEg9SKZtDo0x9xvA=",
    "cpf": "U2FsdGVkX19TnGGvLhgr2+YyXy4Zao6Cp3bXge+6I4w="
}, {
    "num_cand": "U2FsdGVkX1+wtKShRxASoFvvqyMCxrAmo2wD74r52MY=",
    "cpf": "U2FsdGVkX187nIFjY6NUXoh57Dq+ecfMAPIZqEWbtWI="
}, {
    "num_cand": "U2FsdGVkX1/JE8UByfGXARuhBqqmT2jxb6QkPt8r9nw=",
    "cpf": "U2FsdGVkX1+m/SQzw+6UhltOIseOOMFXzeitbu8nJDY="
}, {
    "num_cand": "U2FsdGVkX1+4aLDIxF7ZAPZf+gOgHlYuGTe73Kc851U=",
    "cpf": "U2FsdGVkX18gVI7P1GryjF9hN9DG/DdIzJtTMMcCXBs="
}, {
    "num_cand": "U2FsdGVkX18/sf9RvawNmizb14NCinMH2JrDShuoxGg=",
    "cpf": "U2FsdGVkX191SojHw5z4+zM38ke09Oinnl98Hsy8+Xs="
}, {
    "num_cand": "U2FsdGVkX1+ZlhJSgze1r/FTCFsjYSC8ZtB8lfp9lwQ=",
    "cpf": "U2FsdGVkX1+DaV5Mxs/zuw8WYUsOugMxO1pZ6theITQ="
}, {
    "num_cand": "U2FsdGVkX1+shOhVNMpd/DDNmDHxEmRlyA8soGWuc/M=",
    "cpf": "U2FsdGVkX191tUl+RT9erskelfUNT2BcUCTcdaa8cUU="
}, {
    "num_cand": "U2FsdGVkX19mp0qQugtMoMo9kJOCl7AQjgd6Yl1bVt0=",
    "cpf": "U2FsdGVkX18zyHsBcVRAy0ETBtnG/MHbuHQBdd2W6oU="
}, {
    "num_cand": "U2FsdGVkX1+K/7193X416iEk1Wa70xaH9737tQ1qn6I=",
    "cpf": "U2FsdGVkX19ICncUAv1kWZ6v2seI2T0J4GiuggAiTVs="
}, {
    "num_cand": "U2FsdGVkX1+5xjDJHBYc3iQfWKEHNt9FAdYpnZ92TBw=",
    "cpf": "U2FsdGVkX18l37Uq8TYXL3/IG/axZ7GOzRzb/f14ZjE="
}, {
    "num_cand": "U2FsdGVkX18gUa0gGL9nuopKDKnGJQM8Wx/E8sTNR0w=",
    "cpf": "U2FsdGVkX18B5PezwaOxQQeFZ3Blw/96t/PKsYPNmmk="
}, {
    "num_cand": "U2FsdGVkX19vy/sImruWcEv57HxFfUcFTx7SY6oi0jg=",
    "cpf": "U2FsdGVkX19/ulqQ7vLzQU+tvvG5DRqEx48kYuG++xY="
}, {
    "num_cand": "U2FsdGVkX19C0G44f+P+/rUrJMUf6HS2zRmUoBo+PCI=",
    "cpf": "U2FsdGVkX1/bYMs477i4iAeDy4DZrIYAnkEQn8RO4F4="
}, {
    "num_cand": "U2FsdGVkX1+Cvaoz8CthDE59gcRxAOvbmh7WmGL/Kto=",
    "cpf": "U2FsdGVkX1+b1CS040UeKGsGJ0twdQ2Z/HAklq0L5hU="
}, {
    "num_cand": "U2FsdGVkX1/CuZ7bstLs1oxP5JFco6ZM8AEePr6xutc=",
    "cpf": "U2FsdGVkX18aqy/LdE1MvaRJvdM97azestFSYMA0KiU="
}, {
    "num_cand": "U2FsdGVkX18V/jmCGEno7OYi90QEQMyoOp8jrkHSug8=",
    "cpf": "U2FsdGVkX1/MxtzeU31vwc0CmuBPmgkGvhEkBtlw8y0="
}, {
    "num_cand": "U2FsdGVkX1/GVPTz/XZIEXKPldp/5GqEDUwhvUQyHik=",
    "cpf": "U2FsdGVkX18XY1qGFIYmhMqfB1GN2yigL2hWdoZlGcc="
}, {
    "num_cand": "U2FsdGVkX194XWqYoQwx6QBVfSWi+1gNmUAj9egNBZM=",
    "cpf": "U2FsdGVkX18f7Tr54yf+p4ftt23lNhTPm/me7IyDmt0="
}, {
    "num_cand": "U2FsdGVkX18mxI5+4LI0cGDMcAlgX3hLrkH/1hbPJdA=",
    "cpf": "U2FsdGVkX19SbSenyl2+rR2hSLREnCc8Je+Qkx9SBKM="
}, {
    "num_cand": "U2FsdGVkX19hfetInruEwo1DTtijKpllPmYr9S3e114=",
    "cpf": "U2FsdGVkX181BY8kJI30KeLdrU3OqPUs4zDDbCHKiN0="
}, {
    "num_cand": "U2FsdGVkX19UWSL3VPLU9UCy4kVac3wC9pWUMaYHkt0=",
    "cpf": "U2FsdGVkX18mmGZP3fvZdD5RGZ/lEIw3MU8lpR45GmM="
}, {
    "num_cand": "U2FsdGVkX1+HdrkybxSFDiVhndbyjHwow0uFk1OUyPk=",
    "cpf": "U2FsdGVkX18/bIsVC5MmGUyL/uJg14oaTbG24UJuHX4="
}, {
    "num_cand": "U2FsdGVkX1+4fGsTIdKpxv0S3nxV8AqooYwjFV7AAOY=",
    "cpf": "U2FsdGVkX186xGMrkweRsgo7Yyg7io7v6/bUHYOwsUY="
}, {
    "num_cand": "U2FsdGVkX1/wo8/CbaJIiN3UPjz25qDnIL51arJCSXE=",
    "cpf": "U2FsdGVkX1++d7bdQhmiEhFHMg8E1iIjO9jPT6HQdqw="
}, {
    "num_cand": "U2FsdGVkX1/l97k6ixqCeQPH3EAstXItccVG+V9pzCg=",
    "cpf": "U2FsdGVkX1/BDEzn1d1IgQ+596CIqsWoV11sae+7Rmc="
}, {
    "num_cand": "U2FsdGVkX18hNySRZW0AVyOVPDQj49ayqdDSzAmQcbg=",
    "cpf": "U2FsdGVkX1+ALSpqORrr10zEtJBgkMQLE59FnZYwojY="
}, {
    "num_cand": "U2FsdGVkX19M1bYGBIgdcR34/5hLiHiYWvAk0BOqbOY=",
    "cpf": "U2FsdGVkX1+v9LDf8xlqeJpUTHUYATHZCWim57nnicY="
}, {
    "num_cand": "U2FsdGVkX18NRchewi9mW2hZPX4wtABY4y16sqZ4hH8=",
    "cpf": "U2FsdGVkX18thhjfr+5KXGaWtpvwBqFFuRBfaV1klrg="
}, {
    "num_cand": "U2FsdGVkX1+JhVK8HyfY4Nz8tQlR/YeOfXyo+tKO9Dg=",
    "cpf": "U2FsdGVkX18kEtPFX2S7DvCgfNrlHxhtK4CkOJk8W7w="
}, {
    "num_cand": "U2FsdGVkX1/XwHKZ7D3FQ/F0spVehhQc/PD+AaEc7BQ=",
    "cpf": "U2FsdGVkX19xbYhwPTK1VCYGlWbTQOBokr18c2lY0x0="
}, {
    "num_cand": "U2FsdGVkX18YLNZBghrPpWj5Jz2MzTqgEEECAepuddo=",
    "cpf": "U2FsdGVkX19uiZq4V7Mpms80rFxjmpBqCfsE1DQyHsI="
}, {
    "num_cand": "U2FsdGVkX193PhAGbneuKRAyx53ZWeHFx5a6V37aBTc=",
    "cpf": "U2FsdGVkX192lP6YnRhLTdiu/ausBREBi/cW+RGBzEk="
}, {
    "num_cand": "U2FsdGVkX18O6RCc7I4MUuIUmUCV2kB51BexYJcMB0k=",
    "cpf": "U2FsdGVkX18Nd+TU7667zKCh2Who0i9Qxz0/80aLl50="
}, {
    "num_cand": "U2FsdGVkX18SyRMSsvArgWhcY1yTJYocCT63uUVLSe0=",
    "cpf": "U2FsdGVkX19r8HmDcSULnJAp7rsg342MkzJskR/dDZM="
}, {
    "num_cand": "U2FsdGVkX18YlsARzRf1bCqw2vwaHbEj3XWft9q8ij4=",
    "cpf": "U2FsdGVkX1+btVfFEAV23lS/w26xPJFhlDJKYqOCnzM="
}, {
    "num_cand": "U2FsdGVkX197PwfdWr4Rvrrvel784ylwO3evZSbOzOw=",
    "cpf": "U2FsdGVkX19ILLRlni9OL2tDXRJYRgSNk3G9j3EsI1k="
}, {
    "num_cand": "U2FsdGVkX1/JG4ZmCqLJdT1TfmhzmsQs0RFW3cjGcyg=",
    "cpf": "U2FsdGVkX18/qqijzHne5BwvnIqN+sv1jYE4RxDAGpM="
}, {
    "num_cand": "U2FsdGVkX1/X24UWhc8q32O2A1gR4CiAzV1C4fLl67o=",
    "cpf": "U2FsdGVkX18SS/H/iCVZ5D0t3/mDd1YNokVQBflabMo="
}, {
    "num_cand": "U2FsdGVkX18XAQhnJ6a6UCDZrC2uu4dcLV3Oaph+Abo=",
    "cpf": "U2FsdGVkX1/8LobGqtn7/5EMCQW8TryO+5XnBlfN3Ds="
}, {
    "num_cand": "U2FsdGVkX1+1vQOh27o/yb64cYey2AL4R2l61A2WcMY=",
    "cpf": "U2FsdGVkX18Fans4jX5RwOtEc1tsQ2UH7No3ax2i82I="
}, {
    "num_cand": "U2FsdGVkX1+m54Bcf+LivL1qgNBCpCFl1a/BwdH8Rws=",
    "cpf": "U2FsdGVkX187DPlrD8dLiXkXsfXF+l9lCzmgSGFdaSk="
}, {
    "num_cand": "U2FsdGVkX1/XkirrBjhFItz1vDCBktcGqSHumrwwAEU=",
    "cpf": "U2FsdGVkX1/mOFlhr5N75MO+4HLG/IgWp8TyIO9RgdA="
}, {
    "num_cand": "U2FsdGVkX18vfdswWz2t/UtDqPEoTC5n6qlWu18ZPMo=",
    "cpf": "U2FsdGVkX1/KtiCmIlQaKQexjFEgNGusLRg3tfV+sI0="
}, {
    "num_cand": "U2FsdGVkX18TChoWCD+Xo+islT2TvG4F4+g78zY6W8c=",
    "cpf": "U2FsdGVkX18iNTpcTVV0tbCQq0SsK5Z8Go1l5f9CrFU="
}, {
    "num_cand": "U2FsdGVkX195zPVEgI57HYjmUvXVXx7OekIzd/nn9Kg=",
    "cpf": "U2FsdGVkX19adTTuUmP3cQnV2sPsBzsbi1VyLHVkv4c="
}, {
    "num_cand": "U2FsdGVkX18Ox78KtlKmTrLb/f1lIFzEb+AS7lkf9Cg=",
    "cpf": "U2FsdGVkX19W4eG/TM2b+/I071DpcvqeA9odawYQilg="
}, {
    "num_cand": "U2FsdGVkX19GCnRi0gwQTGAnpvFgOy5mXEJl4Hg2QnU=",
    "cpf": "U2FsdGVkX18++vciqRFr77vQ6N206tcoWBNitUsRhQc="
}, {
    "num_cand": "U2FsdGVkX18MVx8lt83QIIAHnBVjRP25+PXMXNeeZ0g=",
    "cpf": "U2FsdGVkX19ZNtww7sOxspJSrtOYPcmuFn2i57sS4EU="
}, {
    "num_cand": "U2FsdGVkX1+JFAo11GyxlpmCkTJmUetqXTgsoCsV1ys=",
    "cpf": "U2FsdGVkX18vqEIJtB8w16Evf1lPwknwFnbegJOb7gA="
}, {
    "num_cand": "U2FsdGVkX1+efOZaDGA9sVwUYOdLs2FPRIUuBrUDY7U=",
    "cpf": "U2FsdGVkX19g71aPyylPuAetZc2zNs9OoFybGSxMzMs="
}, {
    "num_cand": "U2FsdGVkX1/qS+gUs+gdFKaB7o7uJrGPh+d4MF8GmMU=",
    "cpf": "U2FsdGVkX1/fZMX+zzVcSmoi6O5xzeh8OS8a4jLD8GY="
}, {
    "num_cand": "U2FsdGVkX19E2yclcsgVXHfvytZxkZRmyrFh9x8XhAU=",
    "cpf": "U2FsdGVkX19nU942vqXG4l6Jprqo3wIoPWgQQ78EQGg="
}, {
    "num_cand": "U2FsdGVkX19MyZQxTZYeorAhLQKvB3wIVqf6tiOXABo=",
    "cpf": "U2FsdGVkX19SBulF8GqBF8IQyId6h7dDcbcXvAaRo1g="
}, {
    "num_cand": "U2FsdGVkX1+RxnUdtUgp8FyVHKeOQ4LaWQ7nZfqw1wo=",
    "cpf": "U2FsdGVkX1/2x+M33wtZzcNF3QvC2ziVT9xWr4f4Ff0="
}, {
    "num_cand": "U2FsdGVkX1+j+ybRp+KckUbSi8/DhY5V2zvFKKASwtg=",
    "cpf": "U2FsdGVkX19r0KUgMDnhs2cSxbpfjP1PpQxWcKMct5w="
}, {
    "num_cand": "U2FsdGVkX18+Gw487IiEOmRahXzHwIFgEuLKauItNnU=",
    "cpf": "U2FsdGVkX19YYgN8Uq8LwBRq5/8A/Ef88M1XQFdw2yk="
}, {
    "num_cand": "U2FsdGVkX1/kBn842VIIgDEU2A+x01/jv8KpxxI8gjI=",
    "cpf": "U2FsdGVkX19sgTQI2W+V8KDbx9s3CWzt+VDTLUjQfeg="
}, {
    "num_cand": "U2FsdGVkX18+/sljzJH+9sZkne43JpcCJep8QnAZbjc=",
    "cpf": "U2FsdGVkX18sbD+Ku4Jte6DIAHOto1qMilku9Bkfmaw="
}, {
    "num_cand": "U2FsdGVkX1/dgCfJy8K4GMrPRki2AWyqAsZNQDCdUeM=",
    "cpf": "U2FsdGVkX196wqcsrKHvT/xwEd6GKFdedQX7bYz9JO0="
}, {
    "num_cand": "U2FsdGVkX1/QP8zm8sl7bQq1ms1Ei+ACxtiV9ECNCe4=",
    "cpf": "U2FsdGVkX18zjvN+dt3YL36z7TyLABHCeznXjcrEhpY="
}, {
    "num_cand": "U2FsdGVkX18gSDG5HJSZnTNb86Aj2pWWg4NGZZlXHJY=",
    "cpf": "U2FsdGVkX19Dkc7jr5bvvGr9fc834Jzm1qD+JDBP69E="
}, {
    "num_cand": "U2FsdGVkX1+ZeW43jne2WLKh+9d8NgpRo6Tr4bxOdSE=",
    "cpf": "U2FsdGVkX1993JSsLVG6pIcysSXMgjpazGBRieZ8CuE="
}, {
    "num_cand": "U2FsdGVkX19vL6vE6XsCztp9rKbZ7SKI7JfeuMfSjVk=",
    "cpf": "U2FsdGVkX1/5zb0ojddWGE1SRmh5RY/IhX9CUf1kEtI="
}, {
    "num_cand": "U2FsdGVkX18PeNImCMfSvT+o9ouK3dfW9YVwitI+B3A=",
    "cpf": "U2FsdGVkX19H6+Vi+S39qInhtJ/Z0SDCCIf+GXehA+0="
}, {
    "num_cand": "U2FsdGVkX1/lV0igF8Tm2T8UOuUSxwvXoNI7ie2Dq6U=",
    "cpf": "U2FsdGVkX1/gxkbRpjqegODUhQuXQcstyc65ugFhNu8="
}, {
    "num_cand": "U2FsdGVkX18GcsXd5da2zzXekjHqtLYnNOksdyZP5NI=",
    "cpf": "U2FsdGVkX19nngcp/YWOX86NZKVjlbY1JwMSNlG5kGo="
}, {
    "num_cand": "U2FsdGVkX18XDV0RkfELz3OI+mYIcab+UtYDn3A40Rg=",
    "cpf": "U2FsdGVkX18I8+01Uq/px7pv+VLLuzC9/OfRmyeMjOs="
}, {
    "num_cand": "U2FsdGVkX19yO8fWTKx0K3lp52TdtiM7+JBmnKLgM+A=",
    "cpf": "U2FsdGVkX1/hf7hRBeVSmV09SQcF5Qwezr2IFokV4p0="
}, {
    "num_cand": "U2FsdGVkX1/kI+Z5PcYgwopMyLIuWrjUN/xGcJVplj8=",
    "cpf": "U2FsdGVkX18/O+WizvDFYENdzv96NToj4dKmQWY9YoM="
}, {
    "num_cand": "U2FsdGVkX19NwGPqyA7xrpuF3hwANgA8y62CodPSz10=",
    "cpf": "U2FsdGVkX1/K1rRh8p7YMHhFEJeKK5isGUTnXQSvcdE="
}, {
    "num_cand": "U2FsdGVkX19wB4HpzcP5Vxaz1oCFuLn8vh2wCHT0mtk=",
    "cpf": "U2FsdGVkX1/3h3yKbKtVfXGlfHx/f2RfLpnRemYfId0="
}, {
    "num_cand": "U2FsdGVkX1/eyfPJ2LxDIW4r37A5rRMeQhlkE5VyWd0=",
    "cpf": "U2FsdGVkX19UwvNMsQWHMlJ+HzWMytKfn5VHf3iMVPo="
}, {
    "num_cand": "U2FsdGVkX19enSjCM4lVHNB0unW+0wLKCh6AowyiTLw=",
    "cpf": "U2FsdGVkX1/0Z9zINgNaiIG302TMZ2lT7Z2+rKlt2PU="
}, {
    "num_cand": "U2FsdGVkX19C4i1Y7Dk+X2AjkMHrDY6PSVp7rPY8MLA=",
    "cpf": "U2FsdGVkX1+BBFuRKxUt4tjSm/lht7OSYYgINW3hptc="
}, {
    "num_cand": "U2FsdGVkX18TBDPR8ElE2bX3RM9a5NdL1p33T6Olmoo=",
    "cpf": "U2FsdGVkX1+nW3St/q17Odr6nd0+0PJmOg6TMN1xxQs="
}, {
    "num_cand": "U2FsdGVkX18REbDDl3+pagVZuBvyihRzKZfN9NYuTX0=",
    "cpf": "U2FsdGVkX1+xgVDqrOGR/hgk30JflkY5Mmub3qh8pUY="
}, {
    "num_cand": "U2FsdGVkX1+2Ft9GjhhuztgX8m8VfLlISWwwlj0bEe4=",
    "cpf": "U2FsdGVkX1+WEmCe0n6yaCRYRkOrRCLNYvP1wGl1KKo="
}, {
    "num_cand": "U2FsdGVkX18sQ8TDBvHpfRR1S5WcFuKoYEyT9d8NQdU=",
    "cpf": "U2FsdGVkX18fyewbq79QkfYxoBNzXSufpYu7FDQ98yY="
}, {
    "num_cand": "U2FsdGVkX1/0BHp3+mN9g5UbFGEO5t2jMCAhXvRFOQU=",
    "cpf": "U2FsdGVkX1/XYZTyCfSO+vjExEL3fO8GX9uslHdJ46w="
}, {
    "num_cand": "U2FsdGVkX1+JNfMCNMAVUilpKCNAjcqvwkX+9plxFzo=",
    "cpf": "U2FsdGVkX1+OzbVlJapWKmcNTqRa3xrpbc1dvYwZSqU="
}, {
    "num_cand": "U2FsdGVkX184Et1Z9ZGo5aH6dN1vJnMSUEcTtRhr/DQ=",
    "cpf": "U2FsdGVkX1/683xJd/sDr1muICXpdWFkwF50M7+nq7M="
}, {
    "num_cand": "U2FsdGVkX1//poog/z05ieNJM9LwS6/XeudkAV8qYrw=",
    "cpf": "U2FsdGVkX18y3NMiS7vg2KyBx3W23iXzYQhd669kAPY="
}, {
    "num_cand": "U2FsdGVkX18qW20nB0mfDC7gEilFxcSZXARtaB1QBEQ=",
    "cpf": "U2FsdGVkX1+jc8dYZzga5fre6wfwvHOTLwEfpeY2XYg="
}, {
    "num_cand": "U2FsdGVkX1+3udARVdmXynKWcBNK8BRtLQqCXMp2/sk=",
    "cpf": "U2FsdGVkX18kvSC697iRhH3TMKDAeUCNrUVG7b+c3Rk="
}, {
    "num_cand": "U2FsdGVkX19+2nXVnh55EN8HSPnhwc+N7S6Ob8QsL0E=",
    "cpf": "U2FsdGVkX18VhdC1gnHIeX7MNO8SzkFMVFemXNv1Cm0="
}, {
    "num_cand": "U2FsdGVkX1/tEfBf90wi1yg2tgYlXM/pKxz7bZV5Rpo=",
    "cpf": "U2FsdGVkX1+eQpE9lZ+OTVN/VDVMFZZJN1BmlZzpbSA="
}, {
    "num_cand": "U2FsdGVkX19uVSeqUcfgrnHMKcGiPY6WaTj4tDwtHYk=",
    "cpf": "U2FsdGVkX19zTwcAof+OHofsXoD9RV5tBfOPAcfHpEo="
}, {
    "num_cand": "U2FsdGVkX19ObUaWUikxNul0Ba3oGZDpOj7tN19RKxA=",
    "cpf": "U2FsdGVkX197DLyjS4u+z09q2BIpvlwXeKuWLPLUl2M="
}, {
    "num_cand": "U2FsdGVkX19V54V351lvyfUIH2ko5LUBsuVZfrynsTM=",
    "cpf": "U2FsdGVkX19Lq7QfbXwhjjbA0Lwwzw/W2SgnLV57dYo="
}, {
    "num_cand": "U2FsdGVkX19UWhSch7v7bEvRhqq9VZtlPlQ2NHs203Q=",
    "cpf": "U2FsdGVkX19IeqY2tIuoxxBi3soMlVpVoeiDvGL3dso="
}, {
    "num_cand": "U2FsdGVkX1+0vgnFt0K/LOF71mJX/Mcw5KCxCiYE7wQ=",
    "cpf": "U2FsdGVkX186CvxN/oh1yPpUTE5/TAZ8EvrM2SUywRA="
}, {
    "num_cand": "U2FsdGVkX19MWHZvFw296PsoXxd7kM2EFm7mU8xCkEM=",
    "cpf": "U2FsdGVkX1++rXPpOGsY8cKCM3i/aFtZ/Q9kXZPFtsU="
}, {
    "num_cand": "U2FsdGVkX19/myEN7ByUHyiwZ5gDDq7iBq3WP9+Jm98=",
    "cpf": "U2FsdGVkX18Ni+SXiK7RLrxesPMlW+n9Gyzfhw6Zp7c="
}, {
    "num_cand": "U2FsdGVkX18QjvALR1W65hZcpkXlHcVsRo+CJNobz4I=",
    "cpf": "U2FsdGVkX1/4fnew/jzMJpBQ3784ZtHcVOdt79twVeg="
}, {
    "num_cand": "U2FsdGVkX1+zMgce43eCjjhkoMRB21mDbZORJnyXC+k=",
    "cpf": "U2FsdGVkX1/ABNWS0Dis2YT33i8JRbJeP+cJvxCLnkI="
}, {
    "num_cand": "U2FsdGVkX1+qPLa/yjzDPV3bSqLbBFoEw0tfCHJQgZM=",
    "cpf": "U2FsdGVkX1/QZ16zy+/2/+K4lS+nOjvAq4qJuNG7pf0="
}, {
    "num_cand": "U2FsdGVkX19dgqnX1X4ZQcZYLMzMZlqRiDboo5RJ75E=",
    "cpf": "U2FsdGVkX1/OdpbYtzmdDcxy3we4LHdhbj+iwgqvEJ8="
}, {
    "num_cand": "U2FsdGVkX197mf27gs6fB4M+NQj23kEfB6Vxzgb9hKQ=",
    "cpf": "U2FsdGVkX19OOq+/oErp43sLZa/k0stFMk71ykOYFTA="
}, {
    "num_cand": "U2FsdGVkX18hfeXnL6zh3516C00M21ZTs0y13HmiQ78=",
    "cpf": "U2FsdGVkX18bCu/opV4QOZn0skbV5JHd77J9AervvsM="
}, {
    "num_cand": "U2FsdGVkX1+EtnmsgX5laZbQuUyf89GScaBWOmN0u3s=",
    "cpf": "U2FsdGVkX18gsyjQIhDQ4Ur9gebqJVLPo23L1+hmtgU="
}, {
    "num_cand": "U2FsdGVkX19G7cYsXaDXEg1Kg6AoHbJOsq6MmtGJKjM=",
    "cpf": "U2FsdGVkX1/l/vJwd6l1oRg6Y9kboUh/h5jH0t8X+gk="
}, {
    "num_cand": "U2FsdGVkX1+DSJeLj7FTJUxh6XAM2aV+49YIwtj5ls0=",
    "cpf": "U2FsdGVkX1/FpIh1LkYqDMz1kPSH+/mQH7S7rAUTuDc="
}, {
    "num_cand": "U2FsdGVkX1+0bhCP+uQhGOS/Jr5XaQHtNc1urw9gytM=",
    "cpf": "U2FsdGVkX1+Sy/mNzzBClJU9wOoW+Brzh/N23Nv97pM="
}, {
    "num_cand": "U2FsdGVkX18x0xMIlpS3ojicKxvgoEvlFRsB5uNaCZE=",
    "cpf": "U2FsdGVkX1/2p34suuULPWt89lZ6linHIrs5Qd/hsZo="
}, {
    "num_cand": "U2FsdGVkX18WivFmfXrBjodvCKa8loxyqoh5QsSBtpI=",
    "cpf": "U2FsdGVkX1//kZVnf4uD++iqDD6FHWcEntmLRIShuYc="
}, {
    "num_cand": "U2FsdGVkX1+KLSNK03SIaFfq3Cx+jQCwi7rBf6kxOaI=",
    "cpf": "U2FsdGVkX1+rye54DM86jXRpXWDHueSpdyLcbjtziZw="
}, {
    "num_cand": "U2FsdGVkX1/xdolDAsJA9wN2kAOsqiRNJwNdTkpTvlU=",
    "cpf": "U2FsdGVkX1/6ug5jnkT0qCsQOrEIvGah8Qc7LbHIysc="
}, {
    "num_cand": "U2FsdGVkX1/7SZPaODe2oslr2SmtdQPx/pzeGMWioFE=",
    "cpf": "U2FsdGVkX18elbAgtnJdM/z3mP9byUpPhc0BV70YGd4="
}, {
    "num_cand": "U2FsdGVkX1/dgDkCwrnfEeNAt/1Duc644JKVFyIiIbs=",
    "cpf": "U2FsdGVkX190gsQfn+NRRmCUh1ldmSTkYZqhPep3w0A="
}, {
    "num_cand": "U2FsdGVkX18IGYc4R+710oiXuFrhrL6y8hgn83BNrus=",
    "cpf": "U2FsdGVkX19QfVVaeM6Y13fI2iurx4+B6N0SdnDXCgs="
}, {
    "num_cand": "U2FsdGVkX1/qeTqx5A4l6UMnCX97nfu+DqyWt8igyQQ=",
    "cpf": "U2FsdGVkX19iSyJL8V7m0qJ3H33QM5qw6PVTyI5XA+E="
}, {
    "num_cand": "U2FsdGVkX1/ko+mzdF/EXyy6tJila7nAqCKAJ2F3+Cg=",
    "cpf": "U2FsdGVkX18lvXy7cMibcgAaWsygwvcF2MnNQ850PEY="
}, {
    "num_cand": "U2FsdGVkX18OrwOrfE6av4ZdqRP6IB2JTVRUK2qqQO4=",
    "cpf": "U2FsdGVkX1/hs34xM90+K/WwVfl5b0+0Xl/z67SU36Q="
}, {
    "num_cand": "U2FsdGVkX1887puz/6mcoVcT7t/2+Dp43EgSsrWGKY0=",
    "cpf": "U2FsdGVkX18qkNYHg0iVxpnodnVNlalOeGVMuc3xm2w="
}, {
    "num_cand": "U2FsdGVkX1+CvFSxOQHljzZvdv2vIce0jnj6/DTz+Ww=",
    "cpf": "U2FsdGVkX1/ybkE6J0m0Yw+CYEJLTZMwJkgzgTqwGhE="
}, {
    "num_cand": "U2FsdGVkX1+/h7nHUjk1creNLvlFhlkuEHRGli5N1lo=",
    "cpf": "U2FsdGVkX195Mldr7dSdNOKS0an4jczj6XQ8GrYwj1w="
}, {
    "num_cand": "U2FsdGVkX194xNLxaIvFCOp56j9oLmU4ig9aMJKYo18=",
    "cpf": "U2FsdGVkX1/ABEO9q6pXmI71dcvb6jXg4Zb03pVLFsY="
}, {
    "num_cand": "U2FsdGVkX18j07p4LpAros9Ab3kDAfmoYdFhWokNqt0=",
    "cpf": "U2FsdGVkX19OwneuMm1zgtgUbETN7g+BpXDyRulcoHo="
}, {
    "num_cand": "U2FsdGVkX1/bgRuzz7Igd3VM05OHaUfYZLqCMlUiDak=",
    "cpf": "U2FsdGVkX1/PJ+hDwzgjcmKyhrncMxdLT6iJ/OzmaSg="
}, {
    "num_cand": "U2FsdGVkX18HVgiUlXSymJ5rZxbzw6GOi4ChDTveaSc=",
    "cpf": "U2FsdGVkX18TpghCeGCvpweqefkwWszDhLn/ObA5vc4="
}, {
    "num_cand": "U2FsdGVkX1+5pS1+VFUgPCMDwig+5wIyrsWMe9IuPmw=",
    "cpf": "U2FsdGVkX1+u7Wn5Yty4yzRF02LfGl24OnDPa+tlflM="
}, {
    "num_cand": "U2FsdGVkX1/dn7xsJijfSZ6sLhZ9N+QXnXbcyWWV8Yc=",
    "cpf": "U2FsdGVkX18CSbYMYDMNxWHZ8ragAN/i1Ls0/9/6mQs="
}, {
    "num_cand": "U2FsdGVkX1/8oI1mbF6jRw2CezFBuONfzCf1g+k5mKg=",
    "cpf": "U2FsdGVkX18QAiNXrWslEznZO7Zy5+XAyyECjvTXhyo="
}, {
    "num_cand": "U2FsdGVkX19ELSD22SIUG+guBa1ntFBE1Zh9rRGvYAw=",
    "cpf": "U2FsdGVkX1+Ijh/AmwAp3R8sKpIM3mBVOfrEdlwOMTE="
}, {
    "num_cand": "U2FsdGVkX19AWVyRvvB+oa1x6lp4MGf/YQ7cviYXLEw=",
    "cpf": "U2FsdGVkX18fhHTVW2KF6iB7Vvd+3DTd9tnCt+KdvpA="
}, {
    "num_cand": "U2FsdGVkX19ycuHJLvHkhZi4QCKcKUmp+vqDUDmKFZ4=",
    "cpf": "U2FsdGVkX19OsCjAkiIRu56FUYxWEXA8Mn/Z0pwDqlk="
}, {
    "num_cand": "U2FsdGVkX19fBwRKhR2AQqCI73u4ekFp/aLET49lo/w=",
    "cpf": "U2FsdGVkX19I33jijBkTbU0eeu6TrcbTtMPuQoKifc4="
}, {
    "num_cand": "U2FsdGVkX1/hjuSem8Rn1+QI/P8bZyjLlMrBLfcw0Ik=",
    "cpf": "U2FsdGVkX1+3qU1Jwk+TNdl0OaLFbnyG4IDalp4TwNo="
}, {
    "num_cand": "U2FsdGVkX18j646l2h9YtYmTGmFYp2ZMAEYJxF+0DlM=",
    "cpf": "U2FsdGVkX18UDvl1LAckgzL29i39+lCFYgYaKrltuNo="
}, {
    "num_cand": "U2FsdGVkX1+q+Hot3bF2Zl5Yl+4h5jgb+1a7HASgqo4=",
    "cpf": "U2FsdGVkX1+3IGfxc4bGnEsQmT6tmLyOAPEiEkp/YXo="
}, {
    "num_cand": "U2FsdGVkX1/ok0+8GwI/wtevd5guNZC4UWM2CgprnPU=",
    "cpf": "U2FsdGVkX1+llnuZshj6Qxr2xcwEwcwHzxBNH6x0xnQ="
}, {
    "num_cand": "U2FsdGVkX183KxCDozWawVwQPbNF43Y4BcWkdjooo14=",
    "cpf": "U2FsdGVkX19oxBdYs7WGT7dZx9porVS+hdM0cQv0BpM="
}, {
    "num_cand": "U2FsdGVkX1+AmryJVUW++R1lPivdjWhPxRFT4aNibxc=",
    "cpf": "U2FsdGVkX19b7HePsdNB+N3I8VcOqkxTK1jR1434EAg="
}, {
    "num_cand": "U2FsdGVkX1+SSc0xx98UPhM/Ym3Y4Dh3k1qC7IbqMYc=",
    "cpf": "U2FsdGVkX1+TaC8aRKSq/y9stw8PSaG+BWuEEjbZNBw="
}, {
    "num_cand": "U2FsdGVkX1+qxAGRNkc4MB1H5oYXh2aLWcMW5CqSafY=",
    "cpf": "U2FsdGVkX18iVzM4KAd03aHPNFnYSsvNiOZzwRALLl4="
}, {
    "num_cand": "U2FsdGVkX19rnJ9sLtArUmfStG1QjR29gnfWAzkrlqY=",
    "cpf": "U2FsdGVkX1+2YRZGGF4zjtatqmH8mLio2YKI2XC18V4="
}, {
    "num_cand": "U2FsdGVkX1+V2/xkl7oVHgHr6WLCe4MxyeeywnQK0iA=",
    "cpf": "U2FsdGVkX18GSFGxl+j3Q4Qh84WnQ7muMTYwZSWbQNI="
}, {
    "num_cand": "U2FsdGVkX1/NGpEONVmi7WxkvIrhsehTzPB5l1ZZPHU=",
    "cpf": "U2FsdGVkX1+B7vFHvc1EgprYsx/or+85j38nsDJhW2E="
}, {
    "num_cand": "U2FsdGVkX19lrwdjlvZNDGoZPReHeVbBbiGtLs8qnh8=",
    "cpf": "U2FsdGVkX19rTOvUhC9G+DUVizraj6pMw7j+we8pWPg="
}, {
    "num_cand": "U2FsdGVkX18T6xQ+2xIVfeE+/RYsd3mVChZtsFfEQMM=",
    "cpf": "U2FsdGVkX1+FvxLSsNyoV6f1bc9gVXCeF1uME/FV/zs="
}, {
    "num_cand": "U2FsdGVkX1+plOH8jbsHa1WlFwiYzGjMv5gxH2dbbQg=",
    "cpf": "U2FsdGVkX18ykduhSvbRCkTgl6I26vlGEG0wEARmaWU="
}, {
    "num_cand": "U2FsdGVkX1+rksB1H3h54BhIhUEtkb2thtXXBCwewXI=",
    "cpf": "U2FsdGVkX187irVDqL9F/SOY//k42EB5f6ZFBa7l1jk="
}, {
    "num_cand": "U2FsdGVkX19vD+3YWJRG3CHfjhISZGws3GkoNKu3IgM=",
    "cpf": "U2FsdGVkX18uTTRaZp7QRZrvFTWSBbpjEKDvhiGHJaY="
}, {
    "num_cand": "U2FsdGVkX18zw60A+2HhLtk+hmFeUntyCbJBFFLApiA=",
    "cpf": "U2FsdGVkX190CcBG3WEQ9mbjyilOVGl5s5PSFSYLX4s="
}, {
    "num_cand": "U2FsdGVkX18EE7yWnaESfPaRA9xqML6aNxeEQXd1p7Q=",
    "cpf": "U2FsdGVkX19W1u7AenHgWwF6ufyOhQ43VmZDhjf6jdI="
}, {
    "num_cand": "U2FsdGVkX1/aexJ5N1oYRwAOybYUDXG/oI6cO3WSSwU=",
    "cpf": "U2FsdGVkX19X2rHQfM1aqhxirE+zU3H3tYI4m59e61g="
}, {
    "num_cand": "U2FsdGVkX1++cAFH3UjOluNekkSfLDGEz68vJiX54PI=",
    "cpf": "U2FsdGVkX1862pgZSdlfv9oboKOf9CmCMSnuVMzE4Us="
}, {
    "num_cand": "U2FsdGVkX18NaREd0Yck/8RV5BGof/fq7dIFXYDzgrk=",
    "cpf": "U2FsdGVkX19kYhzQdqBu1q/XupxCx+yOnRgcFdtk7IM="
}, {
    "num_cand": "U2FsdGVkX18hndSfu6PVIp/i8YlBOOsL5rntSHXVbek=",
    "cpf": "U2FsdGVkX1/Vx62KBg3zyMi7mjs2UQE/hMPA2eDf1No="
}, {
    "num_cand": "U2FsdGVkX1+OiI9B/7c13Zw9w5wWvVKeH5Nv2P2p7S4=",
    "cpf": "U2FsdGVkX1+VJ136s1wEztC5s9L05cX3iBB56PaupJ0="
}, {
    "num_cand": "U2FsdGVkX1//XVrWMoowwTaGnlnxE1E+KCjYWWuJc+8=",
    "cpf": "U2FsdGVkX19NfLq0N9B4Jw65T3x25h6Ss0WS4UQLtH4="
}, {
    "num_cand": "U2FsdGVkX19Smr45InZLnTc+zDAB2SDGmNq7cDl9jJQ=",
    "cpf": "U2FsdGVkX18r4vyCqryl0EQIBgQPZDPGk9xflzitJCg="
}, {
    "num_cand": "U2FsdGVkX18ncnDLLvLGiTZqNHog53UgqdQk0QSlvxk=",
    "cpf": "U2FsdGVkX195dk7MnMLunAiP/5qte3n+fr9UjcSoYME="
}, {
    "num_cand": "U2FsdGVkX1+naQ7HWLMznsS4fhv5Q9fI8xskF9PxK8I=",
    "cpf": "U2FsdGVkX18QTyM3lKmkPR4JoYyTtITqe3bGo91kJZs="
}, {
    "num_cand": "U2FsdGVkX1+1zJ4zmY4B+Q7796jC8mvjAkYFDYmhXto=",
    "cpf": "U2FsdGVkX1+4LFGer+otGJ4T1NGC88lLu27lJVyGEug="
}, {
    "num_cand": "U2FsdGVkX18ooF1CGs8GHAB+gs0r+8ggw1SLjmmsDO8=",
    "cpf": "U2FsdGVkX1/gaUwny57tZFpTAAzckFTb8NocDXWfLPI="
}, {
    "num_cand": "U2FsdGVkX1+99BAVBkoTbvB/5GXUTGIpxr07mKrG2fs=",
    "cpf": "U2FsdGVkX19xOdcEiFlJ1tLEtb8Or2LwXwoQaX4qlKE="
}, {
    "num_cand": "U2FsdGVkX1/Cag9v0EkHtB6W503bp65ilIcv8nsM7Bw=",
    "cpf": "U2FsdGVkX18ZKp/0i2dKCO1M97yJP/OQICNlITEII4E="
}, {
    "num_cand": "U2FsdGVkX1/nRl7nmMyaDy4mvULq8cD5U4xfZ95kzLY=",
    "cpf": "U2FsdGVkX1/3M833AiOecvnapasRhmIWIXt7hJKEGvQ="
}, {
    "num_cand": "U2FsdGVkX1/tbV4D9TBu0vIH4wJdxt7kLZtpy6cxon4=",
    "cpf": "U2FsdGVkX1+3qVYqnivEU/fKhaxeofoYt4hc5H4dWRA="
}, {
    "num_cand": "U2FsdGVkX182vWR+EVuuefNPaMfcsxMFORoBLB4ATEw=",
    "cpf": "U2FsdGVkX1+40wc3LyfuX/ImNK3RcN3v4I4uyl3Eqlc="
}, {
    "num_cand": "U2FsdGVkX19Jp+LbQQMxt25/bdX4njMBMTQ6/dJ2LjQ=",
    "cpf": "U2FsdGVkX19diEWS63EDtMzrIT76B6k0j6pdoAuvb2c="
}, {
    "num_cand": "U2FsdGVkX1+bXR7GFfT8T8oQS1Pd7G8+ozdL9Vr8X6M=",
    "cpf": "U2FsdGVkX193XzrUAYaCZms6G4SATV0W8U82Eto9/r8="
}, {
    "num_cand": "U2FsdGVkX19W96Uf/UNd2Esta40jFZDDHLU9IqSpY/o=",
    "cpf": "U2FsdGVkX19eqnaWxJSJl9uRDp4yhi5+dlZyt3u6w9Q="
}, {
    "num_cand": "U2FsdGVkX1/btw3lIsM+ZCL0V/01ZdLr4wyZBjj2+j8=",
    "cpf": "U2FsdGVkX1/N+oxFyQUxApMf43Re5iKn4oVa3YlKfOQ="
}, {
    "num_cand": "U2FsdGVkX189mfvU/NNVFdz2+U2gUfUAXVLGnmVzV5A=",
    "cpf": "U2FsdGVkX18EOpq1jbFyPgcYqU3/9e8kgOylVb+hpmo="
}, {
    "num_cand": "U2FsdGVkX19Jm6m54kKzWviTQRR5r9Eutifyb22SV9I=",
    "cpf": "U2FsdGVkX1/dpBiklQ5PCbTVZDew9z6KmPCWMiEtlHw="
}, {
    "num_cand": "U2FsdGVkX18mzTeCp+IFfjRopa14aZQeNRAOcAhWigw=",
    "cpf": "U2FsdGVkX1+H6BNlf9w5tNdkaBBltenDW0dFGTJQokM="
}, {
    "num_cand": "U2FsdGVkX19FyQAUTIfSGzG30yhfeOyl5Gk498wrAcg=",
    "cpf": "U2FsdGVkX18ilcuOBPkMVPAG3gkOcxoOlmXShx40lJg="
}, {
    "num_cand": "U2FsdGVkX1/LMXFsXzjF7iUwwaQi/JgUsXgbMsF3ytU=",
    "cpf": "U2FsdGVkX1+hFt0NjOEanssPPQD189k5jRFxT8DHebw="
}, {
    "num_cand": "U2FsdGVkX19iPUmsA3019qRcG833DXyQ0nenwc1WOjw=",
    "cpf": "U2FsdGVkX1/n7LCyR1AmET8/nA8BPVTN/kxoPyyVit4="
}, {
    "num_cand": "U2FsdGVkX1+7wPp/ZqBKKlCzYV+nLPt6aPPUxoY9mFs=",
    "cpf": "U2FsdGVkX1/0rDz25M2yoMNmXgI8dLYeqAOCU9cEGGk="
}, {
    "num_cand": "U2FsdGVkX1+VPHUM7WTooORpNfzlVAYC6ZNckubPuO4=",
    "cpf": "U2FsdGVkX19LTwE7KYfgDpeIsYux3T/IdjfoaNMcw34="
}, {
    "num_cand": "U2FsdGVkX1+QmKFIMg+Mw25r+DacP6ULP7lt40vCKVo=",
    "cpf": "U2FsdGVkX1/j1vZzg32IKNPqNZapRf0Ujp0FI5K7asI="
}, {
    "num_cand": "U2FsdGVkX18Olm6cz0Cb0co6FfXEKXTn/LYoPnZavvY=",
    "cpf": "U2FsdGVkX1+dD5u7ZKXQ2N2rgWbULdXhvSYWUoSCxJQ="
}, {
    "num_cand": "U2FsdGVkX18gdo+qfUpeFE5l8bYCGCjuZ2c/xq5CwwI=",
    "cpf": "U2FsdGVkX1/+/UKLQm+XBBN0p8UHLFXBoHEuH1NqHkI="
}, {
    "num_cand": "U2FsdGVkX1/GW6b7ORXIEYbgHjk9ffBNHqMRiUPzXzw=",
    "cpf": "U2FsdGVkX19bvHDbjDdVOaUJ4gibhM/3gBpXC5TcD1E="
}, {
    "num_cand": "U2FsdGVkX1+4yIAq/6+ioavqPvRIQYOSoeoGmhQrt/k=",
    "cpf": "U2FsdGVkX1+JQ+ufDbH1Eqq09sIqgiiJAkPml2T+B64="
}, {
    "num_cand": "U2FsdGVkX18bXspO3HeWtY53GxTvx9iZMEGExA+aEYE=",
    "cpf": "U2FsdGVkX19goYjzTowe50qoQXn4NrZMyIcq4vT30WU="
}, {
    "num_cand": "U2FsdGVkX18lu2gvk0/mQrSehfIAXl2cUr9rdPbFIHM=",
    "cpf": "U2FsdGVkX1/TmfHAEGzEJ0lqYjY47ZSi5fTXPQESkFM="
}, {
    "num_cand": "U2FsdGVkX1+XD8JmHxT/YayVQz55zkcjWG/1SzbW8DA=",
    "cpf": "U2FsdGVkX1/UKvwnDmlQt6HlA3E7/JQLDTcT+Daao6E="
}, {
    "num_cand": "U2FsdGVkX1/hdhHGRFMDtoiD5s3CLu5bBvOexMf8M9o=",
    "cpf": "U2FsdGVkX18VgPONYtg0iZGJ5XvVnaTc5NiNpZcpFwA="
}, {
    "num_cand": "U2FsdGVkX19tnuHwmLUwFtxbiGcsl6ds2+aQ/Q1urJM=",
    "cpf": "U2FsdGVkX1+EoKWvJMpkDRz362VWwIvblUz6cx+dyzo="
}, {
    "num_cand": "U2FsdGVkX1/1j7a4QkpkH2AUZqIuP1iF6RKiZbFc/Iw=",
    "cpf": "U2FsdGVkX19dedHp3uZwVpnOg43UG7YD86HgN+cIGTY="
}, {
    "num_cand": "U2FsdGVkX1+xALc4VRatEqA5Wuq3S5yAuX4ReXSbu5Q=",
    "cpf": "U2FsdGVkX183bj6SrUi1f/ixWzPl2mFnL+CJz5cxtBc="
}, {
    "num_cand": "U2FsdGVkX18SjtTpmDgHr4dDnGzBymdd6Ny0xPWBj9E=",
    "cpf": "U2FsdGVkX1/pFp6iSGKg0MI3QJWd14Y8k09Ij+HW1Is="
}, {
    "num_cand": "U2FsdGVkX1/CgDE2Cm1JSESr2D6cGuvglqPznbJbwG8=",
    "cpf": "U2FsdGVkX18DsWMvF7qQVj841xoWVRfAlNiBP9/70mg="
}, {
    "num_cand": "U2FsdGVkX18cxXHazvgCGnrb50zYEYc3YsMZ9s/OiRo=",
    "cpf": "U2FsdGVkX19giC5o8pEbtDZgU//ubSrVGTTU+aUuINI="
}, {
    "num_cand": "U2FsdGVkX1/9psPi9uP3SfnskDaSYvgmQsJl9UjGy34=",
    "cpf": "U2FsdGVkX1/E3t5tdWZMp4DLDGuo5tj4RVVQSJVjtL0="
}, {
    "num_cand": "U2FsdGVkX1+8qrT+yPjeX8qyVnzcmngmlCYmdFg0uz0=",
    "cpf": "U2FsdGVkX19pRkq8U9wnriK9a/qYPJSi63xLpcMQOUI="
}, {
    "num_cand": "U2FsdGVkX19A0i5S2JJF3/cawxHbkOmeyppQa1pI4fw=",
    "cpf": "U2FsdGVkX181Mkkswp8Ox/o04fWTonb9jU/TTnZFGSk="
}, {
    "num_cand": "U2FsdGVkX1+urz24cR5e2MJoRqui44GexTMtW2kgsDA=",
    "cpf": "U2FsdGVkX18+t/wt22O0zcgi3Ur3vDb8mJuB2II/D2M="
}, {
    "num_cand": "U2FsdGVkX19PomgcPlF7ieNa0Uc9vvByy9yd9stpU4E=",
    "cpf": "U2FsdGVkX197CFH77/DVayGTfnYesZkOQdVnaxBgI5Y="
}, {
    "num_cand": "U2FsdGVkX1/N4SJ158l8fK3XHRWu5QDOBgUjSnZsvRs=",
    "cpf": "U2FsdGVkX18Ryr1+WXX2Uz2y0dLylthxvERyrgkW7aM="
}, {
    "num_cand": "U2FsdGVkX1+P9dsHiyIXYXvJ/xM0VTuDLnDuabxaS40=",
    "cpf": "U2FsdGVkX1/HiP/+QsRwtDjdRKhjLeStKlqw1pNa//g="
}, {
    "num_cand": "U2FsdGVkX18/skbaCLs4VcGcpeK1E2p+63Wj1e5ziPo=",
    "cpf": "U2FsdGVkX1/UoBeyRunBEtKky4N/xbuO0f7Uh+QewMo="
}, {
    "num_cand": "U2FsdGVkX1/trY4QAPRUtQO1ekUz/xrP2QbHbD/YXtY=",
    "cpf": "U2FsdGVkX189ncyxtVslnPdMsXPbKixLy+65dOJIlqA="
}, {
    "num_cand": "U2FsdGVkX1/fTcjvBG0vLMMOeIEACiIIgnPgv4Y0Hlo=",
    "cpf": "U2FsdGVkX19pLFHIMoUAXMpYefwHzivn8BbSftNgDuQ="
}, {
    "num_cand": "U2FsdGVkX18+F+sMIuW3I2hV1mzXmWDBgneppcUviNQ=",
    "cpf": "U2FsdGVkX1/R4sNL0NIUqI381Rh7+wCX2S2I+T/fAmY="
}, {
    "num_cand": "U2FsdGVkX18Xfa94va0caQkRgMVhjIlIXdnVsBuXvlg=",
    "cpf": "U2FsdGVkX18f41Rtv5f9ce4ivwCTEOHokclwitzNw5c="
}, {
    "num_cand": "U2FsdGVkX1+heDOi1MoHmJ4u1L9eIdQ9ITceRpTYtI0=",
    "cpf": "U2FsdGVkX19pn3frmMNez7Cd/fQHJoeCY0GW7K3lf8E="
}, {
    "num_cand": "U2FsdGVkX1/UlrRe+95e6VU91h5CfEsuVXc8j/YvzDE=",
    "cpf": "U2FsdGVkX18wYk2G3b7TbKW8uJxN5a0BiqORoQFDjes="
}, {
    "num_cand": "U2FsdGVkX1/0qjKg9Et/UFdcF4Lvm5fO+M/ciasq7oI=",
    "cpf": "U2FsdGVkX1+mtDjjWjH4Pg4x1H0vryGePiIqynDcM9w="
}, {
    "num_cand": "U2FsdGVkX19Koxq9WYe7NRA5ZVoBoDMpkeXqh95Eluo=",
    "cpf": "U2FsdGVkX1+uCxnZsWuU4WVMIvt1jZupk+EUdSgPBwU="
}, {
    "num_cand": "U2FsdGVkX19uyba66suOUbaG2uo9GUVvFof9DLC26H0=",
    "cpf": "U2FsdGVkX18QbJUmD0h0w3bnXjk0Al1OEtAJNWZn7vc="
}, {
    "num_cand": "U2FsdGVkX19HzBzG5aIVtUK9OnK86ubAC8nBGd5Egk0=",
    "cpf": "U2FsdGVkX196fbVQscBUbMp4my6+iJFwT3L5fFHpHx8="
}, {
    "num_cand": "U2FsdGVkX19LiQik191/VGSciO+ePhxD+EF0coyoY4I=",
    "cpf": "U2FsdGVkX1/52R4g6FKsyEz3J2NFcI0lGAlH2iBWCYQ="
}, {
    "num_cand": "U2FsdGVkX19ME6qgO3mqXrlOlmM/vB17OZ6syfbMP2I=",
    "cpf": "U2FsdGVkX1/4Jpg2yVvN+pF1Bi4qsg/7lnBdx7a19FI="
}, {
    "num_cand": "U2FsdGVkX19zKTAKAAuihMUprFNkWJIsfzke9s0MK3g=",
    "cpf": "U2FsdGVkX1/5hgmpqBNXwZyE0XU+RFxrtqiHWxAQlPo="
}, {
    "num_cand": "U2FsdGVkX19VIx32ck1+Qj00FvHKhx3FE++QfPXzaoU=",
    "cpf": "U2FsdGVkX18BkWQG5iujKti8Xio4/J+9CfCdGvaRFtA="
}, {
    "num_cand": "U2FsdGVkX18yeK0vQhpleYPJQAdUJ0CszwDOVcCFMlU=",
    "cpf": "U2FsdGVkX19e3umubdSEw3if9JnoE98z6bxYvgYjcO8="
}, {
    "num_cand": "U2FsdGVkX1/YcoCggUdyTOChVjC1iPfHbTEVhZ9GXrA=",
    "cpf": "U2FsdGVkX18aqUAlsmp5zS2G1laODJ4uMM2g1TeHflo="
}, {
    "num_cand": "U2FsdGVkX1/sAWBUwERluZjm7ebA3Pe79KZieshspdo=",
    "cpf": "U2FsdGVkX18g8PeNNsPTQDr4qY2KYRFXT7Keecz7xCc="
}, {
    "num_cand": "U2FsdGVkX1+TImSuZ+zJ3NASf2BRyKTRAx65vNtR7jg=",
    "cpf": "U2FsdGVkX1//MN8OG5trSPwyXRajK621Mo/h2BNU+28="
}, {
    "num_cand": "U2FsdGVkX18jektBaBl3T4Mx77rW7j1qZgiKnPAa7fs=",
    "cpf": "U2FsdGVkX1+5wp7W9u2lM/qRKl8yWXUW9NSt4dUY1oU="
}, {
    "num_cand": "U2FsdGVkX19sQSzzdzZKtk3ARalSXQCsk9Ye4yHIfsw=",
    "cpf": "U2FsdGVkX1/AfqskaNMqAp/deT0hJ9xsyhcgq7kQsA4="
}, {
    "num_cand": "U2FsdGVkX1+bFTEyyRA4/FQRywpxL2IEt+R4HVC1uH4=",
    "cpf": "U2FsdGVkX1/7vn5dEPEIe7NMak4VXaZD3a6mrIrtQJc="
}, {
    "num_cand": "U2FsdGVkX1/wz6sT3ixJaLhagzr5l8cf/nEgAgxkhQo=",
    "cpf": "U2FsdGVkX18bDIddhTFqgxBFcV8lyHIdXvqnYqYCxac="
}, {
    "num_cand": "U2FsdGVkX1866FfUQ7/JyDVjsZBfwZONEet5lTpXh9g=",
    "cpf": "U2FsdGVkX19AQ7Lw2/dObex6PcImOv52XMH0/isTXzI="
}, {
    "num_cand": "U2FsdGVkX1+QUDfyQwXfLwuq6JupasdMSLicw8Mv85M=",
    "cpf": "U2FsdGVkX1/5I9pP7LvStYGlvv+Xne9NFnYzk0FHlc0="
}, {
    "num_cand": "U2FsdGVkX19Hb3sIOGlnVN3YNr+iRz4hOVKkWzCs6G0=",
    "cpf": "U2FsdGVkX1/yksExYqhObmQTDMtCiHXtAvtqkCrES4A="
}, {
    "num_cand": "U2FsdGVkX18x8BgCV0lN0NAz8/ZGaBezlkMSS50Yn9s=",
    "cpf": "U2FsdGVkX19KQ9eCw78nls9Ddn1MTqe0PhlVEmLeKFk="
}, {
    "num_cand": "U2FsdGVkX1+sab9ghZUXhiX6BxTiPCSq3iwoNUMseHs=",
    "cpf": "U2FsdGVkX1/ZSt/6vNd/HGAoHE9U5YY7dqAat6Jpaa4="
}, {
    "num_cand": "U2FsdGVkX1+1QhfnnPPeDCpAIw8lZgjCWQxA1p76KrU=",
    "cpf": "U2FsdGVkX18W+Ch9LVp49Kdysl/Hg4YckJZ4u+s6yYc="
}, {
    "num_cand": "U2FsdGVkX191xbn0UaiqPXPJBgPYYeJG7HpSI13ct/8=",
    "cpf": "U2FsdGVkX19HApNje4DmandYcK8lF2kELqbI9QLbetw="
}, {
    "num_cand": "U2FsdGVkX18I9GtIAMDFElIIE/rIeGW6gVzR2MDb7XU=",
    "cpf": "U2FsdGVkX1/yPQDKlZaiJ7U6t7cwqy6tUrmI1jwJPWQ="
}, {
    "num_cand": "U2FsdGVkX1+8W5aejW7UrHyzGVODfwAkHGuf+dhqmaE=",
    "cpf": "U2FsdGVkX18Rekk22+5yhV0Z3y43OpmjDOSukd43YEY="
}, {
    "num_cand": "U2FsdGVkX19uxDo3cS1qUYVkirsPVR/xF6VhD2ydSmg=",
    "cpf": "U2FsdGVkX18C1YWj8Rv1/hjinBAhbA4X88UQOA6PwAQ="
}, {
    "num_cand": "U2FsdGVkX1/xR9FhB4KZwb25OsxcELa1A3iRgAAz4hg=",
    "cpf": "U2FsdGVkX1/0DURvOnB/660xiLHNUBt6WjtAsSPli1U="
}, {
    "num_cand": "U2FsdGVkX196+eBtpPfOKUwxRRxfjfLWWqTezZiQJIc=",
    "cpf": "U2FsdGVkX1+rDIT3MjtbHCxVIYfQXFbvZa4PaU0qSzY="
}, {
    "num_cand": "U2FsdGVkX1/kJQo/aF9kzuXAUxx8SjxX5cpIDZPvMAg=",
    "cpf": "U2FsdGVkX1/9slERRAkrw1e2039+7RA8FwhzDGYY2cw="
}, {
    "num_cand": "U2FsdGVkX18cU38one5YgVdQqQolEdK8ZWUwjMDHl/0=",
    "cpf": "U2FsdGVkX18aptyinDav5ywIDERdxec8sQ0oU7Bp8vs="
}, {
    "num_cand": "U2FsdGVkX1/1HUS1dsTZ1lMxB9I4nLD4ok1JjYNZ2L4=",
    "cpf": "U2FsdGVkX1+xbwDCLb0PgKHSRfayWkOcbDEaPXu4RAQ="
}, {
    "num_cand": "U2FsdGVkX19zDT+rDa3vL5wU4rjLcK9rNjiOEgj2jtU=",
    "cpf": "U2FsdGVkX18mVgcwI6UWhVo5fNvRUhUd5kadxHwP4Xk="
}, {
    "num_cand": "U2FsdGVkX1/jmwCsoaFRqbXXUT+0g8nAI8Y2dofpnME=",
    "cpf": "U2FsdGVkX18ybzF5OSxw4MSPRhjbBJ4zQlfcX2Nf+g4="
}, {
    "num_cand": "U2FsdGVkX18QsYkkCe4Yw4/iqPbxUC0+4F6Dprw3nT8=",
    "cpf": "U2FsdGVkX184WRyBsB0CcDaQdVZ5nMkw9K7K7BgaSTY="
}, {
    "num_cand": "U2FsdGVkX18K15r865xpAf/hu2YfvQag5xTaN3/EAls=",
    "cpf": "U2FsdGVkX1+Z5sWkUSfgwyap0+3cqcyrTiU75CnBvbo="
}, {
    "num_cand": "U2FsdGVkX1+KGy5ldjipa1Bv8bqa5sGhsjOM+2qHlEc=",
    "cpf": "U2FsdGVkX19pd+/l0gEpXTTiu+UQIN9H72sowE2/P/w="
}, {
    "num_cand": "U2FsdGVkX19/bPWsk52YDwZ16tUIUoe9CbVJf0fJnsA=",
    "cpf": "U2FsdGVkX1/L8FDJnLvP1fiTVMq5Nm/CK820Pn3wGzQ="
}, {
    "num_cand": "U2FsdGVkX19b97m/p97aVRI4HnWF8ZPdTQNOQ81MPZE=",
    "cpf": "U2FsdGVkX1/ksjB7npIW9Od8aZ+c8+XVvlVxHqjXcTk="
}, {
    "num_cand": "U2FsdGVkX1/jtWiWNRnFlstWD2ujMwizNRO18da5Rf0=",
    "cpf": "U2FsdGVkX1/YVZWhnjwmeWbBggaIypzVGuK4rovV6jg="
}, {
    "num_cand": "U2FsdGVkX18SZ3K3V+AinOETDrvKuJ4msFY7sKdUb+w=",
    "cpf": "U2FsdGVkX1+8vubN3vke7la+VjWgewA3QQXkSOWGoIw="
}, {
    "num_cand": "U2FsdGVkX18sEJPG+Er/s6QviLjUh9YkHUBi1DfJmdg=",
    "cpf": "U2FsdGVkX18aHpMpsQtraopjPrMc1c+a+bpe2zjbtp4="
}, {
    "num_cand": "U2FsdGVkX18WPUA1wCJlC7+O91ED0aLqROITzCb46kw=",
    "cpf": "U2FsdGVkX18r70zf5B1lme0/HqGt2xpxouAkpA3qCVU="
}, {
    "num_cand": "U2FsdGVkX1/CMfNpqB6AaqJaPNyVWg94k484g2NABO0=",
    "cpf": "U2FsdGVkX1+DxUTENm4ZL4jOGtn0tsg7uxbkYOwycG8="
}, {
    "num_cand": "U2FsdGVkX1+m9N5bP/QFFu5OBqj0UgJoD5AfrO3MOxg=",
    "cpf": "U2FsdGVkX1/uCk8VNtSOaYPoyUhfKV0iPbFSsSbY5Fc="
}, {
    "num_cand": "U2FsdGVkX1+NXreIk8H/GNc1+itluJuxJ2EbM/TjHeU=",
    "cpf": "U2FsdGVkX18K9GgirRHj7aPW/nnhC298NI3fGp/nAHE="
}, {
    "num_cand": "U2FsdGVkX1/LxlNiJ9YDn9wwIg5noX8guEaW/e7tfAY=",
    "cpf": "U2FsdGVkX1+8ZHQsrmOISpqszBI/Gn2cgBxlsikvK9M="
}, {
    "num_cand": "U2FsdGVkX1994cQkm6OZ2odiope4yVLX1vo5Gl/KUoE=",
    "cpf": "U2FsdGVkX18d8x/G/V/vPz176zSGF2Rl09ficHizFsc="
}, {
    "num_cand": "U2FsdGVkX18EFxgFr4zifRwM2ZhXg5BWpnJGspMSZg0=",
    "cpf": "U2FsdGVkX1+sCmGE39fNco27tgQOBfWqvE0rx6mswok="
}, {
    "num_cand": "U2FsdGVkX1/dlPtaAty0l2CMVZNa5+8ybE8khbDt7PA=",
    "cpf": "U2FsdGVkX1/NgyViysiWYQhnrJ4OrnYmh/3lsTDzlcI="
}, {
    "num_cand": "U2FsdGVkX1/5wWbE3BmrwIX11JwblIMtVK8bjv6uLJg=",
    "cpf": "U2FsdGVkX1+pGUG2SZnbpjKl1hllior6I7Jg2qCwkAI="
}, {
    "num_cand": "U2FsdGVkX18Vnwab4SZ9DF6CssBC9X5x4sA3BW/sSm8=",
    "cpf": "U2FsdGVkX1+0zZJ78/01nJZco9j0BEILVlMPaydKx+A="
}, {
    "num_cand": "U2FsdGVkX1/+xWVqQaANBtuRpIzvDNkdwscpqO7v3mQ=",
    "cpf": "U2FsdGVkX195t1iA5+FxujpWAMel/L7I4+4FO+TmMWs="
}, {
    "num_cand": "U2FsdGVkX1+PzcZBU+5VgNDX41KSNIK8dsYdDAZoXoE=",
    "cpf": "U2FsdGVkX1/60tDJ2Weg6AIkhvmj4QRT97KIaavmTGQ="
}, {
    "num_cand": "U2FsdGVkX1+h+O1ZACwlaS2mnqjCeKmxOJAXQwfh6W4=",
    "cpf": "U2FsdGVkX1+pmcuYJUiqvRN0LEu/ZSjxVV9pR83o4nY="
}, {
    "num_cand": "U2FsdGVkX1/FM9GOYCHpUkCvi+DBn0EgRutZ0HOBToY=",
    "cpf": "U2FsdGVkX19vac0mmc7xOuqRBa2VbwaEd6nfzPAAFgw="
}, {
    "num_cand": "U2FsdGVkX1/UJiLc+RoGgUuAqGeDKMxBLbWhxAbuSgk=",
    "cpf": "U2FsdGVkX1947Xv4GSe1jzKMFJamqkqJ9Zg9f3AQRas="
}, {
    "num_cand": "U2FsdGVkX1/oJ9vG0EtBvsNIwB+aaBVDQFU1IMzr90M=",
    "cpf": "U2FsdGVkX1/knaSRBKQ6s0AkA0T9ZQHUCYzNMj2tHp8="
}, {
    "num_cand": "U2FsdGVkX19M+SCWSaBwqx+2x65xHfpkbGN1RZfnpWI=",
    "cpf": "U2FsdGVkX1/coEoTe6DnbsSb06w3D+TVLLwS8AaNXKo="
}, {
    "num_cand": "U2FsdGVkX1/J9v5lIKI8dNL7B7tMCNgbXBxLiIr/LX0=",
    "cpf": "U2FsdGVkX18gIVsCzlfCJPF6aJHjYrLN+7yQqSovDbY="
}, {
    "num_cand": "U2FsdGVkX18aXqM2Q8LiPv1aieCfPy5mymOM/SKxk9E=",
    "cpf": "U2FsdGVkX19DuVh3Ig3P98xchRUB1u7Ee/OM7VM4k/Y="
}, {
    "num_cand": "U2FsdGVkX1/Ty5Bcerrpxa5LCX/edQvQ+gsE4Wb5vEs=",
    "cpf": "U2FsdGVkX1+qtu3DCvh5OI+lDiUkWDQtb+s9Foq/QbY="
}, {
    "num_cand": "U2FsdGVkX1+vnKV346wihCr2P9X4APHhqKX5y91YSXM=",
    "cpf": "U2FsdGVkX1952tBRYB7G1fiMI+MviUn/sZnYD0Nqme8="
}, {
    "num_cand": "U2FsdGVkX1/DhDvLekpICSMkjVPBRL2TFDDbJFYRr/o=",
    "cpf": "U2FsdGVkX1+O8cqgwZntAE1ISSwmFofR8dh+iKhuWCk="
}, {
    "num_cand": "U2FsdGVkX19sMjdM0gtJMH9GhFU7ZnkG6Jaa3HDHvzU=",
    "cpf": "U2FsdGVkX1/18Xt+PQPV4FxwfLjFdiNY0lIJ4TtNLno="
}, {
    "num_cand": "U2FsdGVkX18GTbmvgMSEcTeqJC/hKOVux7+Swq4qKy4=",
    "cpf": "U2FsdGVkX19Rwe30VtsHmHV9+mRnFI8OclF6+w2wucE="
}, {
    "num_cand": "U2FsdGVkX18tx2/Ek5psbvUqslzwNiEXcj/sAoyE8DY=",
    "cpf": "U2FsdGVkX1/9dppsCbF3Fw/Qmn0OeGdMGtSiHQBkYuE="
}, {
    "num_cand": "U2FsdGVkX19ZpTomFzAtO5aucjiBrelVbmbyj1dblus=",
    "cpf": "U2FsdGVkX1/TtXkJq4x8yfHEqc3It81qkG0vCcV/5Os="
}, {
    "num_cand": "U2FsdGVkX1+9thGix3gCQB4AIcS5gUXP43slPRrtSCU=",
    "cpf": "U2FsdGVkX19edLaxDvcdyC4H254JWfnPiihtWL3nTJs="
}, {
    "num_cand": "U2FsdGVkX1/uiqx/fAYkIiw5aEvKOdTD682cWMV4LvE=",
    "cpf": "U2FsdGVkX1/ETbwoRPQdzdPmXhtTL6IAFMpUdSesJxo="
}, {
    "num_cand": "U2FsdGVkX19nL0lhNagWlNIvkKt4HPomwCEUaIOUyVo=",
    "cpf": "U2FsdGVkX19CKnUqGY/1Hj30TudwaIbQuEiS0pA5jhw="
}, {
    "num_cand": "U2FsdGVkX19KYkAPdV9R9tEOQJiX6gXJCRQQtOK8nAU=",
    "cpf": "U2FsdGVkX19w5QtydDQ98/Gjq+A+pcjySAVP4h8SJrY="
}, {
    "num_cand": "U2FsdGVkX1/MNAtOw+vWascNj5qO9ojV5dVr+DgHMX0=",
    "cpf": "U2FsdGVkX1/l61Xsi9z6B6v+j72ZUMSSkNe0TmqDslg="
}, {
    "num_cand": "U2FsdGVkX1/sdSmgGvHP5Uz9GbdaWk78A4RXo8lFzTk=",
    "cpf": "U2FsdGVkX1/9633AFJL7FQKrbSY0KzoZaZ1i6WnuEfU="
}, {
    "num_cand": "U2FsdGVkX195UiuICrtxQOXbznFXdrwBFC2JT8W8n5k=",
    "cpf": "U2FsdGVkX180MAFJBjnv0rOepbE6IoQn8WfwmVOHt2A="
}, {
    "num_cand": "U2FsdGVkX1/84vlpTl9c33i3Mk3grUnuIh3mJUqZov8=",
    "cpf": "U2FsdGVkX1/cAVYh2UpG5Zry9JgQOVrxgjrDaqrQijw="
}, {
    "num_cand": "U2FsdGVkX1/eJ1zQmIvVqPZ+s0K30OU5gpHKpcM2+fU=",
    "cpf": "U2FsdGVkX19BtfK9GrLOQ9Cjk4sT4VlTp3gAackUUPM="
}, {
    "num_cand": "U2FsdGVkX1/2E2pzSt+KRzQoQBRpnfLGFeWX4lgHONk=",
    "cpf": "U2FsdGVkX1+Jc96xsK+WqK/7brxmWh5SNoQ2anfxfLU="
}, {
    "num_cand": "U2FsdGVkX19nU0lr3zOOZD+6GPYLlk0oUn4YC/Tl81w=",
    "cpf": "U2FsdGVkX1/i2qdQbPKGQ5X+XHFSCdzFFBe5EUGNykE="
}, {
    "num_cand": "U2FsdGVkX182f55ENPpXIwyaVMhfcfhZZiL1hIoDGCk=",
    "cpf": "U2FsdGVkX1/OvjqPl+O+l4dMRnxHev2VoCBuhJ0AWS4="
}, {
    "num_cand": "U2FsdGVkX1/RhJtFiZJZqur62V4aES4xVqsumSP304s=",
    "cpf": "U2FsdGVkX19yJwg0HDm3bfXHloUkE1hJdTHObiULQkc="
}, {
    "num_cand": "U2FsdGVkX1+W00gaTmkfdQTz3PLD+kophJuFhF5p9yQ=",
    "cpf": "U2FsdGVkX18nPiU9zKly+KmfSQ4BDmoBPEPe1tN0BFM="
}, {
    "num_cand": "U2FsdGVkX1900ghlJLjsjNq1mBfnT0lf19Gf7KB7Y9s=",
    "cpf": "U2FsdGVkX18sEEAz/GxchitZBHJwGOMy5t/kQhjHqN0="
}, {
    "num_cand": "U2FsdGVkX1/RciH6PKOB+1+OLy19nD0ffw4IR4Nl/aQ=",
    "cpf": "U2FsdGVkX1/454Vb2ewgnpACK2EKuT4I9ewsbriPJ4k="
}, {
    "num_cand": "U2FsdGVkX19PXNq1TyN/hyYNAwZS8Dt0uLknHiqG0oA=",
    "cpf": "U2FsdGVkX1+qXRvJ207Xe3u1DFomhrv7Zf6V2TRzAe8="
}, {
    "num_cand": "U2FsdGVkX18js7TWFzcLp88yDv/RO8smz3NoqaxS2yQ=",
    "cpf": "U2FsdGVkX1/j8k6x6WuKe8Ch1OMUwgetbMSUvOzxO0A="
}, {
    "num_cand": "U2FsdGVkX1/SQVYdDqthXMCk+8HUYrh5+VMCI7hfRmA=",
    "cpf": "U2FsdGVkX18+VGu2ilwyFUClktD+GHc9mT1+wgIpL6k="
}, {
    "num_cand": "U2FsdGVkX194QQ3cEhYP/jmhmIheDbrFiaRpAjMLgww=",
    "cpf": "U2FsdGVkX1/vVMlqWezJpFiYITSw9QOfAI8+XM+RMmk="
}, {
    "num_cand": "U2FsdGVkX1/2hO6jQfRIQ8yTXwok2+5LD+ZrYiOXt6g=",
    "cpf": "U2FsdGVkX1+WL26skajFshAwzfBiEHo+llWPp4WwGQM="
}, {
    "num_cand": "U2FsdGVkX18k20W9FyYP1KuCRfILRAthsLvtErIdK6A=",
    "cpf": "U2FsdGVkX1/3gpB48FlplaElw7S0IgY1yJh8Sn+udQk="
}, {
    "num_cand": "U2FsdGVkX1+ki8R2OqGdV4zco34j0bcc7XdQ5UG8d7k=",
    "cpf": "U2FsdGVkX1/jGChaKAVRmJQ+rK2WK5K7SB/vyLv7XK0="
}, {
    "num_cand": "U2FsdGVkX19kam4JMCJ1aMbUu2nPpMWsqj4q2KqgeGU=",
    "cpf": "U2FsdGVkX19Ll3YFxeN1FdXKv+ZyErRrFj+33JPTgPA="
}, {
    "num_cand": "U2FsdGVkX1+iJArkW3qhpEB3sudkxDQXVKXUSdxBMzM=",
    "cpf": "U2FsdGVkX18gZg9QJJsikTMoqIa7mVVRoXHLbs4mXBU="
}, {
    "num_cand": "U2FsdGVkX1/PLQVXUSuD9cmgKHyoAvA/+iqjcxPbTJo=",
    "cpf": "U2FsdGVkX18cgMvnai7T4h06bOi3JutxWbskQdORRCg="
}, {
    "num_cand": "U2FsdGVkX193wOPoezPRavt6EpzcAgQ3yWrjcwATZRI=",
    "cpf": "U2FsdGVkX190JHLQpvV3mILidCZzPPmX1EzN4+1QEBU="
}, {
    "num_cand": "U2FsdGVkX1/WTeu9ZMpLwhc/77VANab65myObBrKLM0=",
    "cpf": "U2FsdGVkX19fi9Yn86bwK8T/0adDleC6JECQ5Hbo8Vo="
}, {
    "num_cand": "U2FsdGVkX18CvzbhLwmq6+ngY7k1mhWGUe4UtoTJMKw=",
    "cpf": "U2FsdGVkX19M+7BZK9SXX9XoAJfj6DlNZDp2xoWEWc0="
}, {
    "num_cand": "U2FsdGVkX1/00aKfmb7/WnbwQxqmDpZw5lwfMxDE7Qg=",
    "cpf": "U2FsdGVkX1+UWrv3PHCa14ARusVD6ilu6FRxelavO4U="
}, {
    "num_cand": "U2FsdGVkX1/zGrDBOU/1SnH/7Ch7JujHVthZIy/VUX4=",
    "cpf": "U2FsdGVkX1+wlVEQTgunClGQrlk7nfqlBPAwzPOcCkE="
}, {
    "num_cand": "U2FsdGVkX1/rMQ6M0oOwvuBgilDfVfEh1UoImuajFps=",
    "cpf": "U2FsdGVkX1+kUskYAXZPn7yMveMAEqS7NJ3DDbS/low="
}, {
    "num_cand": "U2FsdGVkX1/F451GNeSD9pefx5aSc7Hh+P2pPlVpgaM=",
    "cpf": "U2FsdGVkX19vmhepgxy+ppIcejF5RKzcd8ampRykNik="
}, {
    "num_cand": "U2FsdGVkX1+Z61IAI7v7B0aXsqcIFcD/saH4pNfBz/o=",
    "cpf": "U2FsdGVkX1/VAqxQ01bePnc+5jQcbnbmT6dBOsZELoA="
}, {
    "num_cand": "U2FsdGVkX18frgwdOCTp5oy+seRDJnjIMAZJo6Lva+E=",
    "cpf": "U2FsdGVkX19B4jZ56kLXcFAxVAvjV/lzUdx3tt4kofM="
}, {
    "num_cand": "U2FsdGVkX19tsKU1jTjwHXwYlNkGL2b19bG43PZjnmE=",
    "cpf": "U2FsdGVkX1/W30dTxmjPA5gU/HQnx5E8zw2mIo//+CY="
}, {
    "num_cand": "U2FsdGVkX1+Z/Qs2RmCZHAycc5xa1I81Yc4fFS51G7g=",
    "cpf": "U2FsdGVkX1/lxqq6+wv3rTXjk6Ok4SdRn/+X3VcCMTA="
}, {
    "num_cand": "U2FsdGVkX18+gVFw2rkB8m/N5WALNE8DPi9Tu1X0Cbo=",
    "cpf": "U2FsdGVkX1+CiMtuN57+swy0Wl5h/4pfrr7+XinQYNY="
}, {
    "num_cand": "U2FsdGVkX1/dTUOwyzkjPey44NkG6zLfcljoYtIFUkk=",
    "cpf": "U2FsdGVkX1/VHwYiSlESgJ0KajF3QZ007sNCUZwFQfE="
}, {
    "num_cand": "U2FsdGVkX19ZZCXSteVvbQ6cdLS7iEE8PiN7HNaAWEw=",
    "cpf": "U2FsdGVkX19s+D23TL9Y5TFEYCr8HEZ1/deNAWfeX0o="
}, {
    "num_cand": "U2FsdGVkX1/JuN0l2t+Za2K6qaMYzjCPS51d6MJHvus=",
    "cpf": "U2FsdGVkX19t8RtviuNFb500juX2HjHUxdZSrylKUWc="
}, {
    "num_cand": "U2FsdGVkX1+2lEr7Wtin9BDhlyRDW9sBkYMNYc6pFWM=",
    "cpf": "U2FsdGVkX18iRy2sNCju6hIKDYoOEZ8fNQiXi2WRSXo="
}, {
    "num_cand": "U2FsdGVkX1+u3koEYDVeDVzwE5Qdu0rJL/Ut9KCX2wE=",
    "cpf": "U2FsdGVkX1+qJgMWXzGRhFsQYaJsk2vfrDC7kXcrRJo="
}, {
    "num_cand": "U2FsdGVkX1+sXBj6wwvb4dq29zF2cpo3aP3H/w3K4hs=",
    "cpf": "U2FsdGVkX19iwNJJuSmGsr7tWDemPlRFT1xYAVAbWrE="
}, {
    "num_cand": "U2FsdGVkX19EkxudXnKp69eOn5BX4WxhGbLxFvxrH3g=",
    "cpf": "U2FsdGVkX1+KojRfixsfU3NqnpUC6up1KZTDqT5XMDk="
}, {
    "num_cand": "U2FsdGVkX1+GaGmC2i23d8RU7XE3K+RtCKRu3aFCPUg=",
    "cpf": "U2FsdGVkX19p5Z38YiS3W4idZdZIbhIIz+b+sngWJtc="
}, {
    "num_cand": "U2FsdGVkX18xQjyoDXBGTyeKKQr4mZkmkDiLdfbReUI=",
    "cpf": "U2FsdGVkX19h9uMdJeEp0+a5MJ36ZUerdv8dhpwG7sk="
}, {
    "num_cand": "U2FsdGVkX19dpKGzAWJxw9TO6217nlBAModiM4e3S2U=",
    "cpf": "U2FsdGVkX19cLAvabl96xVszGf2TdmxGXohDVmQOiHE="
}, {
    "num_cand": "U2FsdGVkX19wsPS5nA1q2UhBRNcPj9rjCrbrspG2Kj8=",
    "cpf": "U2FsdGVkX1/CMiAosB37vEHcMe/F9xy+cYEMw+KbQQw="
}, {
    "num_cand": "U2FsdGVkX1/YfEkaR/f8dXBbexNcbMOBa/AoUrbf90Y=",
    "cpf": "U2FsdGVkX18KTSXvKl7/cTxQMh2uCAimQdrbU8U9rxk="
}, {
    "num_cand": "U2FsdGVkX19cIsO0qDiT9Ybwqw7cDF8Lf8RfI9jeEds=",
    "cpf": "U2FsdGVkX188mk+NtvBHSZBxVyAJp5HNIEJkhYqrS0Q="
}, {
    "num_cand": "U2FsdGVkX19iTmjtJeX+YIsFxmnHhaDRvkdgrINpBgM=",
    "cpf": "U2FsdGVkX1/oeDMg9xTfsxoUAd1ITeKJ9Aj60HiC0ko="
}, {
    "num_cand": "U2FsdGVkX1+b0S/Cfe1/MBD+lx4mZtc23a/HZTimupc=",
    "cpf": "U2FsdGVkX1+1VDNhu3b5uzn1bCI8vkxwHCJv9RHV9AE="
}, {
    "num_cand": "U2FsdGVkX19WVl3U7M7f4d9Z4FJMALjt6t6S25BgNG4=",
    "cpf": "U2FsdGVkX1+0Nj3DeDixTgxRIBZ6WEwI7mr7jqXGVDU="
}, {
    "num_cand": "U2FsdGVkX1/QCv9Q2gYT5VjWbOQXquyk+itLtZxOG/8=",
    "cpf": "U2FsdGVkX1+jJcIpadenayz11isTkpdBTMNVwehxME8="
}, {
    "num_cand": "U2FsdGVkX1+8S04STjQl0sy1LruJ78uB5qA0ltTHmHU=",
    "cpf": "U2FsdGVkX1/94ObrgQ7RQ1zV2Z2chAnmwZe4brqqn+0="
}, {
    "num_cand": "U2FsdGVkX181NzlCUqVQBKaF4WmfuFB7MRoFjKBrfjk=",
    "cpf": "U2FsdGVkX19PKV5rZuCZzk/XN+M6i3S8wdA1Gs5kLK8="
}, {
    "num_cand": "U2FsdGVkX18d1IKKd0SKtqenO60BtZ2E3HSnNsNZL1M=",
    "cpf": "U2FsdGVkX1/kONufXkqeVV5NwDDazZn2Y8j3GFfgz+Y="
}, {
    "num_cand": "U2FsdGVkX1/63WAAxQnVbpFc2Inr3GlwRPnN7iRVbQU=",
    "cpf": "U2FsdGVkX196GDZ13BXLROvk0C29X300HRvgtuySWPs="
}, {
    "num_cand": "U2FsdGVkX1/VTO/1prwjF42Xzpih1XiGuct3/nigMxg=",
    "cpf": "U2FsdGVkX18kE5dp7wHH+GZM2VExZBdMk/L3o/wPDBw="
}, {
    "num_cand": "U2FsdGVkX1+IXoLJPWl8c1LPm3ocQmaU03bsWS4d2Q0=",
    "cpf": "U2FsdGVkX1/R0iM5HpPESqrmsQ+otG9P1r5xEQYASSo="
}, {
    "num_cand": "U2FsdGVkX18vco645/PGU824EOWPmvFQ8s2dwr8sP30=",
    "cpf": "U2FsdGVkX18PAMPKSYXYDhr9IT+6ptUV3aPYV8+cdUk="
}, {
    "num_cand": "U2FsdGVkX18nE4Pl89LgMXc95RmrJB1lp+UOfqkxSLk=",
    "cpf": "U2FsdGVkX18zX/RGSU/6w2f5S4IRuFom6PNKUU2Dh0A="
}, {
    "num_cand": "U2FsdGVkX18BjmYqVze2QJuN+6mHXKOILUdm1oKUP8Q=",
    "cpf": "U2FsdGVkX19noCE4bVXgD/nMvFDdsFgWAPyZBPdTXp8="
}, {
    "num_cand": "U2FsdGVkX19xqPW5Bd0+gGoeBDjguJ8Fjezw897In1Q=",
    "cpf": "U2FsdGVkX1/PvMYlhh/d/ewr99gLEWQ/Y5uYbzfUUog="
}, {
    "num_cand": "U2FsdGVkX19n5iYOtAkt5VSWhwbnNQeVm2qS6613yxk=",
    "cpf": "U2FsdGVkX1/u8/9aPzdn7+wAtLOOpufHo9MDiL57htI="
}, {
    "num_cand": "U2FsdGVkX1/uXXNNwjm5zDNTLH1kCwJ84sA4pUlzaR0=",
    "cpf": "U2FsdGVkX1/LMYnMZIY0dOqWMFfydTnK+684xatWg28="
}, {
    "num_cand": "U2FsdGVkX1+PwsLsy69mWZjL7MAWLSdlNVTQ1I5aHg4=",
    "cpf": "U2FsdGVkX1/zwxSCI/1TxluGJI5jd73D7CDml6DOnpw="
}, {
    "num_cand": "U2FsdGVkX1/P5JbunbTulkxD8hqZTfyeWF/QUB1TOvY=",
    "cpf": "U2FsdGVkX1/UVIDWAAY4tCLL3tN25O9Jt1JVP0SaHUM="
}, {
    "num_cand": "U2FsdGVkX1+0NEE+24ORI2pSvPC0gm3VWkLlfQS3nJo=",
    "cpf": "U2FsdGVkX19DV7BLhRStxFNYYeHVu9XUBh0bzMOTv+E="
}, {
    "num_cand": "U2FsdGVkX1+ptRn34JqYbfCWn8jCkmroLd4SNYjkQPc=",
    "cpf": "U2FsdGVkX188qmRI3C97bK5ocONsdpMeBfvFJqM0QoA="
}, {
    "num_cand": "U2FsdGVkX19jGFfIS9Iy8T5EQGITiiAPquuN5avS0pA=",
    "cpf": "U2FsdGVkX1/qJxJ0JnU4IhuaYE8U3UZSGL/Cet4ibBs="
}, {
    "num_cand": "U2FsdGVkX1+o3zfvuSvt5AhV0zrXTtBs8sJVQNumlz0=",
    "cpf": "U2FsdGVkX19f02zpoaVLdZubp/ll9HZRR2dBG6KfQa4="
}, {
    "num_cand": "U2FsdGVkX1/RLAlGkLtb7TZKjeOOnRTquUG+FxS/YKI=",
    "cpf": "U2FsdGVkX18DhEnVAwFfCF1yBP0fX+pBfX7oYDlkjAw="
}, {
    "num_cand": "U2FsdGVkX19FK48jVFmrG9qpHoMOPhFp5jlDI423PTY=",
    "cpf": "U2FsdGVkX1/9xdq+d5LudGM9HBgZ83FAz0MPrMWqRVs="
}, {
    "num_cand": "U2FsdGVkX18+SH16yQVmQ0UKDQnf9cYAH90a2wNeEkQ=",
    "cpf": "U2FsdGVkX1/PXMx95Wn7/nkTPr4JA6cDFJl8OjOg9ts="
}, {
    "num_cand": "U2FsdGVkX1+SshoyPtAwb3CJYH227RdoCABkglNT5g4=",
    "cpf": "U2FsdGVkX19fpS4vSqPNpClb06RucM/jg2QO+CZMrTk="
}, {
    "num_cand": "U2FsdGVkX19rHRh3pCcnrp236xXmoxn23U95uTYzR0I=",
    "cpf": "U2FsdGVkX1+BSXMxEnnoRyxY8DC7erxi7qq/3jPT8hA="
}, {
    "num_cand": "U2FsdGVkX18oIh4pzv2HbIWQv87yOv9biBgMsIE8HdU=",
    "cpf": "U2FsdGVkX195jKyj4scGbVR8LWcnUovBvp6O2Rh3Pzs="
}, {
    "num_cand": "U2FsdGVkX1+TJDhtqLcT9RQ3vd14Uebm5Bmv6752Y2k=",
    "cpf": "U2FsdGVkX1+Eb+G4Lyp0HB08HhYAGlJXDy0ucwxtEbo="
}, {
    "num_cand": "U2FsdGVkX1+EFftLInwQlf3xytrC1TznyeTonMolH5k=",
    "cpf": "U2FsdGVkX19lb3en5NisaPvmI2cm34tQlJ9y8S9tDEo="
}, {
    "num_cand": "U2FsdGVkX1+8mBsIcx6wXMEnKhydtT+0VZDPFrTYabA=",
    "cpf": "U2FsdGVkX1/zAKMubM8WRGibucMdsX1AkmPBN+qekmM="
}, {
    "num_cand": "U2FsdGVkX1/zVF3hIVhFDKWqjt3TutMJ3qohtnt5yQc=",
    "cpf": "U2FsdGVkX1+r+TsSuUeEwRmRrO2i8sMK45fUwMieU2o="
}, {
    "num_cand": "U2FsdGVkX18uEKChtIjCP0Crlil6cgafQCYzAQjq9hM=",
    "cpf": "U2FsdGVkX19sbltRjkZ2uk+WAc11xFQi9TpTmB7E55Q="
}, {
    "num_cand": "U2FsdGVkX18US1PHOa/xpVPC5Kz0YKH8G6Z/hbuGC9U=",
    "cpf": "U2FsdGVkX18jNgPuHTBTTPyL3BHmuJn7UKCsywkfRYI="
}, {
    "num_cand": "U2FsdGVkX1/thUP86ur46YoR/2XCLeyqmt4CgLcEB6E=",
    "cpf": "U2FsdGVkX1+wOMFHSPrWSFI1+PNBlhXJORotizZnL2g="
}, {
    "num_cand": "U2FsdGVkX19Ea8DGgTF2v0+kQLveXBQFcx6zmi/p2V8=",
    "cpf": "U2FsdGVkX19D9IYpmboo4nIDmXdQChlfOby0IeYQK+w="
}, {
    "num_cand": "U2FsdGVkX18vTRzlvg+1mMQ1iaEUfLU/H0bEn45awqk=",
    "cpf": "U2FsdGVkX1+p2eP5pLNmGMxYiTY+NPOiGjet2hbTci0="
}, {
    "num_cand": "U2FsdGVkX1+qj3n8gyVa3RTFG+fSP+QHY0APYsjB/QA=",
    "cpf": "U2FsdGVkX1/+S73kpsDEDkn7mLmObikju4TBfbAtOfk="
}, {
    "num_cand": "U2FsdGVkX1/JeCHU9Pdh6lNhAe5Z1GYlsmSvEEkCQCM=",
    "cpf": "U2FsdGVkX1/0A4TgSeU3//Y1VS7tix71/driYbPmfaE="
}, {
    "num_cand": "U2FsdGVkX1/s/At8eRus5jP3LQ+TDn5JQnh2JfdEq2c=",
    "cpf": "U2FsdGVkX18vJDTxSMRyLCfeyO0KY8gUZdKedzhtokI="
}, {
    "num_cand": "U2FsdGVkX18qYf0HPxR06gHDyxssLuaSH3EActKt8bk=",
    "cpf": "U2FsdGVkX1/0dOG3g3YNr6qvrf6x5FyBhK/dIm6+SIs="
}, {
    "num_cand": "U2FsdGVkX1+WTuKOViXPBLPBNbCJnDH+VERXHrhOGX4=",
    "cpf": "U2FsdGVkX19CKJGlpfT2ljuEQg3yApM0KgtvFmA/NPc="
}, {
    "num_cand": "U2FsdGVkX1/Aeq80p7x3FF1Ma0a+DerRLK2B/HyaY2o=",
    "cpf": "U2FsdGVkX1/2c6PVZN3IBHhip+KsHao6pD6BpBtihms="
}, {
    "num_cand": "U2FsdGVkX19rY865xZHu+XnN1NHPPyZqrPxahoDA7Q4=",
    "cpf": "U2FsdGVkX196xoPUROQBgwywRBH6QYic6CYw39mByW0="
}, {
    "num_cand": "U2FsdGVkX1+adh/GPG5CWzuPexlWG1vcELT1umU10gI=",
    "cpf": "U2FsdGVkX19x1ra32Rfw18n8iFKMh7RwofOA/uZSsZk="
}, {
    "num_cand": "U2FsdGVkX1+BWkNrwWJV+dJGWvORi5hEk4x4gRz13PY=",
    "cpf": "U2FsdGVkX18IDUJWR8WzTy+ZWtaV/lR5XEEJklJ9xDM="
}, {
    "num_cand": "U2FsdGVkX19TRoac8ucnE90Q2xqGV7R6wHKHQsW1hwU=",
    "cpf": "U2FsdGVkX19JQTu1REkSIMYBUcTLiWQb55DquAj5Avs="
}, {
    "num_cand": "U2FsdGVkX19v4vA2iRPxlL/iDUYI0MJ/Yn4uxzoTFgA=",
    "cpf": "U2FsdGVkX1+3063GzT2cLa9tCFRple+stNsBiugFekA="
}, {
    "num_cand": "U2FsdGVkX18yEFmt/eqYThdj1YSp5TReMNvheObvhXI=",
    "cpf": "U2FsdGVkX1/GRjd7+khyUV9uh0/QsBrV77AslZZQT8Q="
}, {
    "num_cand": "U2FsdGVkX182hOzhhuGgX2U+RD90MBfr9DL6BRclF/I=",
    "cpf": "U2FsdGVkX197YFhLcXHUwDs6pTXWB4yssiU/Iibdmto="
}, {
    "num_cand": "U2FsdGVkX18cnMMn8l55d/SNggdt+8facqtEFsGiDlo=",
    "cpf": "U2FsdGVkX19W56lFOxa1pzGMLfx0oSGVP127MWE6eGU="
}, {
    "num_cand": "U2FsdGVkX1/0cLYSdcXLv1bP1Mtiue9In6pnDcL7i6Q=",
    "cpf": "U2FsdGVkX1+080XtXnJ7UEdj3pmU/Gk9BdUd6y6IKd0="
}, {
    "num_cand": "U2FsdGVkX19uAt2MXbEWlXckO2IenspSvCqifKLBlhc=",
    "cpf": "U2FsdGVkX18yqE4GUPaSqY6I15GW6fdaWOt+dX8jJ3M="
}, {
    "num_cand": "U2FsdGVkX189aephMzZSN7t3UQAYWtpoY5FkRdNj3Ec=",
    "cpf": "U2FsdGVkX1/CYcX6M1X/a0oWTVZ7i+7SXs0Md7HWzXo="
}, {
    "num_cand": "U2FsdGVkX18YQ0o67EmRc5I8RAsiwjbm3QW45AXkkNw=",
    "cpf": "U2FsdGVkX1/sEeGmbhvYypaC+PBWD34FXp7DTxB9aBk="
}, {
    "num_cand": "U2FsdGVkX1+F69058GjWF/NaBGnh/ncnUR2Tmo4fFds=",
    "cpf": "U2FsdGVkX18fxvncaH/jVeidzG2vU/7iAc2nR5kvHlM="
}, {
    "num_cand": "U2FsdGVkX18KKMmb8N9I6j+73u2v9Dz0ndyvMxKf7wE=",
    "cpf": "U2FsdGVkX18sR8VqL55pRuA2dRoDsU6AkAfkvLUH5B4="
}, {
    "num_cand": "U2FsdGVkX1+0lq2NbdXfu0L4h97b2gahGlQyT9gBjpE=",
    "cpf": "U2FsdGVkX1+A6tn4hBWcNxoMotddylz+VdOoxQpf34w="
}, {
    "num_cand": "U2FsdGVkX18Uh9U0V0BIZNN0MWG61cUkq0to2DZiBQ0=",
    "cpf": "U2FsdGVkX18Na1RkTg2zjOmdIkprOqMwkapZmKtWInQ="
}, {
    "num_cand": "U2FsdGVkX1/m+ET0gO1Y35ZLvH9ZaYeG2YxptpsfVcM=",
    "cpf": "U2FsdGVkX189Xtk382hax396l5rJfOh0UTK50Y2TRLE="
}, {
    "num_cand": "U2FsdGVkX19HHzWA34ULIY/xvj53pT3JbQfZufJ4s9s=",
    "cpf": "U2FsdGVkX18+CQqaoej8kPI9+mjc6o9fuwgc+cl7zZg="
}, {
    "num_cand": "U2FsdGVkX1+wVwtbOXSNFZsjtsSVJyGg290tl3yWFHk=",
    "cpf": "U2FsdGVkX18U0DinMMtwBnKlsuxjImnydpYvYq/4uDI="
}, {
    "num_cand": "U2FsdGVkX1/IRvPd5Ohwx46W/4AyvjvUBhRhL2vYN8w=",
    "cpf": "U2FsdGVkX19lnZZk9nLz/x08+3T56SNC02wBgsIGJPE="
}, {
    "num_cand": "U2FsdGVkX196iDz8B998P8FkMqgnhan/lGbjOe6b4H4=",
    "cpf": "U2FsdGVkX18jr2k35LN9RwjXWgcAKAxulcFbPESmBKE="
}, {
    "num_cand": "U2FsdGVkX1+TRC5RzPc2L5uM1MnoVa1IaRqoZnz5hUE=",
    "cpf": "U2FsdGVkX1/ij0L6XcZILmrHsI1eQEmq2iLBR00GLAk="
}, {
    "num_cand": "U2FsdGVkX180VdZ6hb6Qw/i3sesiEpRT+8+ms55PZUM=",
    "cpf": "U2FsdGVkX18qQXg19T+qXiRRQYr++PqJ2wsXo5oRm+c="
}, {
    "num_cand": "U2FsdGVkX1+lBJP0B1M2QJNFA2SNGSWDmPXkdX3xWQA=",
    "cpf": "U2FsdGVkX1/rjLZ1Fk3Op2/aVcR37VmfWyMZbit9mLE="
}, {
    "num_cand": "U2FsdGVkX1/ZlvpvDnJFH6wPvOOaxfn5XgKn6dxioYw=",
    "cpf": "U2FsdGVkX1/U8X0gK6gU8FopXn/eonITgqV5unFh7H8="
}, {
    "num_cand": "U2FsdGVkX18P1wi/yTan08Ai9GOFDQvPSlYIl9DorDU=",
    "cpf": "U2FsdGVkX187vJUpbHMMHJruXZQ4SrzGZ5cOyKatcDo="
}, {
    "num_cand": "U2FsdGVkX18I6M6/3oUwW8X7Hc3idSJhzJSoIoXBaAs=",
    "cpf": "U2FsdGVkX1+kJWDZaVz3JWH2Km61i7mOaZKiBOuaMys="
}, {
    "num_cand": "U2FsdGVkX188ppYZ/gQpqeJGUrGo4L3EwjQ9n2504zM=",
    "cpf": "U2FsdGVkX19ChXhI/OKGsGhD9uDcOrb5aJ/lsdjTSIE="
}, {
    "num_cand": "U2FsdGVkX18BnuScir9XXQ4qtOOCKzfotR6I0TWpnvw=",
    "cpf": "U2FsdGVkX1/qUmYfdD+6G6rwldYAGgNl6cmMJ6S8DJk="
}, {
    "num_cand": "U2FsdGVkX1+bHan3ZxPL32hGZ84Q77c5G10l+FOtBxo=",
    "cpf": "U2FsdGVkX18poFp5YKwHZUvksUXLlHzgGevoTC3DOp4="
}, {
    "num_cand": "U2FsdGVkX1/QJV2xKN3NYMoaykIi8x5Rubg3abwMy1Q=",
    "cpf": "U2FsdGVkX1+t120poKyETEHuQk4wJpqNYl4YeCbZQmQ="
}, {
    "num_cand": "U2FsdGVkX18f2CBKMB+mVe0tayFkKyJYJbcvnu9jaBY=",
    "cpf": "U2FsdGVkX1/z83lA18PxRrQ8WgBtEzc3b9MRzy5ewTQ="
}, {
    "num_cand": "U2FsdGVkX18Dskq8Po/4Sw2wFSOn8CfsxHz8W9YiVDk=",
    "cpf": "U2FsdGVkX1+oQ6xuGL0lRfAM165NSRgKyPiiP5ZNess="
}, {
    "num_cand": "U2FsdGVkX1+nhivai5AtOT7vWvU8BVh3KiEfgkziQgo=",
    "cpf": "U2FsdGVkX19FmwMuUKCqVQxJxrxhcMTLNTV7VH9cymw="
}, {
    "num_cand": "U2FsdGVkX1+KxAjiTF5rF42+UMXEi6PljbGJQ0jdARM=",
    "cpf": "U2FsdGVkX19T3D14+ZK6smKhbbLdNdO0uc4hv9o7Zww="
}, {
    "num_cand": "U2FsdGVkX1+/zaIf+DnRaezmDgtWE+zZMpCbOk2louE=",
    "cpf": "U2FsdGVkX18HgTIV6yaIgd69hl1cCR1kjocyssIU60c="
}, {
    "num_cand": "U2FsdGVkX1+pyQl9La0xrcY7fGPYCBhc47AMkdCoUiM=",
    "cpf": "U2FsdGVkX1+8RpLjbXX4Rx0ASKXYv024lrB10S2U+bw="
}, {
    "num_cand": "U2FsdGVkX1+ltxUXNts2rGSjG/bBTYqgQ5DZCWGeoMs=",
    "cpf": "U2FsdGVkX1/nbfCbzjmvvMGqqh+hsHcPzdiekUtA4jI="
}, {
    "num_cand": "U2FsdGVkX19byCQ9/sQx+Tz8fGpv9f1TpZmIrXX0iC0=",
    "cpf": "U2FsdGVkX19+za1pqs+chQsYk5oFCdGOWXTUMC173p4="
}, {
    "num_cand": "U2FsdGVkX1/Cb9Cu8SfGysTflDf97CRIBWlY+ER90YU=",
    "cpf": "U2FsdGVkX19VvwAAAj4lZVDUHhSAvS3htsWtc9rZgsg="
}, {
    "num_cand": "U2FsdGVkX1+M5+ZGkzG1PP/+s4XFaCp6JpGlN1P6Q+M=",
    "cpf": "U2FsdGVkX18VG159EGUwRa195t0KdKnNkpWuo7DP7HI="
}, {
    "num_cand": "U2FsdGVkX1+0faAiF4UZn9tHxJKk/FyQoYQCvne5xR8=",
    "cpf": "U2FsdGVkX19uCznHvyCVzKy8sDrdeD7mqOoorwDxeas="
}, {
    "num_cand": "U2FsdGVkX1//ERMHx4WMgrkKjvD9z4yUAXYBqwXDuwo=",
    "cpf": "U2FsdGVkX1+d/IgQLW2OYbfFjPQ8G2VDyMA1fukm70c="
}, {
    "num_cand": "U2FsdGVkX19W0uTtUBoOFys/OK+EILrucm86QzRCfRM=",
    "cpf": "U2FsdGVkX19LrlWutHxBsqCCCN/7LLCYI7yGkxuudW8="
}, {
    "num_cand": "U2FsdGVkX1+V2IbMrE1iNLUb1xpqUDZM9L3XtcktthY=",
    "cpf": "U2FsdGVkX19UKgICk9Ruaz/0ikpCVnmAcItim0xVQxE="
}, {
    "num_cand": "U2FsdGVkX18n3Nhsaty+AhwyvAOuzL60Au//lKyBc8A=",
    "cpf": "U2FsdGVkX19S/ugiHqowM/cdC4H/5uAL3BvsPApQL5U="
}, {
    "num_cand": "U2FsdGVkX19yBoXMrEhbMQATBi04ioKsrxMBwU8sW5g=",
    "cpf": "U2FsdGVkX19SbGME55jFaYa6CZyXMEbK4KdsRiumzOI="
}, {
    "num_cand": "U2FsdGVkX1/QkKObTB7Anu77oZl7FlXM0GjqHBLH1d4=",
    "cpf": "U2FsdGVkX19l2MrZUI3yDlf1/00RHSmikbhYaKnw61k="
}, {
    "num_cand": "U2FsdGVkX1/vs2sibokw2tDmQN48Vix2Ve+GwoxFzIc=",
    "cpf": "U2FsdGVkX1+xFNcUj/guB5q5W3TdvSAidSY0FSl/z84="
}, {
    "num_cand": "U2FsdGVkX18+MhzaX13Iv3jzOHKvO/zvJjeO5Ql8pPk=",
    "cpf": "U2FsdGVkX19/HxRlml55L2Ge6EoT7XS3NjZvF6rLTXs="
}, {
    "num_cand": "U2FsdGVkX19b4GOQ3Ind6kdwEqEU3D0b6CkQvBhoBNI=",
    "cpf": "U2FsdGVkX1/2lTDArkX3br23XvjKKzA6e+APUO1qHao="
}, {
    "num_cand": "U2FsdGVkX19UmtFoCH8e0ODUKmyz7xsHLWyJAuMiZQE=",
    "cpf": "U2FsdGVkX1/bjC36vX4MBdcs0onhs38Yy2D/o/+MEOw="
}, {
    "num_cand": "U2FsdGVkX18A7dYqAzHyv2NxdUkPzEBDUQ3wTcJLSwI=",
    "cpf": "U2FsdGVkX18ISGHdGUnzSNIJeFodTTmvYiC7rB2hQeM="
}, {
    "num_cand": "U2FsdGVkX1/MXXOjzaoV7Vm+J03HGDDIJTcH0+4La1g=",
    "cpf": "U2FsdGVkX192eRloNEaxH0jIwdNKvRfgUcvGGSDaf24="
}, {
    "num_cand": "U2FsdGVkX1/djj+XVnaI4xTBoPMze44/pV4YkyVefH0=",
    "cpf": "U2FsdGVkX18O/W+RzXYWwvnrVXUnOH1mo70wda0cn40="
}, {
    "num_cand": "U2FsdGVkX1/KSa3EKNW06KIjYJbv2Hv46EH5WUOfWIs=",
    "cpf": "U2FsdGVkX1/GsctqKK3ocZhG5BORdQS6asEroWg0f1w="
}, {
    "num_cand": "U2FsdGVkX1+8GtrJXBgRDUu22LzbYTyzpQjK+zKoxEc=",
    "cpf": "U2FsdGVkX19Iv6UuGtNAyElW4QrZbuOXFU+iVCXm+4w="
}, {
    "num_cand": "U2FsdGVkX1/DCSO5PyXa+5gHcZKoXZG92TAp4YQIXZg=",
    "cpf": "U2FsdGVkX19KVTih7p2OlXm8uku20TbuUzo3CdfZa0Q="
}, {
    "num_cand": "U2FsdGVkX1/XdtAXQDNbfiN8E+32uooW/3y2zR6hN/I=",
    "cpf": "U2FsdGVkX1/iYF8QRBGgQ4F2Ire5pLheNwd6VJJ01Vw="
}, {
    "num_cand": "U2FsdGVkX1/a2ev/wl1UQRMHajbkYsiZYQ4s8OIyAZY=",
    "cpf": "U2FsdGVkX1+EaNwCG/UHdoI7ZpNsU6whuYvU1u9LshY="
}, {
    "num_cand": "U2FsdGVkX19WaKQVIHxbaOoQewLSFMmiNOJ9rS5JKQc=",
    "cpf": "U2FsdGVkX19P0KFXstUYJcY6cwtpMFBPh+TNP4c0Ghs="
}, {
    "num_cand": "U2FsdGVkX1/cXuNnZbR0dNHgrMO9oZsm7RogCeGGo/E=",
    "cpf": "U2FsdGVkX1+rZ6WMDWadIOr+4dVkL9YAvPkYub6e40g="
}, {
    "num_cand": "U2FsdGVkX18OlvMCsTqiJMK1wC2zo0Ycc7YshOpwpUw=",
    "cpf": "U2FsdGVkX19PUadbn4F6d8COFv+2gAezm3WQaCAFKqM="
}, {
    "num_cand": "U2FsdGVkX18XzzI1hExTy+xomiljfiD6zPpB2woaOmE=",
    "cpf": "U2FsdGVkX19bgQzmluicLhr2yukNjnD3AfqtwolIRWg="
}, {
    "num_cand": "U2FsdGVkX1/WDei5PmR/Gw0QtWfnKuGD/vWAO71pMyE=",
    "cpf": "U2FsdGVkX1/L5givMDqV87piw3oMC3ZDdGGpEbGM20Y="
}, {
    "num_cand": "U2FsdGVkX1+tVbOJFayb2GiwUR868Khz5F0h2f9qYDg=",
    "cpf": "U2FsdGVkX19gm03UE+tPXrxVHQZ4frd9S5+4OhSbptQ="
}, {
    "num_cand": "U2FsdGVkX1+FOq8pn0LvEU5TfGwyOm+qi0kDdPqXvko=",
    "cpf": "U2FsdGVkX1/y7HhsxhIP8aOjSnbgSLR2zFNFhDyR9k0="
}, {
    "num_cand": "U2FsdGVkX1/4EpbgvrXUI0aVOS766DlFiXa3ilKVF4g=",
    "cpf": "U2FsdGVkX1/TQcFb9tg7gDSbFWd49f+P6MPlHNcvaxE="
}, {
    "num_cand": "U2FsdGVkX19t29sRisg4sRNsoDZsndhfm0CBESTbJyA=",
    "cpf": "U2FsdGVkX1+8hLLd8SYyeJWASC7/cANwU+61vQaO8As="
}, {
    "num_cand": "U2FsdGVkX1+hEWf5N+KAVMKTEWIYh9m+rqmugebpXts=",
    "cpf": "U2FsdGVkX1/VgFYKYIwj/+Bvg4i4e87AC1NtgQm6bUk="
}, {
    "num_cand": "U2FsdGVkX1/UTUs2GMfdWjU1TJNtfgyKQHmXl3cg23A=",
    "cpf": "U2FsdGVkX1/jgryCkVpsLBoJduD0EN9yldUezhGvffY="
}, {
    "num_cand": "U2FsdGVkX18L93lffBB+4Y2m0cWsPgYHs80thUaLsr8=",
    "cpf": "U2FsdGVkX1+cp1Gqh20iTqRZY7rCAHKbpbJMryQAxVc="
}, {
    "num_cand": "U2FsdGVkX1+45dgmPO/cOo7T0MYetPSQRdUTF89l3O8=",
    "cpf": "U2FsdGVkX18WClmns8IvnyxCTzrqKwt+cP3QjnJ7Dgw="
}, {
    "num_cand": "U2FsdGVkX1+IjV1+oTFr/jDT3UE7zRpKYhYzRKZXGQc=",
    "cpf": "U2FsdGVkX1+F+rKbn3+YaAoG7vjzJawAx1bq2XxTYd8="
}, {
    "num_cand": "U2FsdGVkX19DVfZNqPsMjASMNGW48DV2RGOzqi+GDOs=",
    "cpf": "U2FsdGVkX1/udzcHzcRgqd0yl7B0m+Ui/ptGiKf7KbY="
}, {
    "num_cand": "U2FsdGVkX1/IGqIKCirwiUvmKhPG0CuqxorXBiwRHbE=",
    "cpf": "U2FsdGVkX19JSbfO3OdTo6P/GH1wcB8WOTPi2UFJ3ok="
}, {
    "num_cand": "U2FsdGVkX18T8OTWXCZ2V6/gPrfQT3sC8w0/oEE4xzk=",
    "cpf": "U2FsdGVkX1/WuO9NYubkYKiRatZN2l9fEbOMREPTtIc="
}, {
    "num_cand": "U2FsdGVkX1+Z14S6qkihuLrR7P55EaV2De+ta2fuKQs=",
    "cpf": "U2FsdGVkX188W7DDqOyCBQDtQQ8/1KNm6FEsR1F4w6E="
}, {
    "num_cand": "U2FsdGVkX1/9RzpmaBxY2Z8MlUv70PI83k+XqBpZfZo=",
    "cpf": "U2FsdGVkX19Ft5KIfun7fbcliQbw26WIaXUM9jZvrkw="
}, {
    "num_cand": "U2FsdGVkX1+ex9CY78USVZl3HK805031lhaXx4BTo7c=",
    "cpf": "U2FsdGVkX18u8XqRmuFQgm6Zh+zIu8Vtdl5uh9xE7i8="
}, {
    "num_cand": "U2FsdGVkX1+LJGmy8CoB0cm+m8erOCLARn5Pgstmqus=",
    "cpf": "U2FsdGVkX1/uPIEXhPDuyfdex4V4HEILiODo9grdOs8="
}, {
    "num_cand": "U2FsdGVkX182VPoNH4uMkRnanaLnCnXdyHCSNgBCVmU=",
    "cpf": "U2FsdGVkX1+7z7Dw9xbP9KAts8GLT9pU5+2cFnofG/A="
}, {
    "num_cand": "U2FsdGVkX19i5qftsbMA+PGSrpyI7XJQ+aWGupIlL6A=",
    "cpf": "U2FsdGVkX18JjNbK/4KW+VS8Y6jatSSCLBRIBS78Xjg="
}, {
    "num_cand": "U2FsdGVkX182lWvGhcfD56YsMSao+tRARZwNSXAlMpg=",
    "cpf": "U2FsdGVkX19gqRSChCWDlySNnswj+nQFsDnufEACbhU="
}, {
    "num_cand": "U2FsdGVkX1+Wj+EDRi0WscsMxm6xPMxMETsVvPQmSQQ=",
    "cpf": "U2FsdGVkX1/te/PiVIMBiFjbprkn2vnMCp6FaWRQVEg="
}, {
    "num_cand": "U2FsdGVkX1/AI0reiMl3X7erM1kQlej8bdIMmHOqNHs=",
    "cpf": "U2FsdGVkX18MvkCepv6VlpvWenwgK8azdeX4GZ8cKdg="
}, {
    "num_cand": "U2FsdGVkX19qizonUEhQkHBpVItDdh2RCsJHXfNqO68=",
    "cpf": "U2FsdGVkX1+RqHVf/zvbTCu/qT4fgqX9dHzRvx4Fwr8="
}, {
    "num_cand": "U2FsdGVkX182KDRPq8aZ2J0edRz2A3Dk97uSqG3puyA=",
    "cpf": "U2FsdGVkX1+sFWe4ItCI/jUHkoLVFkqV4odV1xnvzrU="
}, {
    "num_cand": "U2FsdGVkX1/XRD0dRyuPyuz4hrZ8t99B/qyBwuHN44w=",
    "cpf": "U2FsdGVkX1894RiIWp266MRDLI/s5Se/jmbPm/sAtB8="
}, {
    "num_cand": "U2FsdGVkX1/lSZ7nbyG4DElbK0u8d9jRBHziBIDBQSY=",
    "cpf": "U2FsdGVkX1++w9GsAzhUs2qtMUwye8tHC7XQLKsO3A8="
}, {
    "num_cand": "U2FsdGVkX1+pEYRjmTLWpBLZO6R1jR+U9YnSTEMgGWA=",
    "cpf": "U2FsdGVkX1+szQzfEvc/UdFgAM0zq2IUi9wTjkr437w="
}, {
    "num_cand": "U2FsdGVkX1+0QHgItM9AavXdeXeOgyCgC3gAThJ9g7g=",
    "cpf": "U2FsdGVkX193ogZfU9Z7sFVb3FP3wInwEq0R9Wc/Z2c="
}, {
    "num_cand": "U2FsdGVkX1/7olo7fMuhZdisNnyxUhyPlMRhR/0UrMI=",
    "cpf": "U2FsdGVkX1/yMvQyCdGV9IoxRvR9NeXy3zbskXupWXM="
}, {
    "num_cand": "U2FsdGVkX1+DvCMyCumTxDGiNF44sc/VE462jA3mYP4=",
    "cpf": "U2FsdGVkX183Pg71aHU8fSTTCzLJz2H0On1b7bmji9w="
}, {
    "num_cand": "U2FsdGVkX18Os3xMHkEFB0bFE8EPpbhoCux3wbhOw4E=",
    "cpf": "U2FsdGVkX1/HFreWYBrlUvBFOkDs6GabF86ztDIhpDs="
}, {
    "num_cand": "U2FsdGVkX1+F30LzYt4NANA41mosp8Tw0ZmKgUylUYw=",
    "cpf": "U2FsdGVkX1+0eJJJENSZ+IrlkwZFSI1SpTw9B+Z89+M="
}, {
    "num_cand": "U2FsdGVkX19RB9CZB7r65upZeT5j8XEk2FkaUTGCI0s=",
    "cpf": "U2FsdGVkX18/Y8KvO0XA1PjtV70kCNhnPvy/fMd2fzM="
}, {
    "num_cand": "U2FsdGVkX1+uA7EDMxVuyqkrxPC08eY+GmRSF+bqTMM=",
    "cpf": "U2FsdGVkX18TTV1KLzT0RSNmTfV8fjU1AABkG4BCaMo="
}, {
    "num_cand": "U2FsdGVkX18PgTW4//GoH3QtB4gVZer4mw+STFyNp/0=",
    "cpf": "U2FsdGVkX192xYvv9JW9zEPvQDD/MEe/Pe0c9/rhhFE="
}, {
    "num_cand": "U2FsdGVkX18Jswgho4MY+v5ycF9ftghUPwWd3M54F5w=",
    "cpf": "U2FsdGVkX1/iT18DzrVMP5GN6P0V/FW0qaAY6nIcyac="
}, {
    "num_cand": "U2FsdGVkX18TCvEZV4XFwrPgXvy/SA+TztJPwaZPcM0=",
    "cpf": "U2FsdGVkX1+/wNa9ZlDza0wL7vac42awSBb+3lDYfmU="
}, {
    "num_cand": "U2FsdGVkX1/x1O6Dy5G9fblC9W7HvoaI1uAGisDktbw=",
    "cpf": "U2FsdGVkX1/rwU2ovF1OoeeNvo6KOH9WF4Iaw++RZq0="
}, {
    "num_cand": "U2FsdGVkX1/YkouCTnikw6UzaCduvPYRIkKzL8UjbQY=",
    "cpf": "U2FsdGVkX1+LMLkIjpTwlUkcJqSBeGyDip+oSserYXc="
}, {
    "num_cand": "U2FsdGVkX19aGXmS7gpUZJ+lzh/WG61+Tddq5h8qGyo=",
    "cpf": "U2FsdGVkX19ep75zyGZlkqfRbYgA2gcDs9jFJBlAzjs="
}, {
    "num_cand": "U2FsdGVkX1/Rh6UGaHKqQ4GIcpB8UwFq6Vje9rt+MGU=",
    "cpf": "U2FsdGVkX18pTap9WZX8sc9ijIxVEcnYBP0wXn/F3rU="
}, {
    "num_cand": "U2FsdGVkX1/itLlvvNHZzVSmYslrn3eaMZcwuqaiGRU=",
    "cpf": "U2FsdGVkX1/ueAeEvPEnptlW/+pO8Y/fzQzeD104Wc0="
}, {
    "num_cand": "U2FsdGVkX19DRZVCP+jlf7RqUbo3a3vY4p2b6gj4zP0=",
    "cpf": "U2FsdGVkX19zFuXIZoGQdWvUaGdq1Sxu8aNjWGHWyp0="
}, {
    "num_cand": "U2FsdGVkX1+Y/cPwafMtYsb8DE4h30Om00YpOUqJj0c=",
    "cpf": "U2FsdGVkX19sRIA97861UdpwKxkuzeRC8JY4Ok/n1wQ="
}, {
    "num_cand": "U2FsdGVkX1+fUCysVVV2jtELDT7UAPnatS5icA1lMmo=",
    "cpf": "U2FsdGVkX1/+aov8ZcdIeJHsqVD7fEt3IePMwV/w7SM="
}, {
    "num_cand": "U2FsdGVkX1+9ZHUixn0lI3Z9YSJMQIv2pFfM/P4aEUg=",
    "cpf": "U2FsdGVkX19ofN5BGCoPDS3gJFzsFxzUAZNLFXC6qR0="
}, {
    "num_cand": "U2FsdGVkX1+LDqEgfLtP/kJtQLfl78lHQXnzEn2xIIU=",
    "cpf": "U2FsdGVkX195gjv4bBJu+gQ7nmvs6Alj7r5tu16PVAw="
}, {
    "num_cand": "U2FsdGVkX1/9sk9mHDB9ecHUT3v8h/XlIjK/bhlpbYw=",
    "cpf": "U2FsdGVkX18goyaRAWrDkeb3DmFnRZM3lD0dXj00/ic="
}, {
    "num_cand": "U2FsdGVkX19BxvofuIrgHA2UI+zlih7Q+21JOs1+Z8U=",
    "cpf": "U2FsdGVkX18qxTvPgtg0MrU56vYojmnIYIEuXqjllPA="
}, {
    "num_cand": "U2FsdGVkX1+Z9hhylTBosQd1v1Cxib2TDhmi3wdnrkM=",
    "cpf": "U2FsdGVkX1/dO+Z2vvRv6vVmO+NE2dD6CFWJ3ybKhq8="
}, {
    "num_cand": "U2FsdGVkX18gAP4TmpCKDsbbbEdFQgMrqq2CqyuJsS0=",
    "cpf": "U2FsdGVkX19WNKwppdRSF3TWkb2lxLn3gXmCVTuctes="
}, {
    "num_cand": "U2FsdGVkX18f26SsFUz4No0kiuaNi1/Kkxwr3RJUtE4=",
    "cpf": "U2FsdGVkX1+WX3WdDoNMei0yjor7feuw8NfmIHAa1HQ="
}, {
    "num_cand": "U2FsdGVkX19XDHfc2Q8Z89JNMl6OWbm1HdXS1EToy/4=",
    "cpf": "U2FsdGVkX1+pAueYhPv41LGgzrBw9He/rh02z1NWqxs="
}, {
    "num_cand": "U2FsdGVkX1+QsOJAmCnVPkRkWoQy7ErxR3w3DqvHBZU=",
    "cpf": "U2FsdGVkX1+DgVM+QRK1+UzCTjmJ5wWBAToZUg+3N+Y="
}, {
    "num_cand": "U2FsdGVkX18Ywm+A2k+andoDloDYMamzUW5ZtQjGibw=",
    "cpf": "U2FsdGVkX18iwZxlMn7A+O0W4sqTfwC6LUyUccFqqX0="
}, {
    "num_cand": "U2FsdGVkX18a0SUT8j1i8ICl4LVujQge0qPZ1M6xIKE=",
    "cpf": "U2FsdGVkX19ja+n3CAl062amzCKrvPW9AKeYVA620f4="
}, {
    "num_cand": "U2FsdGVkX18aqbY9yw94BH1cUadu5/ao8earpxZVPj0=",
    "cpf": "U2FsdGVkX19/r1wHpD1+mORFMkFHpiexyCR8rNb/8AU="
}, {
    "num_cand": "U2FsdGVkX18YDq3PzMmRVoBgjE+FOWhNePq/DCOi3+c=",
    "cpf": "U2FsdGVkX18KjOUhHSHjsnY05bWbgGdvpQoaMsC7z1E="
}, {
    "num_cand": "U2FsdGVkX1+VXYheR//i913MkA7OLXi6BJVuELhs1Hg=",
    "cpf": "U2FsdGVkX1/MN+yAXDOveEmiPzHduD66jzXD9hZeqQY="
}, {
    "num_cand": "U2FsdGVkX1/q5VRajlzF23yh8QscqYPDLCK5DwNwbBk=",
    "cpf": "U2FsdGVkX1/GGZzZNniVAUfGEIrfZlLQOceRBgWmy4A="
}, {
    "num_cand": "U2FsdGVkX19TD9DqE7uGFVTJnF/fTbt+cAHdTkexsCo=",
    "cpf": "U2FsdGVkX1/tvUuA763UKso1zVREtNOW8vaNdH8eINA="
}, {
    "num_cand": "U2FsdGVkX1+GH/hWRTor8BBlsRzuNILez+V37RBeucQ=",
    "cpf": "U2FsdGVkX19jjLnImX1JWy2ilCdW+3aRJGtgNsPnD4k="
}, {
    "num_cand": "U2FsdGVkX1+VJv0bgrJjdwFjD2dUZxv8M2fF8fGa0UE=",
    "cpf": "U2FsdGVkX180sV7eFMTRsxdIoZZoWp2SqaRkp7Rntco="
}, {
    "num_cand": "U2FsdGVkX1/53c7Ml4Frg/AsSZIWoje9DjD9W1Mn3eY=",
    "cpf": "U2FsdGVkX18Xfc1JJJGpMsqbV+whuk7liXRCxKxsw1k="
}, {
    "num_cand": "U2FsdGVkX1+PIEyhPkncWLYB/nhmjshVcnaBC2UcGNY=",
    "cpf": "U2FsdGVkX1+ueeUBc8FLM+u1GSYrFTnbkMomVcvv5Ec="
}, {
    "num_cand": "U2FsdGVkX1/iQ+YxMLOOAVQ2b3krkbhvzs8DOcRtsrE=",
    "cpf": "U2FsdGVkX18kSnoqdQWO9vO42F6IA3gBQV/EsJlw4wg="
}, {
    "num_cand": "U2FsdGVkX1983je2IkuoAR/iKBDLu5YXj1RocznR6/o=",
    "cpf": "U2FsdGVkX1/xqkV0GJ1Zmyo6PTS+NgnDFvAMhdpt+xw="
}, {
    "num_cand": "U2FsdGVkX186EnlsvTT3VkZWnEotLDQHsaUFweLWAeg=",
    "cpf": "U2FsdGVkX1+1FuTa3BzbyLNgyCpP1AIpwzpSVs5TY88="
}, {
    "num_cand": "U2FsdGVkX196FxFdyjr+cFVnggZefEcs9QflTyVjoTM=",
    "cpf": "U2FsdGVkX19ZIT6i2P0JUS9m1PDnIKJPFxykAWdDNRc="
}, {
    "num_cand": "U2FsdGVkX19eSTd1LPZm7s0zzA3nduXenzvCtf1xPqE=",
    "cpf": "U2FsdGVkX19KChVlk7FAlNlhBIFzGHYyE70seEeElJE="
}, {
    "num_cand": "U2FsdGVkX18wSaOMBgH5nUU6Nl+y1WjDc8pfWM4010A=",
    "cpf": "U2FsdGVkX18naJHRHjIf9W6iq+Qm/hbZpZM7ayr4PkM="
}, {
    "num_cand": "U2FsdGVkX1+TduX0zppiOkcHxl67TRd7rIaEG6SptUw=",
    "cpf": "U2FsdGVkX198MkwxWjAkdscXVcYReHuYnIVZZToQrZM="
}, {
    "num_cand": "U2FsdGVkX18twn8Bjry3T5Uq8iu841B7rRe9j9Jwhck=",
    "cpf": "U2FsdGVkX18oZ2Hrx+nN/Yv+zJXRHia570rgk4wBXu8="
}, {
    "num_cand": "U2FsdGVkX1+f3jCB3JZqE2+UTMHTGevAmw9gO0A/pp0=",
    "cpf": "U2FsdGVkX1+IykYnMrIW3fEtOdm9TH8Q3gFsARtgAaY="
}, {
    "num_cand": "U2FsdGVkX1+I5lGoUSX7pJKrrYr+PsCrf2djzh+24Dw=",
    "cpf": "U2FsdGVkX18fhCmVmoBmPM7VWF8IygIPrjMn7R1Hb4Y="
}, {
    "num_cand": "U2FsdGVkX19yQtcBBqU3iOBKXkCpQrpRe876ccDbTvA=",
    "cpf": "U2FsdGVkX1/HsIO0MnttMfA1ZjavE355UXcHCyVKWpA="
}, {
    "num_cand": "U2FsdGVkX19qOrdtHALgHof7a8owK4FawaTH8Sk45VM=",
    "cpf": "U2FsdGVkX1/16bUZtpsBoBAqhQ19qA2gUwt+KsRZ3kY="
}, {
    "num_cand": "U2FsdGVkX18DTWlmQIhI5JKLzq2wzSt43+xrvAGZX7U=",
    "cpf": "U2FsdGVkX1/F+HfQEFm2yjHxSXUbxGwBG6f7eyKSPWw="
}, {
    "num_cand": "U2FsdGVkX1/gtMFrIg8HtBPVzkHeMBPBNvJNbhr7wk4=",
    "cpf": "U2FsdGVkX19Lv5pjIypR7qL0nqQULhboyUF8e5E9AlM="
}, {
    "num_cand": "U2FsdGVkX19uOfJj9xV7keO60qL4/qeqdCJIOWHFhsg=",
    "cpf": "U2FsdGVkX195E2ylIP0zOU54igv8KXaI9i7u6S4nWBw="
}, {
    "num_cand": "U2FsdGVkX1/GSzB5Ln8ttHaEXE9qQVAGe7vd5nPed18=",
    "cpf": "U2FsdGVkX1+E+iAX211xFKrzxdxzxcZfkc5Th3JZlqE="
}, {
    "num_cand": "U2FsdGVkX1/gI1fTXdNVJ8ZObHRhCZYzpiHMUM/MIS8=",
    "cpf": "U2FsdGVkX193vDHkHe717wNm/NtQHnkAZ+Y/xl0XjPM="
}, {
    "num_cand": "U2FsdGVkX19cKNrXX9jl8htg3YqjH/UDxMBYLtUq8Ao=",
    "cpf": "U2FsdGVkX19IqO79gWllC8RSCbXKcMXuQPCZZHThytE="
}, {
    "num_cand": "U2FsdGVkX1+uT7DIYbhNPRoMABIBrUSw6CuIPcafCU8=",
    "cpf": "U2FsdGVkX1+DMb32S6GYnoDLeIY30mqSy4YqZF9d4aM="
}, {
    "num_cand": "U2FsdGVkX1+ckF6+ky+9uz0UeyZiE+bfE5q4NZE5rfY=",
    "cpf": "U2FsdGVkX18+6G/PVxJMrc3ozVu7PXbF0WFMGXzmDBQ="
}, {
    "num_cand": "U2FsdGVkX1+lNJKwCPVNSVkTd4fjcRJSaRluzUMQoc8=",
    "cpf": "U2FsdGVkX1/7V/VrFX8GSvL3W/NF2NgYfLDA4Ayy5+g="
}, {
    "num_cand": "U2FsdGVkX19AcwzSqOnD317jwrd0FKgP3jvNzroZYs0=",
    "cpf": "U2FsdGVkX185LgWLzQap9olqsUzUUMLOrB+deqeBwrY="
}, {
    "num_cand": "U2FsdGVkX1+JnftfDmSUnCqoUnSx9mGO7CPZudYRR0o=",
    "cpf": "U2FsdGVkX1/w6rFhhvtG9ZCS8ssIu8fYorv3F9YAPK0="
}, {
    "num_cand": "U2FsdGVkX19ZIJNJbFL+C/8wERmXQ2PpFk2ZDIg4LbU=",
    "cpf": "U2FsdGVkX1+/Q4FjTDcG3QLbtoQIOqROYPYbYuvYCZY="
}, {
    "num_cand": "U2FsdGVkX1/Zp195el8r5DGij0oh+7Up2HxLkjzQvYA=",
    "cpf": "U2FsdGVkX1/t2jqW0S2bW/QD/u+z4ofUBduMAr1i4hg="
}, {
    "num_cand": "U2FsdGVkX1+67yV4mmD+AzGcJXe6SF+uDybzklfw1hQ=",
    "cpf": "U2FsdGVkX194MvxU5j8YhtB+0PUQQOKzVosBGjcQH/M="
}, {
    "num_cand": "U2FsdGVkX19iZbtGT98tUBF3B4IJOPbMVD9eyBsAhXQ=",
    "cpf": "U2FsdGVkX1+0vpWq8elplHXtgYvqsitwX23qOeu84R8="
}, {
    "num_cand": "U2FsdGVkX18HmMRHnoMA/0m2vf4iBablDp1GxWYHbLQ=",
    "cpf": "U2FsdGVkX183MvDUDL0Rcv2Z9BrGXBFWkiUe9Jvxo84="
}, {
    "num_cand": "U2FsdGVkX1+VX9jPYiuqaMIOfhNhOYFvBIwMlwRovwg=",
    "cpf": "U2FsdGVkX18nMIl78bnr42Hb5q8QHSgQtAYSXsN0Ldk="
}, {
    "num_cand": "U2FsdGVkX1+5CLrSLiIDg8PXs0qz4ClEnuEOYoC69YA=",
    "cpf": "U2FsdGVkX18/gaSWA7K0woH4NaVCtbayuViMoE4BezQ="
}, {
    "num_cand": "U2FsdGVkX1/eBNBAmUOKeCl2AD6mgCpZUXrtzFONX7U=",
    "cpf": "U2FsdGVkX1/rNQZZfsbuv1BhmKHboxHRUVjDQsd+h3w="
}, {
    "num_cand": "U2FsdGVkX1/8j6pAjG4DEmDDcAM3XUwLCNfsguIyJNE=",
    "cpf": "U2FsdGVkX1/Mhkv0HkgH+ZxW4Vc0Tuujk0SDXBwyH48="
}, {
    "num_cand": "U2FsdGVkX1/UW+rkwPv/HI19FwtuLrH74BED1FJKiV4=",
    "cpf": "U2FsdGVkX18IieNG7ODwdMuRQVJJPyiUuXN2JJInKO0="
}, {
    "num_cand": "U2FsdGVkX19Jc/YELx6r37KL11P67lft3wW4CBCVxc8=",
    "cpf": "U2FsdGVkX1+xld47xAPbdNxEU98CrguSHM7kDtnUHVo="
}, {
    "num_cand": "U2FsdGVkX19+wsdhYF12qTAi5S55BV3wNl9/EZmgYbk=",
    "cpf": "U2FsdGVkX1/8ocxWBsVw0DMWQ74+AUrcakBL0PCun0A="
}, {
    "num_cand": "U2FsdGVkX1/SoFvom5SF7rH7gcPO1UH7Qp8hy+xQitU=",
    "cpf": "U2FsdGVkX1+15MJACvdJX0VIdrOvfQHG6+sOPM5UAME="
}, {
    "num_cand": "U2FsdGVkX1+2LlRoKMA3SWh5l9SLqCBGOb3XxmA9AZw=",
    "cpf": "U2FsdGVkX18/x1HG1ImEKLdMaY6kBfiTIctocVfw8YM="
}, {
    "num_cand": "U2FsdGVkX1/bZ1Sye3MWgLOZ/v9T+psIRaJN5ixMsE4=",
    "cpf": "U2FsdGVkX1+JigMHZawjeP6damus/EeM1ayYqUjhip8="
}, {
    "num_cand": "U2FsdGVkX18RyZrmhopvTxQnSvafbvgqAzKVpAIbZes=",
    "cpf": "U2FsdGVkX19G3h2Aj+NmaKDAXo/o3GqNazifmE+5/DQ="
}, {
    "num_cand": "U2FsdGVkX1/e8KZk50z8mS/THfRw1g4f8j/y7DpSwEg=",
    "cpf": "U2FsdGVkX19CVBaz12PThKalrbdO08BZQi7GWQWAltg="
}, {
    "num_cand": "U2FsdGVkX1/5Hvim04AtA6jMSiv8Omy33XH/rNuYy0s=",
    "cpf": "U2FsdGVkX1/lCzrWuoLz4ymuoZaBHBAZceNrVz4OEek="
}, {
    "num_cand": "U2FsdGVkX1+fKWOzsj/VRfN54mDEqT1o/4ln3rp737E=",
    "cpf": "U2FsdGVkX18hsLWPLr1RAp3yTSUKeiMrGwtRGSdBJ4U="
}, {
    "num_cand": "U2FsdGVkX1+j+nG+2cQCbSWDr7DdmCk/1jWa+T6kjOw=",
    "cpf": "U2FsdGVkX1+8mGPVBBMlc/UqPShD9JLJ1rGIsZAT8q4="
}, {
    "num_cand": "U2FsdGVkX18qni2BMeUawQx7Vc1C1yy/pJ4rTvxh3rI=",
    "cpf": "U2FsdGVkX1+zxk7sdza9f71PQlMxhZlKIoO/2UnyrDU="
}, {
    "num_cand": "U2FsdGVkX1/DI0TO7Nv5nHkEj4E4w7lVAtmSvo1khR4=",
    "cpf": "U2FsdGVkX187IStw0FG833OtXI4UfH3j9gKJ/o9Vf8w="
}, {
    "num_cand": "U2FsdGVkX1/lWLY07JgP0rc6/mD+9IGzLoxZC5zZTow=",
    "cpf": "U2FsdGVkX19Tnm+hlUMno8BD+HfUtfC2EgDeyCilR7g="
}, {
    "num_cand": "U2FsdGVkX1/NUNGTnFUt8//Whe3Ydphso7yQlmRCXtU=",
    "cpf": "U2FsdGVkX1/up27eVdAvj02sIYhXsY7bzxHoV+GaVR0="
}, {
    "num_cand": "U2FsdGVkX18uEmejLVAcrpJpQYk6/tN21F5Y71/xBIM=",
    "cpf": "U2FsdGVkX1+vJmoxuHPpnvBghjjCFf8r2sYke3oG4iw="
}, {
    "num_cand": "U2FsdGVkX19ESvUbfI9xAUA3tfSnzSJUdLx0LE4W8wQ=",
    "cpf": "U2FsdGVkX1/UKZd7lL9nfpMeUMWWCJw9daAjkeVVEnM="
}, {
    "num_cand": "U2FsdGVkX1+W7rlOy0pjrVu8Wl5I0dk1nJba5mmgP48=",
    "cpf": "U2FsdGVkX1/rykDHBWwbDfJ4moB+ouolvYz4WOi08lw="
}, {
    "num_cand": "U2FsdGVkX19lkfjjw+VYCrRig+VPsaNST6BRAWLkbK8=",
    "cpf": "U2FsdGVkX1+GWaSu6+lbMyCU0c8QKBMNb/eKVABaAz4="
}, {
    "num_cand": "U2FsdGVkX19/vD/yAzTv2xUQ21coGx/iL6x33Tb3WFc=",
    "cpf": "U2FsdGVkX1/uHysO2M0ecCZ4UmYEP3v4JiUpY5I+PVc="
}, {
    "num_cand": "U2FsdGVkX19ewi8jvPXOKB0esgxv/3ixpmrFJUFMyTE=",
    "cpf": "U2FsdGVkX18EFg+4ZLT/7I73S+uXpZ7dpQzW5G8AJoI="
}, {
    "num_cand": "U2FsdGVkX1/q59jNUwSGxfrWRRkw6BkUawQvR391PfY=",
    "cpf": "U2FsdGVkX1/VTq5Ao4NkevzUIc/GOA7uqSY4ef2XptI="
}, {
    "num_cand": "U2FsdGVkX192pvLJ5rL9+wmqPYZyDvuF3pb7L2u914Y=",
    "cpf": "U2FsdGVkX18rUfsGFX0Uy/ikXC1g6t08cXihlJ7Ev3E="
}, {
    "num_cand": "U2FsdGVkX19m0U35oy6FVYdAHzWMBfOVsfOEHLp6TFs=",
    "cpf": "U2FsdGVkX19H7q3p7QNexSjgiIzHxsMl+6A8fOTFFwo="
}, {
    "num_cand": "U2FsdGVkX1/VBIAuUTIITBuG/5oujh0Zz8hEnK4wv2I=",
    "cpf": "U2FsdGVkX1/0k/GcH+MvYOVeMYfdaxHrS+C5cExSFFc="
}, {
    "num_cand": "U2FsdGVkX1/zgMgh2iPfoG3D+CoOr89SvMdVb0NWS5c=",
    "cpf": "U2FsdGVkX18p14/rse51DnMxaAuNs6Lpq59/w2s5kZw="
}, {
    "num_cand": "U2FsdGVkX182ZoCsyzmQuVoCGfcGhmFeVFPM3bZ63Sk=",
    "cpf": "U2FsdGVkX19nwimLfPXkvjaLChHVqTOtSLXnVXJzpmg="
}, {
    "num_cand": "U2FsdGVkX1+NHj8dHL7inBqPUmkujSULI+4ll2yNL6s=",
    "cpf": "U2FsdGVkX1+bXXU8Z+7CLj4Vm+4frt8d2FMS6FhAmYA="
}, {
    "num_cand": "U2FsdGVkX1/89Wg5+u0K6EzxJbWgNkyt2kD8itpxjlU=",
    "cpf": "U2FsdGVkX18Fx6ORV8H3YhXTUk2jnBfRq2vEu5bGCG4="
}, {
    "num_cand": "U2FsdGVkX18MNuUe7nBk/3X9j2QlUUOmUM+Jsc9k9Kg=",
    "cpf": "U2FsdGVkX19IWApDfsQd/9NgjIL83SP7MNHJPsfhkSc="
}, {
    "num_cand": "U2FsdGVkX19UduQ00rnReHelA82jpHyQ2P99bju+QVA=",
    "cpf": "U2FsdGVkX19l4KRKbU5Kncj/Iv04DwrWG6HYAYENuvY="
}, {
    "num_cand": "U2FsdGVkX1+16g6cUuGi+xAq9mfvJQIYJdZLApbsmxo=",
    "cpf": "U2FsdGVkX19qtZFebmw2xkV+ZO5zehTxGRCXJ7y7I+0="
}, {
    "num_cand": "U2FsdGVkX19Gl6JVhY8zO4tRqeMdieWVPVomo/wMSys=",
    "cpf": "U2FsdGVkX1/Hn0uhohoQuu+wuSAmg9k6K89yIPkwQSQ="
}, {
    "num_cand": "U2FsdGVkX1/RMCoHIlFSYE98FjzqFviBmnDecQpGqiM=",
    "cpf": "U2FsdGVkX1890pP4HOicmD6cqMCPGRxu9rzlL/NYVoE="
}, {
    "num_cand": "U2FsdGVkX1+HjRm8Kxdyjpi1a+FgLV1w/qpNCPYp2XM=",
    "cpf": "U2FsdGVkX1/X+s/6G8ybsaGh/15nPR9qYcB+8V0iY+I="
}, {
    "num_cand": "U2FsdGVkX18SNAZ0tZDbuMotU84CAdN0t6+M/OnzDuM=",
    "cpf": "U2FsdGVkX1/8RQZXT4pVSIBr6GT1tATF40UF6UaCHw0="
}, {
    "num_cand": "U2FsdGVkX19BkHIGR46YSB84DJOdi45x6UATAxK2yYk=",
    "cpf": "U2FsdGVkX18cNrMtWZ45Bxegph9r3dtxmCV/GNTuhtU="
}, {
    "num_cand": "U2FsdGVkX1/TdGHj196M539YRQaof7rsD8Gv8Fl4CaE=",
    "cpf": "U2FsdGVkX1+7ioahFs9/uhp9jQMA1Ou6Dy+DSnh1EKA="
}, {
    "num_cand": "U2FsdGVkX19x1T6HQKk+iDvV+8T46Hw+T5Vs9yQcjXU=",
    "cpf": "U2FsdGVkX19QGkNYR06C0tZeoPj5nnx/EpU5Nn4XGhQ="
}, {
    "num_cand": "U2FsdGVkX1+ZM/Umw3Vv8zEXMQ8OmOSIcCM608iQG2E=",
    "cpf": "U2FsdGVkX18f8wVIKPXavpjceJH947LhAnmyTzZwASY="
}, {
    "num_cand": "U2FsdGVkX1+Ke/tGvl72HZ9m/ZV7B6hLVxMWYrgGpoI=",
    "cpf": "U2FsdGVkX18Rd68nRWNiiuZSbkk2OgIwffH1NYtpjII="
}, {
    "num_cand": "U2FsdGVkX1/jYvUH9PdnYA58lOKsYT8Ri8d35NrDOSM=",
    "cpf": "U2FsdGVkX19KIK6ma4i8FD/7TO4Tj7JsK6BtvEvl/eY="
}, {
    "num_cand": "U2FsdGVkX1+yqY+cQZyh6/pqyKFMRj6Wdeyu1BJ2lIA=",
    "cpf": "U2FsdGVkX19nM1lAWRx/qznuQZgLhHM0WOKjFjP3NY0="
}, {
    "num_cand": "U2FsdGVkX188X9IVIKZ0vKjV0YZAeUG/zqsv/eEmkb0=",
    "cpf": "U2FsdGVkX19z9LpKsihD9Ydb21STJ1V1Cq1dRqbGPCo="
}, {
    "num_cand": "U2FsdGVkX18dQ4M/Kek/I0wuQXRSxcTkO4XeH6h1zY4=",
    "cpf": "U2FsdGVkX1/p0p94OXwOdqsTvD4vOAAPpyO84Y/rm8Q="
}, {
    "num_cand": "U2FsdGVkX191x6QsqgDPStL8bOmayloZhIqyRYzz53A=",
    "cpf": "U2FsdGVkX1/SJM6ICQSkc4M4sSPYh59POS0KJWQlpGs="
}, {
    "num_cand": "U2FsdGVkX19fbOtmXnyZ8Yb2AkbBmJjNndUpVKOk3r4=",
    "cpf": "U2FsdGVkX1+XwlviCBVRsfGYtLTponeDm4jBvN0ZerM="
}, {
    "num_cand": "U2FsdGVkX19tQtjyw7WgHJQ1KGB+c6OZKSkcDl/+NaU=",
    "cpf": "U2FsdGVkX1/7qmZZF9RWrsnj5ZMkhMs/MTDvW8NCmBY="
}, {
    "num_cand": "U2FsdGVkX1+B6RiHSVAm6+iFwRWaI//KAT8lEyvHqVk=",
    "cpf": "U2FsdGVkX19er1XS1b9ZJi4FIMqvAinLMCxuSg3jOGQ="
}, {
    "num_cand": "U2FsdGVkX194NAyRTn+q1ghXD75Bu/Z7+JwbcYN9zY4=",
    "cpf": "U2FsdGVkX1/eOdPZGCzqgBo67f0JkEK4ztvqmD39kq8="
}, {
    "num_cand": "U2FsdGVkX1+N+Zfe58GXR/n74We87CZHTEq5hrwN6Zo=",
    "cpf": "U2FsdGVkX1/bnhabCqRDp97fqhSS6tjOFicuohqhTWE="
}, {
    "num_cand": "U2FsdGVkX1+tx7T1AeTSkYRJoalDktl8DCA+WXlmz+4=",
    "cpf": "U2FsdGVkX1/pBZSYt4RXctUCrb4gX3wujANJHr4ZuMg="
}, {
    "num_cand": "U2FsdGVkX18CiaiEgpbNqMAtsufoDt16WtyxrH66RoA=",
    "cpf": "U2FsdGVkX1/l6OV4E/+gffR3fwKy5pFbzSTfEolBVN8="
}, {
    "num_cand": "U2FsdGVkX1+kgfd6VmhInPfhuFtKBg9hEm9znpNLpTQ=",
    "cpf": "U2FsdGVkX19yxABD0Kp62RwQGAyC5sU6OjlDkgeI2E0="
}, {
    "num_cand": "U2FsdGVkX1/UKGT92yamsq1+njBWEtTKYqrIq3x1Gqg=",
    "cpf": "U2FsdGVkX197ZZkDmn2JdgsEL4z6Y5ULr0K/qk0tq5A="
}, {
    "num_cand": "U2FsdGVkX18t8UbxVdtq4qSeg7mCE71XOueP+WrnoCY=",
    "cpf": "U2FsdGVkX1+HXxjZpsvtcIAT9hpW9Rn4HkuZ/BerapU="
}, {
    "num_cand": "U2FsdGVkX1/D+DdTaxSb7FKy1eamZ7ieaT11LdqdbEo=",
    "cpf": "U2FsdGVkX18PthMOFW+pubKAcisC/Mf505k0J7vkzoc="
}, {
    "num_cand": "U2FsdGVkX18arssjzUquemuF3Zu7M/NumrnBnqh89r4=",
    "cpf": "U2FsdGVkX1+nV84G/8Sl5nDrUd7X1PPImL8bcxLU210="
}, {
    "num_cand": "U2FsdGVkX1+1pJwFRbXG/FJkVLzaV02JGdjo9glezdM=",
    "cpf": "U2FsdGVkX19RDOvq2T1yuY1jzneVIa2V6npnZb0kPSE="
}, {
    "num_cand": "U2FsdGVkX1/Nh+lDV9lZNJKpFUQb732Gi+7j41GcuoY=",
    "cpf": "U2FsdGVkX18X45uZsFkL7SKMNSbUoAEtbTzJ9Tc1z6M="
}, {
    "num_cand": "U2FsdGVkX1+yvNs7lMxASjZfIeBF+yOTJx1GdoSMBVI=",
    "cpf": "U2FsdGVkX18ghcz1eU4zW7lMTaSugsPDkpviLLFAh6M="
}, {
    "num_cand": "U2FsdGVkX1+UTRuWagO+ze6sy9hWNRod1BBg1BEHqNE=",
    "cpf": "U2FsdGVkX18Ji0zElwaW2I+RsM0UCfw4+XIWNNU4m+Q="
}, {
    "num_cand": "U2FsdGVkX19fF2RWteeHi1GGA8zNTBjSLrpwDKs6s20=",
    "cpf": "U2FsdGVkX19o5T3fNPuMyelNF0xR4g9w4+mUTbGjZ9s="
}, {
    "num_cand": "U2FsdGVkX1+cWal75kueP+CSp/AV0FKxXFjkIhnOU4A=",
    "cpf": "U2FsdGVkX195LNIubx8gu7jtPONGAnao3nzvP6wC93U="
}, {
    "num_cand": "U2FsdGVkX19auer7d8kqZG+rFmV8krAM0qkmoH4Hlls=",
    "cpf": "U2FsdGVkX1/r5Lwin5ZRy7qhtJb3qxd6QQjm8OkkOK0="
}, {
    "num_cand": "U2FsdGVkX196PClGTb7v0fgZaD/0AW57vJPsHfDOflE=",
    "cpf": "U2FsdGVkX1+BsCUIQLrzbTjs9EMXCc3VrldfeQQ/A/E="
}, {
    "num_cand": "U2FsdGVkX19/QbvABHxV4VzMyVMgdhPoCvwaNSkxOQw=",
    "cpf": "U2FsdGVkX18tqTvxIdET584xmXy4NHpCiGAQh8ABlNM="
}, {
    "num_cand": "U2FsdGVkX1+MOPDgizu49J5ccK/a/qxZWx8rchjLvWI=",
    "cpf": "U2FsdGVkX1/0U8X2n8QQS20NUE2iTspw88M3ugOZ8Ug="
}, {
    "num_cand": "U2FsdGVkX1/fnjmo0hx95lvV45B5BvV+A5AMa4PsuQc=",
    "cpf": "U2FsdGVkX18nDPMLF0Y0HmvoQ8HBApQOADWsvCCrdRk="
}, {
    "num_cand": "U2FsdGVkX19BParrEUzIrdy2NFBHf92R6bIBal0hebs=",
    "cpf": "U2FsdGVkX18xw3pUDKDPXLG2Mi3HU72KK17q2g+oZvA="
}, {
    "num_cand": "U2FsdGVkX1+6Tgk1l81HfF6ZLJ/Uk4Sx3A/FfA8G2sw=",
    "cpf": "U2FsdGVkX19qeJmEZzqMF6b3cf2bjPtkXOIWCottGyk="
}, {
    "num_cand": "U2FsdGVkX1/eImIokJimUEinsEHTpvIxwt58RoBxqJE=",
    "cpf": "U2FsdGVkX190d8GsplbuyH259UOUumWkL3Fnh7yDMF8="
}, {
    "num_cand": "U2FsdGVkX19XDofTI85zCBKwys+D2J9LKFhVpOxFyz8=",
    "cpf": "U2FsdGVkX1+oG6oO2R5YT/khzoZqB520wKAToNN2xxI="
}, {
    "num_cand": "U2FsdGVkX19/5AJshk1MhmBU31eX1Ylm1B1a/b7Tr0A=",
    "cpf": "U2FsdGVkX1/kDq4S/oRmEbW/Cdi7RMQVwH56cNbNAxs="
}, {
    "num_cand": "U2FsdGVkX18j9aPPbCs5y/EszX/2djSgrJc88ppmpbE=",
    "cpf": "U2FsdGVkX19D9Cnis7PYj376j3MA7LxWAnMCbaO+TJk="
}, {
    "num_cand": "U2FsdGVkX1/y+aA36jyFdRp0ipqO2BVAC5oO0QG3W6I=",
    "cpf": "U2FsdGVkX1/2Y5DMpBYh+xZp6RdlUiCsDuMH+de914I="
}, {
    "num_cand": "U2FsdGVkX19Jl7fJ9eWkjD5AvY2hm46Xqp+4xiLn6hs=",
    "cpf": "U2FsdGVkX1/oDz565FCT+xxmK2qI+E2lt5U9PcsfP6o="
}, {
    "num_cand": "U2FsdGVkX1/wP13dEgdLaRU9Lhha4hLWU8yt51jzB5E=",
    "cpf": "U2FsdGVkX185UTn/QWDBW8bdwVNW1exZRQe/aS8M5og="
}, {
    "num_cand": "U2FsdGVkX19D4RWnxCt7l2T7Sl8C5BbOuBFBPreSPF8=",
    "cpf": "U2FsdGVkX196VkF2nkM24iKUDaQLnrBYETod6TBZjm4="
}, {
    "num_cand": "U2FsdGVkX19rzWrAk8NXn25zCu/dBDgJcI+gsfinK7w=",
    "cpf": "U2FsdGVkX1/D9kX5KdQBs/JY1TN9KeDvnEmChO2OpbM="
}, {
    "num_cand": "U2FsdGVkX19tuLNPtVEKVzaaMGOnVZiAoYx/ZC+oyn8=",
    "cpf": "U2FsdGVkX18aOkPQwpUhkc1CA9BQzL/1xN/GeI/QQos="
}, {
    "num_cand": "U2FsdGVkX1+ljHZGEP/U0ZrGe59xZoRP+x9BE6U+hyQ=",
    "cpf": "U2FsdGVkX1//nnxiaETNaLmknVztb8hJtRLHN7MBYpY="
}, {
    "num_cand": "U2FsdGVkX1/0lCbvbyCJQabLSc/zC/LVjVDnQG9yzq0=",
    "cpf": "U2FsdGVkX18vWlbsEvd5pBYsQbb+Q2XOgr/H7mV4W8Q="
}, {
    "num_cand": "U2FsdGVkX18kcLcAi0Fx4KaUD8oPcFKnIaiMlZkDA74=",
    "cpf": "U2FsdGVkX1+XXBnladHH+Ps0IDzxn8/T3wKRnUkGujU="
}, {
    "num_cand": "U2FsdGVkX19f7PxCVZQZsc121Hksoz4NMPdXAb2e+Vw=",
    "cpf": "U2FsdGVkX1/SpcR75o4EG1wK42F/f8v6ZkEyiJXgBSA="
}, {
    "num_cand": "U2FsdGVkX19emT7BUxLhC3ieGkxK0KpWAsV5YRzB0G0=",
    "cpf": "U2FsdGVkX18W84RD3SiPMHPP6/HTKUqWbFwMhk7TibI="
}, {
    "num_cand": "U2FsdGVkX19MNd130aomhmEFLzLMacf0ziTa3FNrkHo=",
    "cpf": "U2FsdGVkX1+BvYgTGep1fUuNmolhexrpFFfMIUYnAvM="
}, {
    "num_cand": "U2FsdGVkX1/TzeBo5YwOKTkKAvOVzRi8nF8uH83vfDs=",
    "cpf": "U2FsdGVkX1+T2tCdeJ/XE5AQvEJoDjQGf+m/sZESk9o="
}, {
    "num_cand": "U2FsdGVkX18Hb1jk+gFQ9U5iiOi4mMd2fby6ZxEtim4=",
    "cpf": "U2FsdGVkX18Kl+MjSK4aK0vQKXcv1Oxj++pH9qngFic="
}, {
    "num_cand": "U2FsdGVkX1+2hVk+qeIo73d6oPiMf1DN3x+ddmcnmVI=",
    "cpf": "U2FsdGVkX1+sesUFP77NNSVXAhypHFT8EGDItBhQ/GE="
}, {
    "num_cand": "U2FsdGVkX1/JnmcIBj96nI8ozuwg0QorYBs4wgdPrDc=",
    "cpf": "U2FsdGVkX1/zn6L6ZJJNboLP3fI/+WpooIqcFY26Eq4="
}, {
    "num_cand": "U2FsdGVkX19SZanmgQ338YmHV+dkqkuB+zG4VHnCtWk=",
    "cpf": "U2FsdGVkX19BGvFhospc4kouYT5LdHixk0jFulfTmp4="
}, {
    "num_cand": "U2FsdGVkX1/YFMA5U/maFBbCglQzkezn61ozWrPsoIA=",
    "cpf": "U2FsdGVkX19hMLR5coCm9whQcuvFkudbvnb6PL+nOBM="
}, {
    "num_cand": "U2FsdGVkX19fiIN7ERpPhglekqE0R/Ew+sNCw7NzRoM=",
    "cpf": "U2FsdGVkX1/2Pkto3371TAgtALF545U1YIAFp6gJfb4="
}, {
    "num_cand": "U2FsdGVkX181wA9wnb1ANeGLJn6bGK5zcsK1eHSYAlA=",
    "cpf": "U2FsdGVkX1/p4EmqCbaXjMzIlCZHLdTJ6jQiSqmuzJQ="
}, {
    "num_cand": "U2FsdGVkX19wWqRJkeYeZ9765WwF29r5XjNS0OHISNM=",
    "cpf": "U2FsdGVkX1+VadFz0mxitWRqKM7/y9p+QycGWapU9jw="
}, {
    "num_cand": "U2FsdGVkX1/7ATvoQJaE/tQvMTlwb9GJXOKCQaKWiC0=",
    "cpf": "U2FsdGVkX1+9VpfVuH3vhmxzn5cevG+SxepR7HYQFTY="
}, {
    "num_cand": "U2FsdGVkX1/GFKwRdCIfcUipPnFZ1mi3CcVk+wlMKd4=",
    "cpf": "U2FsdGVkX193ebpPiXTo1KvwgkXkY96lena0vPzBlCY="
}, {
    "num_cand": "U2FsdGVkX1+1gGCBEVKExeEyTmys2YjwsB/ha/2hZMY=",
    "cpf": "U2FsdGVkX18pzAKwllmuVDLjf2PnRfDU4/6zcp4dix4="
}, {
    "num_cand": "U2FsdGVkX1+McffUSLFoQVwe5Z6J3UemIc5xocbaLp8=",
    "cpf": "U2FsdGVkX1+YqBZTXBCL58tdk9PAg3oADI0JMqxwM8k="
}, {
    "num_cand": "U2FsdGVkX1/3vwN1sf+aovZNdKZmy4TC0rrK18yIeyA=",
    "cpf": "U2FsdGVkX19QnfiT7EkYB5p5Kqs01T1aa1DhgckK568="
}, {
    "num_cand": "U2FsdGVkX1+mUf6NLQfHgtBfgi0tFtYcpBM+hv0uwIE=",
    "cpf": "U2FsdGVkX18PXSi+39kP3+WtA5xCxeCW6c/+I2RjC04="
}, {
    "num_cand": "U2FsdGVkX1+4CgfIRc2ItJ7qkBqLJOa28sIvCqiPR+Q=",
    "cpf": "U2FsdGVkX18gIS84HEv4naQHk5wCIjq6oq3bFLW9IrI="
}, {
    "num_cand": "U2FsdGVkX19AikW6oLnUJnfohnTadpouxM+YSqj+xBI=",
    "cpf": "U2FsdGVkX1/dHe+ckhO8qMTpnnob11/D8G1kYWRhlI0="
}, {
    "num_cand": "U2FsdGVkX18kgWuUL6Y/FaPfagm5Ir+PoM63QpNRnj0=",
    "cpf": "U2FsdGVkX1959Ga28ufg0S7DfDyyU0j5iLUycxyStW8="
}, {
    "num_cand": "U2FsdGVkX19gPQB0TzBMBe09sbSQg+wVL5BjlladpHQ=",
    "cpf": "U2FsdGVkX19r3IyXyNXTt4/KkGP8JulivuakJsSKu0k="
}, {
    "num_cand": "U2FsdGVkX18oROoYqsrdXHeo/7mRarKr4O8kMZTMN14=",
    "cpf": "U2FsdGVkX18umiGDTqtkz0vc+IENGteFRxpVOxTba9E="
}, {
    "num_cand": "U2FsdGVkX19H0eHDUKKmE4egPTw2fiLi63lbuVB9KBQ=",
    "cpf": "U2FsdGVkX1+0yOCbhYpM3OP5fXRe7XFOoTFPKAW44OA="
}, {
    "num_cand": "U2FsdGVkX19uZLVRxvnekpKxKkZHaToYCRyr8SY8hMg=",
    "cpf": "U2FsdGVkX1/EEr+ocV2GSq7mn0AvSJFSR8rY2JKSWQ0="
}, {
    "num_cand": "U2FsdGVkX1+eLyZKzmc/hlNP46VQkXTHVlBhT66Ypf0=",
    "cpf": "U2FsdGVkX18eElLQ3tAIy+fPexO8H1iYF6yxILhltms="
}, {
    "num_cand": "U2FsdGVkX1+5lFf9I9PJX4flEp6xxDjD1LQk8uhXSEk=",
    "cpf": "U2FsdGVkX1+Bk2BXOXu5se8ab0uIHDRCnrokvUMQYbg="
}, {
    "num_cand": "U2FsdGVkX1+N4ztdsVSlw8wCF2j0XoiKJ2zwU1CvesY=",
    "cpf": "U2FsdGVkX1+oXwnu1H6R9/MWeltLYwKWFoPg9SbiGeQ="
}, {
    "num_cand": "U2FsdGVkX1+Hj+uJsgRyB5D/eHLu0tFPmTVVB/Mq5X4=",
    "cpf": "U2FsdGVkX19t0l3uDelTaTUXzgSnBDyBW6J60Cz38HA="
}, {
    "num_cand": "U2FsdGVkX18ZdMdda4adqOyr4iOJ30p63nXDFZS8nyc=",
    "cpf": "U2FsdGVkX1+l/UauOyjIJrQWYSUoXVW4lF3qewRhibM="
}, {
    "num_cand": "U2FsdGVkX18svbvSQurbGRTvR8X3/+r4z/GTtkGDpvw=",
    "cpf": "U2FsdGVkX1/Y39wCRbGcL+ey31bBd4CFqFwOaLdsFGc="
}, {
    "num_cand": "U2FsdGVkX19t0u9X/qaYPAYYTD7nKFcV1Ek8wRU6Gz8=",
    "cpf": "U2FsdGVkX18C31jjTuQKeXS/5tMEv6bJ1eM2dqLgNGk="
}, {
    "num_cand": "U2FsdGVkX1+Z8gvmscJiE25uwT16rXYsaqNH+qnC6UM=",
    "cpf": "U2FsdGVkX18CInb9p57WERxlVWkBBF4ODSXGw64ciF4="
}, {
    "num_cand": "U2FsdGVkX1+wgaW1wv5/9Q4q9TjgjVld3PBrhTFNxrU=",
    "cpf": "U2FsdGVkX18yqM3hFzDXu/D4h/A/yq7PURuE4ueH53Q="
}, {
    "num_cand": "U2FsdGVkX1+bnlM4yM9/8MgeSMhjr1nKO4wc7fX5Zbg=",
    "cpf": "U2FsdGVkX18K7ciSwcWYNZTkE5NEtPyeUBvN0OhHvug="
}, {
    "num_cand": "U2FsdGVkX18LFBAP9J2NDCbc6+wLobsbiTpbE5PE+gk=",
    "cpf": "U2FsdGVkX18qfauYuMG6jsQhbyu788UI0Bm1qZEngE8="
}, {
    "num_cand": "U2FsdGVkX19DyEcOkOavElirSLyA/Ufi1MIx9f/Vad4=",
    "cpf": "U2FsdGVkX181mpKa92kU/ZdPY8XSridm9D0FHgShDpE="
}, {
    "num_cand": "U2FsdGVkX1++Su4WbndVomTARZGaGU2DanOH1mZCU8Y=",
    "cpf": "U2FsdGVkX1/uc7X4xp3/P6gwOwqzLffPoUwLa3E9Xfs="
}, {
    "num_cand": "U2FsdGVkX1/8AAId6vAG6jFNVTv8mhVNNMpFINoKv3I=",
    "cpf": "U2FsdGVkX19/xDaSOc/TO8hISAN9yOTSGiSdeUg8VmI="
}, {
    "num_cand": "U2FsdGVkX18BPokSKwMgxEPOP4AFv8KoX+Mxk6xk1tM=",
    "cpf": "U2FsdGVkX1+TE4yvPNF5X7vXwpS4Dof/F9dmi6oZaLw="
}, {
    "num_cand": "U2FsdGVkX19cT/zTc7yyOAivbGznDGRK8D3OtGyz2b4=",
    "cpf": "U2FsdGVkX1+yZshmBdjhTwtCvekg1rjAHUUvrZviR6I="
}, {
    "num_cand": "U2FsdGVkX1+kCxxGipxBYRyLhoAMaGHUqMFlcH5JoA4=",
    "cpf": "U2FsdGVkX1+CWQTXKCBquKYUtamfNPDAeL2FcBkf+K8="
}, {
    "num_cand": "U2FsdGVkX18zZjzYe6pRm64GZ8jDqdonguVkHVgdyZ8=",
    "cpf": "U2FsdGVkX1/5rJHBZyrqEduqTZ4Ne6Pac23YR0knqnA="
}, {
    "num_cand": "U2FsdGVkX1/MnOiVxRnFtBy+/la7O6nRwk5Rb4xySnw=",
    "cpf": "U2FsdGVkX1+Y9/EV+kq5FG7v/4VL+Bpr5mB2Qj4e0zw="
}, {
    "num_cand": "U2FsdGVkX189/t+lZSrAWmSk6DGyIohWYYmZtH+4qNg=",
    "cpf": "U2FsdGVkX182ECD6Tn1FPNDooUR/KEOUzX4acwStisQ="
}, {
    "num_cand": "U2FsdGVkX1/beKHin0M5msl/pbnNDYzF8Y4z+JlTKc0=",
    "cpf": "U2FsdGVkX19mo18020xUXZNnExRvnQQ/1HYxRKS52O4="
}, {
    "num_cand": "U2FsdGVkX197nZoWGjpPRhCXST1GNSbdhE7Xaeyu0DY=",
    "cpf": "U2FsdGVkX1/2SHqpwuR8GG3YlGnFFPSy8pjelIJqjag="
}, {
    "num_cand": "U2FsdGVkX1/WjPmKBwoBQ7juzmD3ikxjZQ67Q1kQ9/Y=",
    "cpf": "U2FsdGVkX18V3o7wjeiaqioJuTz3KkL0itUzPF15yqs="
}, {
    "num_cand": "U2FsdGVkX19A/3Sp1KZ6wyCA8RBOh6lsZtYfcERC/rU=",
    "cpf": "U2FsdGVkX1/jISlNR2DO3DhwTTm+LPfbMha/kebRrAA="
}, {
    "num_cand": "U2FsdGVkX19MuhhhDhb7cBwbNRKmu/jo2yRqvNJ0Udc=",
    "cpf": "U2FsdGVkX1/2Bbbo45VoSFWUa5eG9ZBUr1OGBh326ZU="
}, {
    "num_cand": "U2FsdGVkX19/nFDLWtQeIy6FZNeYFfIOeSXxDGuG7eY=",
    "cpf": "U2FsdGVkX19MV3zZ7dqFmnokxK7CAr+fmWskm8sV5DE="
}, {
    "num_cand": "U2FsdGVkX1/oXXz7NZAlmP8K6gP9KhhEiIPuCq7XBCA=",
    "cpf": "U2FsdGVkX1/elOeK5U/YyP7PdsWzsQSGnhEFASNlgJU="
}, {
    "num_cand": "U2FsdGVkX18h8GPY3ckg/0LvJM1qQmn79rnqu/OEg64=",
    "cpf": "U2FsdGVkX1/OavQdLumWQsqijFdQGCnz+tcKk4Hn8ng="
}, {
    "num_cand": "U2FsdGVkX19KDB6qZhy/ukR5uE5kpACcgjEOAEBj2po=",
    "cpf": "U2FsdGVkX1+0iWYPuLJTy2YwyAGjVw4VlcmaTIz6LJo="
}, {
    "num_cand": "U2FsdGVkX1/M0Zu4xzKa9FBbHsKxDnkxx6p/FIKi3Rg=",
    "cpf": "U2FsdGVkX1/KHlzUykBCq2IWrx6466NovnwsuM5YI4g="
}, {
    "num_cand": "U2FsdGVkX18FyjzEI1pIac7yK1yzBDe9TP5rLXn33Dc=",
    "cpf": "U2FsdGVkX194fYYVtHh65cziC1EBXjBvwbL2Q3JdwcA="
}, {
    "num_cand": "U2FsdGVkX19G2wCxzV6ZeJagocEzR/FfOGyYXfEuVak=",
    "cpf": "U2FsdGVkX1+9P0IuH2u9XBUwGiY7na7teh4chW8LgUQ="
}, {
    "num_cand": "U2FsdGVkX1/R60h59qacs9dBf24XwFRaBndPZtJ4Rms=",
    "cpf": "U2FsdGVkX1/cRPwjN52k1D1qOYWEcPqFrfi9RFAAsZI="
},{
    "num_cand": "U2FsdGVkX1+zdRd+Z4fgmFR/m1fzor6XAqGjCVh/y5o=",
    "cpf": "U2FsdGVkX1/hj02X2GcB12a3/R2QTGYw7Q+3NyHHW4w="
}, {
    "num_cand": "U2FsdGVkX1+W+EnAXCkbdCArOln0vdIw+qsrahoduAo=",
    "cpf": "U2FsdGVkX1/iRvM24vWmX4wljAYMb3oWXQakM0XASoI="
}, {
    "num_cand": "U2FsdGVkX19yW3m/ZTWoz7YyTqzeFhkRIvBQexOEYWo=",
    "cpf": "U2FsdGVkX18GiCivn+XM8xKIgP67+bfVrXPx+Gv2EaI="
}, {
    "num_cand": "U2FsdGVkX187Fs+MITUMfPkF8qI7BVIUWi4w4sp/Etw=",
    "cpf": "U2FsdGVkX18PnRg8XIsXNU12jywTGDiHcOa7xXev7pw="
}, {
    "num_cand": "U2FsdGVkX1+kXRf5eVMZQIiKMHs3LcBkNBkWd2WLFok=",
    "cpf": "U2FsdGVkX18xyq5NvyuwVfqhWH3xZ9sd9GwKCSEKzec="
}, {
    "num_cand": "U2FsdGVkX19PrRGlocyDdSjrJEDrZCWJcaD1Lma+Hyg=",
    "cpf": "U2FsdGVkX19T7O5I4nrzB3yYtv8Y8uzcL+nWO9I1PcM="
}, {
    "num_cand": "U2FsdGVkX18PrV8QMzUUimTmovpFOxruDR9ZvyHuG44=",
    "cpf": "U2FsdGVkX19iUymyQJBkX6lhi0xkTdOD+2IP22uTnLI="
}, {
    "num_cand": "U2FsdGVkX19FvStZZcUP3A3btBfnzAM4MovOZRse7AQ=",
    "cpf": "U2FsdGVkX1+o0+TOjVm4mZO64Bz+EK1dBkPEBpZ1Kvs="
}, {
    "num_cand": "U2FsdGVkX184QlVRWtVaiDD4GJGCvQwgR6bVB1HC0z8=",
    "cpf": "U2FsdGVkX19jmtIsbQYJC3ePSo2xCOjyfeVWr5tkZuc="
}, {
    "num_cand": "U2FsdGVkX1/vaO9P1UOCq8Kciz511lq7CPPbk1z/Img=",
    "cpf": "U2FsdGVkX18o/uObHKROelsg6GpuLIYWcs7DLH0fOYY="
}, {
    "num_cand": "U2FsdGVkX1+S7zUOmpLH//VhkoPZIQr/4GkzCQumr4c=",
    "cpf": "U2FsdGVkX19CeI+dZRijsNTD/Krn3foYLA1vUmoS3xE="
}, {
    "num_cand": "U2FsdGVkX18KYcd6gIalZlhNzoJcWytz538Ji1X36V8=",
    "cpf": "U2FsdGVkX19n95SUzrXbCaVomszLgg4osqjUbwxh7go="
}, {
    "num_cand": "U2FsdGVkX18He3MlmP+CHxSJCZcVBmChNkiYRo4wHwA=",
    "cpf": "U2FsdGVkX1/kXFP/Q5KGSZJb3KgVwQR8bDsDIDho76c="
}, {
    "num_cand": "U2FsdGVkX191pFOlGEsBeGKAF4Ae+5tSZfs7+RmTvjU=",
    "cpf": "U2FsdGVkX18uGe7QU5WCMiEYyYCnUqFCSJT/OHAyc9U="
}, {
    "num_cand": "U2FsdGVkX1+7vqUcbCquuFeFxAK4ES0J8EVaDUAt8lQ=",
    "cpf": "U2FsdGVkX19+zwCURpIF+cw58360H/WzkbygFwWk3iM="
}, {
    "num_cand": "U2FsdGVkX1+EdDb+uxNA/C6H5pegnUf39vGunUHZ88c=",
    "cpf": "U2FsdGVkX19Iaqlr3AqXgIFDwUhkA87f2be6F+eGdBw="
}, {
    "num_cand": "U2FsdGVkX1+Ef4atFSFmCHfQ69MvTh7XNEXd0tisC18=",
    "cpf": "U2FsdGVkX194uxPXf6aC1RCoQYX8jCGOtl+TP4lTjNs="
}, {
    "num_cand": "U2FsdGVkX1/wNqRpeysh/rahWlQo7qtyNtbuLZPrBTA=",
    "cpf": "U2FsdGVkX1/gySDXnutGAqhh2VgXd9D2JAPLj9SYMAI="
}, {
    "num_cand": "U2FsdGVkX1/QySVxWtdAOWzqgU+mjRtHAhPulnebg2c=",
    "cpf": "U2FsdGVkX1/M0RJNs5VODfvxASKGfy15y2LDXbt1Cxg="
}, {
    "num_cand": "U2FsdGVkX1/JLygh6j5XUhG5CVed9j/IdTfowbrz1V8=",
    "cpf": "U2FsdGVkX18cVrSfl8QUjrqx+BttYg6RVQCFFtueTIc="
}, {
    "num_cand": "U2FsdGVkX18gITRgZA70gIEamSSUn2j5w7U0ARm+s6A=",
    "cpf": "U2FsdGVkX1/6bXrMPBq9JgHYEwo/WD6NPxRawxOfmaA="
}, {
    "num_cand": "U2FsdGVkX1+1drextrcZTNZ97WOiKCrv3lURC8L1glI=",
    "cpf": "U2FsdGVkX19pmTCntvf/JLZY/ek6Vlum5kcjrRkv2bc="
}, {
    "num_cand": "U2FsdGVkX1+EzS3tclkjBCqEJx+Nvi8c+z6NzIv97h8=",
    "cpf": "U2FsdGVkX18dbAP60pbZ455NAK23gRH0Zy2yDKBmoG0="
}, {
    "num_cand": "U2FsdGVkX19AJNFqKlxuyVowznKQpD1WwBBS2Q+MoXc=",
    "cpf": "U2FsdGVkX18LF9bE+tARq5u2PCe4/GQFqp6mHSWmg88="
}, {
    "num_cand": "U2FsdGVkX19rK3KmdiwyEvzQUWEx1rxTgFyc1MJGzIs=",
    "cpf": "U2FsdGVkX1/mBDsAi9UnHq/u7rPyeOmVcKJBmeFUqpE="
}, {
    "num_cand": "U2FsdGVkX1+uyyJ3G1Th0HfgJVuOaMQN9tzPOjGCtXI=",
    "cpf": "U2FsdGVkX1/wymuTiYtReuU3FxIfApyvbZ84r5c46RI="
}, {
    "num_cand": "U2FsdGVkX1/kPbRwI9bDvZaDJJj9DgEWSjaMRpQc8K8=",
    "cpf": "U2FsdGVkX19/GoTzvSGTHguVK1tKUQiRuuGsXGe1iKU="
}, {
    "num_cand": "U2FsdGVkX1+GFXWrDCwff+rVI6T4nb96EjQ6nZcsl6Y=",
    "cpf": "U2FsdGVkX18WAPrOCgnZ/SPvKCagYOUMCOaHjwn5kNo="
}, {
    "num_cand": "U2FsdGVkX18MGyIo6gQAX1Vq6kA6zUVmDfRyqvNoLgg=",
    "cpf": "U2FsdGVkX19D+ggUdnA637dYoJdOvbA/+m1L8E+sR2w="
}, {
    "num_cand": "U2FsdGVkX1+9/SOnqe+q484fEq8F2NKf9Os2DRz8eCA=",
    "cpf": "U2FsdGVkX1/ceVUO3KI7+i+E2Csu1X5BVmjDyAHdhSw="
}, {
    "num_cand": "U2FsdGVkX18GeSfrsaNdB9ROOwL4U5Ewcd6I1McQjPA=",
    "cpf": "U2FsdGVkX19864HnAkRZUP+Q65r9vo10gGPwV35gpp4="
}, {
    "num_cand": "U2FsdGVkX1/LqYZtnwkTTFIFZGUjKTL6C1ixwZ8S1EE=",
    "cpf": "U2FsdGVkX19vLdwTL8UGY6Yvm8NawW65IN9HWMTGywU="
}, {
    "num_cand": "U2FsdGVkX1+A1L5eutx4TDb23kKpIsQLs0eNMTv7CkA=",
    "cpf": "U2FsdGVkX1/8ChxGpddu3uEGJ/CoQb8yftXmptrNQP4="
}, {
    "num_cand": "U2FsdGVkX18SPv+AQ7GUn4/hZuyCk09cbiQrNN7vD3I=",
    "cpf": "U2FsdGVkX1/wgflLbM6E6HrIP7ZLIevp2NQDs0DUn8A="
}, {
    "num_cand": "U2FsdGVkX18aaU5dD08TK8weryABCEaTVMsKWjko9bc=",
    "cpf": "U2FsdGVkX18aPYSliVEWeoqBFRciQb4PxL4kqj0rlls="
}, {
    "num_cand": "U2FsdGVkX1/j4PlMylpURy3PNB/g/FhkVBVjVNrqxWo=",
    "cpf": "U2FsdGVkX18fkI0PGLIL0t/B6oYDpK/8fHfvRjRRVFo="
}, {
    "num_cand": "U2FsdGVkX1+eyoSSBuEzZMFogRVYhR0VHRWjWw0N+wI=",
    "cpf": "U2FsdGVkX18csuzEDXXBTuCHj/hNQqmO+oJiBnTRpww="
}, {
    "num_cand": "U2FsdGVkX1+OlZQbNZsvkcnFeeP/dfLSqtQenJ7gJW0=",
    "cpf": "U2FsdGVkX1/NYJiW60drEYh3XkXQtFRMfAHXi24h8CQ="
}, {
    "num_cand": "U2FsdGVkX187Q5yTqLtmzdtn1Rf9cq7yy9xCbupt2Ao=",
    "cpf": "U2FsdGVkX1+WRpDNqY1RvSWH+2blS6nXf/+16biAZIM="
}, {
    "num_cand": "U2FsdGVkX1+jyXYh1538K+FTtiUg5FWF3zEumcnIlC8=",
    "cpf": "U2FsdGVkX1/IM2hZS9D2VKnsaXEoDSoDgtIjrXpMabQ="
}, {
    "num_cand": "U2FsdGVkX19JFb722l6zHV98GRcdfjFbMJv9pP7eWYk=",
    "cpf": "U2FsdGVkX19meLJfk8MhM+03XzlROafgcEb3OXs/oAc="
}, {
    "num_cand": "U2FsdGVkX1+2MUsC0kdPVKTZb7nKXOpY2+RHGaB+D6E=",
    "cpf": "U2FsdGVkX19YytSkkTI2kk3mdiv1TdTbv+GtpJFKURU="
}, {
    "num_cand": "U2FsdGVkX18xD7MDl9hBLn8XaH3cZsXWqT9a2hCgQRU=",
    "cpf": "U2FsdGVkX18J9NiJjv8ND8kNomDnPf8YF0cvvNkgMjw="
}, {
    "num_cand": "U2FsdGVkX1947FLa/qKraO5NL6OyShCRqkievphBe4A=",
    "cpf": "U2FsdGVkX19eIwu3NZuSBHtFMlMXyVeZnncDwN1VRiY="
}, {
    "num_cand": "U2FsdGVkX18yYSJJiqpHma61HMutjScAnQ8YkeJyUJM=",
    "cpf": "U2FsdGVkX1/BIasptj2rEyBmzwzCT4y3iG4GXgLEVT4="
}, {
    "num_cand": "U2FsdGVkX18Um2iLq1kLXUndWfvcVCUH8WFaFv+3m7A=",
    "cpf": "U2FsdGVkX19WX9YZhhZe5Z7l3LIq0zrBfJiBOd576HM="
}, {
    "num_cand": "U2FsdGVkX19K42jlMOPZ/9GhAzMXPl6gdgHeRDFg2hE=",
    "cpf": "U2FsdGVkX18VMFw7YKaL9m++eNVjliqT+MG+u8xCQDs="
}, {
    "num_cand": "U2FsdGVkX1++H0e82BPcv4hTWv57UnWyfK7KIpXa2+Y=",
    "cpf": "U2FsdGVkX18LpOkbs463j8IP22IDFz3cul2VdacBl2A="
}, {
    "num_cand": "U2FsdGVkX1+bv/63N3DHJ/tDz6KiIlnzwfAJKSXmkMY=",
    "cpf": "U2FsdGVkX1+kUUG0aMOFXsdOu1uK1SoxS2pOUvCK3A0="
}, {
    "num_cand": "U2FsdGVkX19KQ3a0DS/Gkz2kSzsIBRhmj9iwOdCSheM=",
    "cpf": "U2FsdGVkX18ZYm0Csn8CndARRMs9CvV7lxyatikLonI="
}, {
    "num_cand": "U2FsdGVkX19ofMtpQWF4UjNBIbI68RunrDChivkouAI=",
    "cpf": "U2FsdGVkX1+P2zsvMA7LB7u0m70LWIvp+FZT8t+Awkk="
}, {
    "num_cand": "U2FsdGVkX187vdNFh13vprQiHX0S1HN117wB0zhGIxE=",
    "cpf": "U2FsdGVkX18DHtwQU/njn77XMEWBWy0puvBsbg24/mA="
}, {
    "num_cand": "U2FsdGVkX18iAFPu4pvBgTJwqKDZOEbY+urvYVr1IzM=",
    "cpf": "U2FsdGVkX18zS1Cg7KLnr4STI+VxR/J4ANAyHJm6/qo="
}, {
    "num_cand": "U2FsdGVkX1/ByLSGO00+CPhY6mnpPmldXOT2kfaS2K8=",
    "cpf": "U2FsdGVkX1+w05XcEqAovcthVdZYsQLbo/PCW+rphOE="
}, {
    "num_cand": "U2FsdGVkX1+OlfahXX5ZoGbG9sbA/7wvINUARR43BA8=",
    "cpf": "U2FsdGVkX1+sQKUKN4a9kDDFONtAFidDZBYXauQBOlU="
}, {
    "num_cand": "U2FsdGVkX193rCIoqJk3W+LjUayIJuxPGHlX+NuHBCQ=",
    "cpf": "U2FsdGVkX1/Rmu+5KXTy4kgUfx2xfSh1RmdWy52vY8c="
}, {
    "num_cand": "U2FsdGVkX1/s/Cs2MVA7LosO0Js2ARGJ8XOWai/hKVI=",
    "cpf": "U2FsdGVkX1+IpTCc5Y1N473QCC4ETb9kKlfeR8CVXjE="
}, {
    "num_cand": "U2FsdGVkX1/4M8SThLkD46D+7qkaGZveL5MKQYlNEAg=",
    "cpf": "U2FsdGVkX18yTkbQpAgSpsPwqKVHHJDtQgeiPLSmnGI="
}, {
    "num_cand": "U2FsdGVkX18ckYx6u5fBpGwuiVH3gT4VzLv2OTVWSpk=",
    "cpf": "U2FsdGVkX1/kCMJ3VSRGiDTylZS8jubN5FHLG0DoEto="
}, {
    "num_cand": "U2FsdGVkX1+iUmE+0Tn8UBneUIdKroZ16OIphWsMt+E=",
    "cpf": "U2FsdGVkX19+3TGGEG4eweNTh5IhEveaVFXpl8ggnCg="
}, {
    "num_cand": "U2FsdGVkX1+Yc1I3E4lPZTet9nGM6q4SIBw5mg+GIM4=",
    "cpf": "U2FsdGVkX1+vxSBZLge6Y/bASBzv6nKGJdwa/H1EGZI="
}, {
    "num_cand": "U2FsdGVkX1+HfP/WRyZAKdWBFsL87bMAapb83DLYh+Y=",
    "cpf": "U2FsdGVkX19X4JsprzREyojdRNfhhsMvbcL6FJ3b0nU="
}, {
    "num_cand": "U2FsdGVkX19QL61zEd49le0HV0o1lGX3qZ8NOfnELYg=",
    "cpf": "U2FsdGVkX1+f/bFliLOcT7ms/Ri8qwtvnoXv7HEViCM="
}, {
    "num_cand": "U2FsdGVkX1/zlWRIrqI++emaKxpLlAux7uWFkp6nmww=",
    "cpf": "U2FsdGVkX1+z6G/OcBZ+AgeyaKxj7M5dhitl3QpT6U0="
}, {
    "num_cand": "U2FsdGVkX1/BzLyldhfhAtKu9q13bZd53dddAXLY5m0=",
    "cpf": "U2FsdGVkX1/rkn1TcrOx84o+Bq1K6gptzmqMGM6ksWk="
}, {
    "num_cand": "U2FsdGVkX18zsJXtWLXm3D72YOpUmvK1lUm2QYyIezw=",
    "cpf": "U2FsdGVkX19DiEb+qDBm1rWja51iqcVTEJ8UMbeTqPk="
}, {
    "num_cand": "U2FsdGVkX19DvjGFXa9uo5wkpeyJgBq/YTb/ULZGdJQ=",
    "cpf": "U2FsdGVkX18DALsTACHqea5jDIze5u8NLejHgIh22U8="
}, {
    "num_cand": "U2FsdGVkX1/IJG4WE6ayLrchZY/YA+AxboWhx7DONXE=",
    "cpf": "U2FsdGVkX1+JVtFBBwIQrSI4AK88qmtpyQyK0zyjzQM="
}, {
    "num_cand": "U2FsdGVkX1/IdyG0fwqTfzjXGHFaOcTHr28Adz8byWk=",
    "cpf": "U2FsdGVkX1/DRrIEo5SQ11wIItUWv/IXZHwCE8pUES0="
}, {
    "num_cand": "U2FsdGVkX1+ZKOCnt1emFGBIT5VwTAny2l2ytSfNdY8=",
    "cpf": "U2FsdGVkX1+LT63ZzrGcGry5AwASx9mGjxjwREb1Qig="
}, {
    "num_cand": "U2FsdGVkX1+T0LJ0fEKJh0rhIN52JhNDE0/RAyntAkQ=",
    "cpf": "U2FsdGVkX1+QP54cOZrr2dgiaOq5Vuf8AKjtOEe+RAc="
}, {
    "num_cand": "U2FsdGVkX1/IGAt6x+kSOtHQzpo3bSGhWT09tGKBip0=",
    "cpf": "U2FsdGVkX19lxE6im0ZJSdYSC22VhSH3Bkv3Fx2S/XU="
}, {
    "num_cand": "U2FsdGVkX1+tKsnA3uZIS4E1Q70v+YCI4T3SxuoZ3AI=",
    "cpf": "U2FsdGVkX18k2V3cF7gGE4llT4j8HPcsV+tq+Ku30NA="
}, {
    "num_cand": "U2FsdGVkX1+oM+hXMJJgDN4zgDiE3xhEDJqhh4EpMgg=",
    "cpf": "U2FsdGVkX19HL9x2bp+lxhQpLghUbzq3AZ8uwl6d7uM="
}, {
    "num_cand": "U2FsdGVkX19f/wRHDhdfutTr2nR0ONhXVWZfIMNvxuI=",
    "cpf": "U2FsdGVkX1+G8Ufg9Fj7YMN0SY8cAmRAxcALhpIOtk0="
}, {
    "num_cand": "U2FsdGVkX18xtNN8tXRrMbUWdjJwzgJ36QK0af09u90=",
    "cpf": "U2FsdGVkX19ubLruTkr8RTsJwBUo+Y8O92PNxkMWbUw="
}, {
    "num_cand": "U2FsdGVkX18U1D6025BBXoeVeHXpVYBkCSIxwI9gSjQ=",
    "cpf": "U2FsdGVkX1/yhUfQEHwf89nxhKCeyw7D9pBvKnbxD3U="
}, {
    "num_cand": "U2FsdGVkX1+aWbTKkGjur9AwGFOlMv/jeZTXiL2p7t8=",
    "cpf": "U2FsdGVkX1+FSXPBcfRTYtsYVh9YAdzMhZ72Ey+tBmc="
}, {
    "num_cand": "U2FsdGVkX1+9S9vVHlqKA/kS/mhexIZZjbHWkU+gycc=",
    "cpf": "U2FsdGVkX1/Rv+sLeBfJSrP9bmOZIYbk8FW6QeLbP/U="
}, {
    "num_cand": "U2FsdGVkX18cWrrnmKY3jmyrZ9au6CHY45EtEBSOOaA=",
    "cpf": "U2FsdGVkX1+7b9OsksYONg45FoySnzPDWI5UGuVKKx4="
}, {
    "num_cand": "U2FsdGVkX1+Hd9bYLIFM2y1i3AXlAudPrc8JTM1f7kc=",
    "cpf": "U2FsdGVkX1/5/Jb+ylzw10dlZFc3g5okK7Wir7NCJ+o="
}, {
    "num_cand": "U2FsdGVkX1+ALR/b9S1Z4DkWeMp1AU1CAvpToyZ/e7g=",
    "cpf": "U2FsdGVkX191mY220MNgRtl+fUafQ7XvxgQcJqj6rJQ="
}, {
    "num_cand": "U2FsdGVkX18Nsxd46LpsSzYLdV/6NLoneDg8tcPpnlY=",
    "cpf": "U2FsdGVkX180f1KFor6bU20kryYYBugFA/sO98i5z1o="
}, {
    "num_cand": "U2FsdGVkX18J+wXEOO5atKatn0vNDQ8zvV0a6YitcVU=",
    "cpf": "U2FsdGVkX1/gcuQKYhQmipJQG2Bxk5SPBq7J45YHR98="
}, {
    "num_cand": "U2FsdGVkX1/DENslSEZ22j5H9awrCEr+nAGwzPgDIPU=",
    "cpf": "U2FsdGVkX18GfauvrNPDAmpInpozQCQfsOGgi+3L4gI="
}, {
    "num_cand": "U2FsdGVkX19NnK4O7flxKT0czBKROl/o+igFE7zFTBU=",
    "cpf": "U2FsdGVkX1//Yr3Mf0M/2DIwMFkw1iWiK2OOuASMCik="
}, {
    "num_cand": "U2FsdGVkX18GiDcHK32rWIeiyK8F7oPYagNec4G6mnM=",
    "cpf": "U2FsdGVkX1/m+dsqo+CMKSEN4EESuFN820qUBoOS+qo="
}, {
    "num_cand": "U2FsdGVkX19mEhJG75/3tPS8SPP39c8WeKtJPkA+PWM=",
    "cpf": "U2FsdGVkX1+ciZq8K4zxlbID1XjVjhtaGQJ+IDSViEc="
}, {
    "num_cand": "U2FsdGVkX1/dmpG89m+geQzvOVrzB1YaV9WlGszl6zU=",
    "cpf": "U2FsdGVkX19M8L2nBV9GApodlvBCCTZxMDgQqcrie3Y="
}, {
    "num_cand": "U2FsdGVkX1+0txKajqvynGm/Jm9YD1PNHxmjCNJXw6k=",
    "cpf": "U2FsdGVkX19PaPYCKwSoq5/6Ju73y7sdcBgX755v4nU="
}, {
    "num_cand": "U2FsdGVkX19AW95fvlJjrrjvNXHDfORkQh3/YR7alw8=",
    "cpf": "U2FsdGVkX185e16tMouzCIHtGB1pMubkN95wBqMu0jI="
}, {
    "num_cand": "U2FsdGVkX1+971McllQjWblR6Mvb9FXROVRKKhnwrrk=",
    "cpf": "U2FsdGVkX18F9Tkpqgh5LcUAA/fzjmJWlCU5UJKTLHM="
}, {
    "num_cand": "U2FsdGVkX1+mm+BSlyZo3hP2ySbfXYKq6YptCrBBb0M=",
    "cpf": "U2FsdGVkX1/TFyMTV9Jcr6AiiqYUnu0G8ybNYHjFDkU="
}, {
    "num_cand": "U2FsdGVkX1+vv/CXhDnbLVhejd1SdAhGVSonn+WA/5c=",
    "cpf": "U2FsdGVkX1/Dv6/uVscwXGHMPs7zwVshfOoFAkhXf1U="
}, {
    "num_cand": "U2FsdGVkX18uy+k5LvLC4bzQIuq9TfWqVdkqGmRQpc8=",
    "cpf": "U2FsdGVkX1+SBOX6fMgBjOqYNlFZsyUEGMS4hp1XwZA="
}, {
    "num_cand": "U2FsdGVkX18OR6AlQCR+k/3Vx30/6Xw+Nr7W87YRUxw=",
    "cpf": "U2FsdGVkX1+O/OOlQ/17h//ChLwAKOjHxNAEL55kUgU="
}, {
    "num_cand": "U2FsdGVkX1+bQLimL1wyA0jyaZNmggODBtLRaq37uTI=",
    "cpf": "U2FsdGVkX19iRO13ZKJrG3/rzpg7aAyHedXp71oWX/Q="
}, {
    "num_cand": "U2FsdGVkX19USXabq905qZOzZI8NDrcQLsDGbgX37Ng=",
    "cpf": "U2FsdGVkX1+RN0G91G44r78ovlUpCU2yQ0jS3aSb1MI="
}, {
    "num_cand": "U2FsdGVkX18Fc3fPtf5ctEkO/Y719kOffbz76GfDVxM=",
    "cpf": "U2FsdGVkX19QwMlmzPhs93Qj0khm+BB0wG//B6JhZ0Y="
}, {
    "num_cand": "U2FsdGVkX1+DovO04pY53RCN4yEQiIOzD/qDPzOGUa0=",
    "cpf": "U2FsdGVkX1/uepNjT3pPsrDeDS2FIIje5iVLO8lrTg0="
}, {
    "num_cand": "U2FsdGVkX19DCk4p7qyGBWsVfataVTVVZ3++hVbpQ5Y=",
    "cpf": "U2FsdGVkX18tTkvnvbLM6Z/4JpIzCNTMe2xi2E5oXg4="
}, {
    "num_cand": "U2FsdGVkX19UEyqC+3WlR9vJR5OD+CF2GrVpdjTdTRI=",
    "cpf": "U2FsdGVkX1+jdNqKLlxU6vwVxZ6ZJ0LnFyLGYqkR78U="
}, {
    "num_cand": "U2FsdGVkX1+MVVYE5XLCtriPKvr7SDbS2/Iq2RwMB7c=",
    "cpf": "U2FsdGVkX18ARac9wHzkIoP9pjjsask1OU0UUAw89BE="
}, {
    "num_cand": "U2FsdGVkX1+bShuPTwOTUvPaF+YPXOnw9nIxZttAPy8=",
    "cpf": "U2FsdGVkX19YWG/EiD1Tv4Z9wHYjzA8SyG/IF6ajC8k="
}, {
    "num_cand": "U2FsdGVkX19nIqQykdYXt+GobvhXAK6BvLLLXUCEddw=",
    "cpf": "U2FsdGVkX19MsiQLUKnIV5gB3or2eMyNn9UHCQ5gQNU="
}, {
    "num_cand": "U2FsdGVkX18Lfi7zvI19p687zqrHsKlJJiTIrwyr9bA=",
    "cpf": "U2FsdGVkX18d7nxp6ud2KpMNDLyvX0dbuW0FrwClD94="
}, {
    "num_cand": "U2FsdGVkX1/h3aUelIHheWKj2+4kN1JZ7lDjUjijZYM=",
    "cpf": "U2FsdGVkX1+rlFKGwDOhqHgiirJhYYuyXQ3+047ESvM="
}, {
    "num_cand": "U2FsdGVkX1+qy/5vjkphy9XnsQTa4c4cbGN4F07dKkI=",
    "cpf": "U2FsdGVkX19ga260vSFU0GnziWY7y0B8j12XBkZ8SPE="
}, {
    "num_cand": "U2FsdGVkX1/ImdIOccK7/LNuW3etPVPRbzt4ImcmeHQ=",
    "cpf": "U2FsdGVkX19aYIwX5Uj6XcjmwPpVYkaUQZ7CwPWUbDc="
}, {
    "num_cand": "U2FsdGVkX19T3TRcYBOw4UGFiu4ZebVS3SwqdPEEiJo=",
    "cpf": "U2FsdGVkX1/njuU8QEntRdHCRgKBBkQVumS9uFgF/Zo="
}, {
    "num_cand": "U2FsdGVkX19jSwaM1749/AyWcrmIKWZYRp2qxQHO/GI=",
    "cpf": "U2FsdGVkX1+jMvDsaK01nXE/UJGg60e1sDeWWY4vhWQ="
}, {
    "num_cand": "U2FsdGVkX1+vgzkZRveMCuG/W2Tv1Kx7cTQMq8rwOTc=",
    "cpf": "U2FsdGVkX18oXMT/6rdlfXqIJQLcK+aC4GG/Tq2ZVDI="
}, {
    "num_cand": "U2FsdGVkX18MI5RU/3w9nDfpLqfQEZcA8JEmUIrPnys=",
    "cpf": "U2FsdGVkX1+reNzpwNRMYuTMvOch+dgjqQJNk31yCiA="
}, {
    "num_cand": "U2FsdGVkX18JMcRZFfstGd/PSnZE+ovF24wWKwOzQGw=",
    "cpf": "U2FsdGVkX1/9FQx2rI4SIGcWbPHwDkru6KjYisLyhwU="
}, {
    "num_cand": "U2FsdGVkX19rkWi4ctXNRNRyOXKL/P16uPWEVGxVFpU=",
    "cpf": "U2FsdGVkX189STKpww1vdnz/sTwIXWAfMCDacluDBE8="
}, {
    "num_cand": "U2FsdGVkX18ewCBUw6l/fGfaOzYySe6kLyWCg3GNMtU=",
    "cpf": "U2FsdGVkX18wv2I94B5hTtms1/rz3YtgT6pRrigDgsg="
}, {
    "num_cand": "U2FsdGVkX1+x6fCj3ruxLLRyXbCLUE1G2VdpjZ7iV7A=",
    "cpf": "U2FsdGVkX1/9ngS6BiHkluQXU5t3aaW+XfzX27PVENU="
}, {
    "num_cand": "U2FsdGVkX18SqoGOL44yt/I5u4jHDwh0CtF75wCS3d8=",
    "cpf": "U2FsdGVkX18foXyoMma0cnbzrxvTWwI4XOB2TSA/Nvo="
}, {
    "num_cand": "U2FsdGVkX18WrKx8hMf0KaQEzNzlwoMg8IhG2Xn2JKs=",
    "cpf": "U2FsdGVkX1/r3Uxq2Nvd6jk78wCV2VpGWG+O8g3MaOw="
}, {
    "num_cand": "U2FsdGVkX1/3iqEGdYmjsjxj0Iaa013LXFbhFXCBkiU=",
    "cpf": "U2FsdGVkX18BPMYBHnZwKq3UYZkV9Tyo6g5Bffp2va0="
}, {
    "num_cand": "U2FsdGVkX1+RVy/sl/zf591yJGoUire66T1JYse0Sz0=",
    "cpf": "U2FsdGVkX1/UfK726rrh7XjA79B0QPL8p8Uy4eicfDQ="
}, {
    "num_cand": "U2FsdGVkX1/3EQG+KazJ6wsJJ9IawcP2nVggmxCt7/Y=",
    "cpf": "U2FsdGVkX1+Fda95GQjYqf1EpJUzg43ZjyuZPnEg2M4="
}, {
    "num_cand": "U2FsdGVkX1895GB+dg0gbCHLTDHQPavvpfz59y9VnxQ=",
    "cpf": "U2FsdGVkX1+i+d+KevxfDHZJPP+APi5pSgheVNzHCtM="
}, {
    "num_cand": "U2FsdGVkX1+e+b9b90L1tZPPDVjHlwqjZ/W3t5DXyco=",
    "cpf": "U2FsdGVkX1+SLDpudWd/9N4j1aXQw4LQzTs50zrdJuM="
}, {
    "num_cand": "U2FsdGVkX19HE2pJg10EVqIw2LxxyeENv22bwxTDBmY=",
    "cpf": "U2FsdGVkX1/dnIv4wv9zMUUOu48eKTwvYc+CtNj2Ulw="
}, {
    "num_cand": "U2FsdGVkX18+VJDk8C1CDeGjPKRbuKVAptfJwHjWmPA=",
    "cpf": "U2FsdGVkX18q40yJI2HQLNP6cnll0NStLvaIwvU6gfw="
}, {
    "num_cand": "U2FsdGVkX1/jFMPfFn2OZprzmCJR/lenww0OC0283zU=",
    "cpf": "U2FsdGVkX19sf4Gu6KI/vTMfTFp3/c2F3XSWGFIQQOw="
}, {
    "num_cand": "U2FsdGVkX19P1c10plrfop4NxE5T2E6uHvvS2NTIMDs=",
    "cpf": "U2FsdGVkX18sqoZnJO+hhrsJKRMdYEo6TBVqteofXZo="
}, {
    "num_cand": "U2FsdGVkX189HTEXl0EplOZrsgkkuTcbV+acXrjSQa0=",
    "cpf": "U2FsdGVkX18/CzDhZj+4yIOfsFPHMWRgw2EzWX8wkds="
}, {
    "num_cand": "U2FsdGVkX1/l+XOZoPgsoZbOK++DUG9wZIu7k6qgasU=",
    "cpf": "U2FsdGVkX199c0CjLbTnN5S6omwJKByBLS9y3+6pKek="
}, {
    "num_cand": "U2FsdGVkX1/KfF1mc/mKnsDpX+e57N6tMbD7eEXDtjA=",
    "cpf": "U2FsdGVkX19I7jCVDQguZk+Va1SSgGfuITpmk6m+0jY="
}, {
    "num_cand": "U2FsdGVkX189E6yaWgo8Y9UoHSqjxHgmGhq18lEh1IM=",
    "cpf": "U2FsdGVkX18axIgQrK83xCoNWk42/ldh5ALNWRBX7nI="
}, {
    "num_cand": "U2FsdGVkX1/GSnyOpdGUiChCnkwB6ckMmzgzaEAgc9Y=",
    "cpf": "U2FsdGVkX1/gsrebp22oyv9LNov2VUuP5PVcOfQ4L9c="
}, {
    "num_cand": "U2FsdGVkX19Biy0YQAu+KTkv2AiYsfx2E0CB4J83Ehg=",
    "cpf": "U2FsdGVkX19eTyB3OkK2ety+BNV51P+Dez1oh95UG10="
}, {
    "num_cand": "U2FsdGVkX1+DQWaX6ypjXWEwaxyHT0FdQ9j7oWG/DJw=",
    "cpf": "U2FsdGVkX190G5giG4bGwCbm4hQBJ8a1nahPTpiIOnU="
}, {
    "num_cand": "U2FsdGVkX1+TeRa3qmp2vYsw7qJVk6gPI5NdsXEI990=",
    "cpf": "U2FsdGVkX1/bItt+aVoivDZWf1xlubiPJuXTAP6H7L8="
}, {
    "num_cand": "U2FsdGVkX1/lN6PN9nMpq4w4YEiGaiPf7pHZWbOdZE0=",
    "cpf": "U2FsdGVkX19JUzV+pr9/F873ETcY2uXBEyGoQkypx0s="
}, {
    "num_cand": "U2FsdGVkX1+qIdM2qnGgAsk9wYBBUABfqV959tdgXdw=",
    "cpf": "U2FsdGVkX19u01gpl9kGMk3wjRLKdRDBLWhq9Rid0K0="
}, {
    "num_cand": "U2FsdGVkX1+40h9tGpxA65BjLc1pEXTC4Wfzcq0q1s0=",
    "cpf": "U2FsdGVkX19rLNLocG8Db0Y7DaEA5Ct+ONXpn4L6gXU="
}, {
    "num_cand": "U2FsdGVkX1+dAArn6sxOvIg2+oa0aQzFMzflBJBD65U=",
    "cpf": "U2FsdGVkX18O2LrxAezUwgPePZHfwBHaplqjckTeXos="
}, {
    "num_cand": "U2FsdGVkX1+C3w9bDuP/zAKIWHDGfJbt3QmL0aSuK+A=",
    "cpf": "U2FsdGVkX1/GJQIB3Qq5IGkTTAxBDy4wg7HwOLuxj/s="
}, {
    "num_cand": "U2FsdGVkX185IEDoovjDU+nAYGjtOlxSIUsFK9RFUzo=",
    "cpf": "U2FsdGVkX1/3lHmOeQjBDTZ0Q7PuMG5wrUqlbo3+HoQ="
}, {
    "num_cand": "U2FsdGVkX1+I5H7Spft/NmoivMQpAKmgcvZKJDutTz0=",
    "cpf": "U2FsdGVkX1+X9bCpljwzZevsDd3B2tu8wlKAsQH72Fc="
}, {
    "num_cand": "U2FsdGVkX1/ENhWftuORKtQSPO8s27DMFkdHE8SjILg=",
    "cpf": "U2FsdGVkX19sJNw4L+pCGJLY4AZsIfQsSX1pxKZwMA0="
}, {
    "num_cand": "U2FsdGVkX1/MjpC8+3JiT9ZPBoyIYsWv64ykOS2AnpY=",
    "cpf": "U2FsdGVkX184n1/zcx1gBoC0yIzwvFjfYCU4k0HpXn0="
}, {
    "num_cand": "U2FsdGVkX1+IgPJffprTCKKO7RgbjdXNiZ2PnBKtb7M=",
    "cpf": "U2FsdGVkX18j9BYbkm0pZgQNJlwTzJV/jhkd1OiB0Oo="
}, {
    "num_cand": "U2FsdGVkX1/diuXHpHz/BCSUjRq4LfI7DYmYGpCnYnA=",
    "cpf": "U2FsdGVkX18ql130T21EWKd7hhO9N2K6vS8xw4CVCfY="
}, {
    "num_cand": "U2FsdGVkX19FETp0i7mnbUXAn5hw7lPaXjqjTmSWCbs=",
    "cpf": "U2FsdGVkX1+DQt6oddDDAfM53uE1b1LKc4FTLPEdZ+s="
}, {
    "num_cand": "U2FsdGVkX18DINwSHpkz2KQBZNlbCgg5xOz59+cOFk0=",
    "cpf": "U2FsdGVkX1+mRad/3NnYuJCXjrDkxIK/R/zSnNKP65Q="
}, {
    "num_cand": "U2FsdGVkX18Nfk105j0EQbpvX6LW1xAVLztuHgjMjc0=",
    "cpf": "U2FsdGVkX1/xCQQ7JZwR8YIIiEcb68Jz9t2pnrtBdJY="
}, {
    "num_cand": "U2FsdGVkX18odBAwHw5qy3Z5r4wPTckqjOHoDtjurcQ=",
    "cpf": "U2FsdGVkX19uoBpOdTb0IXDwsT4AIPSOAce1pGrF4Xc="
}, {
    "num_cand": "U2FsdGVkX18IDybtpHrt7B3LdHY2hNF4gKE6b4ExBJU=",
    "cpf": "U2FsdGVkX18DZMCBrlotQc/A0Z0sHbhPel1aijH/H5c="
}, {
    "num_cand": "U2FsdGVkX1/BxYnBcXvplgs5pC5su43jVgyRbeg/gv0=",
    "cpf": "U2FsdGVkX19UDSwSlCbg6E9RR3zMo+xafRpZffn90Po="
}, {
    "num_cand": "U2FsdGVkX18htKX95EsZlXe9bYxr2sIt+FDX3eEvCyk=",
    "cpf": "U2FsdGVkX1+l0ugC6t7AtOqVPwuxhWaPM9EWp204tT8="
}, {
    "num_cand": "U2FsdGVkX19F9J1veSklhmn+n+t4eZqanf5gs5NdK60=",
    "cpf": "U2FsdGVkX18wyQDSrovAoCA7mJ/50RSMeL+6yuPfW4U="
}, {
    "num_cand": "U2FsdGVkX18LXth5QYrHTh/A8+sg/Tz1MEmumhV6SI4=",
    "cpf": "U2FsdGVkX18dnVbsL5u0BJudSrdUHACZrC3MFqglrOE="
}, {
    "num_cand": "U2FsdGVkX1+ZawWeQ0poevP8h+GUgGFP6enNOl1ZNXc=",
    "cpf": "U2FsdGVkX1/aGSIf0XxNHEEfr3S2AOvJAS7LXuvVZ3U="
}, {
    "num_cand": "U2FsdGVkX18Uhg/sdyj1d5fj937xXqDsE0UOcZckooQ=",
    "cpf": "U2FsdGVkX1+DivLkpmgfi7Sega2SlyJfeFtU+nWKhBU="
}, {
    "num_cand": "U2FsdGVkX1/x43LJm5mDuy2gonVRnaCp/vR0/PWPmQc=",
    "cpf": "U2FsdGVkX19dthL3XJDbmfC/ofhxSoeCFsoKoMuwID8="
}, {
    "num_cand": "U2FsdGVkX19dVnDw9C8nAx82gT+KWWOZXPkMKw8ESN4=",
    "cpf": "U2FsdGVkX192mht/OLxAHXS60q5Tkd/GBHu126tHFvE="
}, {
    "num_cand": "U2FsdGVkX1/nNMp1UK4dbwj3LUf3bp8N6qUbhaKy9/E=",
    "cpf": "U2FsdGVkX180C6Pau9rFVYvWrgD0N33WyDdrrhFCWiI="
}, {
    "num_cand": "U2FsdGVkX1/cO1zO9NkaTJ3yO5yQa+LxO5eL012sZOI=",
    "cpf": "U2FsdGVkX18kjYXjTUDFQkmGajhamz4zKOGoaDgldhA="
}, {
    "num_cand": "U2FsdGVkX18bYekug6HKBws+KgEKOpz+ttiRYWo/8mA=",
    "cpf": "U2FsdGVkX192wChI7J72cII7OqVy49hCLaRF0J2N2aM="
}, {
    "num_cand": "U2FsdGVkX18IMrli+C+F7xK9HW5TcxaWnJOltV+ov3o=",
    "cpf": "U2FsdGVkX1+91Vz49IXyD8YAhC3aO8KIFLvrdUupkbM="
}, {
    "num_cand": "U2FsdGVkX197J2qauxb4/HHNj6ihPoeMIJJ4Phn+6KY=",
    "cpf": "U2FsdGVkX196JAsGNT9pZnp96KByzDpYnxSuLoSJKQ0="
}, {
    "num_cand": "U2FsdGVkX19ZGPsVUD3RqowfNv4+sOYtSbtZN/LD8L0=",
    "cpf": "U2FsdGVkX1+EoTtIBs0E2qkeXM+gob5Dz+rsDld/mz0="
}, {
    "num_cand": "U2FsdGVkX1/IsV/r+iYrIMEYYUXnzVRCfUK523AMPIo=",
    "cpf": "U2FsdGVkX1/Gj62HqQV2CFBOweOoAyAAGax0FHAKbKU="
}, {
    "num_cand": "U2FsdGVkX1/oJKvLzEDCB35eVTw5GAYHukzECJD3kvk=",
    "cpf": "U2FsdGVkX1+LKpL/mj4lDT4rmsDpBqX+6PdAve8E3NE="
}, {
    "num_cand": "U2FsdGVkX18hJkOvfcnuMKlL1FzPkmqXT/+hITbX6Cg=",
    "cpf": "U2FsdGVkX1/RC1anngx0XoygAkjYIeaqICNzJKrOEX8="
}, {
    "num_cand": "U2FsdGVkX18CKQfA99lcIU1siwJ7jUObwraTGTw4iLs=",
    "cpf": "U2FsdGVkX187PHJHAM5tFJtkRGbBAcdEpWzpGPQR0Lw="
}, {
    "num_cand": "U2FsdGVkX19xK33HnMIif0tGG5dgjbEQJ2FfejKIrCk=",
    "cpf": "U2FsdGVkX19my9UGKg/lXtxNyqZibbYrie7i/ufwG4A="
}, {
    "num_cand": "U2FsdGVkX19iYHaP4ULkA+0t3AGsoHF08fET/OHe/HI=",
    "cpf": "U2FsdGVkX18Jb2POzvuKeJJ+kzuw5M5/yQPbeuk3tzw="
}, {
    "num_cand": "U2FsdGVkX1/Q9Ek/0y+R/9wMjahaWOgLe/dTcuhtERM=",
    "cpf": "U2FsdGVkX1+8TCVDaJwbS38N3Brh24xL5LAJtgs183I="
}, {
    "num_cand": "U2FsdGVkX1+yISxWBOPFUwapjuRbsvJjiDEJ+BFinjk=",
    "cpf": "U2FsdGVkX1+8EaV8h2GN6zDnceFL8UdXK5X/8rsKxXc="
}, {
    "num_cand": "U2FsdGVkX1/OXo9guRTyGlxbHPN0lQIrpnq2ig+dLY8=",
    "cpf": "U2FsdGVkX1/FgSpoNqsLAnA61oMDWFwRFyYSq3FuofU="
}, {
    "num_cand": "U2FsdGVkX1+LzM3ZRHbeZbTGS5XcqGst5k0v3Z3tSOs=",
    "cpf": "U2FsdGVkX19YWc3ZqkP4xm304P18MdRlUjoVDiAWMHE="
}, {
    "num_cand": "U2FsdGVkX19gN5/lZ6W3zEdHmrjxiwpUf3nE0e9SfE0=",
    "cpf": "U2FsdGVkX18W/RiaKRnOVaevsmauznOiA40RcgvMsH0="
}, {
    "num_cand": "U2FsdGVkX1+jac9Rm3lVMfy7STHqmBhH3NH2Wzgat64=",
    "cpf": "U2FsdGVkX1/Oy4D6r/+TIlaU1U2Zm1RiPfJFJk+eCrY="
}, {
    "num_cand": "U2FsdGVkX19N9aYOqPQSUExp2DcLLzYP0sbxQr42TXA=",
    "cpf": "U2FsdGVkX188nMydRwH0oTjAvTanTj59WRIFkRZDoKg="
}, {
    "num_cand": "U2FsdGVkX1+vT0trj5WdQYH8zXBTWIbXD7FI4dP2zvk=",
    "cpf": "U2FsdGVkX19H4K1Nux3+XCd17OQg4ppEeezZeMbeaA0="
}, {
    "num_cand": "U2FsdGVkX19YlhF2la0zRn9mtgEvHJc5eXqjzNZIPDA=",
    "cpf": "U2FsdGVkX1+MS67M8fFOLe7xxNeohwhn82o6I4PU3xo="
}, {
    "num_cand": "U2FsdGVkX1/m1qdKr+TOJtVZXK6V3bd96cZk6EDKBfk=",
    "cpf": "U2FsdGVkX1/wOcdJZNKjuY1PvsehttIh1re843B5dZc="
}, {
    "num_cand": "U2FsdGVkX194JE+pvCsLNOBGZgK+URJq0mI6S+hCvMc=",
    "cpf": "U2FsdGVkX1/vQJrR8GWw+mZqWDwq6V7Qvk2JMr9VSv0="
}, {
    "num_cand": "U2FsdGVkX1/kSmDBRh8TlWDNx+lcZdZS46gxuxTqOjI=",
    "cpf": "U2FsdGVkX1+lnC1UXny7BLkCRZiky8lmfyObaa81UMo="
}, {
    "num_cand": "U2FsdGVkX1+tpaAaUXVmIzHP5ZAGkvysvZBlmji7fwM=",
    "cpf": "U2FsdGVkX1+cNckRpTbr4s5fGMu5QT+1bLNZAyfMvw4="
}, {
    "num_cand": "U2FsdGVkX19WIvTERvtcmKtEVEtBjF4gW/nIB14Jm7s=",
    "cpf": "U2FsdGVkX1/Xz/MJBZfGSmgp6/+W4K02pKjpAW3MJAs="
}, {
    "num_cand": "U2FsdGVkX18WbSxtyVBmj7Y75dIyhPPSns/AaS+Cbj4=",
    "cpf": "U2FsdGVkX1+KmBTZhsN9LZAkuBscdDzVMXsNXS9lUbY="
}, {
    "num_cand": "U2FsdGVkX1+4vMb+vrzCEFLQSIa/vOzQdmDBreaimXU=",
    "cpf": "U2FsdGVkX1/oZxIz9yb4AhRppfDJI2FA8zFKwnifYd0="
}, {
    "num_cand": "U2FsdGVkX18UGsvVJxpRpaYqyVicit4vRYnoN5KDvS4=",
    "cpf": "U2FsdGVkX18jVPn2GKn50K5+gzFWbyaUdZbTTmkdkXg="
}, {
    "num_cand": "U2FsdGVkX1/JuHNWsG4Zd8Ga9B0a6WtfiAXzK8eAfjw=",
    "cpf": "U2FsdGVkX1+AhomslrQJgtNNqAD56oD3WDKmQ0hrkFk="
}, {
    "num_cand": "U2FsdGVkX1/45nu3SgIGy26yzNLHQII2PmJLkxr01hg=",
    "cpf": "U2FsdGVkX1/LeCQe+optcVSte4uSDLZnTtk3H9Ofl4A="
}, {
    "num_cand": "U2FsdGVkX1+sWJ1hs52aco6tYzD1oTCm7GtZcX7az6A=",
    "cpf": "U2FsdGVkX189zBYhI4aIcSAzNncnxU+0ScLKMmZZflQ="
}, {
    "num_cand": "U2FsdGVkX1+UoLHWRDvEReBDJ+ZBm8fP3C8NteOQQNM=",
    "cpf": "U2FsdGVkX1+jlrDerlJQ+xrDi+oL5pWVuxVC0396aUg="
}, {
    "num_cand": "U2FsdGVkX1+wxDFhyEjFCPD9kgChCH5lax478nxoKhc=",
    "cpf": "U2FsdGVkX1/Kh8+ggQWZ5odH8c39cldE8u2gogyt7/s="
}, {
    "num_cand": "U2FsdGVkX1/VYCG8mdcfWPrYgTLKjetc5KTF11RBq2w=",
    "cpf": "U2FsdGVkX1/PiTGsbuhgONy37j/LuHeq9khtABvpyCE="
}, {
    "num_cand": "U2FsdGVkX1+6OjHEo7cH+lIwfJesy161Ci6uIen/AKQ=",
    "cpf": "U2FsdGVkX1+EG0gL428RLxEm/lGVdJOg60pXsbBqq+U="
}, {
    "num_cand": "U2FsdGVkX19kP0a+vGg+mxqpYZI6a7PBcNJWigbSfaU=",
    "cpf": "U2FsdGVkX19PnzlT7jRzGC4tl8rKEa4ncr/W3Mxiefw="
}, {
    "num_cand": "U2FsdGVkX1+Uh7dj50Wner27995olGgJ0w+xXCUHGnw=",
    "cpf": "U2FsdGVkX1/mAHQBT1L/aZ+02BxoSQm0pTSGqZymPjg="
}, {
    "num_cand": "U2FsdGVkX18JqLv87f424P1m3mhUoom4MeI/xQGdIqs=",
    "cpf": "U2FsdGVkX1+wMb8T/SoDYlNf5BSQKz/KIaqwbI8mNh8="
}, {
    "num_cand": "U2FsdGVkX1+nkrmyN7M9mG8798MtAFVWz7UpQB6OrWQ=",
    "cpf": "U2FsdGVkX18V7Uu3OdWJqrW0Gp5ZpO/6dffYLzBru24="
}, {
    "num_cand": "U2FsdGVkX19pxYMd+b/OcawLKsPvHVf4eddmPZXywtA=",
    "cpf": "U2FsdGVkX188rF0qdWKZHD2lfira5PUeWzetYjRttV8="
}, {
    "num_cand": "U2FsdGVkX19CFjVfH7oKdaeaFm+Fd5x5VAjYI4/oEx8=",
    "cpf": "U2FsdGVkX19uPf1Tx8++SSo120uyRCWKDZQdZlJqB2s="
}, {
    "num_cand": "U2FsdGVkX18bmpg8cKGqZ8Yy83eGA7mLHpSokFC0Iug=",
    "cpf": "U2FsdGVkX18QZ8GErsMtODQVn7g2thd63/Mfz/ZQB50="
}, {
    "num_cand": "U2FsdGVkX181xo0cuHwCmwqDA3EFefG4uJymXu+3xKg=",
    "cpf": "U2FsdGVkX1/f/Ql2CopmXRq0jlGaF6qSQBVmLaRejos="
}, {
    "num_cand": "U2FsdGVkX18hTTj+Xb3ntw2cePcVshdB7V5+uNBhk1c=",
    "cpf": "U2FsdGVkX1+LXEQ9rTCwcsrO/yVngKPkEmVZnzZTkc4="
}, {
    "num_cand": "U2FsdGVkX1+uwPhgRuZm0ZCRQRtO4Xky+nbt3Cdzotg=",
    "cpf": "U2FsdGVkX1+oSaFX04FMkw/R68KKjeAOX12l+OgzgGE="
}, {
    "num_cand": "U2FsdGVkX18hoOOPBMCBixaq548wr+2g7V9lCWm1GeI=",
    "cpf": "U2FsdGVkX19g6swA2ssTi2VEtl9uOqOVaF/D9oXlgKk="
}, {
    "num_cand": "U2FsdGVkX19LA93/CW1CT4g1wGllDjRhoRnXPK5UKpo=",
    "cpf": "U2FsdGVkX1/VBcxAasBRHboFoojmFnP65dsUxQ+hnig="
}, {
    "num_cand": "U2FsdGVkX1/1Lxp8mNLAjkCOeUeJHxARzsEM6qNudVc=",
    "cpf": "U2FsdGVkX1+HfEp/xusx6setb3kIe+MYk4Lv0NU3fBg="
}, {
    "num_cand": "U2FsdGVkX1/TVh82MFSkyhfXrOltRBuWU4mmJQmVMPw=",
    "cpf": "U2FsdGVkX1/xbm2n7+NgGCjSEw5TLpNti4Nw1yGrgzM="
}, {
    "num_cand": "U2FsdGVkX1+1uyF/QfeRY+aibfV7f11f1vke4mNGWyM=",
    "cpf": "U2FsdGVkX1+f3O+PKOqjIeDSoEbxRdkj0ms/+BowIGk="
}, {
    "num_cand": "U2FsdGVkX1/7X6Pwsdjbj7DqfQS5/qyWBcQm1cWpdEM=",
    "cpf": "U2FsdGVkX18WeJBPZ+MQnUS7HduVrru9RGuJEjTjN+o="
}, {
    "num_cand": "U2FsdGVkX1+AUZTs6ZNzGIwN9LF19qssK2ajRlalFvg=",
    "cpf": "U2FsdGVkX1+cVKy+dRG4UjmNO6X0qLo2fg3BTNCaQm4="
}, {
    "num_cand": "U2FsdGVkX1+AhnrkZy1kjWPOIIIKNEdmeVhW7CD4OFc=",
    "cpf": "U2FsdGVkX1//GnlxwSXaSeAeKzKljMEBroL529AEUSc="
}, {
    "num_cand": "U2FsdGVkX1+zPlBnLg6aKEeUnl3oeJRtIsOeM4OlxPo=",
    "cpf": "U2FsdGVkX1+eTehLhmd5Rvbmw3PNLgeFiR7kivRDQig="
}, {
    "num_cand": "U2FsdGVkX19teBv+90IuvHgkTtAmsWToZfLO0y9Heuo=",
    "cpf": "U2FsdGVkX1+LmMKv+fBrgrya5X8VPZI03m/AwWEHfCY="
}, {
    "num_cand": "U2FsdGVkX1+pwHZLngr42JkWatX4Yk2e6v39N5XeEgs=",
    "cpf": "U2FsdGVkX19BbPP2JNl1kTmFoovP+7+l45Kggk3eFCk="
}, {
    "num_cand": "U2FsdGVkX1/VDP8H3St+p38usoVdcHSOKLjtAdSzkI4=",
    "cpf": "U2FsdGVkX1+S28FO8OS1IzPiHpxigdxvBWeK1+qDKOE="
}, {
    "num_cand": "U2FsdGVkX19/Ta5t9K61rGimsa0rM8JtB7J1gis3NnA=",
    "cpf": "U2FsdGVkX18PMZQF/EJ3lQI6Ge4dX+HHb7cR1oUTJ4s="
}, {
    "num_cand": "U2FsdGVkX19FS49Rttz+zt5ynE3tLL3mauhIQmrrgT8=",
    "cpf": "U2FsdGVkX1+FgO9DgGVnpKsKnqAbqQ8cTsowtHYm5iI="
}, {
    "num_cand": "U2FsdGVkX19IUQN030/P4l9xRHDRC2YCUWGGIUWKKjo=",
    "cpf": "U2FsdGVkX18wIS+jjdflUSs9HQrO+/4J0ym4wcdD5ls="
}, {
    "num_cand": "U2FsdGVkX1/WHIc2LEwG1Euit6Y4EE27BkF8uYExIfQ=",
    "cpf": "U2FsdGVkX1/VqL5XLeoIbebXh1eF9JUaEkIMtLhiUjI="
}, {
    "num_cand": "U2FsdGVkX196CwCtuFpIkntEFA/15MuxmFV0eZktePA=",
    "cpf": "U2FsdGVkX1/i/dzIpGoH8ZdqzYbEFsfjTzig/nSvvYs="
}, {
    "num_cand": "U2FsdGVkX1+z3BC3bAjPR8QP0oHjzW1tv9K75DsE1j0=",
    "cpf": "U2FsdGVkX1/wE+vtmJwi5oyDXqo7elutkq2W2B5XJgU="
}, {
    "num_cand": "U2FsdGVkX19Ii5g+azU6xQJOtgGsbvNjeuopM5F6G3o=",
    "cpf": "U2FsdGVkX18ACNwHeuV+e9rPfKG8utYRYXfBwHuUGNg="
}, {
    "num_cand": "U2FsdGVkX18tPI0f9K9wGNhaIp8Bi+C5kc3p401aHqA=",
    "cpf": "U2FsdGVkX1/ge96Hwvpw+pO99gc8WlSPfuRFjA9+HAc="
}, {
    "num_cand": "U2FsdGVkX1/8XvW+uB1KA6MJ9cfFUCa9YbJ6VHlIwMQ=",
    "cpf": "U2FsdGVkX19G69QbVOVg0Zncm/pAOi25G1gKIg6XtQ8="
}, {
    "num_cand": "U2FsdGVkX18iEdgm0tlReV/rxbJzzxnYeXfwAXavhtk=",
    "cpf": "U2FsdGVkX1/VslsH54EWW31DDzRcl39kJEpRGyhj7Pk="
}, {
    "num_cand": "U2FsdGVkX19WEEERqHfgs39+CrgLQiRAurv4xmeq6b0=",
    "cpf": "U2FsdGVkX1/VTBwe3KtTqpjy3bjQxk9j3esv63J4TeM="
}, {
    "num_cand": "U2FsdGVkX19D5PlTtSRcpp/sM+t0cVS1hA9hzUFHuCw=",
    "cpf": "U2FsdGVkX1/Mo0CpA+7uoJev5p6zdzd9YAiHCN5FvTE="
}, {
    "num_cand": "U2FsdGVkX1+vhN7rFxMCEGcaaIE2YPBNe0xWbuGaA6Y=",
    "cpf": "U2FsdGVkX19CIe2UEp8m0FUwWz4oom9G7C5XITJ8uH8="
}, {
    "num_cand": "U2FsdGVkX1+i1B+Sw+qDtdJJ1LJf9GXeOvfIc2stETw=",
    "cpf": "U2FsdGVkX18axPgh8EBuwzczXcjBXO/ndlzaVQOgRNU="
}, {
    "num_cand": "U2FsdGVkX1+n1GooMx4c3zlh0xTxzjnWyL2AaBS64ng=",
    "cpf": "U2FsdGVkX187Q0230x1ZWaQpGIG+q8erd7cokvZVgvg="
}, {
    "num_cand": "U2FsdGVkX18bHp3Xqm8d3SXPIyc+mtWw9IbxYP8C2gg=",
    "cpf": "U2FsdGVkX19FH05Sm8pn6OHubJ4vs4yZ8bqGUV/zXHQ="
}, {
    "num_cand": "U2FsdGVkX1/4+PIpkQlfyAhYGQwBil2pkuRaAppGs5I=",
    "cpf": "U2FsdGVkX1/AdjSXi8s6L05uqoIVFYISKvOyByFcD7g="
}, {
    "num_cand": "U2FsdGVkX1/xIba5OypRz11LBIrcXTHtqOrr5eEvgKg=",
    "cpf": "U2FsdGVkX18yrmQvPnAUt0CIoo6ZzxocldGT6cuq7XA="
}, {
    "num_cand": "U2FsdGVkX18QrueSDiEU3JE+nxgzlq2D+J3LE0Fv2lU=",
    "cpf": "U2FsdGVkX1/0OC4FFkTdI3+ybT0tD3tsiLd8Lr+2rzE="
}, {
    "num_cand": "U2FsdGVkX18rYMOud2279UJkDLFlPoVBx4r19nDaoDU=",
    "cpf": "U2FsdGVkX18jDyZYfpgbkccgnVX3amvWQ2FEj1EblX4="
}, {
    "num_cand": "U2FsdGVkX1+KkAlpieatokivrQtW2K4G5U5VKyeyvrQ=",
    "cpf": "U2FsdGVkX18L17Zlsq9V32AC//F/P88vQ73HbMxH4Jw="
}, {
    "num_cand": "U2FsdGVkX1+cjqTHvisvRVgTGmbG9E12akP3PKcsTwQ=",
    "cpf": "U2FsdGVkX1/R0tcGO/Alx23hW9Yv8CzNGNY3WStmw+U="
}, {
    "num_cand": "U2FsdGVkX18ejamwptQNWWns/r/GmMSeNw67lFlobw4=",
    "cpf": "U2FsdGVkX1+BYqWoesLoTDyeSHhgJBPn2Ww/ab2C+pg="
}, {
    "num_cand": "U2FsdGVkX18QTGcWFPWztwiUd3bcpqXX7FicQgDs4kg=",
    "cpf": "U2FsdGVkX1+tK6JPJl4ljv3Go6EotLybQR+HRiKnu3c="
}, {
    "num_cand": "U2FsdGVkX1+Ik5qeKPRoA61dDSB0RYra6LRnuN7+2Mg=",
    "cpf": "U2FsdGVkX1+DN6ktJaHGw8IX3fzOevZQQS+oYYRDp14="
}, {
    "num_cand": "U2FsdGVkX1/YfJfHA37gD40W7OogGO2zfHGUtUskovA=",
    "cpf": "U2FsdGVkX1+j8GHJH1bqCwmr+Eb10ZG0UT+mh+P8yC4="
}, {
    "num_cand": "U2FsdGVkX1+PScMF+dmE+NCL5ugZedjmvYn+CgelcV8=",
    "cpf": "U2FsdGVkX19/7JfYVaOcUe90B6lQP7TGXJS5/A8NrJE="
}, {
    "num_cand": "U2FsdGVkX1+8ucVmxbR7NsWGaRCYuR4kjZHNfZpktZg=",
    "cpf": "U2FsdGVkX19aB+Ueyqjq7OOxEsX8EGkJOBXUKQcj+T8="
}, {
    "num_cand": "U2FsdGVkX1/OqZIzHM+l5jmpm7B+D8SGVE7Yd6TR5Zk=",
    "cpf": "U2FsdGVkX18tpC25KdBx1kY6eRQCqhX7orgMVl5PrOo="
}, {
    "num_cand": "U2FsdGVkX1/5/VNpuTWKyrUw8gRdrdPBJqUJ4uM4UhU=",
    "cpf": "U2FsdGVkX19vQMqREQSOl0H8eLXL9KaurZ8WFzDuy0U="
}, {
    "num_cand": "U2FsdGVkX1+3nZyxE+XZUBLf8TStBf6XfiQqhtYwhM8=",
    "cpf": "U2FsdGVkX18qtPTVb8vER5xyVNqOzeqYmXwkSHipCFw="
}, {
    "num_cand": "U2FsdGVkX19qa4/Pcu0PxZEkm/Ur+Bbk6QlY1rwo+Kg=",
    "cpf": "U2FsdGVkX19gexJrIFb0y3GcM90INEJq197HsXdHg+w="
}, {
    "num_cand": "U2FsdGVkX1/iKuPm74t8OLFnSBK6Ut2DoK/9TtOt4GU=",
    "cpf": "U2FsdGVkX19j5m3N0rX+7xWQQb6Zr+kPYHtAvilHdO4="
}, {
    "num_cand": "U2FsdGVkX1+QFXqyuiKgXrx+ni4jVGfBMpSVNGWdVbQ=",
    "cpf": "U2FsdGVkX19eonoi4K7bvXeOwPYFIrLY/3owAOwW2SA="
}, {
    "num_cand": "U2FsdGVkX1+YF1d91gB4XQrMhIJyFGYxI3oYER17FhU=",
    "cpf": "U2FsdGVkX18BK3NF1sIY6JAJRu+YqTNNzyaNr2h1ZC4="
}, {
    "num_cand": "U2FsdGVkX1/3WEM0642lJJZidxqSw9mZ9eo+wN+MXak=",
    "cpf": "U2FsdGVkX18eZaywOuI50soKGDIO5awGlsqh1WkboAU="
}, {
    "num_cand": "U2FsdGVkX1+qh/fQ3+Qtmom0rMSu+2+CiO3Pv1D0LP8=",
    "cpf": "U2FsdGVkX1+BFh6XWxxNl79unR8ZyeqKbGQ5g4x4LCk="
}, {
    "num_cand": "U2FsdGVkX1/qxgAL+o5bmzm2/CA+fTybcGN8zJhfMZs=",
    "cpf": "U2FsdGVkX19gSYPsRFHQg2QJ0dVkN85jdNtk3AHe/RU="
}, {
    "num_cand": "U2FsdGVkX1+Y+8bi1/2sZBnHm4jdEQ9AyrPw1HlIkFo=",
    "cpf": "U2FsdGVkX19WWyhbpcZ7NfQVxpZdoaS38HVtTMvqqOY="
}, {
    "num_cand": "U2FsdGVkX1/VdbkKkh4mYVqI70y1Nm+x0Nhtwo5/9Yg=",
    "cpf": "U2FsdGVkX1+sgYeLDo89TpvTswy6Zd+0HYkZMkyyUbE="
}, {
    "num_cand": "U2FsdGVkX1+7SRFe9aYBDXarFMtRg6EypT+EOgkg8/o=",
    "cpf": "U2FsdGVkX1+5uK31IoSTdSqenk20BS+GOVXJP6AZzBo="
}, {
    "num_cand": "U2FsdGVkX19wQ58NEM+fwUvEVp7qhDuoVRN+VbMTHY4=",
    "cpf": "U2FsdGVkX1/FKf8w/uYxRzQ4JP64aZlOIGhyr4qdZO4="
}, {
    "num_cand": "U2FsdGVkX1++o6kmneSPOn6LUlLBUQXz3STW4iHERDI=",
    "cpf": "U2FsdGVkX18tFcv0gsCD0zPOzhcDnoRWU2RJz5tUoqo="
}, {
    "num_cand": "U2FsdGVkX1/eHIbJQsJqvOV0apRym0ozjXjemex0NUc=",
    "cpf": "U2FsdGVkX1/35ds9OYIoJVgT/XFvN2LPdbntWtBTux4="
}, {
    "num_cand": "U2FsdGVkX18ywTdwYsl9yb+o/Ff5dlTcV2ZQ4qW1vU8=",
    "cpf": "U2FsdGVkX19fFST3oaP33VopofyHShTc8wQ9ek+gzc8="
}, {
    "num_cand": "U2FsdGVkX18E1tDiu4pwTOjQOQrYww1hjuVbC7mFSuM=",
    "cpf": "U2FsdGVkX190jEVtoXv8iC770AdPZW3ixTuHTCaI4HY="
}, {
    "num_cand": "U2FsdGVkX19EFlDZn7IgNDLNrHpH5j5YyBnQq44H5SA=",
    "cpf": "U2FsdGVkX1+8wp5inLLivWJTjZmD+osGjlE8Y75/4jI="
}, {
    "num_cand": "U2FsdGVkX18Bwq/acU6DFjn46HVf1htY5a6rVko1lFA=",
    "cpf": "U2FsdGVkX1+Wdyb/JH2tpP/HbVfGqRbQMnh9W4Lg3BY="
}, {
    "num_cand": "U2FsdGVkX1+p+OKIdWcHfprZsJ0GXgeMPRCuXpKepuU=",
    "cpf": "U2FsdGVkX1/AfceqfB+O5suZ9yuWDgMWWdh57HEAvHI="
}, {
    "num_cand": "U2FsdGVkX18piYe8fdafV5ceqO1IkvtS+C6C4P7cgfI=",
    "cpf": "U2FsdGVkX1/niAkGJp7UivhVY043HgcMb/MiZD9g0uA="
}, {
    "num_cand": "U2FsdGVkX19Qq9TgByaEXSCiHr4bzUi1+wZ24nxxBK4=",
    "cpf": "U2FsdGVkX18JkF248XlwaZLz+Zqwtred2e/xNtZpWoE="
}, {
    "num_cand": "U2FsdGVkX19JBNjbq1b9ofnaEDa74YdxJYWUotDBtQs=",
    "cpf": "U2FsdGVkX1/P7v2aLT4b5427o2mMIXhj5HzFlODibic="
}, {
    "num_cand": "U2FsdGVkX1/99PW/kvueIdDKG9BfAO4ivt6pNQB77kU=",
    "cpf": "U2FsdGVkX19+F8U+F2EuL+xhbTShxY/A8Vkd2H0FrBI="
}, {
    "num_cand": "U2FsdGVkX18cXUyb2uBz1pLuyu+a8mdYj23cOSQgswI=",
    "cpf": "U2FsdGVkX1/ouxnVJLWHb1RsKwjyXhE7+5cfwBdyIrA="
}, {
    "num_cand": "U2FsdGVkX1/VlrAPSnOpw3Lc05+MCFKrx2uKO1VfD4M=",
    "cpf": "U2FsdGVkX1/mzO39pF7ZkFG6hlptOw5anxvSpF+0Jsw="
}, {
    "num_cand": "U2FsdGVkX1/B71ypdeRApiyufVKk3TU+bi3MgDzvhCs=",
    "cpf": "U2FsdGVkX190j2E5IlE+Y0k1pYb1ts00TdnE3KUdMSw="
}, {
    "num_cand": "U2FsdGVkX19VLdJs8vqAVPZ4wVqb1gxf8a6zFgRHYdg=",
    "cpf": "U2FsdGVkX1/ivxgtpqriakKv60gKVYkCyGIYPMgD8ks="
}, {
    "num_cand": "U2FsdGVkX1+Ly0G0JT0b1vnpD/e1JLxsGJubafoYCWY=",
    "cpf": "U2FsdGVkX1+0hFw4ft9Ype9qkfbZ9u8qnY5Grq76sVI="
}, {
    "num_cand": "U2FsdGVkX1+6ydV1X8AxCr9oLU0vtEYvhehxXOIadgA=",
    "cpf": "U2FsdGVkX1/BcpRqupjlqJijWEDQ04Kk1ALB4Pah5Do="
}, {
    "num_cand": "U2FsdGVkX19cIRDjsbAyD6QhHMA5R+QdhFg46BfYs1w=",
    "cpf": "U2FsdGVkX1/TjISPMc+lvx9mru8NRxvVzxSi+efw6Fk="
}, {
    "num_cand": "U2FsdGVkX18021egTKNDtBj6BkUVZBogfXKP3WmR+bE=",
    "cpf": "U2FsdGVkX19HWO7Xpfi54ngezOBtIxmLTmdxjQyxmRI="
}, {
    "num_cand": "U2FsdGVkX1+sGjB9rv8jNR8iMsbAz72UpiYrasVMzN4=",
    "cpf": "U2FsdGVkX184PNEdOxEbu2Hsc0BP4+ESomuyXc/g3SM="
}, {
    "num_cand": "U2FsdGVkX18p7cNuX5+ifvii8oCHeNm5/guK8D4/t/g=",
    "cpf": "U2FsdGVkX196Npi2i9hQ8LvKQvDpJqkaPtqnFfblxfY="
}, {
    "num_cand": "U2FsdGVkX19uYL39MbPEQv9z9eYYnR7Zvs50QBw8Y6I=",
    "cpf": "U2FsdGVkX1+25NLw7IFrH3UBJf08VxDxcHmyrUjuwLY="
}, {
    "num_cand": "U2FsdGVkX1/cR1pBMn3lq5LW0ax+myMJZdqeIFqS8bI=",
    "cpf": "U2FsdGVkX1/7kHaYmV0L6qA9KIOsGHgrdGCb8FoYCgw="
}, {
    "num_cand": "U2FsdGVkX18F5jjTo1Rm+hYM4yahacxBTeM3Y6QxI2M=",
    "cpf": "U2FsdGVkX1/rHA52MyGaC/Nn7/rObScO6uxUZKbx3GA="
}, {
    "num_cand": "U2FsdGVkX19frQkDDkOqdiaDgyhVy5NiSE65ar2+he8=",
    "cpf": "U2FsdGVkX19nnoGWf2+NdoLnv8c2JBwzT28gWhELS6Q="
}, {
    "num_cand": "U2FsdGVkX19PxbWPpEeSlKgjyJ4N+bdkki/cmfvllmA=",
    "cpf": "U2FsdGVkX1+a440/boT37cfBi+1apFpN+HODPF7+Ons="
}, {
    "num_cand": "U2FsdGVkX19gphdjBr6kAs7UPq+ZWS7G1/xPwyb4whI=",
    "cpf": "U2FsdGVkX1+a1dpJAzi/KaF+q80zMkz0eQBM36DkV+M="
}, {
    "num_cand": "U2FsdGVkX19FgDR5Ooozjns2yqQRmc+P29MRWhUzqmk=",
    "cpf": "U2FsdGVkX18OJ2+UgkPHoAc/TXD/dvcMEMgNv5bCI78="
}, {
    "num_cand": "U2FsdGVkX19FrGpGoq5Idu2CLLiODKemeLZHK1hmq7U=",
    "cpf": "U2FsdGVkX18itV5Y/JFI/9BBSmTQa+5gU66pjYJbEvE="
}, {
    "num_cand": "U2FsdGVkX18bnUa2yTw9RMU7dszHK5JBi9vBgi6CYDA=",
    "cpf": "U2FsdGVkX198377Rj1upjr5HkUsnjt7jYyIkcKUj9B4="
}, {
    "num_cand": "U2FsdGVkX18Z4sCgllxsJpKuWagS/R5e5yZSNZSCd/I=",
    "cpf": "U2FsdGVkX1/a/XxFFmwVPrDGN1BfIMtWmzYL8NYbwRE="
}, {
    "num_cand": "U2FsdGVkX18kKpZBkyRb1H3yxowTlDby/sYF16Av53k=",
    "cpf": "U2FsdGVkX1/jHU2LB1o57s6FlCPgBBbite0aqIs9QY8="
}, {
    "num_cand": "U2FsdGVkX1/MXyaZRWOoPx3UB23WOfZN8ZgLJB/JdE4=",
    "cpf": "U2FsdGVkX1+vOtqErnJrHsYRgSbCZFLC/IMnLvmtAZc="
}, {
    "num_cand": "U2FsdGVkX195aZyJjjM/Svtu78tj1HO9sA+aEbsh6ao=",
    "cpf": "U2FsdGVkX1+vZQ7idoKZSTqIwKA9DImPA9yDKKgtp9M="
}, {
    "num_cand": "U2FsdGVkX1+VRK6N3ztHfjMvkqNUlV/wpO9WMYHeY0c=",
    "cpf": "U2FsdGVkX1+l/cnCh5P40vS7b9JJg6Pn6swMXTTPg9U="
}, {
    "num_cand": "U2FsdGVkX1//OCXXKGrw2xDUHvyWTlngr5pj2KCMiY0=",
    "cpf": "U2FsdGVkX1+upZZQmqnErbpmgBzV5Ngc9wyQMIliJsc="
}, {
    "num_cand": "U2FsdGVkX1+BcUXJ5YAAlBKK+mtTAoPuTRiUBT5datg=",
    "cpf": "U2FsdGVkX18bSthI9ri7yR5am4FDYdKKPFwKLdfd8G4="
}, {
    "num_cand": "U2FsdGVkX1+kMiphXF0wDzdmhzTk93YdSHFG1aLYays=",
    "cpf": "U2FsdGVkX18BO4weBpz7FwlGMtCQVOnonUb9G15MRsQ="
}, {
    "num_cand": "U2FsdGVkX19MKHW//x90qe+nt5/glc2tB34xwImZuF4=",
    "cpf": "U2FsdGVkX1+zOVoa65AWPhtYapFs1yQ8hVB3j2/9iwM="
}, {
    "num_cand": "U2FsdGVkX1+N6/joctirsRx1RKPnk4NHM9zv30mvcz0=",
    "cpf": "U2FsdGVkX1+1X4GxPbcUZnjxEMTUYkMJ8yhDWOCFovk="
}, {
    "num_cand": "U2FsdGVkX1/0jGrjKedsrkhxdu/ozNTWYE2hTPND7LE=",
    "cpf": "U2FsdGVkX1/juxE41hNEtN0nsjHqgPEs7bxq3sPpio0="
}, {
    "num_cand": "U2FsdGVkX1+DZJy91ApmJp8Yb1AMxomDpe/vqLn86Ak=",
    "cpf": "U2FsdGVkX18qkEVzoSWON6mcTPPHPBJfyhUAEIZ7uj8="
}, {
    "num_cand": "U2FsdGVkX19ySXiIKXKerihTkJdDasJJ7LjA+uJzoAo=",
    "cpf": "U2FsdGVkX1+SbZEIlnzk1KEt8v0WKx1yE/7EV9j8nrg="
}, {
    "num_cand": "U2FsdGVkX19F/YSxeytkI2KXjTZ/YgyeGzzkTcL4s1I=",
    "cpf": "U2FsdGVkX19C+UppZYlBbjkGY6kBSON5KBfiAxV1B/Q="
}, {
    "num_cand": "U2FsdGVkX19a06hb3TcGgp5eK6UGZQRyj5C0u8VaKmg=",
    "cpf": "U2FsdGVkX19d4wKXXdoxfDnNjDaTywRFcjo/gvuSFs0="
}, {
    "num_cand": "U2FsdGVkX1/acv8jb3l7Bi1L7+FUspNollWwZ5C73gA=",
    "cpf": "U2FsdGVkX18v7NqItOwmixtjs4/ALg64QeRDsGoF+3o="
}, {
    "num_cand": "U2FsdGVkX1+XGHuCAELqqhfPkk5WxCOPiikXERxbmqQ=",
    "cpf": "U2FsdGVkX18xVXEQ6LfVkgQ2bm6R+Jp1mMYTmnlf+Fk="
}, {
    "num_cand": "U2FsdGVkX1+hU0mv62tj9TGNwsU8oAvAfQrkh6mdfvI=",
    "cpf": "U2FsdGVkX18bC7gozedA8tuv0RodBJM4Dq1lSpnkfM0="
}, {
    "num_cand": "U2FsdGVkX19JUazd9eHj3qCs7GGUjkr7ryZk70Zu5HM=",
    "cpf": "U2FsdGVkX1/G1hbXYTV83VF2oAL2pmvnEWb+6hE6eX4="
}, {
    "num_cand": "U2FsdGVkX1/eP7PudFJu9njpYy7rczlCiXjEgBfekc4=",
    "cpf": "U2FsdGVkX1//YCw+U2/tDqgOxYTi4+z425lzFGaruN0="
}, {
    "num_cand": "U2FsdGVkX1/s8jzh4q7FMCGMTrLXsLzKq5srWAfWe1Q=",
    "cpf": "U2FsdGVkX19GlumFJKQuIvaEu+y4trRZt0vRD9Is/zM="
}, {
    "num_cand": "U2FsdGVkX1/uZkS8d4zCyVXuTVFXpQfEB6ZEwl9oiUg=",
    "cpf": "U2FsdGVkX1+KI9EUCZKcFP9XAH1iLowb0m20RQvQIfw="
}, {
    "num_cand": "U2FsdGVkX19XiMFP8bxN+P/TX1AYpsAzoyKyA3ZCJKI=",
    "cpf": "U2FsdGVkX1+4ZxE1bYUhBYRprhabsu1Jg6bT2SoH5FU="
}, {
    "num_cand": "U2FsdGVkX1/QzRkTuoqZC19Yglt3tYW6C35VIjS5dvo=",
    "cpf": "U2FsdGVkX1+0dSAuS6/jLaeQsLv4odYGPm7NmR6B6aI="
}, {
    "num_cand": "U2FsdGVkX19+9xUto3e44Uqv+bL6xRdDlWpqpvSodN4=",
    "cpf": "U2FsdGVkX19vK9zNZ+KqOcdT3laaNHWtCMm8qbGY1MY="
}, {
    "num_cand": "U2FsdGVkX19j3sRiRo1t8YvaPL2ztohWR750s2jQhqw=",
    "cpf": "U2FsdGVkX19d06gOpGwcnkyh/IE6SY/mEiwhmh49X7I="
}, {
    "num_cand": "U2FsdGVkX18KnI2S7Y0NUUkQmg105fj2yGNHMCI+qhw=",
    "cpf": "U2FsdGVkX1+iSjvq0N39Qrj2VPhLXiRZIecCByetqZQ="
}, {
    "num_cand": "U2FsdGVkX1863Sj+PaXbJgsOHYIj8W4xA02DiyL0e0o=",
    "cpf": "U2FsdGVkX1+nE4OoeWByZBG5fU76oFutAATo5L6sXuQ="
}, {
    "num_cand": "U2FsdGVkX187qPbA8+hgWHuJUgRQOM7NbbM4yfg4izg=",
    "cpf": "U2FsdGVkX19Hhf/aV+C0OZtqa0OPWLDFgjFMi6iB6NE="
}, {
    "num_cand": "U2FsdGVkX1+xT7freWXS4arQPwpqPVKMDBjRUc5wvZU=",
    "cpf": "U2FsdGVkX1+SwnGFB4CRGMNjL/eLoLj1Xcy0QBZYYeQ="
}, {
    "num_cand": "U2FsdGVkX1/NKHnLdvWCAObGn4vFl9AipegzKkzSufA=",
    "cpf": "U2FsdGVkX18IpW9nfiECs0qjkw5BcB/x/TU2Ci15Hss="
}, {
    "num_cand": "U2FsdGVkX197YPvsSxsutPqm/u94pstK/2ulBapvCSc=",
    "cpf": "U2FsdGVkX18wTZfDhVCozza+4pNQNcTQutw7oEWMsAE="
}, {
    "num_cand": "U2FsdGVkX1+58f1mHzHgSbFMczB3cpcN6mUHmVEluzg=",
    "cpf": "U2FsdGVkX1+2zqe6/wZJBqeDEjUb16g7hKjXBErWeOA="
}, {
    "num_cand": "U2FsdGVkX19Ln1k+PPFGdqlZNjn4+LHmUwRTBZ4NrQA=",
    "cpf": "U2FsdGVkX1/HkPyK2LNLiVXzsVCxb2GItzOLXD4wOSs="
}, {
    "num_cand": "U2FsdGVkX1+wrpatal+k7STjYyyPkzQ480QEkDs+IUY=",
    "cpf": "U2FsdGVkX1/2Q5TLYwP10K0TdU2pqxmpWA9prZu+jsg="
}, {
    "num_cand": "U2FsdGVkX1/UcKjqMudlJBSp/2VBYpkslJVJXt06w/0=",
    "cpf": "U2FsdGVkX19WlsoxKEQ/Y3o5Rgi0Kf7jtx7knEn8zkM="
}, {
    "num_cand": "U2FsdGVkX1+6bX1P8jE98OErhoVfIUvO2gdZMLTNZrg=",
    "cpf": "U2FsdGVkX19hm49oZCiSCvaNn+xi6mESXhTCXWJrmw0="
}, {
    "num_cand": "U2FsdGVkX1/RJ5aLaN4Fzk1nJoy0kYS3vDyhGlDZ4RM=",
    "cpf": "U2FsdGVkX182Ga2sj/mOXGPqvUD90a3ywdn53Q/AfjI="
}, {
    "num_cand": "U2FsdGVkX1979S5/zPQ6zQB1Dni4CpNZudO//bln3cM=",
    "cpf": "U2FsdGVkX1+DkzMCvmChjvVM2V5uC5lKFe8J68PCfno="
}, {
    "num_cand": "U2FsdGVkX19xBzh9sQsiRoA9ih9XivOuuxf5D3kqLA0=",
    "cpf": "U2FsdGVkX1+kMwTYJrjE+DlLChKX7ekJPZhMFqKjChY="
}, {
    "num_cand": "U2FsdGVkX1/Zz33F0/4U5IUvV+n6l7qpdaLZcThQcpg=",
    "cpf": "U2FsdGVkX1+EXj8KTePIGZcUqKLZDAM6CWnPicHELnM="
}, {
    "num_cand": "U2FsdGVkX1+NIEW3K+aDgTwz3TOl+Ez4xgryu8FdU1o=",
    "cpf": "U2FsdGVkX18oUL/IL1/dRfD4y1MVC3Nq1JhDaU1Qfmg="
}, {
    "num_cand": "U2FsdGVkX19ogj8iCQz8qs3ufNYhd+5ExVkcMwyMDjU=",
    "cpf": "U2FsdGVkX1+7OAP2ls5925yvXklHtN+8j14deBanyfQ="
}, {
    "num_cand": "U2FsdGVkX1+U/aZ0gJ1u7wSX4So3/bZN0I3t+oUUZEk=",
    "cpf": "U2FsdGVkX1+Jv9VaazG7i2aGnnFncdxl17w86y9fdvc="
}, {
    "num_cand": "U2FsdGVkX1/8D2VylgXudSg/maSVIvoOwmnrQ4W3HSU=",
    "cpf": "U2FsdGVkX19gISD/t4un6NvM421umT4D9rn5UnoJOms="
}, {
    "num_cand": "U2FsdGVkX1/yoOC28k9Bi3yr3sT1lp54bRZTubwc33M=",
    "cpf": "U2FsdGVkX18Ou62mVcrsg+o9inUFyopXbkzGMrl+SGQ="
}, {
    "num_cand": "U2FsdGVkX1+5dHZt6yJC9by5WHUV0FdA+zRVHpZzo4w=",
    "cpf": "U2FsdGVkX18Bzf34//IYXXq7H8koVtpkTfYcZhTtA6E="
}, {
    "num_cand": "U2FsdGVkX1+aXgBdRXJdd5N9yO/OagwLPl/3c7YEFxU=",
    "cpf": "U2FsdGVkX19MO+cCaNL1CWuL3cuNdMdYqxmnF/qLhPc="
}, {
    "num_cand": "U2FsdGVkX1+n9+vHL1wGQdNlrw1t5ps2nT6cK4Vy2O0=",
    "cpf": "U2FsdGVkX1/tCu9edKO8ipHnUMHCOZHplaIFCmNMkC8="
}, {
    "num_cand": "U2FsdGVkX1+3+pXCsXRAzjVKU28iRQ8UeBsbictCYTY=",
    "cpf": "U2FsdGVkX195i4DHyOSHpnVADdPIKfPV19Ep78QGFqo="
}, {
    "num_cand": "U2FsdGVkX18+tusA21g+S050EZ93bUHGPtV9c2JfuoQ=",
    "cpf": "U2FsdGVkX18ZLPAHQ7NT48RUF/CxfPuZEvwGTxNsaqM="
}, {
    "num_cand": "U2FsdGVkX19+Kphf/HDSNp25A27WH1Isd1w3KGSiO6I=",
    "cpf": "U2FsdGVkX1+TVL2MkdJ7YBegVR+5rnH01tNGUIu5GFo="
}, {
    "num_cand": "U2FsdGVkX1/gp8h8AduYng9FZh5Xcqbq2t2EQUhuv8o=",
    "cpf": "U2FsdGVkX18vOmRbY0re8ZkNBBBpDQS4l7lYH2pldjE="
}, {
    "num_cand": "U2FsdGVkX1/xoLb4X9JUfLkzU4qeTg+Xf61nIoWFAmM=",
    "cpf": "U2FsdGVkX1+lIowrb4aXELWGS9B9yswF6WB7w8FJ8jA="
}, {
    "num_cand": "U2FsdGVkX1+RQXgC3SQQfBwE/K1Gie5odx6F/+oL4OM=",
    "cpf": "U2FsdGVkX197qhwI3UEoUf4SfsqkUaYDyx7CZWxiZ6E="
}, {
    "num_cand": "U2FsdGVkX18cnHlY+mWtRV1kglmR2wReXigdBzFMWsM=",
    "cpf": "U2FsdGVkX19SROqyAH3u9fylzd9uK1wEdgTdt0JWaLA="
}, {
    "num_cand": "U2FsdGVkX19+m9JzdaRoNWZHPgM10kgFe86gMqmVpY4=",
    "cpf": "U2FsdGVkX18mv6pZFMVRtOmxCaoAOE7IU32CS7N8M2g="
}, {
    "num_cand": "U2FsdGVkX19eo38rVQq36fn832d8SYC7zRhBBqYml/8=",
    "cpf": "U2FsdGVkX1+vRWkBccoR7eV/ttp7m20fNQZ/8VOaBsc="
}, {
    "num_cand": "U2FsdGVkX19KSukG3tsl1OYbYRmUcjYGmAal2ohMp9k=",
    "cpf": "U2FsdGVkX1/FjSY7kru6bf51vnjozMPczxE3ChDKF8Y="
}, {
    "num_cand": "U2FsdGVkX18cZIz2RyOcaP2znNDTdFf5vOxelevESsQ=",
    "cpf": "U2FsdGVkX1+nkE1l3/DQwvGMA17nLvfQZXXIQEOfWc4="
}, {
    "num_cand": "U2FsdGVkX1/HzXly9wk8UFm2BKkjW6Di0n7SFdlkp24=",
    "cpf": "U2FsdGVkX1/Oa1fESFnrt4FcaJBPsFBEpz9xoKkjBro="
}, {
    "num_cand": "U2FsdGVkX18/wbKkQko0EOOphPwLeN2mwcHTMMvWInw=",
    "cpf": "U2FsdGVkX19ylMWtk05GuCXT4VbqxxdE8BhvD+u59rM="
}, {
    "num_cand": "U2FsdGVkX1/gGyEZMr0Ov34FWMOhDjDS9qeh2Hn/+cQ=",
    "cpf": "U2FsdGVkX1+yLevLKO5gp3W+eMqYLE4aFIWn8PagnUE="
}, {
    "num_cand": "U2FsdGVkX183O2dCitDvzjNZsKo+ce4O7s5+8fKl8U8=",
    "cpf": "U2FsdGVkX197FV/hvnQpS2rjirVLj+3Ngaew6AkWFEk="
}, {
    "num_cand": "U2FsdGVkX1/ZsIK/0k8Vc4hQoilmC40uPXo7FHqCov8=",
    "cpf": "U2FsdGVkX1/PHBshHkDcyzkQ+QzoUjNd+JcH8ICdSYo="
}, {
    "num_cand": "U2FsdGVkX1+mG+rhHVxYWfyaXjlo0sNAhl0vKAbUHl4=",
    "cpf": "U2FsdGVkX18m228qkE8C7iqQPKWWyi6HmbA9loHq4OI="
}, {
    "num_cand": "U2FsdGVkX18vDL7bJ4CN8yid18jX6KkWzQ2pnXqr/4g=",
    "cpf": "U2FsdGVkX19IWAeKf//LAR7PZ5+J1BnCB3Spl2OueUE="
}, {
    "num_cand": "U2FsdGVkX18oE4EEgwuLUGS0LwBtkEahtUhdbW5jO2k=",
    "cpf": "U2FsdGVkX19HETzBS0cTBqJUAxHR1ffzeFUkqxAQftA="
}, {
    "num_cand": "U2FsdGVkX18aiw8GG7VfzlZt+bqGlvpRvlN8OpP1qGU=",
    "cpf": "U2FsdGVkX1+JvK4Qba3Z4CpSujfiQR8HwhV1LPKB+UY="
}, {
    "num_cand": "U2FsdGVkX18qO24XwhcGUM9W+CQ4TyMQYY/UtuFCvuY=",
    "cpf": "U2FsdGVkX1+mJALpsXlSyrm1TqwNXxQAIZ/wro+6h1w="
}, {
    "num_cand": "U2FsdGVkX19ZJgqr2fpo85o3e0FaOBAV6inLj3JjdRM=",
    "cpf": "U2FsdGVkX1+GnnLbCDC4TzEcS39iJiizH3wQoujF9lI="
}, {
    "num_cand": "U2FsdGVkX1+l1ShDxYC+8cte5fAeOsedUqWHy/lcDDc=",
    "cpf": "U2FsdGVkX18jRjpcC3298Ar9Fse7LCuDuhe742Qmn5E="
}, {
    "num_cand": "U2FsdGVkX1+KDgKqOTHfPc1vFTHbEFvfoJSIaypE69g=",
    "cpf": "U2FsdGVkX1+PqSBazm5sD3aXFzF1XMIUDcQZuLvvZQU="
}, {
    "num_cand": "U2FsdGVkX19seFt+Vw/BeaUmydTYCr+rEYu7C27F4cM=",
    "cpf": "U2FsdGVkX1/3wUvJZVOZhCygrw0DYR1oCCyu08EGWoI="
}, {
    "num_cand": "U2FsdGVkX1+YSF6QTuPKtOHInSjVxl6LkLjU1qqsHfk=",
    "cpf": "U2FsdGVkX18B9o9ammUjGSeeeCmfOL9teqYP8Pn2ueU="
}, {
    "num_cand": "U2FsdGVkX1+dvn13s0SaYUsVv7dPPI0I5thc7XTeV6M=",
    "cpf": "U2FsdGVkX19bh+PPiKZh+4drTpfA5cfNIrnIcyqzsM0="
}, {
    "num_cand": "U2FsdGVkX1/GRJdgAPu+cmt0DwmHJWk2kQDX0HrcSr8=",
    "cpf": "U2FsdGVkX19U40CNYHxui0qjhVb58jO4LtAy8uPcjJw="
}, {
    "num_cand": "U2FsdGVkX194g3B6YggMNGo8B+bPgV/KdO9TYOhgfEQ=",
    "cpf": "U2FsdGVkX19x0+JYpgfVDtIZg7MlN5voGw51R7eKsnE="
}, {
    "num_cand": "U2FsdGVkX19ZHeSsYODtVXOeAwUS3pYlJpZttEdMBpU=",
    "cpf": "U2FsdGVkX18ulQr7q+07W6kP5irV5j45HEBolkm3Dgc="
}, {
    "num_cand": "U2FsdGVkX1/8uRU1L2GglQ5VYr0eUIHTUjYxDyQPznI=",
    "cpf": "U2FsdGVkX18DF2MNzid7G4quMOJ839W4R2gScMhAWR8="
}, {
    "num_cand": "U2FsdGVkX1/HfJby+sR1qXlU+F2XLZwsh7vELJU1DTE=",
    "cpf": "U2FsdGVkX1/BqR4P5ACodE/GmxN+Z3OCY3ETTArn+Ho="
}, {
    "num_cand": "U2FsdGVkX18E87vgRSxaB2PFjmRHxhcpptDADQ8+J68=",
    "cpf": "U2FsdGVkX1+LnIKi3c89DjDmCv/OwqyUeQTYSSdMLXI="
}, {
    "num_cand": "U2FsdGVkX18WOd3rHOxPu3Wo9f7n8Yi0PE8+Ewo+PLE=",
    "cpf": "U2FsdGVkX19dKfqfXXnK2SZqMRHjUSarbkvtR9MTocc="
}, {
    "num_cand": "U2FsdGVkX18B116aA3uOMwc7HZRvYqJbZT70FwfH8Js=",
    "cpf": "U2FsdGVkX1/LKxA6/90TNKnU4JSIAODZWpL8t0YJFw4="
}, {
    "num_cand": "U2FsdGVkX1+vOz2CRdE2Gj1Ko3NUvBoe6YnKGpQm5n8=",
    "cpf": "U2FsdGVkX184yHckJUB5W32iGsmAU9pI6wIlINK27mw="
}, {
    "num_cand": "U2FsdGVkX18IklP/FP33ceYJ0GdMjxF16/XqFQ0PMw4=",
    "cpf": "U2FsdGVkX18EPEf+rJ6ZBPPNzD6XUjkVcPleTWBLkkw="
}, {
    "num_cand": "U2FsdGVkX19Fox6fE/2cy7A4zA5u9V7tV5w3Fr4m2fI=",
    "cpf": "U2FsdGVkX18sL62EWtamZ1TDFR24j+sadypqnSE1lJ0="
}, {
    "num_cand": "U2FsdGVkX18ek0i+d8dxVOp6oyY6M4N7rMdTwFa9VVg=",
    "cpf": "U2FsdGVkX1+pdnsfPm8MEpQy8Px40OT/POaTn25mhHw="
}, {
    "num_cand": "U2FsdGVkX1/teRxDab/xlNdZsQn6/QHaktMs/Vu0UFY=",
    "cpf": "U2FsdGVkX1+9beDxrTS7R7SWMLHU2X+pQoa/i70ZlRA="
}, {
    "num_cand": "U2FsdGVkX18R97ny3LpWOwENz6HefD7J6JWxCjE0XnY=",
    "cpf": "U2FsdGVkX18xIHTB0/LffMqbln80uiybARtqbyZOIGk="
}, {
    "num_cand": "U2FsdGVkX195I//CoO5u1Xp70nQiuzbw0RvMDnLY3GE=",
    "cpf": "U2FsdGVkX19LTwZQRK9DjI/Ld8T5/hjTKraASGfht1o="
}, {
    "num_cand": "U2FsdGVkX18LXb71myHgeebYRCuZFHHp0jtl3NKwlTc=",
    "cpf": "U2FsdGVkX1/van/rXHsJklRXvV6w/2gGlh/xMSxRlbc="
}, {
    "num_cand": "U2FsdGVkX1/GDxu5rHKq+w8uWj5BRnA/0jT5V0qYiL0=",
    "cpf": "U2FsdGVkX1/I6d/ItVANiH9dgaK5lng236MUY0AifBw="
}, {
    "num_cand": "U2FsdGVkX19jo9j+QSF/tzYYFeevrOVinhzMRILL5p8=",
    "cpf": "U2FsdGVkX1/c3XUN/acDQCj+zP9j3C3E26awP3FyLXo="
}, {
    "num_cand": "U2FsdGVkX1805I8z6AsxxiPyZ1e3AR/A/g5ZuiXiHo4=",
    "cpf": "U2FsdGVkX18wvV4b9N5n3uIK3P7B6dPa4yTJLUOru8A="
}, {
    "num_cand": "U2FsdGVkX18CsXjq5Qp97Qo7Es73E8dtA8/2GivPi9M=",
    "cpf": "U2FsdGVkX1+wd+sANATsWJqzhhV0Q3UMcpNsTTSpwzc="
}, {
    "num_cand": "U2FsdGVkX1+D3rd59YdfNoLHwKlcJbCRdejyOJiTpVs=",
    "cpf": "U2FsdGVkX1/QL2CsCQb9euwa5WFvMPqD83KFL3czkQc="
}, {
    "num_cand": "U2FsdGVkX18VUwb+3t4EO96G5Bqr57+ZJ4aZWKKw3zo=",
    "cpf": "U2FsdGVkX1/rSAMyYLjhjju7/fgHC7duEseZH4mdaXg="
}, {
    "num_cand": "U2FsdGVkX18JNk06kgaDHGXxthMqJqOLSSCezcC8QpM=",
    "cpf": "U2FsdGVkX1/AdGUogYIXfOF2qPdpSsrBfA51tRNFGYs="
}, {
    "num_cand": "U2FsdGVkX18tt1ilfBf4OGjHhaKYq0+y9bTvL/7xxoI=",
    "cpf": "U2FsdGVkX18RmYBLA8XWFNl7YLCjsagwQwG1hch03yw="
}, {
    "num_cand": "U2FsdGVkX181zBIE0542NiXqyB4yijvsOdsuRWzoWM0=",
    "cpf": "U2FsdGVkX19UNdc425bxteB/Z0dNs1l49O4Qh7Wsod0="
}, {
    "num_cand": "U2FsdGVkX19PF9ZyKV4014/FYsMZ2yOR5DYl6ZW/P0g=",
    "cpf": "U2FsdGVkX18BtnlSwZ8Ujz8tng9sZVlSo3Bh6u+Ftl0="
}, {
    "num_cand": "U2FsdGVkX180JL53cq8Um27w25ztPicp4c1a7vs0eSA=",
    "cpf": "U2FsdGVkX19Fz9L/3UIs07vJ88TrzDFJTL2WhxkLOxA="
}, {
    "num_cand": "U2FsdGVkX189E56HHSsl8sy2guPGsArgBsRSzyO32Cs=",
    "cpf": "U2FsdGVkX198ESzolGJZ9SZtr8mKvIDzHbpW4qWR64E="
}, {
    "num_cand": "U2FsdGVkX19AeWtcbRwJdBxqpcLCuaS56VBW4nH3px4=",
    "cpf": "U2FsdGVkX18TOVKujVYpf4f2Qz//391CEZm3+4mxlME="
}, {
    "num_cand": "U2FsdGVkX18In/Oxpc/SQO0+Oq5LI5Ao0XmHP96r8Qc=",
    "cpf": "U2FsdGVkX19++Tlwpmig2k2W4SayxSWU+l6a3xQykLA="
}, {
    "num_cand": "U2FsdGVkX19yP5NRpTvzNdXuG2JohEGMjKV96DZkE6Y=",
    "cpf": "U2FsdGVkX1/k7OluA5Vcq9w7RpvNW4Rhqp9DiIV3LV4="
}, {
    "num_cand": "U2FsdGVkX19dT89PaB6ElGe0IPYPLkyJrOTiC8ffEKg=",
    "cpf": "U2FsdGVkX1+trP7DPfTl5vpr51071W+q0Y3yCtRFz3Q="
}, {
    "num_cand": "U2FsdGVkX1+dRP++5AP7PsuYCcPwwRnP9TsQ6zJ9OW0=",
    "cpf": "U2FsdGVkX19x8qWLT2nIaKJm55Qvfanxn8xk14/Bnrw="
}, {
    "num_cand": "U2FsdGVkX18XnB9Qjp6fOU6IcT7Xzh157yG8yktfMXA=",
    "cpf": "U2FsdGVkX19Ouf2X/KS7czrgeE09TWMki+cNnqgBB/U="
}, {
    "num_cand": "U2FsdGVkX18I2TvSVI2XEjUyCqDVvgatWkGMje8lVB8=",
    "cpf": "U2FsdGVkX186P0Ya3I0giQAdhuPrfdRT1SOEt/aZip4="
}, {
    "num_cand": "U2FsdGVkX1+a03VnXc6BKbVF3sQFpLTfCfuOIZ9W25g=",
    "cpf": "U2FsdGVkX19tN6p69cmZMlviQR4w/wZLnRkG1G6so/0="
}, {
    "num_cand": "U2FsdGVkX1+fTWvDWdQ5qiLhD6X8NcVZ+8p9izi/57Y=",
    "cpf": "U2FsdGVkX1+ZGKBDgMAybhaO5ieJb+S2/NGf6ZLTOUY="
}, {
    "num_cand": "U2FsdGVkX1/CV2j15Ly5/n/4Hp/wncl2Y+sfbby2w1A=",
    "cpf": "U2FsdGVkX18mokbsX+dTVFp1HuXxGZLlwG3ISqNlsRg="
}, {
    "num_cand": "U2FsdGVkX1+shKQiHt4NVa73N348Nc6UI2FNjzg9S2g=",
    "cpf": "U2FsdGVkX1/D/G3j5xFwvJ5OzkX4xJ6yVMPbs2R1EkI="
}, {
    "num_cand": "U2FsdGVkX1804O3Xnk8knxeaI4Cw99bqVhDuQWbObWg=",
    "cpf": "U2FsdGVkX194t9lBI0qtKaJFdTusCvJeqlxp3cA6xmk="
}, {
    "num_cand": "U2FsdGVkX18FquU3XUqyVrH1O3KrU/e4MPWiRAd7Agc=",
    "cpf": "U2FsdGVkX1+GC4BMFBP7vQVeMhhb02cnF8DSXqwCspk="
}, {
    "num_cand": "U2FsdGVkX1+LlaO6s7vz1taqBxE39BH7rKuR028YSBo=",
    "cpf": "U2FsdGVkX1/0cEB+J6y2ciz8TT48UPUjXhBT3SFPG4g="
}, {
    "num_cand": "U2FsdGVkX1/gr/UtTHbcaaVbrz0LDrDSZqU8pVC1hcQ=",
    "cpf": "U2FsdGVkX1+a0OpxkEkCg34311tkOuhU0AOnGe2QJ/0="
}, {
    "num_cand": "U2FsdGVkX1/pxr1EJd1RO8a3LaCUzHhuEKheBLoByHk=",
    "cpf": "U2FsdGVkX1+yaScfpxoHiVeF+D3uPr22PpyYE1BXln0="
}, {
    "num_cand": "U2FsdGVkX1/KQR+wd13Wvl0MHQcfRfMNY1S/hPAa9kQ=",
    "cpf": "U2FsdGVkX18Lxa9sE+Im1yoS5cr+OCSnCxHsiaQ5+/k="
}, {
    "num_cand": "U2FsdGVkX1/tCENv8ntPrGccBZsslnR5AN9pwb4tuh4=",
    "cpf": "U2FsdGVkX18QntUndeKmxdVGT6nddnnKtP5T2JFBfn8="
}, {
    "num_cand": "U2FsdGVkX196F6AdNou1+6X7ZWUYmBXSg/AVjD62mRk=",
    "cpf": "U2FsdGVkX18NDti+wvTwvwmN1p/DlNMlsZUU4QBZ+8U="
}, {
    "num_cand": "U2FsdGVkX1+Eksh/8yR+hC4j3J1geIAKx4sT8HRdYC4=",
    "cpf": "U2FsdGVkX19CUFBEso7SIH/0XxeHRZGBLCAH8/DguQA="
}, {
    "num_cand": "U2FsdGVkX1/N2Hb7cmhKMldfrW4czXnknSAQIEwhVjg=",
    "cpf": "U2FsdGVkX1+63JVY3AV4IRzTxKSUv32e7ZW+t2EEwK4="
}, {
    "num_cand": "U2FsdGVkX19MfngjfJv4lrAiFIpwQX1ZXxq8BnGAXHQ=",
    "cpf": "U2FsdGVkX1+xSmFwTxg1OxyF5NzVALwUDYVF8UWfLg4="
}, {
    "num_cand": "U2FsdGVkX184a1rEzdE6MM+NkQ1ybVvikhTYxNV/PUU=",
    "cpf": "U2FsdGVkX18QOcd5/TAVRN4TFTKS1M5ZQ6Ik8xwb7BA="
}, {
    "num_cand": "U2FsdGVkX19ZjIth7wN8tr4HPVVmB2bRCnV2QPrB1zE=",
    "cpf": "U2FsdGVkX1/EpzHwHYu9di3sRpVFvSlIXh0v1wp0fTg="
}, {
    "num_cand": "U2FsdGVkX1/SRcytTYQWz/FS6+Mk7NVcPnYMViveuvw=",
    "cpf": "U2FsdGVkX1/DIup8FbjtJ/NQ0/N4tSz7mnDXxtNBTgU="
}, {
    "num_cand": "U2FsdGVkX19k13XBVfJ7btcODRlZeUmzWPdCu2R+wwM=",
    "cpf": "U2FsdGVkX1+uQBBY4u9r4OkWbNJt7wTkLHzTAaPRtBk="
}, {
    "num_cand": "U2FsdGVkX19LLQhYssXWmvTPOHaOtTXMVc/Wc12v9+g=",
    "cpf": "U2FsdGVkX19Y1RMolkS+FFhOYqnz9rweetpmk/t7GgQ="
}, {
    "num_cand": "U2FsdGVkX1/DIYpvUrO53m2rcDQnigzibnxOCe0sxas=",
    "cpf": "U2FsdGVkX18bYU3A/P2386VIsIof0IN15x922f9jJqA="
}, {
    "num_cand": "U2FsdGVkX19Yt/Afo8WpVfTqjv6cdLzy2eBiRZFLwOk=",
    "cpf": "U2FsdGVkX1/NkdG5wSZPCDNbgM3eNbVkrpQ7GxfMedQ="
}, {
    "num_cand": "U2FsdGVkX19egorBjg52BTtwIcdrYlmRKydIhd2CdR8=",
    "cpf": "U2FsdGVkX1/UgUOxKjCMtsihiNPufl4lUHIr98qKicw="
}, {
    "num_cand": "U2FsdGVkX19isxExDfaFR/N7FcW1cJronE5Zp6YE+jA=",
    "cpf": "U2FsdGVkX1/k40D2UoQbr9IKe6tJuxer7kBm0Ro4f7k="
}, {
    "num_cand": "U2FsdGVkX19av8jYhmh6lfDj/9LqPZdlTnhyDqkrrjk=",
    "cpf": "U2FsdGVkX1+aWN/85lHsD4b3Fji7L7fiaDKv+zjvk40="
}, {
    "num_cand": "U2FsdGVkX19ZNIsliQ3TKQbncBBUDzQBvwsM6REO0VU=",
    "cpf": "U2FsdGVkX19fpOg/OAsrZXLiyQs5kONvYh+FfIqvXBM="
}, {
    "num_cand": "U2FsdGVkX1/ZpcXDYtmcdYHXpgn4jFkRIwiPy0wzzZs=",
    "cpf": "U2FsdGVkX18texZKxZwo6191zmyfeqt3+5ZHxQ8N8UM="
}, {
    "num_cand": "U2FsdGVkX18K1MdCAOBico8MxfyLVRkK47bkUZkCjRo=",
    "cpf": "U2FsdGVkX18igtgjJFtvjuQujkLLkmZB+61h7yYyzY8="
}, {
    "num_cand": "U2FsdGVkX19jYECfLLolCRVr5UrsK9rpWC3JaRrreVw=",
    "cpf": "U2FsdGVkX196R51K15y8MXuhArYQZSCS9YXJQUS3vCk="
}, {
    "num_cand": "U2FsdGVkX18mph/9xzw9T6v4elzKLUyOaAthxgNaUWE=",
    "cpf": "U2FsdGVkX1/9gZMs+JBOXtLLuudKwsVqZIA1OzWkr30="
}, {
    "num_cand": "U2FsdGVkX1/c2K94d+m1zjVh/AlNs+iIS8u6dvgFxBY=",
    "cpf": "U2FsdGVkX1/q7W+siCu4tXXeEgOTs9p7WM/6KHltsMo="
}, {
    "num_cand": "U2FsdGVkX1+Sqr3a/HX9TbqMHDdEb96V41o4mXg/TFs=",
    "cpf": "U2FsdGVkX1+iD5N4H4Ylx7cRFP6+fVf2vVpxw6jqc9I="
}, {
    "num_cand": "U2FsdGVkX1+XtBNvy+koSDS42hg4tBqITuKA3ZKEfUs=",
    "cpf": "U2FsdGVkX197UHw2IWUMxSnFHEyXYd0vJrrDdYeQf+Q="
}, {
    "num_cand": "U2FsdGVkX1+ejkVNGFkgUVc9xZmf4eDsNV9rOvsARto=",
    "cpf": "U2FsdGVkX19Dnc8PcEaKH6GQeo5+i70zRkgHLf7TxWc="
}, {
    "num_cand": "U2FsdGVkX1+g9fHsS1IqhG398uqsSYfZ2Dj8vb5wXn4=",
    "cpf": "U2FsdGVkX19k2lTp3zIBcMmZuK0fe8gzLKw3v6G8+MM="
}, {
    "num_cand": "U2FsdGVkX1/MOIhAMe95nUrZ6Y+eZJ52pTmDqwIWfvc=",
    "cpf": "U2FsdGVkX19ldM4KKuZ99hP2u2RuhwTcrz1KYvXY3Pw="
}, {
    "num_cand": "U2FsdGVkX1+U2nMMvmhhqfItlGCi6HiiOZ6Ba364NsM=",
    "cpf": "U2FsdGVkX18lK674YJ7JD0qrqyclZp15D/xVKLc3Gis="
}, {
    "num_cand": "U2FsdGVkX18tnH840U5VAklVHmviNFB7/3Ph0IIugfA=",
    "cpf": "U2FsdGVkX19qsQc3Z5z/bsEi09gVJtpRmsNwOh58yuc="
}, {
    "num_cand": "U2FsdGVkX1+McTyoboIxuQJCuroBRQNSVQvsCsJKgv4=",
    "cpf": "U2FsdGVkX19etaxEOqduNLMq2FgMSCIuhYgIjJ1PDzs="
}, {
    "num_cand": "U2FsdGVkX1+YynX8ynRTG0IkqJaijRHEmgH0Zsf6/Ps=",
    "cpf": "U2FsdGVkX186K5Vs+DIqUhhFCJHPK3Naho6+xS8/wIk="
}, {
    "num_cand": "U2FsdGVkX19/6PRCJrlB2N7kJO4WV//dvUndtYSNEVo=",
    "cpf": "U2FsdGVkX19/9/9c0bg5ZT7u9qhYC5B+C+o9zb72xrs="
}, {
    "num_cand": "U2FsdGVkX1+dhpTOEHcSmPoKnuhu1BOJWE0OugBaoXA=",
    "cpf": "U2FsdGVkX186TgTNmm6IsCvcPOCvdrpC4lW19ErchRU="
}, {
    "num_cand": "U2FsdGVkX197e4pHMwllQKCC561A7RfDq+4XJZ6Dz8E=",
    "cpf": "U2FsdGVkX18u8+VI4Un2skzvVTwuIA/i3cGHhUpiR3Y="
}, {
    "num_cand": "U2FsdGVkX18femCv1cMOc3S0PZ1Eil+xqzxDMqb94Ys=",
    "cpf": "U2FsdGVkX1/EEniWHYwQUuTqCXis+bFigQGqfGr0vKs="
}, {
    "num_cand": "U2FsdGVkX1+oLyHU+oYz1V1ZPz+fmBWGOal7F1BPRIg=",
    "cpf": "U2FsdGVkX19b67/N9JKi51WXXlS4fbtDfGBMrqMzk3E="
}, {
    "num_cand": "U2FsdGVkX1/pzXm0DS0qF+Vx90uWa0V0xVkAnddtEME=",
    "cpf": "U2FsdGVkX18G+pXz9RxDUFxzYMpQsev+eS/n/wjg0W0="
}, {
    "num_cand": "U2FsdGVkX1/alqwFpeuuQKMS/IlwXIY9vUlhX0lVbZ4=",
    "cpf": "U2FsdGVkX18a53omOAQvBYNsZNnkzR+AYjF7NLCopvI="
}, {
    "num_cand": "U2FsdGVkX1/Q6LGydnTINHi3kTe/eX8QS/ZVh/0Lrhw=",
    "cpf": "U2FsdGVkX19rKeTTVZr/aoqS61ZEM86Cr+zEZdvywPA="
}, {
    "num_cand": "U2FsdGVkX18bP0b5Ex4T2/ms3HDjQl91CV2TcZP9uVk=",
    "cpf": "U2FsdGVkX1+ay1C7S6qmVo2JhVUkEGCHq23Zsl2m3Dg="
}, {
    "num_cand": "U2FsdGVkX1+6QF7nPg6uIV/UuHH3TJYa576HkW7DOqc=",
    "cpf": "U2FsdGVkX1//RJ+5RoQdFgGPL/UNZBIE3Ymt/AGmSCs="
}, {
    "num_cand": "U2FsdGVkX18Lc2ZHRZYdOcGKhM8lo/JmOE2WzB+PZQQ=",
    "cpf": "U2FsdGVkX1+JJJ2DPCu61yA97iR8xf/TP6dZEBqgwA4="
}, {
    "num_cand": "U2FsdGVkX18+jbWvhgpS4YtuZ1eQobrYoy489n8v59o=",
    "cpf": "U2FsdGVkX19m4h5w0ozTp77m5p1It7sIpoOvrH8inb8="
}, {
    "num_cand": "U2FsdGVkX18GBhS1xrfbHlL2rW22RKlP7zglpYyCQPs=",
    "cpf": "U2FsdGVkX18AZgC2RRcFkQ2Cr9SqSFqo3ojWCpaxnQA="
}, {
    "num_cand": "U2FsdGVkX1+XTdw4mBgjTj3aFsYq7QTpVXdliIJHvXc=",
    "cpf": "U2FsdGVkX1/chfJZ/KLtoOSspkIOVrNY68ca0QwH1g4="
}, {
    "num_cand": "U2FsdGVkX1+hC+tvoh/X4M9HCwifhgKh3TUE1TfFeWM=",
    "cpf": "U2FsdGVkX19iXKbeZ5iUlPwK0Pgug48YZUjL2+FOaO4="
}, {
    "num_cand": "U2FsdGVkX18vCJmjd4DhTs+XHrCCV9rVeMoyRl+V+tg=",
    "cpf": "U2FsdGVkX1+RG5dlc8fkE9TJKgoSEmsxIRnrWoGhoF8="
}, {
    "num_cand": "U2FsdGVkX19vVLbnTnMS0c4lusA7EfQGTLpX9dvwFLE=",
    "cpf": "U2FsdGVkX18S/op5OZawt02s9xf2iY2NW1NFDpFoirs="
}, {
    "num_cand": "U2FsdGVkX19RQEVa3Byz7VJOk/UsgmTPinvsFTVhACM=",
    "cpf": "U2FsdGVkX180aU9wQPBcFubqp48L3xqU9MT8VpAILzw="
}, {
    "num_cand": "U2FsdGVkX19i5Sjv9STxt1QXVquRjDJYDO018toW57s=",
    "cpf": "U2FsdGVkX1+tSAVpBBfpp+r04HXWizuKea1Hrzo2BLk="
}, {
    "num_cand": "U2FsdGVkX1+GtscvFacHo9BVXnXqnn4niqTiHmbIxpQ=",
    "cpf": "U2FsdGVkX1/emIQqv1Cex1Sp6eDdbH44EX4UcWg5c/0="
}, {
    "num_cand": "U2FsdGVkX19tvSZQvCOd6sIko2Lo4V944N8bGa67ONo=",
    "cpf": "U2FsdGVkX18Qg4sJ1TSWSeyRwXeDMDIvfZqrj+Ik6Bg="
}, {
    "num_cand": "U2FsdGVkX18t2cYWfa2eKb0ksyGQXmhTGoaRl/hWcTQ=",
    "cpf": "U2FsdGVkX18cq2lCf28PwMpY2OZpPwuB7MbdDpciS74="
}, {
    "num_cand": "U2FsdGVkX18eJl1hjHmU+zWNKpUnw0/hWKjYwYti8VQ=",
    "cpf": "U2FsdGVkX1+c0ujDzIKVfcegvLsKcJzv89SjtL+AIgY="
}, {
    "num_cand": "U2FsdGVkX18gUIX0u9TqR5ktzbz0Cy6TfiiPHtlj+Zk=",
    "cpf": "U2FsdGVkX190crCJkg67BUhFNLdITQL6urRMrpBm2VY="
}, {
    "num_cand": "U2FsdGVkX18OVe7v/QgRO2GWzP8G9AJrh7UITYScc/w=",
    "cpf": "U2FsdGVkX1/lxttqT1GBxUWSmFFlGyW4utTgMJ14iJE="
}, {
    "num_cand": "U2FsdGVkX1+V5dcsrM4QglchiLPg6Rmv1eCE6NIEb50=",
    "cpf": "U2FsdGVkX1992npWDKhiHTQLUZRMvBwPJ2vSumy1Z1o="
}, {
    "num_cand": "U2FsdGVkX18wpdFSXulaNM+N4r0mlelclLCQSRSs044=",
    "cpf": "U2FsdGVkX19CsuEgazMpfxH41Az9IX8bWxAx/0Dp79U="
}, {
    "num_cand": "U2FsdGVkX1+9aCYw3AUCfLQoeFZobXg27FPTRAZqieU=",
    "cpf": "U2FsdGVkX1+eNX6iVXIJ3jtc90hRf43BZwzcEgM2yiA="
}, {
    "num_cand": "U2FsdGVkX1+ZKhdnAHfDjKO5eaKxVWgvakFFQYAsYrY=",
    "cpf": "U2FsdGVkX19PWFI/oQoLT2T+DzyZjjxEr9qEYwSqqA0="
}, {
    "num_cand": "U2FsdGVkX1/wZMNkkZVTxsU3VpWgIBd7GckB8c1MBoc=",
    "cpf": "U2FsdGVkX1/9zftcRrRP7bTDugHaHy1NdiLhJL2nIcM="
}, {
    "num_cand": "U2FsdGVkX18ArPTk2BgsvjLrSWfTD88VHZdvT9FRnfI=",
    "cpf": "U2FsdGVkX19KBehLHhF+GBdV6ednWyil2Nl9szfXC+g="
}, {
    "num_cand": "U2FsdGVkX19UvjKvpKCQ/XfDbgGwcMiE1DA6LSStULE=",
    "cpf": "U2FsdGVkX19xc0JbBWNwWtIpNIpK4HMphSZg620SVUw="
}, {
    "num_cand": "U2FsdGVkX1+NIgo6805EAfAP9umBvn4C640oqhggov0=",
    "cpf": "U2FsdGVkX18MzrzDWiX6PkqWrfdpVaKkgyEoGQMdD0c="
}, {
    "num_cand": "U2FsdGVkX1+/acz9uIee4Dc6eWUvt3w8EAK9MgGDpZ8=",
    "cpf": "U2FsdGVkX1//n4CyDXeDhvhvKOpd41GGY/vJMnLmNSE="
}, {
    "num_cand": "U2FsdGVkX1914oXEIMdDrRRbn9bEUd5PZ3pzPBmxuoc=",
    "cpf": "U2FsdGVkX1/kfjln2flTHCUO61M+XMVcU5PTtlKAz3Y="
}, {
    "num_cand": "U2FsdGVkX1+XijkyqE3pOWDooDqswIDq/vTWefL81Zc=",
    "cpf": "U2FsdGVkX1+/H2s+ouhZojGkpnZUjUdm1AIC0YmFBCU="
}, {
    "num_cand": "U2FsdGVkX19K1PVhffUQYfxxOvXdkxxOp2cAp3RTb78=",
    "cpf": "U2FsdGVkX1+ZwuXB8D7A7Kgierf0XM3DU1CNVGBHQm0="
}, {
    "num_cand": "U2FsdGVkX19HN1JvCFESiK1RSljFig4J3GqpNFqd1Wc=",
    "cpf": "U2FsdGVkX1+75fO+f5e6KaY80U5JqoLfJUdV0Xod2sk="
}, {
    "num_cand": "U2FsdGVkX18ERP8RkMtGJFhWxBHdAGyPvp8t0YsTE4o=",
    "cpf": "U2FsdGVkX18Kgv2drW5PsSKcuTuMPVbdSr0mr8KUG90="
}, {
    "num_cand": "U2FsdGVkX1+ecyp5N9kI+RP9cYHQkmY81I3ySD5/dVQ=",
    "cpf": "U2FsdGVkX1/fNRv6v4K7sNr7aUf+41d59BH3MzL8XKw="
}, {
    "num_cand": "U2FsdGVkX1+VJ0Pmiq99ICZWc3DAAk51TEq716LIRQc=",
    "cpf": "U2FsdGVkX18+MGfFdmc0PBGzGfj5VJKcSzQvSmUtiE8="
}, {
    "num_cand": "U2FsdGVkX18J6zOHTsNAEe/n5lmYaFgWKJ3Rm8lEYPE=",
    "cpf": "U2FsdGVkX19wCCRqy7gwuHPWr8yMN8/go4cEPqw9Whg="
}, {
    "num_cand": "U2FsdGVkX19Pjy7LJBKj8InzNxcTQYzSd6cP8D85eko=",
    "cpf": "U2FsdGVkX182Hkn4KRq52Pjij4KyNtkbmmJbF36sOis="
}, {
    "num_cand": "U2FsdGVkX19Bhrg3X33KVms++cBAD72EI9siL2ZPn1E=",
    "cpf": "U2FsdGVkX19v+2MkkMIt6TF2wMRfQdRyeBEzAvAA92g="
}, {
    "num_cand": "U2FsdGVkX1+rudg6/igFECCokOvh6OwhuA2zXsSNb78=",
    "cpf": "U2FsdGVkX1/i9oab1lJD8aacBqBHgUeG14EIzMNl0sY="
}, {
    "num_cand": "U2FsdGVkX18mnbe1qaFLVjAnqSL62vkxSoMuIFhvUZE=",
    "cpf": "U2FsdGVkX1/37muN6ORYEEyHiHZe/mPPYQzybdCGEKs="
},{
    "num_cand": "U2FsdGVkX1+kspSPwLb/tDQkHefuTRp6N4na2ReRHII=",
    "cpf": "U2FsdGVkX1/hw5IHGapD2fr5vcAJbz8xrHMYWUGb74Q="
}, {
    "num_cand": "U2FsdGVkX19CUhCm1RuplvdkXJZaDJFQD4wPcz8LMsc=",
    "cpf": "U2FsdGVkX19eSfod6hVlQ5oPWC3DuNYW1RmJnR3K90E="
}, {
    "num_cand": "U2FsdGVkX19kPodJeFpGw8bpM/UGpllTBAqlyh7cG/4=",
    "cpf": "U2FsdGVkX1+kpn3cdgqlOniUETtk7ZeeL1hmcWPZKE4="
}, {
    "num_cand": "U2FsdGVkX18ViWdCG3zaZXgg2DGKkhPD+W3CK1Oo3bY=",
    "cpf": "U2FsdGVkX1+Yi9jCXBpW7NoQ/yWp+9nGz4CWgRV3oXI="
}, {
    "num_cand": "U2FsdGVkX19oUeFf+hZMjuvGytrFnv41zM3akSopqB0=",
    "cpf": "U2FsdGVkX18QXar/v97JGXIAGolzdOgM/XjDc/SqhVo="
}, {
    "num_cand": "U2FsdGVkX19q8vE4uabdGfSJNnqw5zTbTQ8Wz/+qWTM=",
    "cpf": "U2FsdGVkX1/+G/p88DOC6ZK78yKAiJg1uojjF7Hun78="
}, {
    "num_cand": "U2FsdGVkX1+tOXbCR+PoSVGrzrVWmU5VDvocQ/Cse10=",
    "cpf": "U2FsdGVkX1/2d1xSHXPQqa2fBhDbY4xzxEk5z9LRLOk="
}, {
    "num_cand": "U2FsdGVkX1+UYHmADHmAecCTSARPEr8XphaFlDtaIu0=",
    "cpf": "U2FsdGVkX1/Egbtgqyf5shKnfdAIw57pTJbHT2BtS+Q="
}, {
    "num_cand": "U2FsdGVkX18AuFLe5kVXYFrIOHWD3Ua4nKxjhg/IeJ0=",
    "cpf": "U2FsdGVkX1+cnuFxWwclcP1iYMd006l7NBsp8dj1Zc0="
}, {
    "num_cand": "U2FsdGVkX1+Ryo6zfrDjawdspf7hbPysnN6r7SsZHCI=",
    "cpf": "U2FsdGVkX18dyBDqzKSdBEGhYyEdPyk8dhm0FEW7Hxs="
}, {
    "num_cand": "U2FsdGVkX1/L+DsYNWbfFbc1y91pjaKWd7kUPDVxNCs=",
    "cpf": "U2FsdGVkX19AAkVJqaA50CWWj6nL1X6Sg6j/p58iDtY="
}, {
    "num_cand": "U2FsdGVkX1/ApNNAmdhA6Xr7tPLMOPXgGL02HO0hXHc=",
    "cpf": "U2FsdGVkX18Xpqy4vL8hjKNMqsEl4Q03z5pI7CbE3KY="
}, {
    "num_cand": "U2FsdGVkX19VNogI6sEgm/SJqEcQ5fcMKyx5HL/B4EA=",
    "cpf": "U2FsdGVkX1/BjmPbEnPrne/j4c8V2nxvZ/BWJqz+KSU="
}, {
    "num_cand": "U2FsdGVkX19qPK6oHtu1rTS2c9lYU88bs8B+to+DkM4=",
    "cpf": "U2FsdGVkX1/ptDOgsDB3+uekJGKcwBeTl59+7SRdVRU="
}, {
    "num_cand": "U2FsdGVkX1+YQ+Yn0fkRG6glKRceNJETDCqBR2eKSPc=",
    "cpf": "U2FsdGVkX190Do31dI8kzBJoS06L2RrVCgGL3sxpXag="
}, {
    "num_cand": "U2FsdGVkX18quWvmQ+TJZibvubReJdA79/jA4w2T5bs=",
    "cpf": "U2FsdGVkX1+iebVGoICD+U3oEH4MZtCt8toHn8Zh90M="
}, {
    "num_cand": "U2FsdGVkX1+Zvq/HbXD1kFb2+e+xlM3JjhyHeH59bGI=",
    "cpf": "U2FsdGVkX19gYDgxXI/nX2wQnzDcPVJaEQOrdMn/cbk="
}, {
    "num_cand": "U2FsdGVkX1+1xU7fVuiuJhEDNWiyMf5QCjNhThEh3/c=",
    "cpf": "U2FsdGVkX19njbVZm9aKiALMMn5V1LLIvHRvxEhmwzo="
}, {
    "num_cand": "U2FsdGVkX18EmJtnSQtPqPqMdrGD3G2stQpUu3rmYyc=",
    "cpf": "U2FsdGVkX18bZZn6Kf54HPHZzwMrxwLJ6Qkzo+gi8QY="
}, {
    "num_cand": "U2FsdGVkX1+gzGauV8Yyj1W48/3OMHucEl0b6ll3RSo=",
    "cpf": "U2FsdGVkX18Off33MDn43sq0lPXNIcExSkgzdtFiB4w="
}, {
    "num_cand": "U2FsdGVkX1/FzlCI484IZqq+5zBWRr0Y9vsBhKb4CrQ=",
    "cpf": "U2FsdGVkX18TaeK1gKCVwYyCmaF/ZnOJ/sCUnGQkuIQ="
}, {
    "num_cand": "U2FsdGVkX1/OS2vONoSdi6gBFU37Ci7Sj7toasuS7Dg=",
    "cpf": "U2FsdGVkX18Begu3cEosFsw0osEx00zYagk622xogJM="
}, {
    "num_cand": "U2FsdGVkX18RPNASv6Hq2F4rmthkohfF3LXdk4hUtBU=",
    "cpf": "U2FsdGVkX19Bnc8iU6264d6nZPowsP0s4vvdBF/pymI="
}, {
    "num_cand": "U2FsdGVkX1/Aa2zYGN3k6RLBj+3z41aYBn54l/9c/O4=",
    "cpf": "U2FsdGVkX1+VHMSmOMcvAWpZCJP3Mdwo1tznx045G64="
}, {
    "num_cand": "U2FsdGVkX1+0mvcCmBsaRg2wTyFE1qEe44kMPajjjw8=",
    "cpf": "U2FsdGVkX1/h2ccux280T77VlVYl8fPb3Ya78yDFc9U="
}, {
    "num_cand": "U2FsdGVkX1/nG/ruyLZH8P3lX4X9glAbPcAD04mueUk=",
    "cpf": "U2FsdGVkX1/MLFTCrYvPAz+2T/UOP7wFuaJE89PSu8g="
}, {
    "num_cand": "U2FsdGVkX19aSb3PCWoc61APESv3Aczvh2EWPZpLI4A=",
    "cpf": "U2FsdGVkX19FfCZeE1hVUhOvbn6xV5RPf9XhzzlCDhQ="
}, {
    "num_cand": "U2FsdGVkX1+nRtATRckx3ecP7I9Hh5L+f3NEwsoID40=",
    "cpf": "U2FsdGVkX1+z0k8brZJX4nobK09nSWkcf4cSoTT70lA="
}, {
    "num_cand": "U2FsdGVkX1+3jhpdnwDm5vIyfRom8WMEnkrJkFdhm6Y=",
    "cpf": "U2FsdGVkX1+5egjlm07KgRUnLC3P7sn6aDyoOawI/Lg="
}, {
    "num_cand": "U2FsdGVkX1/PQ/ffvE7YfGwSZ1ikhAT6/qka0zB7uiM=",
    "cpf": "U2FsdGVkX18ogxwTVnbdcbcbQoMeg3yoqt66rwaLhDQ="
}, {
    "num_cand": "U2FsdGVkX18fzy2R/Afr5E1Rt8ZKbubyyEoRgkX41Q8=",
    "cpf": "U2FsdGVkX19+xm9puX36YoyFuSZN+bzp/lVAHVw+t1w="
}, {
    "num_cand": "U2FsdGVkX1+sX8rcgDGL1sJTKnWGkEPl9JhpD2KXSxQ=",
    "cpf": "U2FsdGVkX19AN+GsHNKBqfqlLh5tZ1nzHpE/dHslFrE="
}, {
    "num_cand": "U2FsdGVkX1/Q4upKEKQPe5lcxXcfXx5jJV1HBA81PQ8=",
    "cpf": "U2FsdGVkX1+HRXr8iDFs29CaWxjRh1xBmW9YHMi2QIQ="
}, {
    "num_cand": "U2FsdGVkX18mUQn/GPEU2pH/q5fs4MR1aFviTONaXGE=",
    "cpf": "U2FsdGVkX1+ah3OUh+RxFZImiChN8Ufo6ZNd4wuv8uo="
}, {
    "num_cand": "U2FsdGVkX181CZM1cFMruSLQDnPTcQPyW3vWZgYpwAw=",
    "cpf": "U2FsdGVkX19OSUfMYpSFXfNVqiULtTNOrhW//NqA5Lg="
}, {
    "num_cand": "U2FsdGVkX1/F0P6qszCBSyuDOk09kE9xuXDYmsc1r3g=",
    "cpf": "U2FsdGVkX1/rEnzFRj2u7HVshfQevFn8jGFaq/S2qM8="
}, {
    "num_cand": "U2FsdGVkX18LUtQWuIeiyamRuT5cWioXepJTA7jwAPg=",
    "cpf": "U2FsdGVkX18+K2xtc7f97axyD15ZJjudukuBVHQuDZA="
}, {
    "num_cand": "U2FsdGVkX19CIMvt7+UOppyYNu/9U+7xQVFljhXbFiA=",
    "cpf": "U2FsdGVkX1/Xf5gPSLSa+tgY09Gn8Xpal2WNqDbODQY="
}, {
    "num_cand": "U2FsdGVkX1/Sy9GguT8E1YJy0B++KohnC7HoMWjeKd0=",
    "cpf": "U2FsdGVkX19eborT41QrxUszvfoJR4PHp1fKMHT8GMo="
}, {
    "num_cand": "U2FsdGVkX1+5dKttAvzAHf83ECcG+C3uLqPtUnFCld4=",
    "cpf": "U2FsdGVkX1/mmdVdkQfH4lAPnklMDg/b7kvG6/fTx8o="
}, {
    "num_cand": "U2FsdGVkX1/y2YTO3lRZD42hhWqKHijKSfmSxbr+GOU=",
    "cpf": "U2FsdGVkX1+tOQl4OrKQlAIAdpwuoemCgDCYc08yYhI="
}, {
    "num_cand": "U2FsdGVkX19P4PcxcOolWUuSG2nxmOw3CFs0g6sEwcw=",
    "cpf": "U2FsdGVkX195Er09FMu1DOvcvnt+NcckAOPd3LpsSAA="
}, {
    "num_cand": "U2FsdGVkX18jNHpp3KgkitG59YTEhtCmCE2tchG11kQ=",
    "cpf": "U2FsdGVkX1/rmmRowaBTlyWXH4oBDQXmV4nxrH+QUfI="
}, {
    "num_cand": "U2FsdGVkX1+hf+PVeo+kq+ff0wZeTCv5i7YndF4chJk=",
    "cpf": "U2FsdGVkX1/tC164/TaTaT4TyhJDAZStbNiJMKXho50="
}, {
    "num_cand": "U2FsdGVkX1/YTRuOvdqywmEB7ODmj9co3fugcWFyhCE=",
    "cpf": "U2FsdGVkX18eGWG/1SlsJzjWZYGmgZFrIVIJ3i2VEYs="
}, {
    "num_cand": "U2FsdGVkX1+ZQ01Io7omlvrd/sILHSTIRnNLrEJw4mg=",
    "cpf": "U2FsdGVkX1/Q63IyXfY85ZAL2molhH8MsRLWxOX2+zE="
}, {
    "num_cand": "U2FsdGVkX18JUzZhu7G6HIkKOmROC1EUllf0kjNUAz8=",
    "cpf": "U2FsdGVkX1+Wf1fTh15NrCGzImX2XX7gvHagP+Ny1DE="
}, {
    "num_cand": "U2FsdGVkX19ASokt2dDW/jvIJJ6HSvriUxIBuZuCTg4=",
    "cpf": "U2FsdGVkX18T2Go52GLt8AeLCeDqpLgDR/+WLdKewb8="
}, {
    "num_cand": "U2FsdGVkX1/n9vMLg6RK2BJzUvoFc8rv6NHNKeko3+8=",
    "cpf": "U2FsdGVkX1+ZbkZuHVYnzMIdXBYzl+sjBNbHR6PplLE="
}, {
    "num_cand": "U2FsdGVkX1/Keu5HlF3O3sJ6vrAdiEKsNpx/kG+Ra7c=",
    "cpf": "U2FsdGVkX185FrLFoqxQUs/AN4P0rsC6i9qVZ1OkyvQ="
}, {
    "num_cand": "U2FsdGVkX1/xh4Z6ZyinA0gwE0eecKpuJePUH5samMI=",
    "cpf": "U2FsdGVkX18sPRFRINY8hnGfKqZvqb2YStn2M0f1xRg="
}, {
    "num_cand": "U2FsdGVkX1/lPlXkvacW4I2EWIzEitImFR4G8vXLRNY=",
    "cpf": "U2FsdGVkX191pnOEYQ3saTrE8+UILzP/4Jjgw9RQ1TM="
}, {
    "num_cand": "U2FsdGVkX1/AnHKW0yig7rbwn0WIrc3neXCc0NQgoGM=",
    "cpf": "U2FsdGVkX195vvx5BYrt0XBBLmqfHnZCBmYPsadIn5I="
}, {
    "num_cand": "U2FsdGVkX18IZkZ+P/Jxj4Unl4p2tKh8uUiABjWS6cA=",
    "cpf": "U2FsdGVkX18jwAVfNceIc7gwawlXgxIPfS23a0yJVVI="
}, {
    "num_cand": "U2FsdGVkX1/vmxDMXQy3EAQsthlP/G0Qy2CKMmOQ0zQ=",
    "cpf": "U2FsdGVkX1/mqJna/m9niwqacehpP8FKSyKV3q0aewA="
}, {
    "num_cand": "U2FsdGVkX19NmMBgP9K93EnGANHBAPeQEls6/0apvl0=",
    "cpf": "U2FsdGVkX19v31MUrMBENry+Nq+ylr8QorrGJbdg1j0="
}, {
    "num_cand": "U2FsdGVkX1+8ioj4tx1VFDglYtd36xoH7zse6a+CJBE=",
    "cpf": "U2FsdGVkX1+Vxx0ZAxgb8JUrpZNSgVX2IDS0mqVjpHg="
}, {
    "num_cand": "U2FsdGVkX19EPB5076QGSJXiRZZcy651H/ywxRIzJMU=",
    "cpf": "U2FsdGVkX1/YtsVA7pJ00V+gKoVMTdr1My3pb1XzXeQ="
}, {
    "num_cand": "U2FsdGVkX19SrAi/Rq+NIbicMNPYCkuJ8rtyZR13gaM=",
    "cpf": "U2FsdGVkX1/n9VeADhYdseiAMHVf1Ho5sD369GW+RWs="
}, {
    "num_cand": "U2FsdGVkX1+KaAiVr/fCJXbjWnKVCpZ5O+ApHIiYgJY=",
    "cpf": "U2FsdGVkX18XgwLYbKvBDUiiA7HoFpVkb3PIQ5lykWk="
}, {
    "num_cand": "U2FsdGVkX18zUAOZwOFyYCSqM3pWiRLOJtMDXPXS65A=",
    "cpf": "U2FsdGVkX1/8zddyYqpPXmgEFGMMBJObUTT+DdjVk/c="
}, {
    "num_cand": "U2FsdGVkX18O4ZDY6Dmw9rUc/ldUY3Gw3X6tjJKR1iE=",
    "cpf": "U2FsdGVkX18XapWc2zf80L1ct43UemJHqoTInihvnP0="
}, {
    "num_cand": "U2FsdGVkX18DugrxyY9vke7w8KoVEZrPSovVvXzRJ1s=",
    "cpf": "U2FsdGVkX1+GRZugtilmL8MD/mbGjo7xaXJCGlixX1k="
}, {
    "num_cand": "U2FsdGVkX18X3feECJmKU68NiRHuFTIF07vXXsdTWE4=",
    "cpf": "U2FsdGVkX1/czJIK0Du68ZGJRAunCkk2HjHn7Q31RPk="
}, {
    "num_cand": "U2FsdGVkX19QOqyAYPI0GQ12rZF1f7ene23TY/o9nQ0=",
    "cpf": "U2FsdGVkX185+o5JP3O0CF6PsjdNWGp658UYXVSbccc="
}, {
    "num_cand": "U2FsdGVkX1+/1U9oVyZxZNogUW6ChWRsGvPingPjNBs=",
    "cpf": "U2FsdGVkX1/r0BylOwnpI70AoKNCukCfuUzwRp7f1SM="
}, {
    "num_cand": "U2FsdGVkX1+WOemkFBQFSTO6A8ujFJQF53byMJC+sxw=",
    "cpf": "U2FsdGVkX1+VW8wthRhqo5qEOd2OGiG/rQowy83inwE="
}, {
    "num_cand": "U2FsdGVkX1/XCxh7eyd7wO5z2/EVZA/HdjlejpUnNr0=",
    "cpf": "U2FsdGVkX1/6igWvP1Kqr2+tREB09VH75Y463+jb4Do="
}, {
    "num_cand": "U2FsdGVkX1/3oIF2uiHIFTaZiFXGeM39A6mriPg44r8=",
    "cpf": "U2FsdGVkX1/5FQH0SXQtmB7fO/jfXvf6vABNBZZm1g0="
}, {
    "num_cand": "U2FsdGVkX1/rHiC8gT9stBaG8tfCWHG1w/ZKK6WTqVY=",
    "cpf": "U2FsdGVkX18fLfJLHhief+QTOQX0Jr8bdwXja5cr+4Q="
}, {
    "num_cand": "U2FsdGVkX19zdQI5uaDh0jFShomfIFNFOj+UFoKoqeE=",
    "cpf": "U2FsdGVkX18Hpip0mdQcwTvbuAiX0KiSQFxhsmBc9iI="
}, {
    "num_cand": "U2FsdGVkX1+8xRYhTN77LAwOta+r1i1kpxMfaTIUcWw=",
    "cpf": "U2FsdGVkX1+SxDPivP1NYj9BV1wp6Jkd+yN7ixhytR4="
}, {
    "num_cand": "U2FsdGVkX1+Df0BsVAeS+UN9Em5P9Z1RfOReO4VOfGw=",
    "cpf": "U2FsdGVkX18FQtf/R1OrqOTqy9Us0/leJHUQNp7Opgc="
}, {
    "num_cand": "U2FsdGVkX1/XL1qK2gEhMaagu2nD18VH20n0QIMunpM=",
    "cpf": "U2FsdGVkX1+rWgIZnqgbndloSfq/dMuMNyPxtEbC4io="
}, {
    "num_cand": "U2FsdGVkX18ocq8Ppx2MezxYNGqQw5P5xFlW1m/51uI=",
    "cpf": "U2FsdGVkX18fJpbZy4iPtTEVG1hEhzXwlTjMtMnluxo="
}, {
    "num_cand": "U2FsdGVkX19tdLQ/1F2/aec8gYPDpeuBvpcbvbeCZY8=",
    "cpf": "U2FsdGVkX199G2Uxqh6vd1QOOL7YdbrNKnkZ5B3xMNA="
}, {
    "num_cand": "U2FsdGVkX19isYbItMU9YmS9fgg2jbzttQ8SwvlMkrU=",
    "cpf": "U2FsdGVkX1/jXjgt8DbX0EwdKyM0X4xxEsv15IdlaqA="
}, {
    "num_cand": "U2FsdGVkX19Xm5ZThrGzEeSFINjBORu/0tvDYtQr4y8=",
    "cpf": "U2FsdGVkX19XoNbR/ozl/EWlldmb/nqvx+FbIA6f//I="
}, {
    "num_cand": "U2FsdGVkX1+MA/UpAv34QlCwZRs/AA3xfK014azaC7I=",
    "cpf": "U2FsdGVkX1+FAix3nUy5cBTLIJTtPT+OXJCyg4wy4QE="
}, {
    "num_cand": "U2FsdGVkX18vf//EKLdDrHnHTMtsktUBgv9WWD1lhnA=",
    "cpf": "U2FsdGVkX18GISyT8FzxqwAYlL3dh6Ys/ZFuc178ORE="
}, {
    "num_cand": "U2FsdGVkX1/fsUcDknnKz9z3kaQcQTrtaG6ego55U/0=",
    "cpf": "U2FsdGVkX18XCBw1cqjsPUPGDFkqdEAUC4lvR0/G8Cw="
}, {
    "num_cand": "U2FsdGVkX1+aPUZT0ThvSoWDMLxY4eK9/cvnpovcz6g=",
    "cpf": "U2FsdGVkX19hD0zi6FSKXQXRxTRvTYxGov3kif7XkYg="
}, {
    "num_cand": "U2FsdGVkX19IfgQSafu/XUtAPrRwGIUuV7g1c9EbrME=",
    "cpf": "U2FsdGVkX1+3eTfdPy6S91GROu8gYIvt/Aj+u4BaS/E="
}, {
    "num_cand": "U2FsdGVkX1+mSSbEpmy58bBw4FN30NzrRLx3J+6LeVw=",
    "cpf": "U2FsdGVkX18O4cmpQOnGDXhD/ybrRpBl1EjP2a8+r3E="
}, {
    "num_cand": "U2FsdGVkX19xcqBEeHavIMntyz2IahevwT804jbsm9k=",
    "cpf": "U2FsdGVkX1/7mBWsMukZciYNtfybEOTmYrROGKy2t6c="
}, {
    "num_cand": "U2FsdGVkX1+u6CDDbkL/ypplcKPMkTIzducBIHVCw0M=",
    "cpf": "U2FsdGVkX1+d8wKZn32LXG/Qa5aWZmY+twKaQvgPCTo="
}, {
    "num_cand": "U2FsdGVkX1+rpT7TOzcdgXGbSnbtfoeGgnorRwFqQuM=",
    "cpf": "U2FsdGVkX19Ezvk/zqd6iU5WQQCHrbj7XiJFbWh0Zew="
}, {
    "num_cand": "U2FsdGVkX18Bp3rrZq4MndQy9fGQnO2GLB0H3EWfIWI=",
    "cpf": "U2FsdGVkX1+sMyajPXsp7UlLgdrPejo+kF82/HjMB6s="
}, {
    "num_cand": "U2FsdGVkX1+jaihfnO4RK9jvK8nsvIkJhiZwrx4Qq4A=",
    "cpf": "U2FsdGVkX1/62x3+neg402L+uOC/7L1o7eO4aY0gASg="
}, {
    "num_cand": "U2FsdGVkX1+sGS4m+B2GKt1swEc7NB5E+RUVk8rh46k=",
    "cpf": "U2FsdGVkX1/TLykOG5B9BNlEvrrNejynRrD1RNAjjBc="
}, {
    "num_cand": "U2FsdGVkX18qwxOqlMUqYH/lcXnbNb8zeUY2UDFxRD8=",
    "cpf": "U2FsdGVkX1+ZqoH8sICR2o7ISVP1HXuxM89N6p6ae2Y="
}, {
    "num_cand": "U2FsdGVkX18qn7YIqOvFh/4kAfCgauMl7DX9Y4sfllc=",
    "cpf": "U2FsdGVkX19HscYZIsNXSY1/bert7SvCeGbFyc9bPLg="
}, {
    "num_cand": "U2FsdGVkX1+NBe1f9iiTg+8Zs5GNN8bbNzyQpkX1Pi0=",
    "cpf": "U2FsdGVkX1+kSg8DMlSZgMQRSUtfCqKChEp+BVPhof0="
}, {
    "num_cand": "U2FsdGVkX18vXGFqAnvOobYjd1QIrVLG9eB5nP+Ke+Y=",
    "cpf": "U2FsdGVkX19hsZaPDRuc5GxvRRI6xXGI5bTAxEt1shc="
}, {
    "num_cand": "U2FsdGVkX19x5rYNjj51ReLwTrfQxaCSm2feyKVJAlY=",
    "cpf": "U2FsdGVkX1+eKdi8EWfme7Ms/WKsex6gLbZwrZjKBhI="
}, {
    "num_cand": "U2FsdGVkX1/LFdvPO9/AaWpBc8h0ZJhqf0ncPuoXi0w=",
    "cpf": "U2FsdGVkX18euSBLbAWCE34nZpU0+/9EHJWPPgmQcH8="
}, {
    "num_cand": "U2FsdGVkX1/ggOeDJMaeTgvl/nUMX2+SoHOV59fMdAQ=",
    "cpf": "U2FsdGVkX1/5yDIS7QnJiuTlz4jRf8Yq+JrJRQ1qsmU="
}, {
    "num_cand": "U2FsdGVkX1/TdSl0crAlN3rpJ+qgUNKfSEojASeb2MA=",
    "cpf": "U2FsdGVkX19QBDAGRFbeAXQUy0vzt1FqgB8BwE85Fs4="
}, {
    "num_cand": "U2FsdGVkX193HibLVKgiAF5uhpUl4ZEUphwpTJXpW1U=",
    "cpf": "U2FsdGVkX1+JVpYamuCJriSt+4xSgQY45ggTtU0ubxY="
}, {
    "num_cand": "U2FsdGVkX1+iTbIdo6ZaWqjKoh9JEQaDbbS2J9Go0b8=",
    "cpf": "U2FsdGVkX1+iHarfm77QQlkN7ov3rMg6vduGt8yB1Xg="
}, {
    "num_cand": "U2FsdGVkX19EF3AM4/FdMuzYB3j/MsBoxsRLI3RVjIE=",
    "cpf": "U2FsdGVkX1+v1e5BKcj54Ka5RKJ/CZUvI7H5/rsa8J8="
}, {
    "num_cand": "U2FsdGVkX18GB0m51XaASFaWMF4cMzELDSV67pb7ZCI=",
    "cpf": "U2FsdGVkX1/n9RdJz18jv4iTduT/kOBogW3/3FZ/kus="
}, {
    "num_cand": "U2FsdGVkX1/AyZ1AL7Vx3q2r+osEIEmRjyK9d4cf0jY=",
    "cpf": "U2FsdGVkX19BPKfRQ+wuzRE+bdZQ1ZuDhuX6IRaPPRM="
}, {
    "num_cand": "U2FsdGVkX1+Z0CBgkF2UdRLIAwOvqYexsu7OlPopurk=",
    "cpf": "U2FsdGVkX1/GVkDctOoDd3DmV1frgslBTggH2qutuZk="
}, {
    "num_cand": "U2FsdGVkX1+trZDDy2wy1kRByaM9NjtkUIiGKLfcHOo=",
    "cpf": "U2FsdGVkX1/zYiiVOHRnHLRGKUFqrMcNGvJTJ5NQVVI="
}, {
    "num_cand": "U2FsdGVkX1+8WfJy3rqEsP6VNxB6yTfKrQzLHOqWDpo=",
    "cpf": "U2FsdGVkX18nJ8cAbaLVhl9XuHlifB6x35w/Bcr5JZo="
}, {
    "num_cand": "U2FsdGVkX1/IKepS+fLdPS5W521Ey7j7RioRBf1XnAw=",
    "cpf": "U2FsdGVkX1//TpJzd8ZUpYaUAWHwx+wNxWjsPAAcotQ="
}, {
    "num_cand": "U2FsdGVkX19C9EhWAKSdbZHGVM2s7iONPfwPh856l4s=",
    "cpf": "U2FsdGVkX1/U76rK/FP2Bz/7EaDJtEE8/0sTxNqq+/c="
}, {
    "num_cand": "U2FsdGVkX19+mZgFxoN56Cgp+rR4J4YQ/s9d8m4hn40=",
    "cpf": "U2FsdGVkX1+4vowiUM0evxDSRM2amu50aGEhsCAL5IM="
}, {
    "num_cand": "U2FsdGVkX19ywloXIdDWtINNV1SST7NDDZ5+q0mZs9k=",
    "cpf": "U2FsdGVkX1+tBn1X/5pnH85C/AzCQ2yZXUiyYWCcATs="
}, {
    "num_cand": "U2FsdGVkX18dSO1Ge2N1qfpADhAliPqP7akPqsYfFgQ=",
    "cpf": "U2FsdGVkX18aZL91Pmd7tdmSQ/BAKci5KgEkAWri1hU="
}, {
    "num_cand": "U2FsdGVkX1+PX2TJEgrDaqCIQsBSSE1lp6aL5jVCiKk=",
    "cpf": "U2FsdGVkX1+pWyl6yUTZZT7L9OE0Dp9LquZSdcTgb/0="
}, {
    "num_cand": "U2FsdGVkX18d6qiWB3kxVMGoEtGKs4cYiLwWTlNdZz4=",
    "cpf": "U2FsdGVkX1/VP1OLDeElOhSPwIY4teU4P8kXmP22plY="
},{
    "num_cand": "U2FsdGVkX1+hqpCo1vb2XAD+71N4moIX8PWvTdRbsII=",
    "cpf": "U2FsdGVkX1+ShvWIjSeCtKBOfTnwhq4xul175lE5VfI="
}, {
    "num_cand": "U2FsdGVkX1/5SJWKuOMABYRFZToIb6HLOsw1UpwotGg=",
    "cpf": "U2FsdGVkX19qIh22qznf9+0WOCESCnsACQ7hszNbk6E="
}, {
    "num_cand": "U2FsdGVkX19XZF00jyNdzeH8ZcCSh7EDJFr7+2QSZV0=",
    "cpf": "U2FsdGVkX1+nXwu64L8TkEf0YpRJpl5yTeAv7hmzOqI="
}, {
    "num_cand": "U2FsdGVkX18kXhsfuo0XC363FHMpk6sciM06hnXH42U=",
    "cpf": "U2FsdGVkX19DPHaFOp3scFQdlKrwfsX63a4XrRS928Q="
}, {
    "num_cand": "U2FsdGVkX195WBLi7QJI1k9LE1p9lltqxPJH9t5FQy4=",
    "cpf": "U2FsdGVkX18RQCmxqQZpa5rabkVrbaDwRN5JXkpE1oY="
}, {
    "num_cand": "U2FsdGVkX18nU9sVrBL2olHjjX8RaYRvGFeOAVGYq2A=",
    "cpf": "U2FsdGVkX18rjoAIlV5t9gOtiWpIMC9sfL4/nf4bfzc="
}, {
    "num_cand": "U2FsdGVkX19cSubyFb25aHRCVlGrZ0jAuAbAUmHnPSo=",
    "cpf": "U2FsdGVkX187ejbYDlFxjN03DTffUJCZfvSbY8HeBU4="
}, {
    "num_cand": "U2FsdGVkX1+C1o0oOP2a7JENpFiGJWNOPe3TEVjlBtg=",
    "cpf": "U2FsdGVkX1/5wrdeMR+IVXSj0b7m9q0cXo+PkrTO5uI="
}, {
    "num_cand": "U2FsdGVkX189LSvj5TD3BuhYdk09WEU9NP0kamUP014=",
    "cpf": "U2FsdGVkX1/CzGAQVPaBlK4iK8sxEb7ThTGbg05l+hw="
}, {
    "num_cand": "U2FsdGVkX19P8Zu4mF46eCD1Kxr7H2TqEEJlrn2N1oE=",
    "cpf": "U2FsdGVkX1+WMOHg0LnsdSt66et7puK5scHWa/tbn4I="
}, {
    "num_cand": "U2FsdGVkX1/9qlEBloAT6FK5VoNkFfU9eW2RM2EC9sY=",
    "cpf": "U2FsdGVkX18P8YsPcLf0DPEWenJN3C/SzwCmpjgNqvQ="
}, {
    "num_cand": "U2FsdGVkX1/GiBov+hXi48PLxhoFRR5w/tJxkRzno7M=",
    "cpf": "U2FsdGVkX19Yy+ZTMz++ZtcBnZD5+FKWrcu2vMqiC5Y="
}, {
    "num_cand": "U2FsdGVkX1/1UrFG6EOrgUjd8214U2wl1xopuMuXEtE=",
    "cpf": "U2FsdGVkX19/AqTEaQ8aE1s2nMlpkzllPLHXB9gFnJQ="
}, {
    "num_cand": "U2FsdGVkX18xir4PlU+1c0SqH+36A/iJoAIGL9sIO30=",
    "cpf": "U2FsdGVkX1+s6qZsr8B5nX0taaoa5H1NukHLHqMPe6k="
}, {
    "num_cand": "U2FsdGVkX1/tLh40KYfYPt2cZxWjGNT29eDsgvjuN7E=",
    "cpf": "U2FsdGVkX1+CYNxFouC7fqTO9WKXBX88JyDdRr+XoZ0="
}, {
    "num_cand": "U2FsdGVkX19Kc9gT6+DXWfH0l9HoNBM7L+CrcoE4OTc=",
    "cpf": "U2FsdGVkX1+Zr6FhRv7PdZY37TsqIwgySHQlhgNeCy4="
}, {
    "num_cand": "U2FsdGVkX1+1hXR/QfOJZsxAEqS+UNHYvah63Km13Io=",
    "cpf": "U2FsdGVkX1+y/qmmZ/oE3bTsUGFBS2jrTLLUzWfhFTo="
}, {
    "num_cand": "U2FsdGVkX18z0AG5aT6deLjYtet6xBzRqm/CMfoJJ5E=",
    "cpf": "U2FsdGVkX19Kd6xsnMLu0e70ClZTPj8txqPff8WGKhY="
}, {
    "num_cand": "U2FsdGVkX1+VGrmzVTb/G8I1cpfgoqyl0uhBv/qk5vs=",
    "cpf": "U2FsdGVkX1+8ED71YIGjkj7bcuYBf3Qh/f5VoBRekC8="
}, {
    "num_cand": "U2FsdGVkX19H0hBdXuln/qzehZGMjsy4fVcqeagC1Ew=",
    "cpf": "U2FsdGVkX19gz1wTZYWY5m6naYIvXff0jJNzbnKs3WM="
}, {
    "num_cand": "U2FsdGVkX19n8+ypo7J/1/dQr6OjqYrsmYaGsWKCdqQ=",
    "cpf": "U2FsdGVkX19ErbtnCfMWK7/woJjAwyERCWBJ9dSjqhs="
}, {
    "num_cand": "U2FsdGVkX18AZKuSPVwiSWX1v3x8DhW54yJVBcM+qQM=",
    "cpf": "U2FsdGVkX1+r5VjstjgQ6hTfd2GYTmo+991zJWvmVmY="
}, {
    "num_cand": "U2FsdGVkX193ZClUi9faR6P3slvnKmScFcsGiewLYSM=",
    "cpf": "U2FsdGVkX1+gCbibRnHw9OkkB2psZSSYJPBW8pk4J9M="
}, {
    "num_cand": "U2FsdGVkX19VOQfEcLNOkOa42y3soWmlGY4INWJsg68=",
    "cpf": "U2FsdGVkX18Fr/EwXtneH9hGkXD3wPqxLrH+GaJi8H8="
}, {
    "num_cand": "U2FsdGVkX19Lhc+SfvsPEE+kRStHYDOlB6fNG+qt3Xo=",
    "cpf": "U2FsdGVkX1+Qhgr5pw0qFfI63GCdrgUNvElIhQXVs7M="
}, {
    "num_cand": "U2FsdGVkX1/acwiCJ1bl40c3uKC9cSzGHONo+pTNVVc=",
    "cpf": "U2FsdGVkX1+FNJf8nCBRYpSm8kWH71Pluu/0oZqnuDE="
}, {
    "num_cand": "U2FsdGVkX19yRDuXTirh/FEw6OxG6H0HV6j72DliPKs=",
    "cpf": "U2FsdGVkX1+BSJzmug2QrCIjweA52ySdH2ihLf3tEFQ="
}, {
    "num_cand": "U2FsdGVkX1/MP/4CQKwDqoIo7K7KdhLu0N56WWTuprA=",
    "cpf": "U2FsdGVkX1/1eN3eexnZObvJ2X1A0Np+stLzmZZa7lw="
}, {
    "num_cand": "U2FsdGVkX1/4c1Dkr4s09EznsLe7J3TB7rcDzdQV8cU=",
    "cpf": "U2FsdGVkX18ZVyOY0AMlrk5ZCMuA2VvEoVMGZzmzVes="
}, {
    "num_cand": "U2FsdGVkX18HrY7EFfvxal/QEdYkY3KUx/Wl6ROGFFo=",
    "cpf": "U2FsdGVkX1/Jk5iEnVBW7x826ZI7zQgMqRqcWxhd89U="
}, {
    "num_cand": "U2FsdGVkX18uzRa1AwIbA8nxPbtk4P9VZ7VFR+j8CRU=",
    "cpf": "U2FsdGVkX1/xHP6JRXN5BEwEMkSmLFu747G5y46gvbg="
}, {
    "num_cand": "U2FsdGVkX1/cWx0xkmJ7T1LyrVFgsa1IAEIJ0TGlBKY=",
    "cpf": "U2FsdGVkX1+Lgj5DWMn/bwsdM5LmrgEBA5SQStIAZhw="
}, {
    "num_cand": "U2FsdGVkX1+EeOXFKpLBDNIOji/r6ozsaIGn7qEL4Jk=",
    "cpf": "U2FsdGVkX1/GfAtTdIu5bdctgI2oE1CuLvIjSbT9uiA="
}, {
    "num_cand": "U2FsdGVkX1/tv+4Jz6IVbQcF4fc66IwUFyuNrAIHjGs=",
    "cpf": "U2FsdGVkX1+AflSBpVYtET2eDsbPcw+LyH9Ns3WtRAU="
}, {
    "num_cand": "U2FsdGVkX187ax5oDi/jyOyvP4EyKFawlIPC88lNHrI=",
    "cpf": "U2FsdGVkX1+VC0ZyzrLhtYuKeUrUhAJnQAkQpUX8DVs="
}, {
    "num_cand": "U2FsdGVkX18diWASDGjn1XTlOen6GbfIstY5VO+Teiw=",
    "cpf": "U2FsdGVkX19FDdgLxcvxugtxgUjFRmVx+5/ObPYEvfw="
}, {
    "num_cand": "U2FsdGVkX1/uuDYSSD3nk9NMPLGmRQboURKidcQGfac=",
    "cpf": "U2FsdGVkX19BTUEaGeDv/kIx50iPXgLrv8wff1Hb/Kg="
}, {
    "num_cand": "U2FsdGVkX18U7FQ5allW8Vo6DuS9peblbnutV1LvxcY=",
    "cpf": "U2FsdGVkX19feSvRAju8a4EtncCF9K1jY+YkPdLUVqY="
}, {
    "num_cand": "U2FsdGVkX18rVHiCuFWT0ZHYOJXnXojujYhCrGIMCG4=",
    "cpf": "U2FsdGVkX1+5MZR38T4crLYc3N1nqXhkEncyflPUwPU="
}, {
    "num_cand": "U2FsdGVkX1914pVzigc3KJD4PDDI+KR0kTxOoi9sldo=",
    "cpf": "U2FsdGVkX19JDuOcsE02yaas0hYruKwajOb9mwhnUYA="
}, {
    "num_cand": "U2FsdGVkX19A0fk7k6Rfe9Q5ipj6JAu/LfZDXB1ESIc=",
    "cpf": "U2FsdGVkX18t9EnTAqJ0QtyUa08dHK72aP0EIGUfNGE="
}, {
    "num_cand": "U2FsdGVkX1+k/eQRw3bEa67T4n8ugSHjsGRWBfm1Ruw=",
    "cpf": "U2FsdGVkX19rQMrZqsXm0+3AINKaYidmSB5JcD2YZF4="
}, {
    "num_cand": "U2FsdGVkX1+uAeuqBJoLADn7l4epsySU4gfBICBoZ9A=",
    "cpf": "U2FsdGVkX19KVncXHd8ZnKRBzwy3jdbg0ICsxWbd5Nw="
}, {
    "num_cand": "U2FsdGVkX182dY6E5Z76NeB1tL7eV4m8uvnxImJXqEo=",
    "cpf": "U2FsdGVkX1+jyvFU/a6EgV+AyggNn7B2T2w4YNcdja0="
}, {
    "num_cand": "U2FsdGVkX19VzhpPS51IQiDgY9FgmWCrRxZpG+b4AMA=",
    "cpf": "U2FsdGVkX1+0MrdN+goeDveF/yWfUtRnBXU8wDfoOLk="
}, {
    "num_cand": "U2FsdGVkX19wEZLA4Ps587RHQ4dKqbpgy4lZPua9Ixw=",
    "cpf": "U2FsdGVkX18EK2Gm02Ra8ZD4IPGH2bDsYybjlcfpFDQ="
}, {
    "num_cand": "U2FsdGVkX19MJARpB/OEGDebux+GGfTS0sLooPA09SQ=",
    "cpf": "U2FsdGVkX18QYYgE+T0TM8W9TUL9HUQuoZ2gVegFVBE="
}, {
    "num_cand": "U2FsdGVkX1+RxMEq1TpEtFdvEg0rWqhFwoWGgWcPsYk=",
    "cpf": "U2FsdGVkX194TELwGzuEREC+nQhcjnn9oGPxHhNq3I8="
}, {
    "num_cand": "U2FsdGVkX1+WeC8x882Knffg713NhIGtzDMz7UAcAJI=",
    "cpf": "U2FsdGVkX1+/9ZR+aFj0NfdyOHlVupazVkGGuE7ruf0="
}, {
    "num_cand": "U2FsdGVkX1/ZYHCi6WsQCzpsIphUyBTcEPOLWnYhqzo=",
    "cpf": "U2FsdGVkX18fyD8Wa5EwwhH/yTmxaYTo/iImXDk9SPU="
}, {
    "num_cand": "U2FsdGVkX19gXMXhAUq8xXwu96bs2EhsTrLEPLdZIF0=",
    "cpf": "U2FsdGVkX1998jWZBhBO3SRV6A81pnfdWl7M+49CxzM="
}, {
    "num_cand": "U2FsdGVkX19yoMs1tIdMwb4WOQ6TUIoQt1Mo5n+npww=",
    "cpf": "U2FsdGVkX18RsV3fhs4N842LjsOuLqTAB2CU5xL1Nk4="
}, {
    "num_cand": "U2FsdGVkX1+EoQy9+z2HEFEXxoWDeScgyOb1x7tZiOw=",
    "cpf": "U2FsdGVkX18hmev5FaWfJsRCxaB62AHbxIBqlznTXIM="
}, {
    "num_cand": "U2FsdGVkX18WkZz9wiPQPXZIPe7m4pzCGqh5rG7eXOU=",
    "cpf": "U2FsdGVkX18e9jZC986DnHy1nyc9V1oOrOMYJn9xeE4="
}, {
    "num_cand": "U2FsdGVkX1+RlNzK3Ih54MSRotf/maWmdhs3lwdbNyQ=",
    "cpf": "U2FsdGVkX18vSdw+9/r8ESKe6/IZ1yJH5rTzzPq0ups="
}, {
    "num_cand": "U2FsdGVkX19XTBzCA6aRc2gpr162LDcQcLu/x36NkTE=",
    "cpf": "U2FsdGVkX18ZCA0TefsQDr8kJCAnLSdBhCWLpD2oX9g="
}, {
    "num_cand": "U2FsdGVkX1/bq1IVxYNHkBp9Nn/h0xo5e7kAw7KUguo=",
    "cpf": "U2FsdGVkX1+ccpz0tYTOfZiRTAxbQPX22qpwhztT8mE="
}, {
    "num_cand": "U2FsdGVkX19E8flL3R1R3Gb/PBdRKBwvTXYiS73W29o=",
    "cpf": "U2FsdGVkX18IrYGARBnpInSS/pR34wG/f+L2kRwtWjI="
}, {
    "num_cand": "U2FsdGVkX1+OwaXfZHw8pHNNFAaEW4l8oO4hjyDUZII=",
    "cpf": "U2FsdGVkX18T2QLHvaDqg7K94QU2hd0ZxYO189LMMHI="
}, {
    "num_cand": "U2FsdGVkX1/tt4pR3UcvhDky9jB6b630NHjokEboHY4=",
    "cpf": "U2FsdGVkX18AZoup1McgucEEqSWxx9sTwVFp4aQasZg="
}, {
    "num_cand": "U2FsdGVkX19QWLADdGKaaNIOCYCAIcDa6URcn1CnhYg=",
    "cpf": "U2FsdGVkX1/vzRBjMsNicCp6szHJxHXtERm8AsNL0Io="
}, {
    "num_cand": "U2FsdGVkX1/R+m3QCK4SByX9qWKhjWtSwURa1eHwFDQ=",
    "cpf": "U2FsdGVkX193HITrkTyH28YZpaIGNRkaxvmzdWUT7Nc="
}, {
    "num_cand": "U2FsdGVkX18CnsBGDoyd6nXb7T22q1vkk0nd27lhsek=",
    "cpf": "U2FsdGVkX1/B6+XabwXgl1k+BQhIIfRrtpKv6MMa9rE="
}, {
    "num_cand": "U2FsdGVkX18hPgroWd5lU74x4N85YiGwHrOmGzRfGf8=",
    "cpf": "U2FsdGVkX1/wkKmJPs3f+9PL0rgEtoiysTzkTgzmF7c="
}, {
    "num_cand": "U2FsdGVkX19Aar3Ef/suFCFgcCJJoSrP0ruTXDiOrzo=",
    "cpf": "U2FsdGVkX19cIgGw/g/jB7/3lXPxzGAyV9TLbf5FOo4="
}, {
    "num_cand": "U2FsdGVkX1+LNkMChaN6a+V3jz2vMe3ImS33LlyyGkk=",
    "cpf": "U2FsdGVkX1//7sTE+YA6ALm0KPgShwaY7SXXlcNMQKI="
}, {
    "num_cand": "U2FsdGVkX1+hQqHLE/pssPnQXFiU15TMCkY56V7aVBY=",
    "cpf": "U2FsdGVkX19p44Xm36z7PoRWTwx87tkc6tC0iHzxJSU="
}, {
    "num_cand": "U2FsdGVkX18bmpcDXUC++vy4JnkDEEP6B9Z2aWGij9U=",
    "cpf": "U2FsdGVkX18WDzIckCQi8QBZs+yTtTKY/Sxza9tC/KA="
}, {
    "num_cand": "U2FsdGVkX19QtJ9+xvd5qoPULwiVum/nIOvWUoFZbSM=",
    "cpf": "U2FsdGVkX18CSlAQ6U3SApvElqDfsifVGNDglDVzSiU="
}, {
    "num_cand": "U2FsdGVkX188YdOkE7wUrma9CmwGrw17jRkWu7bqvSY=",
    "cpf": "U2FsdGVkX18QUX3rh+d1B9uKwjAuLv78MJbnpYOMLLY="
}, {
    "num_cand": "U2FsdGVkX1+62P5mGF2uB1Bp9oRHtnXGqvgyZy+tzSo=",
    "cpf": "U2FsdGVkX1+XAGGvJYXak6gyUL2qDdD9dK2TpdL3CrU="
}, {
    "num_cand": "U2FsdGVkX1/A+JYpr0B11wuD0Juk4Qb2Zv6WrOS0XqQ=",
    "cpf": "U2FsdGVkX18Ui3t4xXjsRe1WaJs72cARG/6BezZsYZY="
}, {
    "num_cand": "U2FsdGVkX1+JC96VBS61C/qMJY5Mq3t95EA6UVzW38g=",
    "cpf": "U2FsdGVkX18YQG/U69r3eRRFQaYM4SuZMlwMa2pYDQU="
}, {
    "num_cand": "U2FsdGVkX18XhsurwBZH6JXiarQLbZ7kGabUQrgcjxg=",
    "cpf": "U2FsdGVkX1/Mna6QmHMLQr2LVmUzWLIIHm8A/hvD9O0="
}, {
    "num_cand": "U2FsdGVkX18NHY230yo/z77Hp4XAyUljxPkzPl9DbVQ=",
    "cpf": "U2FsdGVkX1/e4brO+KVCFX4vN0SpblnIuDtTCpOqw2U="
}, {
    "num_cand": "U2FsdGVkX1/7wzjP80UVMURUJ3lTHt/RGA76rGdkPwc=",
    "cpf": "U2FsdGVkX18o8yGxu5IAzo0JdVp+14qcCvyLCCJHMdE="
}, {
    "num_cand": "U2FsdGVkX1+TF5+xDxPSzMw0ywKJcOMHLun6/tR+fq4=",
    "cpf": "U2FsdGVkX18kcIO4hHRKaAvSit4M/TY3hmynqI3Vtvs="
}, {
    "num_cand": "U2FsdGVkX1+TkNwCgNwFVaeRT6VGsPYUw3XU+vunv+4=",
    "cpf": "U2FsdGVkX1+YakzoxPUXpuWmzmy5FM0LqsJh3sGKKOQ="
}, {
    "num_cand": "U2FsdGVkX1+7zdXHI5oN8gLZd662BI6jE0RvsCTLvow=",
    "cpf": "U2FsdGVkX18dehxSJ2uHFfyTFqBxRtuy9tW6fjpB+Do="
}, {
    "num_cand": "U2FsdGVkX189bBKLzdJUwvhFX+vDP+M+C/zZfqjQDTk=",
    "cpf": "U2FsdGVkX18H22qiHZOv+cWDHMT6njlYEXB5iwfC/DE="
}, {
    "num_cand": "U2FsdGVkX19iosJldx9VqYxv9T4VH1qzCvvIVEEdNDU=",
    "cpf": "U2FsdGVkX183I0sOEQSaC1DkClmM8hTN17S8lLn4hzY="
}, {
    "num_cand": "U2FsdGVkX1+qa+k9Xot58n2oul/z30RtK/HMha1yJcE=",
    "cpf": "U2FsdGVkX186c6fRUXqOsb7FK7s+ygCgPkRqe7HSy9s="
}, {
    "num_cand": "U2FsdGVkX18FjvFm5j/pFgFHzQhJP0pTY2pBpgsxPOg=",
    "cpf": "U2FsdGVkX1+i7TJq+f5gl4YlGyYavab28e0/KCSZnbM="
}, {
    "num_cand": "U2FsdGVkX1+Xc/SMdlPSesqRT53TrKrBefXwVu3UQRI=",
    "cpf": "U2FsdGVkX19400PYjWjCS40C2LcAO2+opHakKpq+MH4="
}, {
    "num_cand": "U2FsdGVkX19BCfuKnSVCUQLZMrjQt0U/Db8jfF0Ygm0=",
    "cpf": "U2FsdGVkX1/b+t/xtRQi+SEEjqSQBNJsNVWoBLWqPpc="
}, {
    "num_cand": "U2FsdGVkX18HkefPUi9pIZTr+dyrhhQsx/7MzZ0XTjU=",
    "cpf": "U2FsdGVkX19XlhyLWaneUGIp9AmUJU3lseanX2cNeVc="
}, {
    "num_cand": "U2FsdGVkX19eKbFuDXqOkwbFlpIDTHbsIeKdex66tq4=",
    "cpf": "U2FsdGVkX18/+SAQuTOQZsQCrFIx0SMgLc1zHKbPusI="
}, {
    "num_cand": "U2FsdGVkX193nZtMUaSYSnawE3Ts1g1QXP07DMKREIk=",
    "cpf": "U2FsdGVkX19hSgoFrssdplsJdmeYgwAArxgrEmDkM+w="
}, {
    "num_cand": "U2FsdGVkX1/7HiLfTbybVLAOA39mU15rwpN46+VwXuk=",
    "cpf": "U2FsdGVkX19PWss5eN6bu4vSxms0oUoBc2xVb/5INnA="
}, {
    "num_cand": "U2FsdGVkX1+1/uYJdmKH+rui9/aaK/CX2TiP6GDkqMI=",
    "cpf": "U2FsdGVkX1/sKYe64Bc44aRGUpD8hO3AO/GWb2UKbMY="
}, {
    "num_cand": "U2FsdGVkX18jcCC7eVuJaH4g5OBIF8dCtwQzcqgKLH0=",
    "cpf": "U2FsdGVkX19+sUx1fow8KOVOq0Fb0xzrwl9sDrqmaro="
}, {
    "num_cand": "U2FsdGVkX19wM/CN6teWJZ9PNX2sl1Tk9QuGIP1qzg8=",
    "cpf": "U2FsdGVkX19F3xFaRuQ6IIJgAuATgp9aoOgCUOw/a1g="
}, {
    "num_cand": "U2FsdGVkX1+lSuWSBQSQaAba6YxDD20QqaWYU9i+8Ak=",
    "cpf": "U2FsdGVkX19cMjYzLcCb60dkUF7gDBn68vcAGoXxu2I="
}, {
    "num_cand": "U2FsdGVkX18ARbJblBus2xW7ATJh9BR0k3vErBLRP1o=",
    "cpf": "U2FsdGVkX1+mgY0EZy/ItCA2sWm3rBdLDhQSlgW4ShA="
}, {
    "num_cand": "U2FsdGVkX1+k2BRU4i7QoWAU7BwAa25H8S2+4eGdcKM=",
    "cpf": "U2FsdGVkX18ebdoJK6KxNwq6GZAp0cKCQ7wyDYYrtLo="
}, {
    "num_cand": "U2FsdGVkX184SFHBZDC9bcnSWiPh07e26AsNBkhALBk=",
    "cpf": "U2FsdGVkX1+w0amccRaBmnA3e8KH2gYKsHkXAHVrmDA="
}, {
    "num_cand": "U2FsdGVkX1+uqtmvLOcs0pv5xLLeb0B0bxeHrb2U0FQ=",
    "cpf": "U2FsdGVkX1/7jxiSFtmP74DPh4GGrjoFGb/9jX28g2w="
}, {
    "num_cand": "U2FsdGVkX192WIGhj10mbf+E0pn3F6XwWO7IHu3cN/0=",
    "cpf": "U2FsdGVkX1/ALvWvOw/lhBQ3erKxCZWRiFrAEb+efww="
}, {
    "num_cand": "U2FsdGVkX1+K/sEmEOYsS1kuRz6deVgI4MbYp8pwRD8=",
    "cpf": "U2FsdGVkX1+u0c6dMxpPKzw231fupawOiFCbIEkID/Y="
}, {
    "num_cand": "U2FsdGVkX1/nPc8wdq/LC5C4h70pi1toV2AdtWGM4Ac=",
    "cpf": "U2FsdGVkX18nXb9Sx2sIMNg4mw0NBErjkWo61EaUFhI="
}, {
    "num_cand": "U2FsdGVkX1/C/FAszWqmBa22IZslk5B2D8SdPLCzSec=",
    "cpf": "U2FsdGVkX18ELRx8ltypcKGeAtaUjKBfwCcrmssKFdE="
}, {
    "num_cand": "U2FsdGVkX1/bN1/L/Z/JLBW+2XfBkl9mC1BbVZcfTXg=",
    "cpf": "U2FsdGVkX19GiPd4K9m3wBZglqcHQrC+OzmyO8JaixI="
}, {
    "num_cand": "U2FsdGVkX1941B/zQkysRBQKkjpR6ysc6fcWFR8ExdE=",
    "cpf": "U2FsdGVkX19zYlcZi92HNy1i8sADBv5ijpz01BjQMKw="
}, {
    "num_cand": "U2FsdGVkX1+DvhwDUF8KGf/rOEK8QtK5b4uCFoiALLI=",
    "cpf": "U2FsdGVkX19uzxJohnK4BhPf+IB69ZYgUk2I98BTrZk="
}, {
    "num_cand": "U2FsdGVkX19wFZz1PODr8KB7FIPE07juO8Md2Fhqooc=",
    "cpf": "U2FsdGVkX1/H4DeXbpTZegI/EHWtMiR+aUaUARy8EXY="
}, {
    "num_cand": "U2FsdGVkX18J4JY9hCN28JQLlrxc6YjokT6g3SXmrTM=",
    "cpf": "U2FsdGVkX1+s8c3kRIdyF4jk3NtetUmzxPzJ/dL6VJs="
}, {
    "num_cand": "U2FsdGVkX19x1PID/ISp+fLr71xyPc5qjlpW03cpRqg=",
    "cpf": "U2FsdGVkX18dL3VYWrAjUgjNYJvkVKVPSE3WsXW9hf0="
}, {
    "num_cand": "U2FsdGVkX1967KgfQusx3176cO5YJp5GLAu2uxyDuJM=",
    "cpf": "U2FsdGVkX1/x6tF26ZU57zcpbfnz4tNIUbVBh26JeYU="
}, {
    "num_cand": "U2FsdGVkX18c9vxEOeS8RhY2k56wQfI8b6obbUyZGSA=",
    "cpf": "U2FsdGVkX1/qvsP6uM2QN7IkmR01ZqqhZ3/Gqq352I8="
}, {
    "num_cand": "U2FsdGVkX18bx9EN0dpAPtpftbL4x3e6/v9icdTQGu4=",
    "cpf": "U2FsdGVkX1/dGH/v/7J/O9CGE0+/GVyk8kTMtyqzg74="
}, {
    "num_cand": "U2FsdGVkX1/kYRgm/WwGfbL8dV5p6k0+N7SEonVCpTo=",
    "cpf": "U2FsdGVkX1813q14C43wx/x4JI0O5GMSQGx/YGlvcx0="
}, {
    "num_cand": "U2FsdGVkX1+ihcoTHm1jOa8HWVdz7yygQox8IWWhNgU=",
    "cpf": "U2FsdGVkX1/Bc3wG7SavudnehEe0n3b1uTxgv4o0220="
}, {
    "num_cand": "U2FsdGVkX1+H4BmDgBeyi6DWLjjqxWh4dNin9jBU814=",
    "cpf": "U2FsdGVkX1+o/+utejTrx6hV4qfLJLtLfTu404q+kAo="
}, {
    "num_cand": "U2FsdGVkX18T6BXacFuQj02CJDMnch+vlv4jRY7haTk=",
    "cpf": "U2FsdGVkX195yZ1PMAEZQkA32uB+0TMMPUOSary8KtE="
}, {
    "num_cand": "U2FsdGVkX18yNlTktQDpZY0fagMXJZLil0slDksF1QY=",
    "cpf": "U2FsdGVkX19o98faIJkpr6pL+oaFSW8gWrJbg4B+l34="
}, {
    "num_cand": "U2FsdGVkX18Jq7CXQzJQbwxPIMbzDiVGLS+5LNhDDaY=",
    "cpf": "U2FsdGVkX19Z6Fakri/t6ACMm54TfwmchUrbBdZmzQg="
}, {
    "num_cand": "U2FsdGVkX1/PXIwBaadSUVjKc2+DoJGkk52Dp+33CJI=",
    "cpf": "U2FsdGVkX19h9JCzkUWzILUrQTr31ItpJ+tET6U+C/M="
}, {
    "num_cand": "U2FsdGVkX1/7DxgiU7dYJrx5ucYTNRWCgy3dlyN/S1w=",
    "cpf": "U2FsdGVkX1/pyaHWv+KXFu/4we8yDHErNOuYcB2rHa0="
}, {
    "num_cand": "U2FsdGVkX1/FvjvZVIO4c91AAGjl9zP/FUrb3ZgblDA=",
    "cpf": "U2FsdGVkX1+uSYKVUF+S6wfgiTI6YkqQYh+TMJrONOY="
}, {
    "num_cand": "U2FsdGVkX19odXJYxxAuKOxu0tvdFlXny79FEQtqLbw=",
    "cpf": "U2FsdGVkX18+uW4SEfjG9YT0O39JRjKD9vk89us1Dl0="
}, {
    "num_cand": "U2FsdGVkX1/reN2YPOj4piZZeTuHP09ogzFy897sbIM=",
    "cpf": "U2FsdGVkX18DQ8e+wfucTse4L5fQy3IM5TxgJFssUKY="
}, {
    "num_cand": "U2FsdGVkX1+NNKSq6dnpqhTzuNu2JY0Sry9w3i/Q8hA=",
    "cpf": "U2FsdGVkX18qkh1jGTu4pY2JTOo2x8JRk1mKryV/n1U="
}, {
    "num_cand": "U2FsdGVkX18AppZ68zDTjD3+ws063n8j98TpjhC8ET4=",
    "cpf": "U2FsdGVkX18gDnlUZNeKQtoik/azjUmV6Ygc9CNtF4w="
}, {
    "num_cand": "U2FsdGVkX184rXfbNUviQu3p1LS3Owntz5bOkK1bZrs=",
    "cpf": "U2FsdGVkX1/Wj9nM2atl8BiL7lRXqVS5TBqdmZLPg6g="
}, {
    "num_cand": "U2FsdGVkX18bmvmn6ZJJyb2CQ8zv7sfWCfwinl/occU=",
    "cpf": "U2FsdGVkX19+BatJDcqZia8I77iHCzjqVfIS+XSkh1U="
}, {
    "num_cand": "U2FsdGVkX19qsSeIiEGzppccrvcCmekkCsIaAP2qhWs=",
    "cpf": "U2FsdGVkX1/TFnSmJmwMc/W9tdbITiTT1RdRw/mm+9A="
}, {
    "num_cand": "U2FsdGVkX19OT5SYJ4OnoWFae8hAsBHdFgCNeztIzcI=",
    "cpf": "U2FsdGVkX19stdkZynNV9ToYbrXH6uy/ZeLpr1l+Ou0="
}, {
    "num_cand": "U2FsdGVkX18aRt4R+n2/7eeX0lxgHcjy7Z8FWfuEInw=",
    "cpf": "U2FsdGVkX18ae66yQ8qlt5RPZYCLiWC1fsgcRHJV6S4="
}, {
    "num_cand": "U2FsdGVkX1+6kxXi5XNwKcyi2Fyylfq8oCwSF+FP42o=",
    "cpf": "U2FsdGVkX19Wk0MsixeNcJ56UngjI7UlJu6dGYe9qsU="
}, {
    "num_cand": "U2FsdGVkX1+021o5uODBsImt32s34bwqQsuGCDL1wJY=",
    "cpf": "U2FsdGVkX1+sdXJsXEC9kXNL/FcmftiXDnUMGbzMm5c="
}, {
    "num_cand": "U2FsdGVkX19K1FiAJSS+3U1pNdm7PPEto5DI6/GBuXo=",
    "cpf": "U2FsdGVkX19ut2P4e0UTkkfAOEoL8aFvBDykxCiBGiU="
}, {
    "num_cand": "U2FsdGVkX1/7XE2Nv7knoFxpO0SudVpzDUrpXIJtKYk=",
    "cpf": "U2FsdGVkX19p1BNP4M1n0U/seJh5zjExybsKymG7Ycw="
}, {
    "num_cand": "U2FsdGVkX19iJLvHuGh63yIV6gPuArnColuQhUTNl8c=",
    "cpf": "U2FsdGVkX1/oP3FWPFHpJ4wT9XD2gEaF5yAjfWRbTZw="
}, {
    "num_cand": "U2FsdGVkX1/rH3bCRNfC09XwXglwGwhrz5au+0JzgTs=",
    "cpf": "U2FsdGVkX18LIQxA9cU3FoKqGfqjXE/F0g5hTVQUSEE="
}, {
    "num_cand": "U2FsdGVkX19Z3aBlXCaHFK4Lx/GGxJYCIUItwGiwSdQ=",
    "cpf": "U2FsdGVkX1+W21VY79jiL95aTTYRVVQTINEKJIZbR98="
}, {
    "num_cand": "U2FsdGVkX19pG2l5YVgSNl/VC4XsNxq9z9mAoDL2m68=",
    "cpf": "U2FsdGVkX1+VVjH1KsqRuMaWPEWE0U2LUFNS4Hn68SY="
}, {
    "num_cand": "U2FsdGVkX1/Wej42wMeFfuDW7lBeIQUiw9W2U4hFYpA=",
    "cpf": "U2FsdGVkX191ow0bGbgqzAx371bruKe0MWVJWalJkTc="
}, {
    "num_cand": "U2FsdGVkX1/dcZRJaEEHA3bRS5spCCt5TeCTtZtCPEo=",
    "cpf": "U2FsdGVkX19RK9SvIv/ihFVZBvxLcAr3UZzdkvLkl9w="
}, {
    "num_cand": "U2FsdGVkX18MZZUKD0Tz06+AfgwtspjQ7GyejH5FtTQ=",
    "cpf": "U2FsdGVkX1+9WtjpLX/6rPIETMg0YS2UyRJ1mUGZh+0="
}, {
    "num_cand": "U2FsdGVkX19zEw6DOp3AJoY0L335jV442CQ+guuNHuw=",
    "cpf": "U2FsdGVkX18Vmw70N24rQqtNdfFFqoTRoMzYnvmy818="
}, {
    "num_cand": "U2FsdGVkX1+yXulv2twXaHt/qalWPwYYCf8ydiQr9JY=",
    "cpf": "U2FsdGVkX19eGDVpU5DPvsIma4Pff2RG7iFIuXg14hM="
}, {
    "num_cand": "U2FsdGVkX19moGtHvPT/E89UYwKmW6PTfxerKP3J9HI=",
    "cpf": "U2FsdGVkX1/7Q7m+OFjmLwevGCijg9ohrdaZy6muMzI="
}, {
    "num_cand": "U2FsdGVkX188fYnQ0ibJjBei36lHcx1mwzIVfAWqGy8=",
    "cpf": "U2FsdGVkX1/Ddn55TFFGQubLSMHrQRi7mQvNWJ8BFrQ="
}, {
    "num_cand": "U2FsdGVkX185kN/U6Ltz85aT+Xk9Xw+y6gXbF2wdpv8=",
    "cpf": "U2FsdGVkX1/PVI5WOJ3jvSJ2IyL1hyloFTxpszPrz38="
}, {
    "num_cand": "U2FsdGVkX1+7TpOOhT5ZAwx7qVbCSD8dD0lNeibAwxE=",
    "cpf": "U2FsdGVkX1/9H1JSTnJdEl5sg8y5ORa2n0yveIgWqmA="
}, {
    "num_cand": "U2FsdGVkX1/E3SLLCgimzjAH58qILtGaDO982Kkzbo4=",
    "cpf": "U2FsdGVkX1/za3RwXjqF/94Xip0QtbIPukSynwuD1wc="
}, {
    "num_cand": "U2FsdGVkX189K0v4bQf8pn9LaSpLdSa11+eZphy2Ewc=",
    "cpf": "U2FsdGVkX1+UHpL51vyKWDgdL392DJsEYiZsKHMibb8="
}, {
    "num_cand": "U2FsdGVkX1+bhbuxoTOamB6Bll0CuBRn6Z58kF1lESA=",
    "cpf": "U2FsdGVkX19M8YSEGSB6QGF5LpHJYm2vdfMLNifmGDE="
}, {
    "num_cand": "U2FsdGVkX19TnlWr89Ixok2jOL9NjOdGSjEGPG4Eae4=",
    "cpf": "U2FsdGVkX19j2+q32Vv0yYAb/l2Jv3uC6FlEmz95P4M="
}, {
    "num_cand": "U2FsdGVkX1/5mDXZKYJ+4nTG8WAV0Z+RF22k1s51FxU=",
    "cpf": "U2FsdGVkX1+yNgWciFP7nD69V8E8Utiuwv8y1Y2OWiE="
}, {
    "num_cand": "U2FsdGVkX18j80G5TyxK1Om2Dw/GBSa15t8bcGhhgnQ=",
    "cpf": "U2FsdGVkX1+sT6M/8pdn8S0oF9hb0IC3To/M7ngPe0Q="
}, {
    "num_cand": "U2FsdGVkX1+ZXlCdCz8/tjAtyMyM3dV5Bx6Vk2q43jg=",
    "cpf": "U2FsdGVkX1+3i/SZ1D3OfmJVY+WLKF7fbw2bt/DatPk="
}, {
    "num_cand": "U2FsdGVkX19VvZRFCYtS7tfi1T6pSir8l0nxpYMc6ik=",
    "cpf": "U2FsdGVkX1/L4oASKiBOncqUduFVAZvUZy5lr945N8E="
}, {
    "num_cand": "U2FsdGVkX1/mNY9AFKQ4tlLehtp8096dA9lkai1f16U=",
    "cpf": "U2FsdGVkX19ePc1zl74BEIrnYaKGUiiA4/iCvWnu9UU="
}, {
    "num_cand": "U2FsdGVkX1/ttWzA9id4dYzFSQyw285RkcqGWMZqFsU=",
    "cpf": "U2FsdGVkX192gwv3kNPdzarD0lP0ZsqeI5+6tfDtbK4="
}, {
    "num_cand": "U2FsdGVkX18mWT6DyKdAQKQQiMDqtvfKvOyClcs4GBA=",
    "cpf": "U2FsdGVkX1/bNysBPCR0qm4pGNCBkNey2fipsNvIEM4="
}, {
    "num_cand": "U2FsdGVkX19gZ++cmk2uEJJbyP4c0VN+Bya/rMVSK8A=",
    "cpf": "U2FsdGVkX1/Gzb7z3TPBI+Ck4IcygB2XqnHxNlGg4A0="
}, {
    "num_cand": "U2FsdGVkX18KFvrMoqkbU8uPSCxf4hlnlYWlobRNoUU=",
    "cpf": "U2FsdGVkX1850Sw1Y0LZCupqhImgnweIHblvJnWuFZs="
}, {
    "num_cand": "U2FsdGVkX1/wGi0mlTyMl8gG4ZC3FPBFIQQN68WrZjY=",
    "cpf": "U2FsdGVkX19Voy9SWfwgGcLLxk5RdVZ8iw+2tWZe3EI="
}, {
    "num_cand": "U2FsdGVkX1/WfKam43zNjqdppCKTzPrIi4/v8jqVDp8=",
    "cpf": "U2FsdGVkX1+YqgNYAIP2e05kMuHPZHzaRaSIpINTRu8="
}, {
    "num_cand": "U2FsdGVkX19W3FQFhIWl6k9w3pzp5PeXesgAjk3JJYc=",
    "cpf": "U2FsdGVkX1+SSMtOeMDKXNphmfNS+iMY7K4GrfBgwP4="
}, {
    "num_cand": "U2FsdGVkX18R+MHQainRBBgy1SK02GvcHWCsUR9Wk8o=",
    "cpf": "U2FsdGVkX19CIRJMWrReU3o9vey25FX0SWZYbtHfxrs="
}, {
    "num_cand": "U2FsdGVkX1/b5GXRR+wrGwZlFnjnZJnSHEQj4XgyJnM=",
    "cpf": "U2FsdGVkX19rjpqeBc3JjVGB6I4RXREJmCCxlR7o7Eo="
}, {
    "num_cand": "U2FsdGVkX18KgId6fn+hmjyRUjNKOufcLHZZEqTWfPg=",
    "cpf": "U2FsdGVkX1+mUmXAUwwlZT5JlQ6imTqmcfgzHgu8AKE="
}, {
    "num_cand": "U2FsdGVkX19hIAd8IVXNmTF1Y9Ks9QyYNy0D/UKBR7A=",
    "cpf": "U2FsdGVkX1873WZ0LwoG5tTM0XNrJ/LRtoGEiRWsCUw="
}, {
    "num_cand": "U2FsdGVkX18uaTTs9zzZQ8AC+3658h9F5gyilbELtV8=",
    "cpf": "U2FsdGVkX1849DQYND16Uw14aJBvqEEFQT0cz2gi+kw="
}, {
    "num_cand": "U2FsdGVkX1+XvCi830ru86MWAfXHW0cr6nYIJmEgXyY=",
    "cpf": "U2FsdGVkX19KqRsY5Y+1Srhhg/xQ5axTifxn8RJpBdw="
}, {
    "num_cand": "U2FsdGVkX18zOl9wnszEpQvWZXZiQ/BpKADFbKAfPvM=",
    "cpf": "U2FsdGVkX1+2BFGBqkArx9BTkJuyrT7OQJD/OefXPsA="
}, {
    "num_cand": "U2FsdGVkX1/KCvh/sdmDwpndyDCCb0fxvAEMoI61T1M=",
    "cpf": "U2FsdGVkX18fMtJBogMnzW0knoEC/QgJ5arbtnJmQGM="
}, {
    "num_cand": "U2FsdGVkX1+X2CflyESB7iSvLtrk1cl4fMjUge47H/E=",
    "cpf": "U2FsdGVkX18hz1IZwshXar+uZeOMop1O0bzLmhJbcGI="
}, {
    "num_cand": "U2FsdGVkX1/8aB9WNe5lfkD2YNSXXZKkgOUBO3u2g7U=",
    "cpf": "U2FsdGVkX18a5EjxLPzb9SsG/B6sXjodMowBOv2P3II="
}, {
    "num_cand": "U2FsdGVkX18spLwLQfFgsjMY0UG/GOyskTA0/JAbklw=",
    "cpf": "U2FsdGVkX1/B5gPk1shNcNwMJi6z+WPE6WIheKXHe8A="
}, {
    "num_cand": "U2FsdGVkX18s43w7rr+gxCmoe5k13dQSAFvScWvfqaI=",
    "cpf": "U2FsdGVkX18XoyJ1pUjBN8NqbYDcyyxCiAWFC1F3AVg="
}, {
    "num_cand": "U2FsdGVkX197eosyVellBMktsotWGi0OicCXN59xBlI=",
    "cpf": "U2FsdGVkX18H3+mACuh4bVRcHuZtWBG0gGnRwJcYJKE="
}, {
    "num_cand": "U2FsdGVkX1/MV3rza31SqqhaxGrtaxXTvAOja4YJxqg=",
    "cpf": "U2FsdGVkX19nOLa71iCeyMabXmecfLn0IW61yT/LKBQ="
}, {
    "num_cand": "U2FsdGVkX1+N0uyc36xgnB6J9hP7104h+sKlix7mlrU=",
    "cpf": "U2FsdGVkX1/4mK1lLvDp+bpGK6MlLOF2u/SRcPGGXsQ="
}, {
    "num_cand": "U2FsdGVkX1/K1zyDUOOzmXYQ8tpJR2YU4Iu/NaPUZs8=",
    "cpf": "U2FsdGVkX18y29JmjFR/EdPxIlsTlYvbCCfzGOjtMIM="
}, {
    "num_cand": "U2FsdGVkX1+hYO1lJD6F+cjsLb/I1ufDZaV8ksI7Vp4=",
    "cpf": "U2FsdGVkX183IM7LHlyJxs5Yx8aXbm0BJBzqWsohoCI="
}, {
    "num_cand": "U2FsdGVkX18Z7mvkweunDWcLRaSm2ukLCaKtwBah2vo=",
    "cpf": "U2FsdGVkX1+RK3YFteh0GCxNChRUiZqx3QsKSbtKPmw="
}, {
    "num_cand": "U2FsdGVkX1/J4UsEgzTbUjkheBvz8BkcLe+MbgTsKVY=",
    "cpf": "U2FsdGVkX1/3tauiU+0QEVT+qEponhmd0pxg2u61Qnc="
}, {
    "num_cand": "U2FsdGVkX18ognXHsmZapqdmcEPAs6cGI2mEc31rW78=",
    "cpf": "U2FsdGVkX19QWiUuy1OliDTTi6RO+zFM226PK63Oaxk="
}, {
    "num_cand": "U2FsdGVkX18sZwAjK6FyMpNH0D2q8+k+PKHkORAE67k=",
    "cpf": "U2FsdGVkX1+eV1EV7vtft0vHtCLtUmKc+Eoa7EKEq4k="
}, {
    "num_cand": "U2FsdGVkX19861S80uERThFVvYT6iGdrimnHF6mvXMY=",
    "cpf": "U2FsdGVkX1/dYzz/38Urn5Qq0M31shrNrahU8ejgWUk="
}, {
    "num_cand": "U2FsdGVkX1/ammTOQGSKmZQsumWyNHPXI/k+DGh/ZxE=",
    "cpf": "U2FsdGVkX1+CT+U76lreN7CZnJjxpM76R5KQBpD8iwA="
}, {
    "num_cand": "U2FsdGVkX1/9OEFWwRejHaFeEc/MhilBoMAdC4JU23w=",
    "cpf": "U2FsdGVkX1+lYOdN+LIMO0Xl0HKSsmtOIBm70+SjUd0="
}, {
    "num_cand": "U2FsdGVkX1/3HxhluM/uJqN84ieCKc2Pt1sneZtqxBw=",
    "cpf": "U2FsdGVkX1/koAl1f2l0o6wtpOoeWJ/90R3LBUZqeuY="
}, {
    "num_cand": "U2FsdGVkX18MlmuWgreMf0T2jqb0Bb1ADrJFhZSd5q4=",
    "cpf": "U2FsdGVkX18tcLQV1gCeEq8av52piSDz62zrg+bKxEw="
}, {
    "num_cand": "U2FsdGVkX1+sYnQYfCH4kei/h5q37urQEORszgoMUfk=",
    "cpf": "U2FsdGVkX1/jzD4VCnkEEPmX/osu1/cTfU07S4Tlbq0="
}, {
    "num_cand": "U2FsdGVkX1/UpxC/4rs2WVVivVabkwe0t2s/Rk1KkSU=",
    "cpf": "U2FsdGVkX1+lQBOjpQ93X4Tz/vpyMzrug3tcKvngcs4="
}, {
    "num_cand": "U2FsdGVkX1/Lz1B4JjjXsEANB19faOxWizQKcy/OcY4=",
    "cpf": "U2FsdGVkX1+9VUyhLhA5P3vxwyMiNg57Yhwk6luNjR4="
}, {
    "num_cand": "U2FsdGVkX188EJ5le96H7OA47RNycKUy6OcKqFZ4XtY=",
    "cpf": "U2FsdGVkX18ZF4C7/9HWAgphwbo2DdcQc1MpLiBSbK4="
}, {
    "num_cand": "U2FsdGVkX1+EacbZz9iF1tEdikYYO87tH+O8RhH2ckw=",
    "cpf": "U2FsdGVkX19GEV9GTcneyjER1SlQ07I6t8+MdUb56hQ="
}, {
    "num_cand": "U2FsdGVkX1/pWF3L7ruI0jSWIky7ApUgYP4LOLzNfFU=",
    "cpf": "U2FsdGVkX18WLNCQXln0jUN+dxNhFd4RXvgmCp7q7Nc="
}, {
    "num_cand": "U2FsdGVkX1+okN4RBeXhymLDqNUdOmERdhD9KRAKMSE=",
    "cpf": "U2FsdGVkX18/A+dikeIa03DnLA6iKL9J0IqH+Ltt3DY="
}, {
    "num_cand": "U2FsdGVkX18xOLyq/NptgP1DtTEd2jVly4eUNkUvJwM=",
    "cpf": "U2FsdGVkX1+vfhlJM25GxeGquD2ZsEFOBRnKjPWmwJ4="
}, {
    "num_cand": "U2FsdGVkX198zQ/li4I36iX9az1T4JCOnB+1wtqieqQ=",
    "cpf": "U2FsdGVkX1+4A4vLIe0mhu53aKMhMXWc00fMPuzmtnw="
}, {
    "num_cand": "U2FsdGVkX1/nk4b03gYqso0h1HSypaRoSTxQkXIr75Q=",
    "cpf": "U2FsdGVkX1+H+i2bzHP9msLfnMIq1BdFwVirndJzHt4="
}, {
    "num_cand": "U2FsdGVkX1805nomDDcNaue3lEPsX2/N2Me3gy080lQ=",
    "cpf": "U2FsdGVkX1/3fwtm7gYbFSR8RPBrUNbKS+xpGkm9tzQ="
}, {
    "num_cand": "U2FsdGVkX1/g3i1HKRjPXBiK3PRd9wMlsmCNKUJWNwU=",
    "cpf": "U2FsdGVkX1/FsQ8PQhrk4Z7L6A2P9RXSaMB78mBD2mw="
}, {
    "num_cand": "U2FsdGVkX1+eEOGg7yMRC9hGIeME+k+kEyvQjs4DjmA=",
    "cpf": "U2FsdGVkX1+diHNC0t6iCIpEudM+VQJ8cbB+sfgUWdU="
}, {
    "num_cand": "U2FsdGVkX1+T5zOnl24P3ylLKhNr83sLUqSXN4tKZnw=",
    "cpf": "U2FsdGVkX19v/g5ttI0J9bu63riaOz4S2MNjKpmkcus="
}, {
    "num_cand": "U2FsdGVkX1+C9CzM0EqtKKzDJESSIkd7sjvlkvjt/2M=",
    "cpf": "U2FsdGVkX1/DwXSxGUjeGr2w7tk+alBoAYBMz76PHaA="
}, {
    "num_cand": "U2FsdGVkX19op9C6TYJ8bCgpgeMgH1h2p88lIHuZfpI=",
    "cpf": "U2FsdGVkX193QavPp+j0zOndWjxYosPh4+J2+43dYFk="
}, {
    "num_cand": "U2FsdGVkX1/8MGP+BLGgIyRa5FSgAJjHrRYSvEd/MyE=",
    "cpf": "U2FsdGVkX1+ulS4XAjFZ5k4ECdpfpBQPsYjZHyxURNI="
}, {
    "num_cand": "U2FsdGVkX18HVnkg85R+elfGDzk8sMjD4PH3h9OC22w=",
    "cpf": "U2FsdGVkX1+WC0K50Cp5mcG8XM0z4fi6QYZuk8dX2ZU="
}, {
    "num_cand": "U2FsdGVkX1+PPCBgMng5Alx7Eymz9yV8zwmsOmq7r44=",
    "cpf": "U2FsdGVkX181kdCSECd2lekf3kJkrPuWwwhwJzBJiTs="
}, {
    "num_cand": "U2FsdGVkX19kCOjvo/DvqtzbM3y70M0i+ca8CCdVD2o=",
    "cpf": "U2FsdGVkX1/BRxUY/tSuZMJymiauZSq2KYjq7wrxspM="
}, {
    "num_cand": "U2FsdGVkX18nyOK1koVwRuZgfKI1EZy67xyoo9O1trY=",
    "cpf": "U2FsdGVkX1+Ut3EEFkan4eEMuvqgwxUalgkCNKOrUOo="
}, {
    "num_cand": "U2FsdGVkX1+gihdCpxfbrp5KW8+e73/Iew6aSG7KB10=",
    "cpf": "U2FsdGVkX18LF/xBIoMq1FT3dhWXf6c9962bMPO5+9o="
}, {
    "num_cand": "U2FsdGVkX19C1qHFaYOspnmB6lNycZshAwjWuEifqDo=",
    "cpf": "U2FsdGVkX19Ter0zrnjPmnEz8Q1ZZ2aALF+fRyvE9Ys="
}, {
    "num_cand": "U2FsdGVkX18nNbT3Qd/8kXHUFtKhYjDhwemZuEZXe2g=",
    "cpf": "U2FsdGVkX1/9p0CuZlnxBXApqY7GSIhfpJHxXjUcmrg="
}, {
    "num_cand": "U2FsdGVkX194QclxYeTBE1PAimlLpXTpaBHm39K66Qw=",
    "cpf": "U2FsdGVkX1+nxIJyNwcvW308AZRWIluvBIs7TEXZtTI="
}, {
    "num_cand": "U2FsdGVkX18IsgBUhtlZ+aV8bB3RZN/m0gHVq+CHzzE=",
    "cpf": "U2FsdGVkX19kXGafn0UVXMBjnWW+PCJ6zb+q/VP0y7c="
}, {
    "num_cand": "U2FsdGVkX1+jR1d6kcSE7lbomoRalPxVCD1Aa00BOo4=",
    "cpf": "U2FsdGVkX1/iVx22jvT0vLVsW85i5HcJPGoc5uXcVCg="
}, {
    "num_cand": "U2FsdGVkX1/EYnCONmwTVtA42AFvBSKAwzxqA+Sxggc=",
    "cpf": "U2FsdGVkX1+0ZyuK1QSE6qk1O2bALHKw/nLnyhyzdYw="
}, {
    "num_cand": "U2FsdGVkX1+aKm22MRH15jp8EwxfjkubIhxBn/dJ4EU=",
    "cpf": "U2FsdGVkX185UEQejvLH2YkHs/xVJqTDw0jfKcfv2m8="
}, {
    "num_cand": "U2FsdGVkX1+c8BM36epjDEFebQdKr1ZWCFfHREPFPYg=",
    "cpf": "U2FsdGVkX1+tkzGUfmILQ+z9VW03sZklW1CBL4+FuoQ="
}, {
    "num_cand": "U2FsdGVkX1+h02d3+11f6L8POciKJuBzl+wZh+fd1wY=",
    "cpf": "U2FsdGVkX1+US6jbd44Q+Trm8Jq8fKgKGLSdMWC4dTI="
}, {
    "num_cand": "U2FsdGVkX1+QL0xXH495qxVgvTQ4O9SicEuRxLr1Lfk=",
    "cpf": "U2FsdGVkX19BJ7jTj/H6G1tL9JFMHJpDBAegvGvvhNY="
}, {
    "num_cand": "U2FsdGVkX19+H/OyFd6yk3fIxyPTthKN1WO1jgC9cwQ=",
    "cpf": "U2FsdGVkX19yy8MD+AJefvHNrrdSXWzBOfZIYYMRL6s="
}, {
    "num_cand": "U2FsdGVkX1+cSpGnITMSOWEcyuEOMBty3eFjCDYvUrM=",
    "cpf": "U2FsdGVkX18ZXEeYKBVSX4BBuZVKzv1679y4oEnWozc="
}, {
    "num_cand": "U2FsdGVkX18SWnS4iPVuj8FNsGMQayPr4Hhg9lppHRY=",
    "cpf": "U2FsdGVkX19zjk1Ll2+oBxvEnBKdw4hNVX04MGr24dE="
}, {
    "num_cand": "U2FsdGVkX1/DZlUXPPJkToja/ajtK5+VrZsxfLfP0H0=",
    "cpf": "U2FsdGVkX19DEtX4KGMgAcP40NjsA3K+HphkZKWa9Mo="
}, {
    "num_cand": "U2FsdGVkX18ye9jooSqiaTEHLPdOMEnDUmsMml94zQc=",
    "cpf": "U2FsdGVkX18x/YgfraKrCfweUHaNZWCUcGWEsjeLTKE="
}, {
    "num_cand": "U2FsdGVkX1/CP8L8OciAIzbFyFM1w0tsfw4y3uGxx3E=",
    "cpf": "U2FsdGVkX1806P465k2BOOtLzQsE7KOEGP0tkY0k3E8="
}, {
    "num_cand": "U2FsdGVkX1/V+h9x5oUPiOV+9ExgeOW2oOQjeBJp7CU=",
    "cpf": "U2FsdGVkX18q/uDiKXaa1akSGSYLg9TOJE6qU/XEqTU="
}, {
    "num_cand": "U2FsdGVkX18VjQrW8tIsfQGJ2YNluCtI6naMmUy+/Ow=",
    "cpf": "U2FsdGVkX18/pM4f/DqsunplnPSCtxlVluOsBixkHM4="
}, {
    "num_cand": "U2FsdGVkX1/TEaWBFFNvK33L0t7EyIpuwI5qeh4fyYQ=",
    "cpf": "U2FsdGVkX18Otzse92GafRxhkxCHES1wA1NX3Yr199E="
}, {
    "num_cand": "U2FsdGVkX1+IeO4t6Z7tM0JR7O6hoeMCiZ7lJcx3Q0Y=",
    "cpf": "U2FsdGVkX1++a5oMBm9W14WchZK5uTc7F2vLA5zxyfQ="
}, {
    "num_cand": "U2FsdGVkX18ObRoxN6wVPr+BEMfuqc/apoANGQEEm40=",
    "cpf": "U2FsdGVkX18zQsW446pbItmSjSD5TCQfB+XcASrtLO4="
}, {
    "num_cand": "U2FsdGVkX1/tcIvKbIpZEw2yWFFRKTpvQCmpfiF7lkY=",
    "cpf": "U2FsdGVkX18UjHEedkmufW2Of9J62QkJaoqpUqzbAFs="
}, {
    "num_cand": "U2FsdGVkX1+X++p6unkQ/+XMCOASDA33Q2UvNNXdCA4=",
    "cpf": "U2FsdGVkX19P2pV6AAfm1fze1ewj5p6LRjlBJYuL7x4="
}, {
    "num_cand": "U2FsdGVkX1+aWYO2oS4Y3Z1vDs57dfAK0nCQzrYlztk=",
    "cpf": "U2FsdGVkX18sivHkVkdcYo3hkUHMG3bVjxpCdhYWDhg="
}, {
    "num_cand": "U2FsdGVkX18JxM+L1ng+0lhN2XwjCmvf4aJP+cDVzgw=",
    "cpf": "U2FsdGVkX19rxz5g6iw6DZF7G7ow6pvONy0NKQlpR10="
}, {
    "num_cand": "U2FsdGVkX18Iz8CXruOpJOY5jJ3BtOUtl9eaBRJX4MU=",
    "cpf": "U2FsdGVkX1/FyvPkXGntc880gacDHz1CPQBp7JdUHNs="
}, {
    "num_cand": "U2FsdGVkX1/8RVz2ZvdKV4+qFif83GVviMH5/y943WQ=",
    "cpf": "U2FsdGVkX18LMgfuA3VgwAMZlbmrZao+RwuJT0aTPhQ="
}, {
    "num_cand": "U2FsdGVkX18SMYWfEbg95y8RbHI4o3aZfVYKbym5YFM=",
    "cpf": "U2FsdGVkX1+H00USxWgbiTZpSKuuikwJW2vaFLjHcL4="
}, {
    "num_cand": "U2FsdGVkX1/5CIqwMDBYVN8vn2IRNY1uWsxUCAl5Z/8=",
    "cpf": "U2FsdGVkX1806xU0wNgttQyznLayM0CM17HWdgaz0KI="
}, {
    "num_cand": "U2FsdGVkX185Erd93MlEoYiHyxnVIUuQMaj7qNboyoQ=",
    "cpf": "U2FsdGVkX19wblWr/YnwlSSqy4t9rIGOXz8mlb/+m8Y="
}, {
    "num_cand": "U2FsdGVkX1+f/4JougxTZmvSeaJ8Tq793x3QEmcz22Q=",
    "cpf": "U2FsdGVkX1+gwUdi9elHt+pqZV+hHPRsCv3A5vvZGbQ="
}, {
    "num_cand": "U2FsdGVkX1+hirZJOMZWSJlFdIX1ZyKW1SIUwm5IzNE=",
    "cpf": "U2FsdGVkX1/nVxQJUmdkgt/2ABn/vPVGjOPH9L/4tz0="
}, {
    "num_cand": "U2FsdGVkX19T7DNH5LXXSAwkzX6UsR51z4toujCq+60=",
    "cpf": "U2FsdGVkX19hBFJDvw2oEuMIGCOLHCxV6ZZquusf7oE="
}, {
    "num_cand": "U2FsdGVkX19O5EKsBOAKXntQ3vdstkCbayBu3goyZk8=",
    "cpf": "U2FsdGVkX19DMTyma99qESt+vVhQm2974o3JC33i/pE="
}, {
    "num_cand": "U2FsdGVkX1+Dx0696Qt+yQeaQb45qMNH+mH9a+0RNmQ=",
    "cpf": "U2FsdGVkX1+ySyMow8wBTJuMqXgzehiST+uLROCDyc4="
}, {
    "num_cand": "U2FsdGVkX1+/nX32Pw9a1D9rDSKWd2xhA5mCtu3Ne/E=",
    "cpf": "U2FsdGVkX18RBxeuqaiZOTnTvChcwj7tEVFw/OAzs3s="
}, {
    "num_cand": "U2FsdGVkX1+U58qLIvYoZEaXimg7xeZ4PHqeZWbEQP0=",
    "cpf": "U2FsdGVkX1/WvW+phVKkXQsc9nDdDfYkTVBrJpkY3OQ="
}, {
    "num_cand": "U2FsdGVkX198w8gTRLKTcg/i8ehLtyc6ZJLvgSVS9Kk=",
    "cpf": "U2FsdGVkX1/2d8vzno+CdYgOlEF3Y92tDKqa1NFKczU="
}, {
    "num_cand": "U2FsdGVkX19h/oxQFCmxdmd4FTKxnBg0Jige3//l9DA=",
    "cpf": "U2FsdGVkX193ZJM0bVukRgyHWeZ49UHoIDgBstMRHJI="
}, {
    "num_cand": "U2FsdGVkX1/rfFG+nSduV5YrsfKOfRTlSogcThHN+/A=",
    "cpf": "U2FsdGVkX1+53ewdbIUEbCmj15iejaGQ22bGyuDWCAg="
}, {
    "num_cand": "U2FsdGVkX19n17vzKsKgGnGoGHu7Y7uXL8aRe0DbJdk=",
    "cpf": "U2FsdGVkX1/0FiVKveF8ACH8ZOabluolJZYwAV7X3Fw="
}, {
    "num_cand": "U2FsdGVkX1+VVxqGbcT5UEgdOlY3p1OJPzpL3aif0Vw=",
    "cpf": "U2FsdGVkX1/rJGGKdBIPIoHK632lSMiZxYPg/GSQ9wM="
}, {
    "num_cand": "U2FsdGVkX19Sa7FlAOFnXbsMbGgj9s2DibxFtS5MEYY=",
    "cpf": "U2FsdGVkX183FrIncxkLuMtpG8Sk025TQj4AvQw4ZYE="
}, {
    "num_cand": "U2FsdGVkX1+WhWV6U6+p5yHBoxKNarrNOdA3/Zwotf0=",
    "cpf": "U2FsdGVkX1/THwwU0gBnRv9c/at7d7j4O6nk7hCHmgs="
}, {
    "num_cand": "U2FsdGVkX1+je+OnGMhA5e87+tOdqSRbFqLcLP9kS+A=",
    "cpf": "U2FsdGVkX1/VikEl5GHGWY4zH46jXP/mMfnP0KGtE8A="
}, {
    "num_cand": "U2FsdGVkX18vQ3k18B1ml6fVcyvclpw1QTSK81pT//Y=",
    "cpf": "U2FsdGVkX19jCWOUq6NqAp3/qp9igcPJNglxFJJvmoc="
}, {
    "num_cand": "U2FsdGVkX18EP+yQr1xOK0GDV4lqdmlNuWkagkzmFnk=",
    "cpf": "U2FsdGVkX1/IQa9BMaEuivP4EXxRytzi7jMoyg6GLqY="
}, {
    "num_cand": "U2FsdGVkX1/TY4Sr6EG2Hq+5btLzHoWbjALvcrqtkxc=",
    "cpf": "U2FsdGVkX1/nj/8ekvTFrcEXxJJpOalWzu/iI4ChJEA="
}, {
    "num_cand": "U2FsdGVkX19czPPtM+0xMLh7VQsZfIK5rcAtlukbKGY=",
    "cpf": "U2FsdGVkX1+fuCzUYZFeKs6RMCPrELi8V/y1QQ7HxXM="
}, {
    "num_cand": "U2FsdGVkX18aKnpr2JN1lkkgJBM9Zi4RYYjF1ZkpYco=",
    "cpf": "U2FsdGVkX1+q03UsFEzbW6+RYYOw5/IMBhl4Je1lf/A="
}, {
    "num_cand": "U2FsdGVkX1+u94AmIHyO70dEpftxC9kCA0mIBHRV3CM=",
    "cpf": "U2FsdGVkX18gOvS8OfcdJFPv30Hy1LawHvjofCKjX0E="
}, {
    "num_cand": "U2FsdGVkX18uXufclzTjJZqwruPauDTL5qeJAvcVgY8=",
    "cpf": "U2FsdGVkX1/42hkxe5Qr0Rw/lRFi7VqCbDmcVCRD0/s="
}, {
    "num_cand": "U2FsdGVkX1+rYuEI+GDqzorStyWzqXxrYjVAUTlgBfo=",
    "cpf": "U2FsdGVkX186p6e51qytjNPCoqo1Z5CavuQmrlmn0B0="
}, {
    "num_cand": "U2FsdGVkX18GehY1yZEe4O/M3c0h/bcP6n/KcsUlKPQ=",
    "cpf": "U2FsdGVkX1/RG+Kkh4Sn8rQiUUpQ7FWEaRsDsCq8KmY="
}, {
    "num_cand": "U2FsdGVkX18NQH3dgi0dfRTBlOUFo5owJDxmz0uizEM=",
    "cpf": "U2FsdGVkX18ed0fSF4pOTa27KbIzuReL05oixbwx1UA="
}, {
    "num_cand": "U2FsdGVkX1/INuDXEc+4zc41VFpBqBKbBbPYP7wJEdI=",
    "cpf": "U2FsdGVkX1+vmsIR58k5ZNjKuEtjGIg292wp2gxfC/4="
}, {
    "num_cand": "U2FsdGVkX1+coeZULaouM+L7RjYy2761Em6vZulpr3A=",
    "cpf": "U2FsdGVkX18C4b5XvLSydSb6NKqTVJuMkKwRqFy50mA="
}, {
    "num_cand": "U2FsdGVkX1/s5Q8uixdQ8OAVRgLmSnU+Alyb/NyxVx0=",
    "cpf": "U2FsdGVkX19LybDtahxW+C2gHgUjx7QIgtFX62FcH0Y="
}, {
    "num_cand": "U2FsdGVkX190MpO4uCvEvxQ4zP0pVBx7bjGdPkY/iIM=",
    "cpf": "U2FsdGVkX18g/MB5SYBOAmJHUXnoH2J+DBegFZNddkA="
}, {
    "num_cand": "U2FsdGVkX19Ktb04qtM/ZBOK98MN878mjmQ63OKgVyY=",
    "cpf": "U2FsdGVkX1+sre1fcf7jWG0OUERd6uWB0LO75rguAt4="
}, {
    "num_cand": "U2FsdGVkX19O9LngyPeT9fxd3fJ19kDWduBfQP0Gz5Q=",
    "cpf": "U2FsdGVkX1+K7QJ0/BuBOZCdBvNJMdYQZbPtBnLsqgY="
}, {
    "num_cand": "U2FsdGVkX1/EraqINlLKPA64CGVQb6vJ0MPqsGUFiRw=",
    "cpf": "U2FsdGVkX1+nU3R/pS9KLepgd66BDs4dwJJKkNEoxc4="
}, {
    "num_cand": "U2FsdGVkX19l+hblUQ4G5rM0ENhe5pu8vQr7crKscMQ=",
    "cpf": "U2FsdGVkX19aZMYjeoMlSiC7HGXx40J4PJ+kQPtVmfA="
}, {
    "num_cand": "U2FsdGVkX1+4lzDm2DH0OBCpqv5DryGgpOwk+L6ybsM=",
    "cpf": "U2FsdGVkX1+CRga9v9h4CPvQe19wja7NmY21oUxkqwI="
}, {
    "num_cand": "U2FsdGVkX1+9p69UVKiFJLdrCoDAWMdoBfgCGkGg1rg=",
    "cpf": "U2FsdGVkX185mcOn8yhWyuWCvkNSFfWnU6tx9Sjyjf8="
}, {
    "num_cand": "U2FsdGVkX1+321roRb5z8LffMgIeUaApNTFCg1Yk8XY=",
    "cpf": "U2FsdGVkX183cBMkY99zxEdOmSEJptzyyUsolLd2/A8="
}, {
    "num_cand": "U2FsdGVkX1/jnlqUNLNyxnLM79x3sRB7rreWHO010v4=",
    "cpf": "U2FsdGVkX19jlaKewNcr/lpVxdz+ihhhxkXbCi3TxVY="
}, {
    "num_cand": "U2FsdGVkX1/YyWExZZG5i3U0k0wIpE+Nh9+f/0NB4Dc=",
    "cpf": "U2FsdGVkX1/kF5hPt9LHTyzwA80G6xSZVoBEfCu/Sfc="
}, {
    "num_cand": "U2FsdGVkX1+njPfioFyXslqT7X5cxCBR3sRfm0ZpVbw=",
    "cpf": "U2FsdGVkX19Mj1aKEzMkXv+6c4FIPLn9BChVFw99vVg="
}, {
    "num_cand": "U2FsdGVkX1825aho02oIx/3w+yibG/8TQZ39DLNQJHY=",
    "cpf": "U2FsdGVkX1+t57fg5Sw/3p74URq6R2zS1qym3ZVxlWA="
}, {
    "num_cand": "U2FsdGVkX18KulAjm3HaQPUBCtNVlGfFTCU2iOppRYw=",
    "cpf": "U2FsdGVkX1+kxbkvmhN4y2os1x2F84pajib3sm2mnhI="
}, {
    "num_cand": "U2FsdGVkX1+5JdWLzPG+YV1+EUz3LRRLdLvXBY/1Q5o=",
    "cpf": "U2FsdGVkX1+6Q0pOYDm3gpPe3Mwu5skw/xX3p+/NCwk="
}, {
    "num_cand": "U2FsdGVkX1/r+JCUnTAmtLDCnmeS1ulHk63/EIp/zK8=",
    "cpf": "U2FsdGVkX1/sBRXdRDpZlJAiG4QdXFjJcAgnvsLF3Cw="
}, {
    "num_cand": "U2FsdGVkX1+Bbkv30iD4AO6PxDbf/a8DTLUJlpnV4jQ=",
    "cpf": "U2FsdGVkX1+uTRtsGZJQ5s/0Wymd9JIhpR7grLf0kFc="
}, {
    "num_cand": "U2FsdGVkX1/9RRhcoj/C33mP2S0h9FrOTtArA+JJvRU=",
    "cpf": "U2FsdGVkX182OiFa6EzLgnYiz1/LXt1QhwSYMeP5hHw="
}, {
    "num_cand": "U2FsdGVkX19+mn7fFcO/TrNluHyr2EMTGu6/m+HNvNQ=",
    "cpf": "U2FsdGVkX1/cbPjrs840uh3t2kmc0zlh2mC+dCIVTFE="
}, {
    "num_cand": "U2FsdGVkX1+noScnoFwsEr6wBXLVEI5bXaqbdit2oAw=",
    "cpf": "U2FsdGVkX19ISHDqVywKvanuVr97TME6MfOsy6pU0ZM="
}, {
    "num_cand": "U2FsdGVkX198ZeURVa3lpOmdXtDKIU6oGUid45R97cQ=",
    "cpf": "U2FsdGVkX1/j/+dhPbhnx5WZvfOagvXKrDSBsfrh0gg="
}, {
    "num_cand": "U2FsdGVkX1/pHSeiCXAelHzxlym4r3H7t2qfUtDkSx0=",
    "cpf": "U2FsdGVkX1+izz6/xVmP4RCG36A6KqPoM1n0qtF3A8s="
}, {
    "num_cand": "U2FsdGVkX1+o2IIrm51XoH+SqsEWs9PwnS8YZ00TjsQ=",
    "cpf": "U2FsdGVkX1/Eo1WIF25ktBf0zPoZexUrO1iUNrlwWeY="
}, {
    "num_cand": "U2FsdGVkX18xYXx6pI0xP9ntU2QUjNHA4ueV6OKnZJc=",
    "cpf": "U2FsdGVkX1+GE+el2G55PsJR+heTJQgvspoiqZ67V8A="
}, {
    "num_cand": "U2FsdGVkX18VuJceySoDROiDAhhH0I1n0/8wwD/yrIM=",
    "cpf": "U2FsdGVkX18UwFIPQbkwYUlBIriPo1Ldrcp9r4i6Wgg="
}, {
    "num_cand": "U2FsdGVkX1/O0LXXKBmo8nrzuj98FANZK5nE3I6QyOE=",
    "cpf": "U2FsdGVkX19x/JPz/h0oc/PX6Zu2ZX7jsBAO0vtuvp0="
}, {
    "num_cand": "U2FsdGVkX19dxvKV+rCA+NKss7r8L4qvonH8Qr3c2ZE=",
    "cpf": "U2FsdGVkX19Z8ljLc8T5mX4hy7CmXfdRva+IgMAcAwM="
}, {
    "num_cand": "U2FsdGVkX196e8dw2Zzkh1nshFKRt/Ufij6B67UiJcA=",
    "cpf": "U2FsdGVkX181vvKt4jJZ9GolHK/KUz2bK2QBKn/d80I="
}, {
    "num_cand": "U2FsdGVkX1/6ieeP5yNvOPvAYleopabu8lV3VXmjIaA=",
    "cpf": "U2FsdGVkX186jyDMst3KyqNFk5lfppWdXJoGxvoTJvI="
}, {
    "num_cand": "U2FsdGVkX1+Lu/ka6G1KBUIcUYYxR3TxJ2QddJAmtw8=",
    "cpf": "U2FsdGVkX18KGWRRsUdNLfedsJvPcy/4smT89pS7v5I="
}, {
    "num_cand": "U2FsdGVkX1/gkFZQQhOCHQ4ZTunzikzZ5WtyU199xCs=",
    "cpf": "U2FsdGVkX186tS59ZVtq05X+pn2MU7f7WpjuesVGdTI="
}, {
    "num_cand": "U2FsdGVkX1/G3Xfyv62ngctnIiuZOhZl+aZ1jGXf9vI=",
    "cpf": "U2FsdGVkX18ooI6h61a9fJ8zoNDBTRRC2qSNeD5gdn0="
}, {
    "num_cand": "U2FsdGVkX18KYLq1JovEQBrzqZJi4F9iuiJt+OfM2i8=",
    "cpf": "U2FsdGVkX1/NwhwwXDgrCUQTqCyXAH8VJxAySv1bBAE="
}, {
    "num_cand": "U2FsdGVkX1+psp1Mqq6QEELlG+KD/z2aHHLEzCUK9R4=",
    "cpf": "U2FsdGVkX1/fR+yCdlhhVOdcsJSScBs76UzXWVXkqaY="
}, {
    "num_cand": "U2FsdGVkX1/G0S8/UiZv6jV0hYxJPfWuXBPHkTy0yps=",
    "cpf": "U2FsdGVkX1+ccGrpRzGxUCRltYFlGaSR7MtauzQRCDw="
}, {
    "num_cand": "U2FsdGVkX19yk7OfrnATI+ilgCD/bmB4rYw1HjeBu8U=",
    "cpf": "U2FsdGVkX19RgwS7nJNQH1ZKulKdX5G1jbezS/VYvFc="
}, {
    "num_cand": "U2FsdGVkX1+6tXJOLqjskB0LzYp7NoEPpKlD/FUR7UY=",
    "cpf": "U2FsdGVkX1/d8RDZP1r25nKVbgiElzsjcxEVoaaXznA="
}, {
    "num_cand": "U2FsdGVkX1+kEqhhpVMtkAFDA4MYt0iLryGueQspjlQ=",
    "cpf": "U2FsdGVkX18pNLuZ9QF8LjqouBrX996LwrRLZcwS/lQ="
}, {
    "num_cand": "U2FsdGVkX1/m8zY6WskSXoIbG/agyOjxwx7mogJl09g=",
    "cpf": "U2FsdGVkX19hDK9v9dHPc+FqldsBWZeAxgv7w7ZxzYI="
}, {
    "num_cand": "U2FsdGVkX1+868FL6N8fGJcmCevdQodXL4+tc97fRoo=",
    "cpf": "U2FsdGVkX1/bo9MFZTcOsHlFaN5mapnsonSRoLheqIg="
}, {
    "num_cand": "U2FsdGVkX188NGFHibojEtx23MBa6yHVSdaPIfNaXXc=",
    "cpf": "U2FsdGVkX180On8035n9CoDcGIKnM55KJeDjqJzlqvE="
}, {
    "num_cand": "U2FsdGVkX188xLX4YCawRsdIizs1AxSZKYU0r3+WDSE=",
    "cpf": "U2FsdGVkX19Z77H/x4W0Comcvq7IDXFsJOzewrNVMuM="
}, {
    "num_cand": "U2FsdGVkX1//AE+fVo1xOOpRF6OCJdO7FcCJpcj9xUA=",
    "cpf": "U2FsdGVkX1+XVTd/L7k9qWI/04k2LQZaSNeod/iUI7A="
}, {
    "num_cand": "U2FsdGVkX18ovqwEGae/tz8ThkjA3vqwTIjdGHim22k=",
    "cpf": "U2FsdGVkX193qZOIcvAPneVpeDbm8n9tQMyQyAxxR2M="
}, {
    "num_cand": "U2FsdGVkX1/Qavj06AWIjOKQwE/Jr/GEKkdzdeCP2yI=",
    "cpf": "U2FsdGVkX1/I3DRlkO2Lej5iajHZprO8pGmtONf4A1U="
}, {
    "num_cand": "U2FsdGVkX1/E5Hy7LfqQFmjpaLwk5mjYgx7Gmi7e6oU=",
    "cpf": "U2FsdGVkX1+bC0zGE9vCCam/g7CX4yFWexDmckr7xB0="
}, {
    "num_cand": "U2FsdGVkX19eJpYg55TQDHp0IDDLxewrMq3U79fNKyA=",
    "cpf": "U2FsdGVkX19IfGuYl7pogrg70UYUM84SwW2Zeq/LElQ="
}, {
    "num_cand": "U2FsdGVkX1+z9UDelehjENAKqhX2Pf9oF6rNOrhXQVI=",
    "cpf": "U2FsdGVkX1+nJgC3Um7k4A+4w7VSCtyUtjf7ZV7c0ME="
}, {
    "num_cand": "U2FsdGVkX19ZyZnOJNbKJr6VGNiiYGCaT33T+0Y6Src=",
    "cpf": "U2FsdGVkX181fNs7dXHP+CxTZG0DTFMQXBPxd9Ac+cQ="
}, {
    "num_cand": "U2FsdGVkX18XAg7debmP5jhsKBaOgeCx2mJTHs+K6PM=",
    "cpf": "U2FsdGVkX1+uQN7YrzwIjP632S/CR0ZU1aeV7PFfiLM="
}, {
    "num_cand": "U2FsdGVkX1+NrIigUjE1tFHETAGQHuNkwaNlm1qtwpU=",
    "cpf": "U2FsdGVkX18eNXwKs9UOP28p8ue19rfZpe1RoLjD0HQ="
}, {
    "num_cand": "U2FsdGVkX19UT4/CoIJTTHu+fCS0d5jQEtBXIBJeFfY=",
    "cpf": "U2FsdGVkX1/e2bOIgfgEuaqPJtrHsGoXjLiximq93QQ="
}, {
    "num_cand": "U2FsdGVkX18W+MCCd7ODMBvUKsPwnkq3inSbRRm6OtU=",
    "cpf": "U2FsdGVkX19jmR8+3EFab6RzGKCr3xtl1HbaIkgCiRA="
}, {
    "num_cand": "U2FsdGVkX1/BCdDKzxGcOhJpWedpq/FThzRFC4aLCLE=",
    "cpf": "U2FsdGVkX194se4vDxPG3tZexxFTn9Iuj1ucGUh9/cc="
}, {
    "num_cand": "U2FsdGVkX18eX8g8JuU4J3tAuv74D8fOhgBXKOzFQtQ=",
    "cpf": "U2FsdGVkX18tXZsu7DrB/x1QwOYLLfFeBqrS9bepof0="
}, {
    "num_cand": "U2FsdGVkX1+GpTNdxmc5L+ZIFAOds8uRCOuEQo7h6Ug=",
    "cpf": "U2FsdGVkX1+GIUKRMBFsJSj9bLO6mXQtcHRo395PBWg="
}, {
    "num_cand": "U2FsdGVkX1+U5Rdh5pdjQY8kibms5oOFaKx/E41nEz8=",
    "cpf": "U2FsdGVkX1+4bUWFv2EwFsUHQzEi/kG3vhfWHvcRckQ="
}, {
    "num_cand": "U2FsdGVkX18xUcEcHtleaUMLMComGslL5fWFi/1eqCE=",
    "cpf": "U2FsdGVkX18yCozCcAVYhZhTmlY4sPPdWiHTinFbggA="
}, {
    "num_cand": "U2FsdGVkX1+tzudmozhlwzeyAnE2Cos9i2TK50GhyHU=",
    "cpf": "U2FsdGVkX18ti+tcCXNM2nbvuAYOoc6Noizy9/eXEB0="
}, {
    "num_cand": "U2FsdGVkX195PCu00D6ep4UBx+8iXflvP6y8xpOD8r4=",
    "cpf": "U2FsdGVkX19ZGyNMqzl1zLkYmIUKExDRTRJrh1+EQmg="
}, {
    "num_cand": "U2FsdGVkX1+SX6XkmvNXWhCrp5Xqn6f5r5Z6cqfkv/4=",
    "cpf": "U2FsdGVkX18/QVxqRRJlJWRdz48i0s9hhMEsMBR6JkY="
}, {
    "num_cand": "U2FsdGVkX18rO/qQm22WpGscLsmWyJubdOd/owPxGmY=",
    "cpf": "U2FsdGVkX18dVsEQRXDFpht2iow+OgBsQkwAmESCwdM="
}, {
    "num_cand": "U2FsdGVkX1+kzHKv6HdWjTAalXJGzRZEkf73N6FBN/o=",
    "cpf": "U2FsdGVkX1/MTUA8uKF+Cr9mvbIBSSeySMb6ZLRhWUM="
}, {
    "num_cand": "U2FsdGVkX1+anCFFO8+cOvJLyQoLLB5v3sYFhc+p4xo=",
    "cpf": "U2FsdGVkX19lIp8Tf2NjxtBmrmIEX6oTFeKy4ECwm80="
}, {
    "num_cand": "U2FsdGVkX1+5rtXESH+h3ByMbRptmes14vUTJYJnbK4=",
    "cpf": "U2FsdGVkX18zPv5pynvLL6ViWEAvMOARJjxpK2svUyg="
}, {
    "num_cand": "U2FsdGVkX1+pFiptXwsNmryzwxch27HCOqird1SDUqQ=",
    "cpf": "U2FsdGVkX1+xw87enAs/Gx4y+SE39xQHIvkyQihs+Sw="
}, {
    "num_cand": "U2FsdGVkX1+CxzZn6CNIIB4/djcmsjLfPfPiyHP6Xt8=",
    "cpf": "U2FsdGVkX1+hOFaOS29Ji/syG023ivVFpI0FL/BKWGg="
}, {
    "num_cand": "U2FsdGVkX1/r6ZM56FhM3K966SPKRIL/YsQJ8GZR3F4=",
    "cpf": "U2FsdGVkX1+l5knduhMwpEfWHsdq+F3mfK19GcL0oPI="
}, {
    "num_cand": "U2FsdGVkX18u54fnupAZB00d+S/7//U4XeY4VaAxzmg=",
    "cpf": "U2FsdGVkX1/e4GU/vyY7jr11chgdq902ZMWA1JeePjM="
}, {
    "num_cand": "U2FsdGVkX1+bUc7Ud2+SwsLiZfnardV/V0jv1/4JwiU=",
    "cpf": "U2FsdGVkX1+2NtiHLfkf6YOgWjJ1JglTYT1HrC1JLC8="
}, {
    "num_cand": "U2FsdGVkX19nPmNyTPLJJcsvoBJUhVSnm+zSyfiWn1M=",
    "cpf": "U2FsdGVkX1+U3f1pmj+Enw3aTWNyjqH/zGkL1EFDRDs="
}, {
    "num_cand": "U2FsdGVkX1//TYsFCNBxdqNOOMyu4azGLsbvtYWNqWA=",
    "cpf": "U2FsdGVkX18LoMBdgPNsrV3obSzgUUxahyMGykZwUtk="
}, {
    "num_cand": "U2FsdGVkX1/O2V/v/jRm6nplI+6hQjXgIoSDalE2LD8=",
    "cpf": "U2FsdGVkX19K+KIPupntGXf6s0SBYO9KJ8Qk7BGuO5g="
}, {
    "num_cand": "U2FsdGVkX1/mQ4aK3Lhm8vmoJJYyFZenI2ABlO6Cclc=",
    "cpf": "U2FsdGVkX18fvdEQ3wcr+fy+pdgYYkLzvceBMg0uNNg="
}, {
    "num_cand": "U2FsdGVkX19ECZnAsbBufsOF0BF7683jPcH1rjnBGMI=",
    "cpf": "U2FsdGVkX1/2z7z+Vg0T3L0nT/HGBCL5fB/DbfnCero="
}, {
    "num_cand": "U2FsdGVkX18NTyXY3HGc57bca23Sydepnj6oDrrcXF0=",
    "cpf": "U2FsdGVkX1/UrrtFe7l9h5s4rOzbVltj6DbdQSXEMlE="
}, {
    "num_cand": "U2FsdGVkX185YiuDw9f3Lr5892PxNEwqx1QsT6XV0HY=",
    "cpf": "U2FsdGVkX1/CwoC5dubZjLw742O2i/0BCAkIRtTuVv8="
}, {
    "num_cand": "U2FsdGVkX19FwDubX2iiBo3PEefPfzaT1bcgbsaeoQ4=",
    "cpf": "U2FsdGVkX18AY1YUMxaRIQ0gFQXCtJ7dlvEKrnnPECs="
}, {
    "num_cand": "U2FsdGVkX1+GnVNp5fgtMS77mZAvAX6009WPsy9IgPM=",
    "cpf": "U2FsdGVkX18t4aMeKLpgXFIV84ZsGTmlSLURLLr92EY="
}, {
    "num_cand": "U2FsdGVkX18OXkE1jMAjgABGJUGRHmZnl+URFqQEUJo=",
    "cpf": "U2FsdGVkX1+3dMQjvaCFIOvXfoW44OwPzv3G/eJzj+0="
}, {
    "num_cand": "U2FsdGVkX18z6BAdQtUWdIyAsOnRsaevnFBjDBOGOaM=",
    "cpf": "U2FsdGVkX1+NdOFLwuG8Geit/9VW/CapQPBnIkecz4I="
}, {
    "num_cand": "U2FsdGVkX18thERjhc7pvpjLlbN/+FXQ8lfNC0juIh4=",
    "cpf": "U2FsdGVkX19mIEGuitbNQolhZpnfwKFcYThKN24iG/I="
}, {
    "num_cand": "U2FsdGVkX18IC1nXQqqPpbQq2xftLkZfp0cd0w2zxzs=",
    "cpf": "U2FsdGVkX19VBsZu6ibgbBpuHoGEodNiahRLCGXACNE="
}, {
    "num_cand": "U2FsdGVkX19/jRPPj4oVQdGK8jVhVWpywW53ownismw=",
    "cpf": "U2FsdGVkX1/QjXOWl1Y8/KVJgIEPzGhxaanI10e/GHo="
}, {
    "num_cand": "U2FsdGVkX1+/9zyY+gZ2IweoxrIqBlZzvUgVZzPwcDA=",
    "cpf": "U2FsdGVkX1+i3DVO+2O2VtZHhm6vPDaUzUuadrwnXrI="
}, {
    "num_cand": "U2FsdGVkX1+sU6/30VmU9Py1SDADlZ6YHMabQ+ipxx8=",
    "cpf": "U2FsdGVkX1/vsPG6KCMsAqiEuRKJm1mMsQGgr+ovOcU="
}, {
    "num_cand": "U2FsdGVkX193tiazk99Q31P2b4Oh1LJHYnX400s8duQ=",
    "cpf": "U2FsdGVkX1/wCjHq8Zrg9RElHLyw9Pb1BGdksbh7Y+o="
}, {
    "num_cand": "U2FsdGVkX1/Xf0nLZZtx6wDaNcBhlNOBO3fWTR8TAbI=",
    "cpf": "U2FsdGVkX18RdyhZ4rhIRDY2AqcRo4WnbW0bE6katqU="
}, {
    "num_cand": "U2FsdGVkX1+QQ+grrO6MKQxc2XhCTDGC0kHb2kCZU2U=",
    "cpf": "U2FsdGVkX18GItV77IZrlUErihZdQPeDIx4Bkelav6E="
}, {
    "num_cand": "U2FsdGVkX1/x5J8+C9zmRvcTgUw17eEsN/ifLIO7Vro=",
    "cpf": "U2FsdGVkX1+rTD1Ygxhh2neFdErZBDdgbnI5A6NYej0="
}, {
    "num_cand": "U2FsdGVkX1+XjRy/rV3YkG8w7ceKim1qkACylx5f57M=",
    "cpf": "U2FsdGVkX198T19bRQX040WnbBQY6xRtVe0ZOL9INi8="
}, {
    "num_cand": "U2FsdGVkX1+zwISDcTGb7t6zgBzmaRo3MHkFBs9QwpQ=",
    "cpf": "U2FsdGVkX19iBHxWfoPNWB1WVct5bl/qR4apIvX1CwI="
}, {
    "num_cand": "U2FsdGVkX1+p0CidF4vYvN69dIJlLwmtsWqIx/CDxHU=",
    "cpf": "U2FsdGVkX1/7ldWAOl8SZPYPV+Z3dJ4s3qoMZXot/bA="
}, {
    "num_cand": "U2FsdGVkX18P5NF9PQIJOD89ZgXp+3XXUydvpLW6FlM=",
    "cpf": "U2FsdGVkX19dmPHfJLRJOS2UhFJZojdLPxKoWEfAhMQ="
}, {
    "num_cand": "U2FsdGVkX1/JVtSJEAPjP/5Kow9suP/7AdOuykVfEhw=",
    "cpf": "U2FsdGVkX19L5qvcDW4kxuhTHnfoC1zh0q3NHkhTsvk="
}, {
    "num_cand": "U2FsdGVkX19pbYzFkpoQUiHforrPNijp7wCIxPkLBh0=",
    "cpf": "U2FsdGVkX19pLrfsKMh4LxQpAa+XPg23noBzdNd2Q1M="
}, {
    "num_cand": "U2FsdGVkX1/38kIdt/d+9PQntXpJlis5d7xcWBreFGY=",
    "cpf": "U2FsdGVkX19K9bFQSORx6nxcf/rzscL0exje0/FZjUI="
}, {
    "num_cand": "U2FsdGVkX1/MLZ7276H2RDZK1dQ/X/NE/48UaKXzYCQ=",
    "cpf": "U2FsdGVkX1+x4RVNagOol06dP4QhsXsrPnhEj3CYuQg="
},
  {"num_cand":"U2FsdGVkX19/GFILdcwbEFGvJ5wIgGAum+b7ctd0Czk=","cpf":"U2FsdGVkX18vztp6A5zjQ6CFcnuZprP7afplc76ghUU="},{"num_cand":"U2FsdGVkX1/ReVVaov3yjuMz7nTK2GZhSknFD3LtvoM=","cpf":"U2FsdGVkX19KIvHE6MZXuWn/znNdef0ohd/R5OtZ9pU="},{"num_cand":"U2FsdGVkX19v/7XMWwJoxAS9up4Kc/DeAgin5cn9MQs=","cpf":"U2FsdGVkX18OlE2cwW7Xr6aVIqoVVcl+1/T1kg5Er84="},{"num_cand":"U2FsdGVkX18xdDCwOu8yM5snKpAcBqxhlssXSCaCGHU=","cpf":"U2FsdGVkX1/RIaRde1ptbqSd48i3ofNr6eiYkVQhfj4="},{"num_cand":"U2FsdGVkX1+AEoJKyy2YAbXZhxlsdkcYAWj7Km7asmA=","cpf":"U2FsdGVkX1+2gxQWgmGSgH2FCKaPGUK6q03BYEt0SCY="},{"num_cand":"U2FsdGVkX18joPNGOxUgCNSRDiWd9n40LGJkaO35Msg=","cpf":"U2FsdGVkX1+c8HrFqC6UHmJVWmmdn1szwdSt+L3bb7A="},{"num_cand":"U2FsdGVkX1/Y0TZu42v0wE58s4/Ny1mJ9nteQbbVS7c=","cpf":"U2FsdGVkX1+8e5g+w30N2XPpfDWDZWE77ssjJ5dDK8w="},{"num_cand":"U2FsdGVkX19XIkTQKXEGyo0i7UPlX1UTwZ4lVjYw6KQ=","cpf":"U2FsdGVkX1/JzzI/f7YkMUQiQ/+66shp6pVIBIYvZrs="},{"num_cand":"U2FsdGVkX18+O5XHZnjRmm4ABUae/ZEdsrpuyqavDfM=","cpf":"U2FsdGVkX1+pCScE4vmTB3/63apobD7AJvX4ajbvHWg="},{"num_cand":"U2FsdGVkX1917TuCKL7pspHHYFgZ178idGg3Pt2QxbE=","cpf":"U2FsdGVkX1+RxNvqb2l7R/y8oDOxE5AV7FsO1dx8W+8="},{"num_cand":"U2FsdGVkX1/Z6ZG51EnsWZoYrPH4NvJweUVK130VMYI=","cpf":"U2FsdGVkX1/5I/kuH5TyCKhQoP8rP8VjvLWTmeW2l0M="},{"num_cand":"U2FsdGVkX18vZgICI+1WxmQohXBfubqA9YsFVVUsAnI=","cpf":"U2FsdGVkX19sIsoKefW5/fxMIQVA0e9ZRgHc5UG4KEw="},{"num_cand":"U2FsdGVkX18KNGtUylFKckEF2997mbU7NUjHT1FzXQg=","cpf":"U2FsdGVkX18xd8ob5GSseMGYaCjdMZBchieuCpPK8GU="},{"num_cand":"U2FsdGVkX1+1Nv6HuP8kLPl1nAr1qCkoUDZCZ5flZ2A=","cpf":"U2FsdGVkX1/cAD1mC3GXzOXy4LrnBxtqTtXe5SDsUNc="},{"num_cand":"U2FsdGVkX1/Xw09naoct7Q+bExUQJ6xWj0MST3ceLCY=","cpf":"U2FsdGVkX1+DlVKStJVc0Am+PXdzGzLabBYdHjguYYo="},{"num_cand":"U2FsdGVkX19BLpSPdLm9X1bRW0pI6zUQdo03FS2KdRk=","cpf":"U2FsdGVkX18P9BcikJg8QryZ2noRunc1scM8UgWmJX4="},{"num_cand":"U2FsdGVkX19hbDqZDaU3EmY40A+S2zyPUBNHlYc7r98=","cpf":"U2FsdGVkX18xmWdajfAHT+fSU/wAX+Y2MbNWr/w8efk="},{"num_cand":"U2FsdGVkX18bD+thSwrPjyJCct/zhUSUPdCyjgTHLnE=","cpf":"U2FsdGVkX1/0MCsoiHoqZryObyjeVV0+fafVIVrBuVE="},{"num_cand":"U2FsdGVkX1+YGo2QXTjGODTlzbjbgKel3abie7hnJ50=","cpf":"U2FsdGVkX18F0m13KQftG52lqg8WuyuwxxXPHiyigLg="},{"num_cand":"U2FsdGVkX1/2kN2n6BmsOqCqkApXGj5G4ipZmGWY/58=","cpf":"U2FsdGVkX19PRsyJKPkDRFPSjetMGqzUtotdoPGgtZA="},{"num_cand":"U2FsdGVkX1+KLN3d4cB3I57+9bvSOZCx03R3K71vY3w=","cpf":"U2FsdGVkX19qNlpUilgVCusi4aP9d2J3KT5qU77cJGw="},{"num_cand":"U2FsdGVkX1+RJCdQCyQkpHSgNgoN1jczKfDA19qfNW4=","cpf":"U2FsdGVkX1+qJs8rP0fvaWyKkI16+V9hbzMvqCAlqIA="},{"num_cand":"U2FsdGVkX19AZ9cttW1Xpri+6p/vdMX7Kc5BrJF7MBY=","cpf":"U2FsdGVkX18AiCVF5wapyCO0G+BIwB+DQ7MPPsQiZ2M="},{"num_cand":"U2FsdGVkX1/e0TWztmgUFAUbxA1ziZ/pstyznj9yUT8=","cpf":"U2FsdGVkX1/Bn59s7ZHsZzUoXLAsNAkN2b5ovuPtXSQ="},{"num_cand":"U2FsdGVkX19FT9Afkrph+bBpPFl3+CcubrEgpSXoJaA=","cpf":"U2FsdGVkX1+UIaN2kIAxbE7+eURIIQCAtUotkmflhw8="},{"num_cand":"U2FsdGVkX1/j7gNYc8GesZ+x/jlBKKkKhDda6VZ4o24=","cpf":"U2FsdGVkX1+HkZeXYzrsfYkrWCkDF/bX/jt1uioUyDg="},{"num_cand":"U2FsdGVkX18Yr38i5N4ZFGQtUgOotLMHKifVyGfMEQ8=","cpf":"U2FsdGVkX19s18aNAHXG1d0aIUNSxvxOnwV5+63Kr30="},{"num_cand":"U2FsdGVkX19OGKpsCaR2Kt/N6QiRGxY+uoG0fd+a+T0=","cpf":"U2FsdGVkX1/PPwbfj+38bI0GtmvlDEy/ozzgKDqHG/0="},{"num_cand":"U2FsdGVkX18h28+gPDpZmoa5ThbI8J0hchV7DHvj7M8=","cpf":"U2FsdGVkX1/rz31lgQlYIZKnnetvueSmyIm1d1Kuxnw="},{"num_cand":"U2FsdGVkX1+WDAdph8lW32lHkSvshAGbS0Mr2Og4GiA=","cpf":"U2FsdGVkX1/KxEfh5WTtiIxaMRsvasciJ75eOKglJkI="},{"num_cand":"U2FsdGVkX1+pfEcFKbYhnlZDySIlGVhimRzUVRtokiw=","cpf":"U2FsdGVkX1+IkwGfY4mAy3caScMH0haUbHYvrclDd20="},{"num_cand":"U2FsdGVkX1/PIvkFFpZzp5qibk4TEvyKWTKpcuzFqV4=","cpf":"U2FsdGVkX1/ox4mQD5jAvCxlZme3kCKTos+5NC9hX78="},{"num_cand":"U2FsdGVkX1/S994xUlMljNOmYEkaVNMnYEKXZfzMcjk=","cpf":"U2FsdGVkX19aGZ+U0YmwIQmWf0mk1DaHfxQN/ahj2fk="},{"num_cand":"U2FsdGVkX1+oa33CyMlO/9dOLGA7BhMk387AF/rh198=","cpf":"U2FsdGVkX1/+qXb8Gbutj3aRqz4s18qOmD+s52tv33U="},{"num_cand":"U2FsdGVkX19yD0alfGAYD/M+853vwwI3+FjRfx44b6k=","cpf":"U2FsdGVkX19j0kOJmT84EzPyZELxKPGSwSK11LWJbCs="},{"num_cand":"U2FsdGVkX1981XXpodR/laX91udRv1JVrzmEvhlRiUY=","cpf":"U2FsdGVkX1/tpVo8fXQyuK/B+zByR3PoNFWVBEJkVw4="},{"num_cand":"U2FsdGVkX18RYZouCmjprx7jn4Jn3+fsM6klZS3hwSo=","cpf":"U2FsdGVkX1/upOGkJP+90SZlLAfzAPbhvwWl0RlC1mQ="},{"num_cand":"U2FsdGVkX1+KEq9rQH7TxW9IRTWOoY4Yr86L0pjAnXc=","cpf":"U2FsdGVkX181/SFPV/LsYkP0PGgVEXIudh+APcJM2DI="},{"num_cand":"U2FsdGVkX1/8dVMdI/TpskLowLmIkwtBuxN8kT4twz0=","cpf":"U2FsdGVkX19kW5q44CDGTqjpsljCTc/tuH274rsEwgA="},{"num_cand":"U2FsdGVkX1/AzXl70VlziVRwWbHXzdNiKmBzSN+VWHo=","cpf":"U2FsdGVkX1+oDJ2440ZTOeKeqHnDnSDZLWj4Vf4bO/c="},{"num_cand":"U2FsdGVkX1+QjuWfnQBf1U3eR4aFoPUh5cx6VyrQgyk=","cpf":"U2FsdGVkX19HJab6nAyFEnWGp/l+jwkMwM9n5za6/6o="},{"num_cand":"U2FsdGVkX18yE4VEb+7ADiuDg5rIRvFZWAio0+Vn4sQ=","cpf":"U2FsdGVkX1+2rYM4oA6IKOUvcDi2hr4Zc6skaw7Hbs8="},{"num_cand":"U2FsdGVkX18PWN+AQYKT8xQCObQ9zszz7jb/QOCxDk4=","cpf":"U2FsdGVkX19Ck/p5RFGqGCVZwpDZrMIuXM2ncnPzOZI="},{"num_cand":"U2FsdGVkX184/S+FfSejZFpTp+j3aTM2bX9sEc/P00w=","cpf":"U2FsdGVkX18XU3IkUzp1VKVHLLWXBC2cdpuFnbO4cl0="},{"num_cand":"U2FsdGVkX19m/qLrfRv7OLC8s2HKQLfuiAhhxZC0Mz8=","cpf":"U2FsdGVkX1/Uky3EohDDKapCMyEivF7RlvYh5blGCik="},{"num_cand":"U2FsdGVkX1+njstMDskaS4abakHflV1xuy5ROwDxZZs=","cpf":"U2FsdGVkX18o48BBRZIOaZGOinugkYw7e9ZlCTnRKGQ="},{"num_cand":"U2FsdGVkX1+7SQCxeMxBTGOR+SKVlI3qsZ8QhxuPplw=","cpf":"U2FsdGVkX1/PHxEN3p/By3a8EIP+pnjT8Y6TAtuIIK0="},{"num_cand":"U2FsdGVkX18VIOSzrfl7JHGik58tfg557qmTHOK+4Ig=","cpf":"U2FsdGVkX1/f5WYopCf3B+zvUSamqWuw4giA3ieKIZY="},{"num_cand":"U2FsdGVkX18mQF42BWZnIhJ43d7yESbT1EUqp9UrHvc=","cpf":"U2FsdGVkX18gvSjBd5PbH1dNGDKIQpDIHmMXCZj2ho0="},{"num_cand":"U2FsdGVkX1+ZlRXrcFQddqOyrCiwjH/sR37xAQ5c+d4=","cpf":"U2FsdGVkX1+Gbk+s25PyYrDDDFDFlqLkL+RXSi/sJyw="},{"num_cand":"U2FsdGVkX18MUPVtj7cv/kfr+ZVYSZsSirmS2Gk4A/c=","cpf":"U2FsdGVkX1/7IJBOtVpMSo3TYRoSJesiJu6WF3jVE6o="},{"num_cand":"U2FsdGVkX1+ZMl4YpuifwUg7fAgVTPqnO8jMbRXloZA=","cpf":"U2FsdGVkX18as0a20yL/8MJIgiT7zt0B+XAqFpfd9CQ="},{"num_cand":"U2FsdGVkX1+/UVTZzkf6K3oLxBpZhWxyne/DN2FYKI8=","cpf":"U2FsdGVkX183KAfa4QzUrFimIdntkLMPb7rLoTG6ESQ="},{"num_cand":"U2FsdGVkX1/VuxaV+z1Ss+26xX/oXugYlr3cEbtz1MU=","cpf":"U2FsdGVkX19tG6ciuafjQpYYKKExpalLI+PjVz+MlnQ="},{"num_cand":"U2FsdGVkX1+4pFgtDIFz5Y6G4Zw4b9VNWFAKZEDhAm8=","cpf":"U2FsdGVkX19tOwK/5c0AIy9GrGJ/rPFV5BL3lelRYEg="},{"num_cand":"U2FsdGVkX19nTYxfomH2jgS5QqNWU9xrSSWcSd84PXc=","cpf":"U2FsdGVkX1/eNZzRZPoJ7xW2ecNFfnRgWtJAtU5WFyU="},{"num_cand":"U2FsdGVkX188WgadOlHiK5c2G/uM6vkKf1lEep2Peig=","cpf":"U2FsdGVkX1+nPX2bK9OxlXEL1GB4KbKToSnD3PkJHEo="},{"num_cand":"U2FsdGVkX18ucddG7FUp1FhjxZmxThTf5kfjWGHRH9Q=","cpf":"U2FsdGVkX1+5Et152d3bnUgXCJyl37HAm5upPfPPlAU="},{"num_cand":"U2FsdGVkX192LqO/r3KDf6JNU90b/M8k3rpFnvCjLfc=","cpf":"U2FsdGVkX18nJ4vWd/BJaP9yWr5FpZ0AbNwn1IrTsj0="},{"num_cand":"U2FsdGVkX18zOTRQxlVHWdqO9ugM+0Ga8ShxJ05xaSg=","cpf":"U2FsdGVkX1+XUubkyNlVRCUaXDyU6How0YZ58GK3X4k="},{"num_cand":"U2FsdGVkX1+EeU2OevgvpHro3+vHtA9NZbEzztQKIXE=","cpf":"U2FsdGVkX1/KtLcVKNrlk5/JqOMiu9e3ANR5wKgtrD0="},{"num_cand":"U2FsdGVkX19aorYpexmDQFXpjLYz/G4dvEEAWSpA80Q=","cpf":"U2FsdGVkX19SpEbSnX8MMdTzLXjCKM8LYmyMaxD+G4A="},{"num_cand":"U2FsdGVkX1+0N92ORsDRUdELhHYk2ahATPcfCwpKRcc=","cpf":"U2FsdGVkX19ncDnreDqevnVWzY6sqh9jZhOSdqDwH84="},{"num_cand":"U2FsdGVkX19IYSLcEtvRaP/JqIX1XNVVnKRlmKMM6oA=","cpf":"U2FsdGVkX1/ofsFjENLAxdydb/3EPyBqJ/GxF0L/sL0="},{"num_cand":"U2FsdGVkX181PXb8Tw+Ll1i1qh7KVOvfFa1oJj+oq+s=","cpf":"U2FsdGVkX1/iA4nf42W/2VAoqi+SeoLJ575IJb+fVpI="},{"num_cand":"U2FsdGVkX1+7BKOvlhU7hcTuYiEOqO2uNmxth2RSCRg=","cpf":"U2FsdGVkX19nM0+aa+0wlAbb6E7xtmPGSXjLPjfMEYQ="},{"num_cand":"U2FsdGVkX1+oMa/tGw1zwMzKwa/wMNHklrLHgAa6wbw=","cpf":"U2FsdGVkX1+cSkiJ7yFGJzi4dnCJvXzYqmMlsfD1Qkg="},{"num_cand":"U2FsdGVkX1/LQD17F3N01HsoHX0qaSiPJ7U6g0pf9GQ=","cpf":"U2FsdGVkX1+uOH5CAjmwHm1FXOG8YNe5n+lkSsAUYyw="},{"num_cand":"U2FsdGVkX187EZbkSrSs4JKanjPCYiAF5Z+V7Ekjio4=","cpf":"U2FsdGVkX18bhe6OmQBAXuz9hFIWBYyf/A3C+GXumqo="},{"num_cand":"U2FsdGVkX18ibSOJopXYvA9UiY+wth4sjTpyKrG1mF4=","cpf":"U2FsdGVkX19MqtUFp+PUw6RhrdNbnNRPJDaKXpRk7Rg="},{"num_cand":"U2FsdGVkX18PmWM5iP15PcQ1h04NpJL8Xfb1lxMRh6k=","cpf":"U2FsdGVkX18M5+1o5GMCVvoZAfTcDt21nlnhn/ABXhY="},{"num_cand":"U2FsdGVkX199u0woLq5WO6cldP2wjm4VEEOLF2zgSZw=","cpf":"U2FsdGVkX1/0g3il/4i3ssPmjtODX/T5eQgi1WM0fDE="},{"num_cand":"U2FsdGVkX1+oQW+bchmSdue0JnRGkL2CTOSIM24nFlY=","cpf":"U2FsdGVkX18m0hR546UPLAz11yZm1Ns0EiyV1oYObWY="},{"num_cand":"U2FsdGVkX1+3MkAwCGzv2hAKo/XeFEp7kdw+8BgHiZQ=","cpf":"U2FsdGVkX1/kQQt8BCk6u2Vou55hG/e8OhsdEWpcWoY="},{"num_cand":"U2FsdGVkX193D5Hat+bKpC2x71N/pqgpCMDmFK54keU=","cpf":"U2FsdGVkX1+Zs4BlMALa9/OgUkWdwHDyp+W3k5DvUH4="},{"num_cand":"U2FsdGVkX19xfcznW5ZN7NoZRyen4Z/yBuN04MMWRvI=","cpf":"U2FsdGVkX18IxZUz0gz/sl5LBbfcetnFnAdTgHp/CTs="},{"num_cand":"U2FsdGVkX19TSiU0VoIhSB1qcHHDxsUnqR1AgmjNDYY=","cpf":"U2FsdGVkX18awmCOoqcjywAWD9hKHq77MUYg3UymWJk="},{"num_cand":"U2FsdGVkX1+aC4bHw+00Be3VMDtI1bFIe39w2eMDCcM=","cpf":"U2FsdGVkX19pV84sO+C9jKmkxe+3IpTM79Ba5WwrfAY="},{"num_cand":"U2FsdGVkX191C13VqGUQyq5EIInHxS3I3nnKborLfW0=","cpf":"U2FsdGVkX18JOcKLWX0+2CHGV6WBvx8ginKOkK59z4A="},{"num_cand":"U2FsdGVkX18TGA0uG6eeaXxsC9z++O1IdkAU3pK5lhk=","cpf":"U2FsdGVkX1+WiOX9f93lTj7hfqzUw4aS6ycu3VsuwhY="},{"num_cand":"U2FsdGVkX19qDGaNjOfKY2B9t01r/vCjHNF+p4QN5ik=","cpf":"U2FsdGVkX19dT6NKUR+0KrBcstCUko9dUrXiTrIZovA="},{"num_cand":"U2FsdGVkX1+4plYGhEIZT9aExqM53Oz+L9vQu6o1y+k=","cpf":"U2FsdGVkX1/wLQd3L2fh6kBKNd5wDfWwL18tTIiONqw="},{"num_cand":"U2FsdGVkX1/x9a5ht0bsuXuAsPQJXb6OYbHKZpxr/LY=","cpf":"U2FsdGVkX18vcBEId4P4TyZlvPka20KBwtp/EHg9JzI="},{"num_cand":"U2FsdGVkX1+a6g3LXuYEuVKJJvG5KB/DM7DIMI5lOMg=","cpf":"U2FsdGVkX1/TG71q7Kzf8CY1xQG6IGsZv3h47OWQSQw="},{"num_cand":"U2FsdGVkX19SVGsAwLEomWqYkJ92h7DHQ6eHoxvxQws=","cpf":"U2FsdGVkX18A/QAsc18qKzL3kIeMtCSc5NMGDjnN6kI="},{"num_cand":"U2FsdGVkX1/mRObaR1eqAt7xDwt5gzB9ZH/fK122Ez4=","cpf":"U2FsdGVkX18G+wRCt+w46Z1MTuwf5uS9wyIAVWySCWk="},{"num_cand":"U2FsdGVkX1/aRMwbiAr8/pvfFDlZ3CfnuoyMZVklpag=","cpf":"U2FsdGVkX18VDFByQ6NF50VI5fKZ6UwR+EmosfpMoZA="},{"num_cand":"U2FsdGVkX1+Hp70vXeQZ9vWEYWhdX0QL5bjA1+XOCUg=","cpf":"U2FsdGVkX1/lpZN4KoN4752qMHHcMn+52oV4Gda+htw="},{"num_cand":"U2FsdGVkX1+lzebT7o/qwyWEChqDokxY+Zkq7eT0ZxY=","cpf":"U2FsdGVkX183DG2pzQ+Sa35b67GRdPO0P0sAlseIZec="},{"num_cand":"U2FsdGVkX1/cx4EJcjQUytV4JZMzbRPntIg+D4pa0jU=","cpf":"U2FsdGVkX18WSGxzFs/nAqQDssWs9ZtJB2JqFZPaM3E="},{"num_cand":"U2FsdGVkX19e8TSXd2YsvGNDO3ref7ZlKfE2MUjE4h4=","cpf":"U2FsdGVkX19HRneqEpDcYauEOHD3uatpznGwvvjGnA0="},{"num_cand":"U2FsdGVkX18dGtbKder7D+61sWYlAXqGbyM1+LFRvRU=","cpf":"U2FsdGVkX1+RKeM3nKRJ6dAlpRSJd7s62+fQdkiN0AI="},{"num_cand":"U2FsdGVkX1/e+LL81N1RzGuaMTj3IhYtEF1rN7YEXqY=","cpf":"U2FsdGVkX1+YV+NxqFyNQX9EfxIOaNxGZyy6sFgaNXE="},{"num_cand":"U2FsdGVkX19KWTqwVS/n+u6RYOs+HAPJGXMTPrJjED0=","cpf":"U2FsdGVkX1/JJ8JA3PXcSxBH2GCQ+mjPWttUAmhNWfc="},{"num_cand":"U2FsdGVkX1+ln/jU0HJR2RskOcKe6rl2RuXJQAO59Gs=","cpf":"U2FsdGVkX1/yQ+0e5dTmpYZVyMP+v0SRD+uUr/UF/aE="},{"num_cand":"U2FsdGVkX18OsbdrXDeW4rEmt9jMLJ6TYiiqi7EyLHY=","cpf":"U2FsdGVkX1/AKqQGy1+ydo9C0eZinbT2cGU/thwdzds="},{"num_cand":"U2FsdGVkX19yaGtnUONQ2z4Qgvls0/8wFdmfCdk1YJM=","cpf":"U2FsdGVkX1+/h1foPxKSZErDOgrS12rHM7B/OKvs1jU="},{"num_cand":"U2FsdGVkX19arp/QeoocvuYJ9tzDy9wWo47ApeuiBDI=","cpf":"U2FsdGVkX19sxaa8PuWYyoGlMTHcmr1vnl8/ig4wP1c="},{"num_cand":"U2FsdGVkX1/iVkWmv8y6VhxsYwLqcE9NCaHucP25KI0=","cpf":"U2FsdGVkX1/2paqVltEs9h8cK+M/d7Lb55UjOutgqfs="},{"num_cand":"U2FsdGVkX19uSjA6T1ftfiGvz5WP8h2gyER+ICVa1cI=","cpf":"U2FsdGVkX1+fZVKuEWEPkxCSqM3Xh68+lwdqlLTORcw="},{"num_cand":"U2FsdGVkX18icqxF6KkJiLQP4TRKofmEOtFR8xLp4Rk=","cpf":"U2FsdGVkX18Oq3NQGZb90hSJKuxerwf4MUUEKJlE9P8="},{"num_cand":"U2FsdGVkX18KprUJ+xxwIWdT81OMLYb94rQ636/SwX4=","cpf":"U2FsdGVkX1/1gTc7nSNqLzcVOUWb55RsH6W8vgOKboo="},{"num_cand":"U2FsdGVkX1+GLoJTgnuNtvtT0uJEexoUv+lWxKszNLg=","cpf":"U2FsdGVkX18dTgFR7DwwRexAVtXjriMEpB7322FejSk="},{"num_cand":"U2FsdGVkX19dL+J6YBvxXKbG/0/+h4FFGAuizI2NCJA=","cpf":"U2FsdGVkX18ZhCL1yyo/JggnND3jCSDIN0q6OwCfFIA="},{"num_cand":"U2FsdGVkX1+UoUtN52+96HrnL6fImgIBtYCD9i5NeVs=","cpf":"U2FsdGVkX1/3KGO/Qw99fKc5xuD1d/nQ0Nx71veL+mc="},{"num_cand":"U2FsdGVkX1/3bWne2MMTFJkds2peUqPq9Xz1qe8fc3g=","cpf":"U2FsdGVkX18UkUkpMLz+VP0KbfYB6Yx7V3G/+tFwdwc="},{"num_cand":"U2FsdGVkX19Yy0iNUsJ+iTEz3YJLJ7if6biF1Zd3CzE=","cpf":"U2FsdGVkX1+Z0zk18HvysMPB0UPD8gGeOuC1+hw+0x0="},{"num_cand":"U2FsdGVkX18Yko6Wxb66rib5M7rlTRfTz5khdlVZDVs=","cpf":"U2FsdGVkX1/G+HVcp5kYhOfh5YQEmU/0TDEtjK8jyV0="},{"num_cand":"U2FsdGVkX19WPtI11IBWO8jkwi9NeGHI5KYtpy+KiEE=","cpf":"U2FsdGVkX1/985DXPOJWG1qVmMGcdNQzPQaUzQF+eP4="},{"num_cand":"U2FsdGVkX1/IIJ8XpKvn0DIIs5VCzcHO0IsAQ0DW3t8=","cpf":"U2FsdGVkX18O4NXeZYasYuJl44K5TNdawxRHq8DdOwE="},{"num_cand":"U2FsdGVkX18fvOK13+jLx4tJ7tPYZpKP219fWJ7Nkck=","cpf":"U2FsdGVkX1/MIVYxxHT+vfPbMqo1n15u2O3yFcfuQqc="},{"num_cand":"U2FsdGVkX1+nXF2BduhqqzM2Xb4wIUOeKQdPQ2AFnys=","cpf":"U2FsdGVkX1+wGtrewVwXSg4IDxWkVvjSB+PbgRjgUlo="},{"num_cand":"U2FsdGVkX1+pwrbVfmOE++zDVm7k334kzopUUXdGj2E=","cpf":"U2FsdGVkX19QR9RcmM92z0/dmL06zxycKZIVexJG4lY="},{"num_cand":"U2FsdGVkX19JqG0XCs9g1XBPYTP5I6d5elvasu6gfK0=","cpf":"U2FsdGVkX19YKMpFu/wXqPsl8BDQKmAnR1Q8PbBa1SE="},{"num_cand":"U2FsdGVkX1+prbcJ/u4FI5+u1Umdx/0Wx9RIvFpoFbo=","cpf":"U2FsdGVkX18ZhRgidei55Ekfo71fFAqqRvD0A5YjVWs="},{"num_cand":"U2FsdGVkX1/qy1aT9e/xT1+BwKu5NKtYeLJl6QjltrM=","cpf":"U2FsdGVkX18ZsJtr98QGU14n89MNXRAEatI52buimGY="},{"num_cand":"U2FsdGVkX19OqCgDZvEWMMikafwgrULdjP60qDua/Nw=","cpf":"U2FsdGVkX19aL5EHX7MQym4UO0UGvvNKD8PYrKMSXSE="},{"num_cand":"U2FsdGVkX1/TBPOH3PCiwm+ljaT1qvq2G3heQikPomA=","cpf":"U2FsdGVkX1/8p82Kza8iBhxkQBPg34HTNGTtf6XMvPs="},{"num_cand":"U2FsdGVkX1/mkvuh8qaCdKnyn66fvL2henFGRde7Hmk=","cpf":"U2FsdGVkX19iW+6anuXYm+y164oGuPTo48y9/O3zM5A="},{"num_cand":"U2FsdGVkX18pT9RNayna0B1E4OodIqESTV+laBbQjWI=","cpf":"U2FsdGVkX1/IMZ0+/IDCAGxXcRQmaegsJmdEq4WaFbs="},{"num_cand":"U2FsdGVkX19D3O3ZpzmwtaTuuwawhuS7cH5ezfWZPt4=","cpf":"U2FsdGVkX1/0JgeOLOQ+1HYILC3zpc8b9FXFKSqw59k="},{"num_cand":"U2FsdGVkX1/XwdvitI9xwwvPBjGB+8WxCmVuxR3irfA=","cpf":"U2FsdGVkX1/BAHOGqgC/gz1dtYwv34graGiR0FDenSk="},{"num_cand":"U2FsdGVkX1892EFvcS3ObMtV1a9OFGM2E03GixbSg4M=","cpf":"U2FsdGVkX181SlDSev+iZ1bY7XG/zj0JjxqkGEaaToA="},{"num_cand":"U2FsdGVkX1+4Zx9HtVxAHc9evhSPXXSgJ7AderW2TY4=","cpf":"U2FsdGVkX18su72c3os+HKUWNkmnmdxOb3BUns3xhCI="},{"num_cand":"U2FsdGVkX1+4TgrKPp77de6K8gLSKJqIfBssLp9M2tY=","cpf":"U2FsdGVkX1/t+5c+LPrplymHkdKVbx6fBOWkq2aPNeE="},{"num_cand":"U2FsdGVkX19G+yiJtCLGoZBtVDm8KuWcBB0uCoeLDc0=","cpf":"U2FsdGVkX19TOBOQ/bh3AZYtYhsI/yQZ8tSOy60gx4g="},{"num_cand":"U2FsdGVkX1+7jdbEQ6Rvs9hxt5EnJrqK3UcFx5SpYuk=","cpf":"U2FsdGVkX19IFzfz5KlOz/UeLDtFxhkMXOazEcmLamQ="},{"num_cand":"U2FsdGVkX18n0jIwgSAxF57CpVhw+qyskzUtTB6CR/4=","cpf":"U2FsdGVkX1865/NwYOwFxue1r44vqyPfEX3fY4OvKjk="},{"num_cand":"U2FsdGVkX1+Pjsnw+JExt9v1mqjLgqDxa3Nt7MMPp3c=","cpf":"U2FsdGVkX1/B2qmxhVqhswcemSwdwihPe39diT5dAgY="},{"num_cand":"U2FsdGVkX199eDFrifo6q3WF+K5t2pR6hV+s7PNYk5Q=","cpf":"U2FsdGVkX19N9rjZtpQjcKOR2b8nTUwWga2Exn8jUTc="},{"num_cand":"U2FsdGVkX19HAkQKXoFw7zzFwHI5wyktbQfNlm0Uslo=","cpf":"U2FsdGVkX18Q0p1xNagdb/2MUpIkayXykuZeEdhm928="},{"num_cand":"U2FsdGVkX1+1LysUY2Mc+u4DSxfQ4RMAzFbB/+mQodo=","cpf":"U2FsdGVkX18sSMv/Hz9mb6NJte97AAVF5k5+lIKfCjI="},{"num_cand":"U2FsdGVkX1/uZqta5DV1ymlIfzZJg/tmUK9d2XJEij0=","cpf":"U2FsdGVkX18OyydAThA+UPoxjY/XZDE/LyCkNsKErZQ="},{"num_cand":"U2FsdGVkX19/QYe4WQvnbI1RI5cW0sGpmfXJu8NMre8=","cpf":"U2FsdGVkX198NcQwZhjTwZefw0eBq3yIAlUNKLFTdfE="},{"num_cand":"U2FsdGVkX1+XXOiD46LdMAR5c9iLGIcyigiArZ1inI8=","cpf":"U2FsdGVkX1+EB+CzMpiTAaEkzLWodpq6qXCU1lzaW1k="},{"num_cand":"U2FsdGVkX1+Mr1815gmUpUzaX0N9ZGCyHZhjnyvjeDk=","cpf":"U2FsdGVkX1+yApGZBx3mwFq5u9yc6Gy/q1zx3xnI+/s="},{"num_cand":"U2FsdGVkX1+F+L5rvKv3uYyl9PPeGGKJ1e7UQnuSjHM=","cpf":"U2FsdGVkX1+dRwG7oFkiokYgykvkIfR9T4VTdpuv/lg="},{"num_cand":"U2FsdGVkX193g5EeWw+lzBcAOB8mngjbczOCbVhKDp4=","cpf":"U2FsdGVkX18KBfG5hXC/DMlURqTxESfG2Eh8cgIIQss="},{"num_cand":"U2FsdGVkX19Pq4eL3Lkxr5ADjMYieGTvL67FPDE4sA4=","cpf":"U2FsdGVkX1/CdttuDCRBnXljxIxxB4I92SAwIjUW4xM="},{"num_cand":"U2FsdGVkX1/hGAmjTwQJ06yo8MH7mujSBnsdXebsybw=","cpf":"U2FsdGVkX19b6i3EmBVFl3QOeyg2uwCuy34SLvhkkdg="},{"num_cand":"U2FsdGVkX1+rmmvOF8PR3k9WAqAhEt9RS2s3atjJLRM=","cpf":"U2FsdGVkX19OJOG1NW57cBO4EaFTptFUkYTSV7UUwsk="},{"num_cand":"U2FsdGVkX19FOJ/YvGuLxH7hk86y4h9dfT4Jbd2RbVU=","cpf":"U2FsdGVkX19/hDoNkt4Z7VC/Mk600d51VeG7QQmerR8="},{"num_cand":"U2FsdGVkX19mJAEcyVfDnQvZ/poSqPVNaMNyeHPgAOE=","cpf":"U2FsdGVkX19Mpnd3aFbuakRS37s5WSou+awgDyB+k+8="},{"num_cand":"U2FsdGVkX1+o6R6AhjULrkD9txFloAxPbsIFrOAzzjc=","cpf":"U2FsdGVkX19MIuTff3D1uFrZDpHol+qx6Gnhpo6YXhw="},{"num_cand":"U2FsdGVkX19WX+WNl6ez5A9s0ykQWeS0mivuG9CQfqo=","cpf":"U2FsdGVkX18vFh16UdSzkoi811xtCUhNqBpSdwQaRlI="},{"num_cand":"U2FsdGVkX18QBeE+j0Gh8WTyAtA+j7Yl6TDc76hMTD4=","cpf":"U2FsdGVkX18wuA3Xj9rYyMF1Lq6W/a1z15cDFbQH3qk="},{"num_cand":"U2FsdGVkX1+Bkgh3x67OeRmJY4JBtO34xq3qvSeFa2k=","cpf":"U2FsdGVkX188qa6Oi4mh/I4YzmcYThSBQwL6iZn8nPc="},{"num_cand":"U2FsdGVkX19epey6oLlaPMPGET14fUKNkCPewTaVizw=","cpf":"U2FsdGVkX1+1DqEYOJcsAv6zUop7YqyLUYX7gLP6KEs="},{"num_cand":"U2FsdGVkX19q2gtDly4oNDKlT7fBt9dDqZyc7rYUICo=","cpf":"U2FsdGVkX19AHAIAM1Qy1H2ZKW0R7BnU9pMb7Gz67MY="},{"num_cand":"U2FsdGVkX1/ZoNHzM4RHePOgj7eCuqDCPr5dGzT8LCA=","cpf":"U2FsdGVkX1/x+G++XFQ6MuKn2dDEzWajf0fH5+p0HdE="},{"num_cand":"U2FsdGVkX1/2+3SMF/A+XhTxGqJTLFTvKVE5RqgnZw4=","cpf":"U2FsdGVkX1/OMRJh64P2EbjQjomi/05DuyvGh2nt6+4="},{"num_cand":"U2FsdGVkX1+mP9v9QKKF10RFLx1AF2bz6PMQl3Hy0nE=","cpf":"U2FsdGVkX1+ZUwmX6IPagUjYOYVFGNHZGEyhqw3p1Ko="},{"num_cand":"U2FsdGVkX18gi5VkTnvS906kcvM9HQ5/r68cVxmIhNc=","cpf":"U2FsdGVkX1/0WwbWjLOQcSmw7f+qP6nYsP8cFqrC2Ak="},{"num_cand":"U2FsdGVkX18Y7LWQsM0mlht8GXusEKoR5cWTiVBc/+c=","cpf":"U2FsdGVkX195RbG1JgybynBSSVdhj+62/kAuHeh3OY8="},{"num_cand":"U2FsdGVkX18jjXL+Hyw6KU/KVYT2DcBzZMyo+kn6q5c=","cpf":"U2FsdGVkX18yE5lzQBeKDv4f7sK31XbTpBK3tneIzxs="},{"num_cand":"U2FsdGVkX1854YsTAiwUi/eArL9FVtFnncP6mvF3+rM=","cpf":"U2FsdGVkX19bkDxQzn/SBcxRGukrkrxPdEvtG6DDULg="},{"num_cand":"U2FsdGVkX1/dU0u+4MpEYmZogAD8EkZ5XQVAvX9btUg=","cpf":"U2FsdGVkX1/Wzyu4y196CaPUOnsUpq72tT1Gab/kpZM="},{"num_cand":"U2FsdGVkX19cO7p7xwSWivS+VSbCUxeXCROTVdS5WTY=","cpf":"U2FsdGVkX19EnkjjTYEhP7fobq3ZogDdlW7KGw6RS0E="},{"num_cand":"U2FsdGVkX19IwkAou7azlnShaM4TDykQUOK7i9qRtUk=","cpf":"U2FsdGVkX180sTM3BNrQjXjmWNbOT8D7woHAIdWI/N0="},{"num_cand":"U2FsdGVkX1+eEVfjjuaMhoxNtsqwCdI+T7PjzvkZI1M=","cpf":"U2FsdGVkX185cEIxWPQTDHnGopiWZxO7LmXdkn5LC20="},{"num_cand":"U2FsdGVkX188wz022QGYyCBEodOuuu9EYDby7cPztbU=","cpf":"U2FsdGVkX1/8tO1b9hT1wTRliya8VotbLQPtxhq2Wa4="},{"num_cand":"U2FsdGVkX19g9aw6QtzPOqPV2joMjXfq14rczmo5KhE=","cpf":"U2FsdGVkX18UTrP+/F+wIrqmH+bt4locng9GxvPy8IM="},{"num_cand":"U2FsdGVkX1/mxWuaSgL5M32+FLOAymS5MqfvXeXNFU8=","cpf":"U2FsdGVkX1925OaNafBY0xSrfzaWBIAdzXNsWo/dNJI="},{"num_cand":"U2FsdGVkX19vcdBz/m4CSVam54kANmrwL4kfOfKLrGA=","cpf":"U2FsdGVkX1+ILCBtpf/olWSKf6ApGS4Qup8FLERKi5c="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2204/not_tit/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
